import { createElementBlock as c, openBlock as l, withModifiers as Ke, renderSlot as j, createCommentVNode as v, normalizeClass as G, createElementVNode as p, toDisplayString as E, resolveComponent as K, createBlock as F, withCtx as b, createVNode as T, defineComponent as Re, Fragment as oe, renderList as ae, createTextVNode as _, withDirectives as We, vModelCheckbox as ks, reactive as Us, vShow as Fo, resolveDynamicComponent as Et, createSlots as Ml, normalizeProps as Pi, mergeProps as On, nextTick as po, h as Bi, vModelText as Li, vModelRadio as Pl, defineAsyncComponent as Es, ref as Ae, isRef as ho, unref as ie, toRaw as ci, normalizeStyle as Ro, guardReactiveProps as Ss, resolveDirective as ko, toRefs as _n, computed as Te, onMounted as Ts, Teleport as Bl, inject as fi, getCurrentInstance as Ll, watchEffect as Nl, getCurrentScope as ql, onScopeDispose as xl, createStaticVNode as Vl, watch as mo, onBeforeMount as jl, onBeforeUnmount as Hl } from "vue";
function Gl(e, n) {
  for (var t = 0; t < n.length; t++) {
    const o = n[t];
    if (typeof o != "string" && !Array.isArray(o)) {
      for (const i in o)
        if (i !== "default" && !(i in e)) {
          const r = Object.getOwnPropertyDescriptor(o, i);
          r && Object.defineProperty(e, i, r.get ? r : {
            enumerable: !0,
            get: () => o[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function Is(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: Ql } = Object.prototype, { getPrototypeOf: Ni } = Object, { iterator: Uo, toStringTag: Ds } = Symbol, Eo = /* @__PURE__ */ ((e) => (n) => {
  const t = Ql.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), gt = (e) => (e = e.toLowerCase(), (n) => Eo(n) === e), So = (e) => (n) => typeof n === e, { isArray: dn } = Array, tn = So("undefined");
function Mn(e) {
  return e !== null && !tn(e) && e.constructor !== null && !tn(e.constructor) && $e(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Os = gt("ArrayBuffer");
function $l(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Os(e.buffer), n;
}
const Jl = So("string"), $e = So("function"), _s = So("number"), Pn = (e) => e !== null && typeof e == "object", zl = (e) => e === !0 || e === !1, no = (e) => {
  if (Eo(e) !== "object")
    return !1;
  const n = Ni(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Ds in e) && !(Uo in e);
}, Yl = (e) => {
  if (!Pn(e) || Mn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Wl = gt("Date"), Xl = gt("File"), Zl = gt("Blob"), eu = gt("FileList"), tu = (e) => Pn(e) && $e(e.pipe), nu = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || $e(e.append) && ((n = Eo(e)) === "formdata" || // detect form-data instance
  n === "object" && $e(e.toString) && e.toString() === "[object FormData]"));
}, ou = gt("URLSearchParams"), [iu, ru, su, au] = ["ReadableStream", "Request", "Response", "Headers"].map(gt), lu = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Bn(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, i;
  if (typeof e != "object" && (e = [e]), dn(e))
    for (o = 0, i = e.length; o < i; o++)
      n.call(null, e[o], o, e);
  else {
    if (Mn(e))
      return;
    const r = t ? Object.getOwnPropertyNames(e) : Object.keys(e), s = r.length;
    let a;
    for (o = 0; o < s; o++)
      a = r[o], n.call(null, e[a], a, e);
  }
}
function Ms(e, n) {
  if (Mn(e))
    return null;
  n = n.toLowerCase();
  const t = Object.keys(e);
  let o = t.length, i;
  for (; o-- > 0; )
    if (i = t[o], n === i.toLowerCase())
      return i;
  return null;
}
const Pt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ps = (e) => !tn(e) && e !== Pt;
function pi() {
  const { caseless: e, skipUndefined: n } = Ps(this) && this || {}, t = {}, o = (i, r) => {
    const s = e && Ms(t, r) || r;
    no(t[s]) && no(i) ? t[s] = pi(t[s], i) : no(i) ? t[s] = pi({}, i) : dn(i) ? t[s] = i.slice() : (!n || !tn(i)) && (t[s] = i);
  };
  for (let i = 0, r = arguments.length; i < r; i++)
    arguments[i] && Bn(arguments[i], o);
  return t;
}
const uu = (e, n, t, { allOwnKeys: o } = {}) => (Bn(n, (i, r) => {
  t && $e(i) ? e[r] = Is(i, t) : e[r] = i;
}, { allOwnKeys: o }), e), du = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), cu = (e, n, t, o) => {
  e.prototype = Object.create(n.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, fu = (e, n, t, o) => {
  let i, r, s;
  const a = {};
  if (n = n || {}, e == null) return n;
  do {
    for (i = Object.getOwnPropertyNames(e), r = i.length; r-- > 0; )
      s = i[r], (!o || o(s, e, n)) && !a[s] && (n[s] = e[s], a[s] = !0);
    e = t !== !1 && Ni(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, pu = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const o = e.indexOf(n, t);
  return o !== -1 && o === t;
}, hu = (e) => {
  if (!e) return null;
  if (dn(e)) return e;
  let n = e.length;
  if (!_s(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, mu = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ni(Uint8Array)), Au = (e, n) => {
  const o = (e && e[Uo]).call(e);
  let i;
  for (; (i = o.next()) && !i.done; ) {
    const r = i.value;
    n.call(e, r[0], r[1]);
  }
}, gu = (e, n) => {
  let t;
  const o = [];
  for (; (t = e.exec(n)) !== null; )
    o.push(t);
  return o;
}, yu = gt("HTMLFormElement"), Ku = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, o, i) {
    return o.toUpperCase() + i;
  }
), gr = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), vu = gt("RegExp"), Bs = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), o = {};
  Bn(t, (i, r) => {
    let s;
    (s = n(i, r, e)) !== !1 && (o[r] = s || i);
  }), Object.defineProperties(e, o);
}, bu = (e) => {
  Bs(e, (n, t) => {
    if ($e(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const o = e[t];
    if ($e(o)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, Cu = (e, n) => {
  const t = {}, o = (i) => {
    i.forEach((r) => {
      t[r] = !0;
    });
  };
  return dn(e) ? o(e) : o(String(e).split(n)), t;
}, wu = () => {
}, Fu = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function Ru(e) {
  return !!(e && $e(e.append) && e[Ds] === "FormData" && e[Uo]);
}
const ku = (e) => {
  const n = new Array(10), t = (o, i) => {
    if (Pn(o)) {
      if (n.indexOf(o) >= 0)
        return;
      if (Mn(o))
        return o;
      if (!("toJSON" in o)) {
        n[i] = o;
        const r = dn(o) ? [] : {};
        return Bn(o, (s, a) => {
          const u = t(s, i + 1);
          !tn(u) && (r[a] = u);
        }), n[i] = void 0, r;
      }
    }
    return o;
  };
  return t(e, 0);
}, Uu = gt("AsyncFunction"), Eu = (e) => e && (Pn(e) || $e(e)) && $e(e.then) && $e(e.catch), Ls = ((e, n) => e ? setImmediate : n ? ((t, o) => (Pt.addEventListener("message", ({ source: i, data: r }) => {
  i === Pt && r === t && o.length && o.shift()();
}, !1), (i) => {
  o.push(i), Pt.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  $e(Pt.postMessage)
), Su = typeof queueMicrotask < "u" ? queueMicrotask.bind(Pt) : typeof process < "u" && process.nextTick || Ls, Tu = (e) => e != null && $e(e[Uo]), S = {
  isArray: dn,
  isArrayBuffer: Os,
  isBuffer: Mn,
  isFormData: nu,
  isArrayBufferView: $l,
  isString: Jl,
  isNumber: _s,
  isBoolean: zl,
  isObject: Pn,
  isPlainObject: no,
  isEmptyObject: Yl,
  isReadableStream: iu,
  isRequest: ru,
  isResponse: su,
  isHeaders: au,
  isUndefined: tn,
  isDate: Wl,
  isFile: Xl,
  isBlob: Zl,
  isRegExp: vu,
  isFunction: $e,
  isStream: tu,
  isURLSearchParams: ou,
  isTypedArray: mu,
  isFileList: eu,
  forEach: Bn,
  merge: pi,
  extend: uu,
  trim: lu,
  stripBOM: du,
  inherits: cu,
  toFlatObject: fu,
  kindOf: Eo,
  kindOfTest: gt,
  endsWith: pu,
  toArray: hu,
  forEachEntry: Au,
  matchAll: gu,
  isHTMLForm: yu,
  hasOwnProperty: gr,
  hasOwnProp: gr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Bs,
  freezeMethods: bu,
  toObjectSet: Cu,
  toCamelCase: Ku,
  noop: wu,
  toFiniteNumber: Fu,
  findKey: Ms,
  global: Pt,
  isContextDefined: Ps,
  isSpecCompliantForm: Ru,
  toJSONObject: ku,
  isAsyncFn: Uu,
  isThenable: Eu,
  setImmediate: Ls,
  asap: Su,
  isIterable: Tu
};
function ce(e, n, t, o, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), t && (this.config = t), o && (this.request = o), i && (this.response = i, this.status = i.status ? i.status : null);
}
S.inherits(ce, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: S.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ns = ce.prototype, qs = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  qs[e] = { value: e };
});
Object.defineProperties(ce, qs);
Object.defineProperty(Ns, "isAxiosError", { value: !0 });
ce.from = (e, n, t, o, i, r) => {
  const s = Object.create(Ns);
  S.toFlatObject(e, s, function(f) {
    return f !== Error.prototype;
  }, (d) => d !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", u = n == null && e ? e.code : n;
  return ce.call(s, a, u, t, o, i), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", r && Object.assign(s, r), s;
};
const Iu = null;
function hi(e) {
  return S.isPlainObject(e) || S.isArray(e);
}
function xs(e) {
  return S.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function yr(e, n, t) {
  return e ? e.concat(n).map(function(i, r) {
    return i = xs(i), !t && r ? "[" + i + "]" : i;
  }).join(t ? "." : "") : n;
}
function Du(e) {
  return S.isArray(e) && !e.some(hi);
}
const Ou = S.toFlatObject(S, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function To(e, n, t) {
  if (!S.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = S.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(A, w) {
    return !S.isUndefined(w[A]);
  });
  const o = t.metaTokens, i = t.visitor || f, r = t.dots, s = t.indexes, u = (t.Blob || typeof Blob < "u" && Blob) && S.isSpecCompliantForm(n);
  if (!S.isFunction(i))
    throw new TypeError("visitor must be a function");
  function d(g) {
    if (g === null) return "";
    if (S.isDate(g))
      return g.toISOString();
    if (S.isBoolean(g))
      return g.toString();
    if (!u && S.isBlob(g))
      throw new ce("Blob is not supported. Use a Buffer instead.");
    return S.isArrayBuffer(g) || S.isTypedArray(g) ? u && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function f(g, A, w) {
    let M = g;
    if (g && !w && typeof g == "object") {
      if (S.endsWith(A, "{}"))
        A = o ? A : A.slice(0, -2), g = JSON.stringify(g);
      else if (S.isArray(g) && Du(g) || (S.isFileList(g) || S.endsWith(A, "[]")) && (M = S.toArray(g)))
        return A = xs(A), M.forEach(function(B, N) {
          !(S.isUndefined(B) || B === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? yr([A], N, r) : s === null ? A : A + "[]",
            d(B)
          );
        }), !1;
    }
    return hi(g) ? !0 : (n.append(yr(w, A, r), d(g)), !1);
  }
  const y = [], C = Object.assign(Ou, {
    defaultVisitor: f,
    convertValue: d,
    isVisitable: hi
  });
  function U(g, A) {
    if (!S.isUndefined(g)) {
      if (y.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + A.join("."));
      y.push(g), S.forEach(g, function(M, L) {
        (!(S.isUndefined(M) || M === null) && i.call(
          n,
          M,
          S.isString(L) ? L.trim() : L,
          A,
          C
        )) === !0 && U(M, A ? A.concat(L) : [L]);
      }), y.pop();
    }
  }
  if (!S.isObject(e))
    throw new TypeError("data must be an object");
  return U(e), n;
}
function Kr(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(o) {
    return n[o];
  });
}
function qi(e, n) {
  this._pairs = [], e && To(e, this, n);
}
const Vs = qi.prototype;
Vs.append = function(n, t) {
  this._pairs.push([n, t]);
};
Vs.toString = function(n) {
  const t = n ? function(o) {
    return n.call(this, o, Kr);
  } : Kr;
  return this._pairs.map(function(i) {
    return t(i[0]) + "=" + t(i[1]);
  }, "").join("&");
};
function _u(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function js(e, n, t) {
  if (!n)
    return e;
  const o = t && t.encode || _u;
  S.isFunction(t) && (t = {
    serialize: t
  });
  const i = t && t.serialize;
  let r;
  if (i ? r = i(n, t) : r = S.isURLSearchParams(n) ? n.toString() : new qi(n, t).toString(o), r) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
class vr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, o) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    S.forEach(this.handlers, function(o) {
      o !== null && n(o);
    });
  }
}
const Hs = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Mu = typeof URLSearchParams < "u" ? URLSearchParams : qi, Pu = typeof FormData < "u" ? FormData : null, Bu = typeof Blob < "u" ? Blob : null, Lu = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Mu,
    FormData: Pu,
    Blob: Bu
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, xi = typeof window < "u" && typeof document < "u", mi = typeof navigator == "object" && navigator || void 0, Nu = xi && (!mi || ["ReactNative", "NativeScript", "NS"].indexOf(mi.product) < 0), qu = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", xu = xi && window.location.href || "http://localhost", Vu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: xi,
  hasStandardBrowserEnv: Nu,
  hasStandardBrowserWebWorkerEnv: qu,
  navigator: mi,
  origin: xu
}, Symbol.toStringTag, { value: "Module" })), qe = {
  ...Vu,
  ...Lu
};
function ju(e, n) {
  return To(e, new qe.classes.URLSearchParams(), {
    visitor: function(t, o, i, r) {
      return qe.isNode && S.isBuffer(t) ? (this.append(o, t.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function Hu(e) {
  return S.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function Gu(e) {
  const n = {}, t = Object.keys(e);
  let o;
  const i = t.length;
  let r;
  for (o = 0; o < i; o++)
    r = t[o], n[r] = e[r];
  return n;
}
function Gs(e) {
  function n(t, o, i, r) {
    let s = t[r++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), u = r >= t.length;
    return s = !s && S.isArray(i) ? i.length : s, u ? (S.hasOwnProp(i, s) ? i[s] = [i[s], o] : i[s] = o, !a) : ((!i[s] || !S.isObject(i[s])) && (i[s] = []), n(t, o, i[s], r) && S.isArray(i[s]) && (i[s] = Gu(i[s])), !a);
  }
  if (S.isFormData(e) && S.isFunction(e.entries)) {
    const t = {};
    return S.forEachEntry(e, (o, i) => {
      n(Hu(o), i, t, 0);
    }), t;
  }
  return null;
}
function Qu(e, n, t) {
  if (S.isString(e))
    try {
      return (n || JSON.parse)(e), S.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (t || JSON.stringify)(e);
}
const Ln = {
  transitional: Hs,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, t) {
    const o = t.getContentType() || "", i = o.indexOf("application/json") > -1, r = S.isObject(n);
    if (r && S.isHTMLForm(n) && (n = new FormData(n)), S.isFormData(n))
      return i ? JSON.stringify(Gs(n)) : n;
    if (S.isArrayBuffer(n) || S.isBuffer(n) || S.isStream(n) || S.isFile(n) || S.isBlob(n) || S.isReadableStream(n))
      return n;
    if (S.isArrayBufferView(n))
      return n.buffer;
    if (S.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let a;
    if (r) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return ju(n, this.formSerializer).toString();
      if ((a = S.isFileList(n)) || o.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return To(
          a ? { "files[]": n } : n,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return r || i ? (t.setContentType("application/json", !1), Qu(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || Ln.transitional, o = t && t.forcedJSONParsing, i = this.responseType === "json";
    if (S.isResponse(n) || S.isReadableStream(n))
      return n;
    if (n && S.isString(n) && (o && !this.responseType || i)) {
      const s = !(t && t.silentJSONParsing) && i;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? ce.from(a, ce.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: qe.classes.FormData,
    Blob: qe.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
S.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ln.headers[e] = {};
});
const $u = S.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ju = (e) => {
  const n = {};
  let t, o, i;
  return e && e.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), t = s.substring(0, i).trim().toLowerCase(), o = s.substring(i + 1).trim(), !(!t || n[t] && $u[t]) && (t === "set-cookie" ? n[t] ? n[t].push(o) : n[t] = [o] : n[t] = n[t] ? n[t] + ", " + o : o);
  }), n;
}, br = Symbol("internals");
function Kn(e) {
  return e && String(e).trim().toLowerCase();
}
function oo(e) {
  return e === !1 || e == null ? e : S.isArray(e) ? e.map(oo) : String(e);
}
function zu(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = t.exec(e); )
    n[o[1]] = o[2];
  return n;
}
const Yu = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Go(e, n, t, o, i) {
  if (S.isFunction(o))
    return o.call(this, n, t);
  if (i && (n = t), !!S.isString(n)) {
    if (S.isString(o))
      return n.indexOf(o) !== -1;
    if (S.isRegExp(o))
      return o.test(n);
  }
}
function Wu(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, o) => t.toUpperCase() + o);
}
function Xu(e, n) {
  const t = S.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + t, {
      value: function(i, r, s) {
        return this[o].call(this, n, i, r, s);
      },
      configurable: !0
    });
  });
}
let Je = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, o) {
    const i = this;
    function r(a, u, d) {
      const f = Kn(u);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const y = S.findKey(i, f);
      (!y || i[y] === void 0 || d === !0 || d === void 0 && i[y] !== !1) && (i[y || u] = oo(a));
    }
    const s = (a, u) => S.forEach(a, (d, f) => r(d, f, u));
    if (S.isPlainObject(n) || n instanceof this.constructor)
      s(n, t);
    else if (S.isString(n) && (n = n.trim()) && !Yu(n))
      s(Ju(n), t);
    else if (S.isObject(n) && S.isIterable(n)) {
      let a = {}, u, d;
      for (const f of n) {
        if (!S.isArray(f))
          throw TypeError("Object iterator must return a key-value pair");
        a[d = f[0]] = (u = a[d]) ? S.isArray(u) ? [...u, f[1]] : [u, f[1]] : f[1];
      }
      s(a, t);
    } else
      n != null && r(t, n, o);
    return this;
  }
  get(n, t) {
    if (n = Kn(n), n) {
      const o = S.findKey(this, n);
      if (o) {
        const i = this[o];
        if (!t)
          return i;
        if (t === !0)
          return zu(i);
        if (S.isFunction(t))
          return t.call(this, i, o);
        if (S.isRegExp(t))
          return t.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = Kn(n), n) {
      const o = S.findKey(this, n);
      return !!(o && this[o] !== void 0 && (!t || Go(this, this[o], o, t)));
    }
    return !1;
  }
  delete(n, t) {
    const o = this;
    let i = !1;
    function r(s) {
      if (s = Kn(s), s) {
        const a = S.findKey(o, s);
        a && (!t || Go(o, o[a], a, t)) && (delete o[a], i = !0);
      }
    }
    return S.isArray(n) ? n.forEach(r) : r(n), i;
  }
  clear(n) {
    const t = Object.keys(this);
    let o = t.length, i = !1;
    for (; o--; ) {
      const r = t[o];
      (!n || Go(this, this[r], r, n, !0)) && (delete this[r], i = !0);
    }
    return i;
  }
  normalize(n) {
    const t = this, o = {};
    return S.forEach(this, (i, r) => {
      const s = S.findKey(o, r);
      if (s) {
        t[s] = oo(i), delete t[r];
        return;
      }
      const a = n ? Wu(r) : String(r).trim();
      a !== r && delete t[r], t[a] = oo(i), o[a] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return S.forEach(this, (o, i) => {
      o != null && o !== !1 && (t[i] = n && S.isArray(o) ? o.join(", ") : o);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const o = new this(n);
    return t.forEach((i) => o.set(i)), o;
  }
  static accessor(n) {
    const o = (this[br] = this[br] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function r(s) {
      const a = Kn(s);
      o[a] || (Xu(i, s), o[a] = !0);
    }
    return S.isArray(n) ? n.forEach(r) : r(n), this;
  }
};
Je.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
S.reduceDescriptors(Je.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(o) {
      this[t] = o;
    }
  };
});
S.freezeMethods(Je);
function Qo(e, n) {
  const t = this || Ln, o = n || t, i = Je.from(o.headers);
  let r = o.data;
  return S.forEach(e, function(a) {
    r = a.call(t, r, i.normalize(), n ? n.status : void 0);
  }), i.normalize(), r;
}
function Qs(e) {
  return !!(e && e.__CANCEL__);
}
function cn(e, n, t) {
  ce.call(this, e ?? "canceled", ce.ERR_CANCELED, n, t), this.name = "CanceledError";
}
S.inherits(cn, ce, {
  __CANCEL__: !0
});
function $s(e, n, t) {
  const o = t.config.validateStatus;
  !t.status || !o || o(t.status) ? e(t) : n(new ce(
    "Request failed with status code " + t.status,
    [ce.ERR_BAD_REQUEST, ce.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function Zu(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function ed(e, n) {
  e = e || 10;
  const t = new Array(e), o = new Array(e);
  let i = 0, r = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const d = Date.now(), f = o[r];
    s || (s = d), t[i] = u, o[i] = d;
    let y = r, C = 0;
    for (; y !== i; )
      C += t[y++], y = y % e;
    if (i = (i + 1) % e, i === r && (r = (r + 1) % e), d - s < n)
      return;
    const U = f && d - f;
    return U ? Math.round(C * 1e3 / U) : void 0;
  };
}
function td(e, n) {
  let t = 0, o = 1e3 / n, i, r;
  const s = (d, f = Date.now()) => {
    t = f, i = null, r && (clearTimeout(r), r = null), e(...d);
  };
  return [(...d) => {
    const f = Date.now(), y = f - t;
    y >= o ? s(d, f) : (i = d, r || (r = setTimeout(() => {
      r = null, s(i);
    }, o - y)));
  }, () => i && s(i)];
}
const Ao = (e, n, t = 3) => {
  let o = 0;
  const i = ed(50, 250);
  return td((r) => {
    const s = r.loaded, a = r.lengthComputable ? r.total : void 0, u = s - o, d = i(u), f = s <= a;
    o = s;
    const y = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: u,
      rate: d || void 0,
      estimated: d && a && f ? (a - s) / d : void 0,
      event: r,
      lengthComputable: a != null,
      [n ? "download" : "upload"]: !0
    };
    e(y);
  }, t);
}, Cr = (e, n) => {
  const t = e != null;
  return [(o) => n[0]({
    lengthComputable: t,
    total: e,
    loaded: o
  }), n[1]];
}, wr = (e) => (...n) => S.asap(() => e(...n)), nd = qe.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, qe.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(qe.origin),
  qe.navigator && /(msie|trident)/i.test(qe.navigator.userAgent)
) : () => !0, od = qe.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, o, i, r) {
      const s = [e + "=" + encodeURIComponent(n)];
      S.isNumber(t) && s.push("expires=" + new Date(t).toGMTString()), S.isString(o) && s.push("path=" + o), S.isString(i) && s.push("domain=" + i), r === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function id(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function rd(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Js(e, n, t) {
  let o = !id(n);
  return e && (o || t == !1) ? rd(e, n) : n;
}
const Fr = (e) => e instanceof Je ? { ...e } : e;
function qt(e, n) {
  n = n || {};
  const t = {};
  function o(d, f, y, C) {
    return S.isPlainObject(d) && S.isPlainObject(f) ? S.merge.call({ caseless: C }, d, f) : S.isPlainObject(f) ? S.merge({}, f) : S.isArray(f) ? f.slice() : f;
  }
  function i(d, f, y, C) {
    if (S.isUndefined(f)) {
      if (!S.isUndefined(d))
        return o(void 0, d, y, C);
    } else return o(d, f, y, C);
  }
  function r(d, f) {
    if (!S.isUndefined(f))
      return o(void 0, f);
  }
  function s(d, f) {
    if (S.isUndefined(f)) {
      if (!S.isUndefined(d))
        return o(void 0, d);
    } else return o(void 0, f);
  }
  function a(d, f, y) {
    if (y in n)
      return o(d, f);
    if (y in e)
      return o(void 0, d);
  }
  const u = {
    url: r,
    method: r,
    data: r,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (d, f, y) => i(Fr(d), Fr(f), y, !0)
  };
  return S.forEach(Object.keys({ ...e, ...n }), function(f) {
    const y = u[f] || i, C = y(e[f], n[f], f);
    S.isUndefined(C) && y !== a || (t[f] = C);
  }), t;
}
const zs = (e) => {
  const n = qt({}, e);
  let { data: t, withXSRFToken: o, xsrfHeaderName: i, xsrfCookieName: r, headers: s, auth: a } = n;
  if (n.headers = s = Je.from(s), n.url = js(Js(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  ), S.isFormData(t)) {
    if (qe.hasStandardBrowserEnv || qe.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (S.isFunction(t.getHeaders)) {
      const u = t.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(u).forEach(([f, y]) => {
        d.includes(f.toLowerCase()) && s.set(f, y);
      });
    }
  }
  if (qe.hasStandardBrowserEnv && (o && S.isFunction(o) && (o = o(n)), o || o !== !1 && nd(n.url))) {
    const u = i && r && od.read(r);
    u && s.set(i, u);
  }
  return n;
}, sd = typeof XMLHttpRequest < "u", ad = sd && function(e) {
  return new Promise(function(t, o) {
    const i = zs(e);
    let r = i.data;
    const s = Je.from(i.headers).normalize();
    let { responseType: a, onUploadProgress: u, onDownloadProgress: d } = i, f, y, C, U, g;
    function A() {
      U && U(), g && g(), i.cancelToken && i.cancelToken.unsubscribe(f), i.signal && i.signal.removeEventListener("abort", f);
    }
    let w = new XMLHttpRequest();
    w.open(i.method.toUpperCase(), i.url, !0), w.timeout = i.timeout;
    function M() {
      if (!w)
        return;
      const B = Je.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), x = {
        data: !a || a === "text" || a === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: B,
        config: e,
        request: w
      };
      $s(function(Y) {
        t(Y), A();
      }, function(Y) {
        o(Y), A();
      }, x), w = null;
    }
    "onloadend" in w ? w.onloadend = M : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(M);
    }, w.onabort = function() {
      w && (o(new ce("Request aborted", ce.ECONNABORTED, e, w)), w = null);
    }, w.onerror = function(N) {
      const x = N && N.message ? N.message : "Network Error", q = new ce(x, ce.ERR_NETWORK, e, w);
      q.event = N || null, o(q), w = null;
    }, w.ontimeout = function() {
      let N = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const x = i.transitional || Hs;
      i.timeoutErrorMessage && (N = i.timeoutErrorMessage), o(new ce(
        N,
        x.clarifyTimeoutError ? ce.ETIMEDOUT : ce.ECONNABORTED,
        e,
        w
      )), w = null;
    }, r === void 0 && s.setContentType(null), "setRequestHeader" in w && S.forEach(s.toJSON(), function(N, x) {
      w.setRequestHeader(x, N);
    }), S.isUndefined(i.withCredentials) || (w.withCredentials = !!i.withCredentials), a && a !== "json" && (w.responseType = i.responseType), d && ([C, g] = Ao(d, !0), w.addEventListener("progress", C)), u && w.upload && ([y, U] = Ao(u), w.upload.addEventListener("progress", y), w.upload.addEventListener("loadend", U)), (i.cancelToken || i.signal) && (f = (B) => {
      w && (o(!B || B.type ? new cn(null, e, w) : B), w.abort(), w = null);
    }, i.cancelToken && i.cancelToken.subscribe(f), i.signal && (i.signal.aborted ? f() : i.signal.addEventListener("abort", f)));
    const L = Zu(i.url);
    if (L && qe.protocols.indexOf(L) === -1) {
      o(new ce("Unsupported protocol " + L + ":", ce.ERR_BAD_REQUEST, e));
      return;
    }
    w.send(r || null);
  });
}, ld = (e, n) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (n || t) {
    let o = new AbortController(), i;
    const r = function(d) {
      if (!i) {
        i = !0, a();
        const f = d instanceof Error ? d : this.reason;
        o.abort(f instanceof ce ? f : new cn(f instanceof Error ? f.message : f));
      }
    };
    let s = n && setTimeout(() => {
      s = null, r(new ce(`timeout ${n} of ms exceeded`, ce.ETIMEDOUT));
    }, n);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(r) : d.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", r));
    const { signal: u } = o;
    return u.unsubscribe = () => S.asap(a), u;
  }
}, ud = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let o = 0, i;
  for (; o < t; )
    i = o + n, yield e.slice(o, i), o = i;
}, dd = async function* (e, n) {
  for await (const t of cd(e))
    yield* ud(t, n);
}, cd = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: o } = await n.read();
      if (t)
        break;
      yield o;
    }
  } finally {
    await n.cancel();
  }
}, Rr = (e, n, t, o) => {
  const i = dd(e, n);
  let r = 0, s, a = (u) => {
    s || (s = !0, o && o(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: d, value: f } = await i.next();
        if (d) {
          a(), u.close();
          return;
        }
        let y = f.byteLength;
        if (t) {
          let C = r += y;
          t(C);
        }
        u.enqueue(new Uint8Array(f));
      } catch (d) {
        throw a(d), d;
      }
    },
    cancel(u) {
      return a(u), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, kr = 64 * 1024, { isFunction: Yn } = S, Ys = (({ fetch: e, Request: n, Response: t }) => ({
  fetch: e,
  Request: n,
  Response: t
}))(S.global), {
  ReadableStream: Ur,
  TextEncoder: Er
} = S.global, Sr = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, fd = (e) => {
  const { fetch: n, Request: t, Response: o } = Object.assign({}, Ys, e), i = Yn(n), r = Yn(t), s = Yn(o);
  if (!i)
    return !1;
  const a = i && Yn(Ur), u = i && (typeof Er == "function" ? /* @__PURE__ */ ((g) => (A) => g.encode(A))(new Er()) : async (g) => new Uint8Array(await new t(g).arrayBuffer())), d = r && a && Sr(() => {
    let g = !1;
    const A = new t(qe.origin, {
      body: new Ur(),
      method: "POST",
      get duplex() {
        return g = !0, "half";
      }
    }).headers.has("Content-Type");
    return g && !A;
  }), f = s && a && Sr(() => S.isReadableStream(new o("").body)), y = {
    stream: f && ((g) => g.body)
  };
  i && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((g) => {
    !y[g] && (y[g] = (A, w) => {
      let M = A && A[g];
      if (M)
        return M.call(A);
      throw new ce(`Response type '${g}' is not supported`, ce.ERR_NOT_SUPPORT, w);
    });
  });
  const C = async (g) => {
    if (g == null)
      return 0;
    if (S.isBlob(g))
      return g.size;
    if (S.isSpecCompliantForm(g))
      return (await new t(qe.origin, {
        method: "POST",
        body: g
      }).arrayBuffer()).byteLength;
    if (S.isArrayBufferView(g) || S.isArrayBuffer(g))
      return g.byteLength;
    if (S.isURLSearchParams(g) && (g = g + ""), S.isString(g))
      return (await u(g)).byteLength;
  }, U = async (g, A) => {
    const w = S.toFiniteNumber(g.getContentLength());
    return w ?? C(A);
  };
  return async (g) => {
    let {
      url: A,
      method: w,
      data: M,
      signal: L,
      cancelToken: B,
      timeout: N,
      onDownloadProgress: x,
      onUploadProgress: q,
      responseType: Y,
      headers: $,
      withCredentials: Q = "same-origin",
      fetchOptions: ee
    } = zs(g);
    Y = Y ? (Y + "").toLowerCase() : "text";
    let te = ld([L, B && B.toAbortSignal()], N), le = null;
    const V = te && te.unsubscribe && (() => {
      te.unsubscribe();
    });
    let Se;
    try {
      if (q && d && w !== "get" && w !== "head" && (Se = await U($, M)) !== 0) {
        let se = new t(A, {
          method: "POST",
          body: M,
          duplex: "half"
        }), Ie;
        if (S.isFormData(M) && (Ie = se.headers.get("content-type")) && $.setContentType(Ie), se.body) {
          const [Pe, Le] = Cr(
            Se,
            Ao(wr(q))
          );
          M = Rr(se.body, kr, Pe, Le);
        }
      }
      S.isString(Q) || (Q = Q ? "include" : "omit");
      const k = r && "credentials" in t.prototype, P = {
        ...ee,
        signal: te,
        method: w.toUpperCase(),
        headers: $.normalize().toJSON(),
        body: M,
        duplex: "half",
        credentials: k ? Q : void 0
      };
      le = r && new t(A, P);
      let W = await (r ? n(le, ee) : n(A, P));
      const he = f && (Y === "stream" || Y === "response");
      if (f && (x || he && V)) {
        const se = {};
        ["status", "statusText", "headers"].forEach((ve) => {
          se[ve] = W[ve];
        });
        const Ie = S.toFiniteNumber(W.headers.get("content-length")), [Pe, Le] = x && Cr(
          Ie,
          Ao(wr(x), !0)
        ) || [];
        W = new o(
          Rr(W.body, kr, Pe, () => {
            Le && Le(), V && V();
          }),
          se
        );
      }
      Y = Y || "text";
      let ge = await y[S.findKey(y, Y) || "text"](W, g);
      return !he && V && V(), await new Promise((se, Ie) => {
        $s(se, Ie, {
          data: ge,
          headers: Je.from(W.headers),
          status: W.status,
          statusText: W.statusText,
          config: g,
          request: le
        });
      });
    } catch (k) {
      throw V && V(), k && k.name === "TypeError" && /Load failed|fetch/i.test(k.message) ? Object.assign(
        new ce("Network Error", ce.ERR_NETWORK, g, le),
        {
          cause: k.cause || k
        }
      ) : ce.from(k, k && k.code, g, le);
    }
  };
}, pd = /* @__PURE__ */ new Map(), Ws = (e) => {
  let n = S.merge.call({
    skipUndefined: !0
  }, Ys, e ? e.env : null);
  const { fetch: t, Request: o, Response: i } = n, r = [
    o,
    i,
    t
  ];
  let s = r.length, a = s, u, d, f = pd;
  for (; a--; )
    u = r[a], d = f.get(u), d === void 0 && f.set(u, d = a ? /* @__PURE__ */ new Map() : fd(n)), f = d;
  return d;
};
Ws();
const Ai = {
  http: Iu,
  xhr: ad,
  fetch: {
    get: Ws
  }
};
S.forEach(Ai, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Tr = (e) => `- ${e}`, hd = (e) => S.isFunction(e) || e === null || e === !1, Xs = {
  getAdapter: (e, n) => {
    e = S.isArray(e) ? e : [e];
    const { length: t } = e;
    let o, i;
    const r = {};
    for (let s = 0; s < t; s++) {
      o = e[s];
      let a;
      if (i = o, !hd(o) && (i = Ai[(a = String(o)).toLowerCase()], i === void 0))
        throw new ce(`Unknown adapter '${a}'`);
      if (i && (S.isFunction(i) || (i = i.get(n))))
        break;
      r[a || "#" + s] = i;
    }
    if (!i) {
      const s = Object.entries(r).map(
        ([u, d]) => `adapter ${u} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? s.length > 1 ? `since :
` + s.map(Tr).join(`
`) : " " + Tr(s[0]) : "as no adapter specified";
      throw new ce(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return i;
  },
  adapters: Ai
};
function $o(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new cn(null, e);
}
function Ir(e) {
  return $o(e), e.headers = Je.from(e.headers), e.data = Qo.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Xs.getAdapter(e.adapter || Ln.adapter, e)(e).then(function(o) {
    return $o(e), o.data = Qo.call(
      e,
      e.transformResponse,
      o
    ), o.headers = Je.from(o.headers), o;
  }, function(o) {
    return Qs(o) || ($o(e), o && o.response && (o.response.data = Qo.call(
      e,
      e.transformResponse,
      o.response
    ), o.response.headers = Je.from(o.response.headers))), Promise.reject(o);
  });
}
const Zs = "1.12.0", Io = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Io[e] = function(o) {
    return typeof o === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Dr = {};
Io.transitional = function(n, t, o) {
  function i(r, s) {
    return "[Axios v" + Zs + "] Transitional option '" + r + "'" + s + (o ? ". " + o : "");
  }
  return (r, s, a) => {
    if (n === !1)
      throw new ce(
        i(s, " has been removed" + (t ? " in " + t : "")),
        ce.ERR_DEPRECATED
      );
    return t && !Dr[s] && (Dr[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(r, s, a) : !0;
  };
};
Io.spelling = function(n) {
  return (t, o) => (console.warn(`${o} is likely a misspelling of ${n}`), !0);
};
function md(e, n, t) {
  if (typeof e != "object")
    throw new ce("options must be an object", ce.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let i = o.length;
  for (; i-- > 0; ) {
    const r = o[i], s = n[r];
    if (s) {
      const a = e[r], u = a === void 0 || s(a, r, e);
      if (u !== !0)
        throw new ce("option " + r + " must be " + u, ce.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new ce("Unknown option " + r, ce.ERR_BAD_OPTION);
  }
}
const io = {
  assertOptions: md,
  validators: Io
}, Ct = io.validators;
let Lt = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new vr(),
      response: new vr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (o) {
      if (o instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const r = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? r && !String(o.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + r) : o.stack = r;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = qt(this.defaults, t);
    const { transitional: o, paramsSerializer: i, headers: r } = t;
    o !== void 0 && io.assertOptions(o, {
      silentJSONParsing: Ct.transitional(Ct.boolean),
      forcedJSONParsing: Ct.transitional(Ct.boolean),
      clarifyTimeoutError: Ct.transitional(Ct.boolean)
    }, !1), i != null && (S.isFunction(i) ? t.paramsSerializer = {
      serialize: i
    } : io.assertOptions(i, {
      encode: Ct.function,
      serialize: Ct.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), io.assertOptions(t, {
      baseUrl: Ct.spelling("baseURL"),
      withXsrfToken: Ct.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let s = r && S.merge(
      r.common,
      r[t.method]
    );
    r && S.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete r[g];
      }
    ), t.headers = Je.concat(s, r);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(A) {
      typeof A.runWhen == "function" && A.runWhen(t) === !1 || (u = u && A.synchronous, a.unshift(A.fulfilled, A.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(A) {
      d.push(A.fulfilled, A.rejected);
    });
    let f, y = 0, C;
    if (!u) {
      const g = [Ir.bind(this), void 0];
      for (g.unshift(...a), g.push(...d), C = g.length, f = Promise.resolve(t); y < C; )
        f = f.then(g[y++], g[y++]);
      return f;
    }
    C = a.length;
    let U = t;
    for (y = 0; y < C; ) {
      const g = a[y++], A = a[y++];
      try {
        U = g(U);
      } catch (w) {
        A.call(this, w);
        break;
      }
    }
    try {
      f = Ir.call(this, U);
    } catch (g) {
      return Promise.reject(g);
    }
    for (y = 0, C = d.length; y < C; )
      f = f.then(d[y++], d[y++]);
    return f;
  }
  getUri(n) {
    n = qt(this.defaults, n);
    const t = Js(n.baseURL, n.url, n.allowAbsoluteUrls);
    return js(t, n.params, n.paramsSerializer);
  }
};
S.forEach(["delete", "get", "head", "options"], function(n) {
  Lt.prototype[n] = function(t, o) {
    return this.request(qt(o || {}, {
      method: n,
      url: t,
      data: (o || {}).data
    }));
  };
});
S.forEach(["post", "put", "patch"], function(n) {
  function t(o) {
    return function(r, s, a) {
      return this.request(qt(a || {}, {
        method: n,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: s
      }));
    };
  }
  Lt.prototype[n] = t(), Lt.prototype[n + "Form"] = t(!0);
});
let Ad = class ea {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(r) {
      t = r;
    });
    const o = this;
    this.promise.then((i) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](i);
      o._listeners = null;
    }), this.promise.then = (i) => {
      let r;
      const s = new Promise((a) => {
        o.subscribe(a), r = a;
      }).then(i);
      return s.cancel = function() {
        o.unsubscribe(r);
      }, s;
    }, n(function(r, s, a) {
      o.reason || (o.reason = new cn(r, s, a), t(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (o) => {
      n.abort(o);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new ea(function(i) {
        n = i;
      }),
      cancel: n
    };
  }
};
function gd(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function yd(e) {
  return S.isObject(e) && e.isAxiosError === !0;
}
const gi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(gi).forEach(([e, n]) => {
  gi[n] = e;
});
function ta(e) {
  const n = new Lt(e), t = Is(Lt.prototype.request, n);
  return S.extend(t, Lt.prototype, n, { allOwnKeys: !0 }), S.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(i) {
    return ta(qt(e, i));
  }, t;
}
const we = ta(Ln);
we.Axios = Lt;
we.CanceledError = cn;
we.CancelToken = Ad;
we.isCancel = Qs;
we.VERSION = Zs;
we.toFormData = To;
we.AxiosError = ce;
we.Cancel = we.CanceledError;
we.all = function(n) {
  return Promise.all(n);
};
we.spread = gd;
we.isAxiosError = yd;
we.mergeConfig = qt;
we.AxiosHeaders = Je;
we.formToJSON = (e) => Gs(S.isHTMLForm(e) ? new FormData(e) : e);
we.getAdapter = Xs.getAdapter;
we.HttpStatusCode = gi;
we.default = we;
const {
  Axios: u1,
  AxiosError: d1,
  CanceledError: c1,
  isCancel: f1,
  CancelToken: p1,
  VERSION: h1,
  all: m1,
  Cancel: A1,
  isAxiosError: g1,
  spread: y1,
  toFormData: K1,
  AxiosHeaders: v1,
  HttpStatusCode: b1,
  formToJSON: C1,
  getAdapter: w1,
  mergeConfig: F1
} = we, Tt = {
  CODE_0: 48,
  CODE_9: 57,
  CODE_COMMA: 44,
  CODE_PERIOD: 46,
  CODE_MINUS: 45,
  SCHEMA_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][-a-zA-Z0-9 _]{0,62}$/,
  TABLE_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][a-zA-Z0-9 _]{0,30}$/,
  COLUMN_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][a-zA-Z0-9 _]{0,62}$/,
  EMAIL_REGEX: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^$/,
  HYPERLINK_REGEX: /^((https?):\/\/)(www.)?[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%._\\+~#?&//=()]*)\/?$|^$/,
  PERIOD_REGEX: /^P(?=\d+Y|\d+M|\d+D)(\d+Y)?(\d+M)?(\d+D)?$/,
  MAX_INT: 2147483647,
  MIN_INT: -2147483648,
  MAX_LONG: "9223372036854775807",
  MIN_LONG: "-9223372036854775807",
  IS_CHAPTERS_ENABLED_FIELD_NAME: "isChaptersEnabled",
  AUTO_ID: "AUTO_ID",
  HEADING: "HEADING",
  SECTION: "SECTION"
}, na = "Level 1", oa = "Level 2", ia = "Level 3", ra = "Level 4", sa = "Custom", Kd = "PrivacyPolicyLevel", vd = "PrivacyPolicyText", bd = {
  [na]: "No privacy data",
  [oa]: "Pseudomized data",
  [ia]: "Privacy data",
  [ra]: "Privacy data + medical",
  [sa]: ""
}, Cd = {
  LEVEL_1: na,
  LEVEL_2: oa,
  LEVEL_3: ia,
  LEVEL_4: ra,
  CUSTOM: sa,
  POLICY_LEVEL_KEY: Kd,
  POLICY_TEXT_KEY: vd,
  PREFABS: bd
}, {
  EMAIL_REGEX: wd,
  HYPERLINK_REGEX: Fd,
  PERIOD_REGEX: Rd,
  AUTO_ID: kd,
  HEADING: Ud,
  SECTION: Ed,
  MIN_INT: aa,
  MAX_INT: la,
  MIN_LONG: ua,
  MAX_LONG: da
} = Tt, ca = `Invalid value: must be value from ${ua} to ${da}`, Sd = `Invalid value: must be value from ${aa} to ${la}`;
function Td(e, n) {
  return e.columns.reduce(
    (t, o) => {
      const i = Id(o, n, e);
      return i && (t[o.id] = i), t;
    },
    {}
  );
}
function Id(e, n, t) {
  const o = n == null ? void 0 : n[e.id], i = e.columnType, r = fa(o);
  try {
    if (!Vi(e, n, t))
      return;
  } catch (s) {
    return s;
  }
  if (!(e.columnType === kd || e.columnType === Ud || e.columnType === Ed)) {
    if (e.required)
      if (Nn(e.required)) {
        const s = Od(i, o);
        if (r || s)
          return e.label + " is required";
      } else {
        const s = _d(
          e.required,
          n,
          t
        );
        if (s && r)
          return s;
      }
    if (!(o === void 0 || !i.includes("_ARRAY") && r)) {
      if (i === "EMAIL" && ha(o) || i === "EMAIL_ARRAY" && Bd(o))
        return "Invalid email address";
      if (i === "HYPERLINK" && pa(o) || i === "HYPERLINK_ARRAY" && Pd(o))
        return "Invalid hyperlink";
      if (i === "PERIOD" && ma(o) || i === "PERIOD_ARRAY" && Ld(o))
        return "Invalid Period: should start with a P and should contain at least a Y(year), M(month) or D(day): e.g. 'P1Y3M14D'";
      if (i === "JSON")
        try {
          if (typeof o == "string" && !Aa(JSON.parse(o)))
            return "Root element must be an object or array";
        } catch {
          return "Please enter valid JSON";
        }
      if (i === "LONG" && Jo(o))
        return Jo(o);
      if (i === "LONG_ARRAY" && o.some((s) => Jo(s)))
        return ca;
      if (i === "DECIMAL" && isNaN(parseFloat(o)) || i === "DECIMAL_ARRAY" && o.some((s) => s && isNaN(parseFloat(s))))
        return "Invalid number";
      if (i === "INT") {
        const s = zo(o);
        if (s)
          return s;
      }
      if (i === "INT_ARRAY") {
        const s = o.find((a) => zo(a));
        if (s)
          return zo(s);
      }
      if (e.validation)
        return Md(e.validation, n, t);
    }
  }
}
function Jo(e) {
  if (Dd(e))
    return ca;
}
function Dd(e) {
  const n = /^-?\d+$/;
  return e && n.test(e) ? BigInt(e) > BigInt(da) || BigInt(e) < BigInt(ua) : !0;
}
function zo(e) {
  if (isNaN(e))
    return "Invalid number";
  if (e < aa || e > la)
    return Sd;
}
function fa(e) {
  return Array.isArray(e) ? e.some((n) => fa(n)) : e == null || e === "";
}
function Nn(e) {
  return typeof e == "string" ? e.toLowerCase() === "true" : e === !0;
}
function Od(e, n) {
  return ["DECIMAL", "INT"].includes(e) ? n === void 0 || typeof n == "number" && isNaN(n) : !1;
}
function _d(e, n, t) {
  try {
    const o = nn(e, n, t);
    return o === !0 ? `Field is required when: ${e}` : o === !1 || o === void 0 ? void 0 : o;
  } catch (o) {
    return `Invalid expression '${e}', reason: ${o}`;
  }
}
function Md(e, n, t) {
  try {
    const o = nn(e, n, t);
    return o === !1 ? `Applying validation rule returned error: ${e}` : o === !0 || o === void 0 ? void 0 : `Applying validation rule returned error: ${o}`;
  } catch (o) {
    return `Invalid validation expression '${e}', reason: ${o}`;
  }
}
function nn(e, n, t) {
  const o = xe(n);
  t.columns.forEach((s) => {
    o.hasOwnProperty(s.id) || (o[s.id] = null);
  }), o.mg_tableclass || (o.mg_tableclass = `${t.id}.${t.label}`);
  let i = function(s, a, u) {
    let d = new XMLHttpRequest();
    return d.open(
      "POST",
      u ? "/" + u + "/graphql" : "graphql",
      !1
    ), d.send(
      `{"query":"${s}", "variables":${JSON.stringify(a)}}`
    ), JSON.parse(d.responseText).data;
  };
  return new Function(
    "simplePostClient",
    //@ts-ignore
    Object.keys(o),
    "return eval(`" + e.replaceAll("`", "\\`") + "`)"
  )(i, ...Object.values(o));
}
function pa(e) {
  return e && !Fd.test(e);
}
function Pd(e) {
  return e.some((n) => pa(n));
}
function ha(e) {
  return e && !wd.test(e);
}
function Bd(e) {
  return e.some((n) => ha(n));
}
function ma(e) {
  return !Rd.test(e);
}
function Ld(e) {
  return e.some((n) => ma(n));
}
function Aa(e) {
  return typeof e == "object" && e !== null;
}
function Nd(e, n) {
  var o;
  const t = (o = e == null ? void 0 : e.columns) == null ? void 0 : o.filter((i) => i.key === 1).map((i) => i.id);
  return zd(n, (i) => !(t != null && t.includes(i)));
}
function qd(e, n) {
  return n ? e.filter((t) => n.includes(t.id)) : e;
}
function Vi(e, n, t) {
  const o = e.visible;
  if (o !== void 0)
    try {
      return nn(o, n || {}, t);
    } catch (i) {
      throw `Invalid visibility expression, reason: ${i}`;
    }
  else
    return !0;
}
function xd(e) {
  return e.reduce((n, t) => {
    var o;
    return t.columnType === "HEADING" ? n.push([t.id]) : (n.length === 0 && n.push([]), (o = n[n.length - 1]) == null || o.push(t.id)), n;
  }, []);
}
function Vd(e, n) {
  return e.filter(
    (o) => !!n[o]
  ).length ? { color: "red" } : {};
}
function jd(e) {
  const n = Object.values(e).filter(
    (t) => t
  ).length;
  return n > 0 ? `There are ${n} error(s) preventing saving` : "";
}
function Hd(e, n, t) {
  let o = xe(e);
  return n && n.forEach((i) => {
    const r = i.conditions ? i.conditions.filter(
      (s) => s !== "" && s !== void 0
    ) : [];
    r.length && (i.columnType.startsWith("STRING") || i.columnType.startsWith("TEXT") || i.columnType.startsWith("JSON") ? o[i.id] = { like: r } : i.columnType.startsWith("BOOL") ? o[i.id] = { equals: r } : i.columnType.startsWith("REF") || i.columnType.startsWith("ONTOLOGY") ? o[i.id] = { equals: r } : ["DECIMAL", "DECIMAL_ARRAY", "INT", "INT_ARRAY"].includes(
      i.columnType
    ) ? o[i.id] = {
      between: r.flat().map((s) => parseFloat(s))
    } : [
      "LONG",
      "LONG_ARRAY",
      "DATE",
      "DATE_ARRAY",
      "DATETIME",
      "DATETIME_ARRAY"
    ].includes(i.columnType) ? o[i.id] = {
      between: r.flat()
    } : t(
      `filter unsupported for column type ${i.columnType} (please report a bug)`
    ));
  }), o;
}
const { CODE_0: Gd, CODE_9: Qd, CODE_PERIOD: $d, AUTO_ID: Jd } = Tt;
function go(e) {
  return [
    "REF",
    "REF_ARRAY",
    "REFBACK",
    "ONTOLOGY",
    "ONTOLOGY_ARRAY",
    "RADIO",
    "SELECT",
    "CHECKBOX",
    "MULTISELECT"
  ].includes(e);
}
function ji(e) {
  const n = e.which ?? e.keyCode;
  return n >= Gd && n <= Qd || n === $d;
}
function on(e) {
  if (typeof e == "object") {
    let n = "";
    return Object.keys(e).forEach((t) => {
      e[t] !== null && (typeof e[t] == "object" ? n += on(e[t]) : n += " " + e[t]);
    }), n;
  } else
    return e;
}
async function Yt(e, n, t) {
  const i = await nt.newClient(t).fetchTableMetaData(n);
  if (i != null && i.columns)
    return await i.columns.reduce(
      async (r, s) => {
        let a = await r;
        const u = e[s.id];
        return s.key === 1 && (u || u === 0) && (a[s.id] = await ga(
          u,
          s,
          s.refSchemaId || t
        )), a;
      },
      Promise.resolve({})
    );
  throw new Error("Empty columns in metadata");
}
async function ga(e, n, t) {
  if (typeof e == "string" || typeof e == "number")
    return e;
  if (n.refTableId)
    return await Yt(
      e,
      n.refTableId,
      t
    );
  throw new Error("Unexpected key type");
}
function xe(e) {
  return JSON.parse(JSON.stringify(e));
}
function zd(e, n) {
  return Object.keys(e).reduce(
    (t, o) => (n(o) && (t[o] = e[o]), t),
    {}
  );
}
function Hi(e) {
  switch (e) {
    case "-":
      return "";
    case null:
      return "-";
    default:
      return e.charAt(0) === "-" ? e.substring(1) : "-" + e;
  }
}
function yo(e, n) {
  if (e == null)
    return "";
  const t = Object.keys(e), o = Object.values(e);
  try {
    const i = new Function(...t, "return `" + n + "`;")(
      ...o
    );
    if (i)
      return i;
  } catch (i) {
    console.log(
      i.message + " we got keys:" + JSON.stringify(t) + " vals:" + JSON.stringify(o) + " and template: " + n
    );
  }
  return e.hasOwnProperty("primaryKey") ? on(e.primaryKey) : e.hasOwnProperty("name") ? e.name : e.hasOwnProperty("id") ? e.id : on(e);
}
function Xt(e, n) {
  const t = Object.keys(e), o = Object.keys(n);
  if (t.length !== o.length)
    return !1;
  for (const i of t) {
    const r = e[i], s = n[i], a = Or(r) && Or(s);
    if (a && !Xt(r, s) || !a && r !== s)
      return !1;
  }
  return !0;
}
function Or(e) {
  return e !== null && typeof e == "object";
}
function ya(e, n) {
  return e == null ? void 0 : e.map((t) => n.columns.reduce((o, i) => {
    if (i.computed && i.columnType !== Jd)
      try {
        o[i.id] = nn(
          i.computed,
          t,
          n
        );
      } catch (r) {
        console.log("Computed expression failed: ", r), o[i.id] = "error: could not compute value: " + r;
      }
    else t.hasOwnProperty(i.id) && (o[i.id] = t[i.id]);
    return o;
  }, {}));
}
const Ka = async (e, n, t, o = !0) => {
  const i = await It(e);
  let r = "";
  for (const s of Yd(e, n, i.tables))
    if (t > 0 || s.key) {
      if (!o && [
        "REF_ARRAY",
        "REFBACK",
        "ONTOLOGY_ARRAY",
        "CHECKBOX",
        "MULTISELECT"
      ].includes(s.columnType))
        continue;
      [
        "REF",
        "REF_ARRAY",
        "REFBACK",
        "CHECKBOX",
        "MULTISELECT",
        "SELECT",
        "RADIO"
      ].includes(s.columnType) ? r = r + " " + s.id + " {" + await Ka(
        s.refSchemaId || e,
        s.refTableId || n,
        //indicate that sub queries should not be expanded on ref_array, refback, ontology_array
        t - 1,
        !1
      ) + " }" : ["ONTOLOGY", "ONTOLOGY_ARRAY"].includes(s.columnType) ? r = r + " " + s.id + " {name, label}" : s.columnType === "FILE" ? r += ` ${s.id} { id, size, filename, extension, url }` : ["HEADING", "SECTION"].includes(s.columnType) || (r += ` ${s.id}`);
    }
  return r;
}, Yd = (e, n, t) => {
  const o = t.find((i) => i.id === n);
  return (o == null ? void 0 : o.columns) || [];
}, va = (e) => {
  if (!FormData)
    throw "Files can only be uploaded via a browser client";
  const n = new FormData(), t = {}, o = {};
  for (const [i, r] of Object.entries(e))
    Wd(r) ? o[i] = r : t[i] = r;
  for (const [i, r] of Object.entries(o)) {
    const s = Math.random().toString(36);
    n.append(s, r), t[i] = s;
  }
  return n.append("variables", JSON.stringify({ value: [t] })), n;
}, Wd = (e) => {
  if (window && "File" in window)
    return e instanceof File;
  throw "Files can only be uploaded via a browser client";
}, bn = /* @__PURE__ */ new Map(), nt = {
  newClient: (e) => ({
    insertDataRow: ec,
    updateDataRow: tc,
    deleteRow: async (n, t) => nc(n, t, e),
    deleteAllTableData: async (n) => oc(n, e),
    fetchSchemaMetaData: async () => It(e),
    fetchTableMetaData: async (n) => {
      const t = await It(e);
      return xe(t).tables.find(
        (o) => o.id === n
      );
    },
    fetchTableData: async (n, t = {}) => {
      const o = await It(e);
      return Yo(n, t, o);
    },
    fetchTableDataValues: async (n, t = {}) => {
      const o = await It(e);
      return (await Yo(
        n,
        t,
        o
      ))[n];
    },
    fetchRowData: async (n, t, o = 2) => {
      var u;
      const i = await It(e), r = i.tables.find(
        (d) => d.id === n
      ), s = (u = r == null ? void 0 : r.columns) == null ? void 0 : u.filter((d) => d.key === 1).reduce((d, f) => (d[f.id] = { equals: t[f.id] }, d), {}), a = (await Yo(
        n,
        {
          filter: s,
          expandLevel: o
        },
        i
      ))[n];
      if (!(!a.length || a.length !== 1))
        return a[0];
    },
    fetchAggregateData: async (n, t, o, i, r, s) => {
      const a = `
        query ${n}_groupBy($filter: ${n}Filter){
          ${n}_groupBy(filter: $filter) {
            ${r} ${r === "_sum" ? `{ ${s} }` : ""},
            ${t.id} {
              ${t.column}
            },
            ${o.id} {
              ${o.column}
            }
          }
        }`;
      return Be(mt(e), a, { filter: i });
    },
    saveTableSettings: async (n) => Be(
      mt(e),
      "mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}",
      { settings: n }
    ),
    fetchSettings: async () => _r(e),
    fetchSettingValue: async (n) => {
      const o = (await _r(e)).find(
        (i) => i.key === n
      );
      if (o)
        return JSON.parse(o.value);
    },
    saveSetting: async (n, t) => {
      const o = `mutation change($settings: [MolgenisSettingsInput]) {
            change(settings: $settings) {
              message
            }
          }`, i = {
        settings: {
          key: n,
          value: JSON.stringify(t)
        }
      };
      await Be(mt(e), o, i).catch(
        (r) => {
          console.error(r);
        }
      );
    },
    clearCache: () => {
      bn.clear();
    },
    convertRowToPrimaryKey: async (n, t) => Do(n, t, e),
    fetchOntologyOptions: async (n) => ic(n, e),
    getPrimaryKeyFields: Xd
  })
};
async function Xd(e, n) {
  return It(e).then((t) => {
    const o = t.tables.find((r) => r.id === n);
    if (!o)
      throw new Error(`Table ${n} not found in schema ${e}`);
    return o.columns.filter((r) => r.key === 1).map((r) => r.id);
  });
}
const Zd = `{
  _schema {
    id,
    tables {
      id,
      name,
      label, 
      description,
      tableType,
      semantics,
      columns {
        id,
        name,
        label,
        formLabel,
        description,
        columnType,
        key,
        refTableId,
        refSchemaId,
        refLinkId,
        refLabel,
        refLabelDefault,
        refBackId,
        required,
        defaultValue,
        readonly,
        semantics,
        position,
        computed,
        visible,
        validation
      }
      settings { 
        key,
        value 
      }
    }
  }
}`, mt = (e) => e ? "/" + e + "/graphql" : "graphql", ec = (e, n, t) => {
  const o = va(e), i = `mutation insert($value:[${n}Input]){insert(${n}:$value){message}}`;
  return o.append("query", i), we.post(mt(t), o);
}, tc = (e, n, t) => {
  const o = va(e), i = `mutation update($value:[${n}Input]){update(${n}:$value){message}}`;
  return o.append("query", i), we.post(mt(t), o);
}, nc = async (e, n, t) => {
  const o = `mutation delete($pkey:[${n}Input]){delete(${n}:$pkey){message}}`, r = { pkey: [await Do(e, n, t)] };
  return we.post(mt(t), { query: o, variables: r });
}, oc = (e, n) => {
  const t = `mutation {truncate(tables:"${e}" async:true){taskId message}}`;
  return we.post(mt(n), { query: t });
}, It = async (e) => {
  const n = e || "CACHE_OF_CURRENT_SCHEMA";
  if (bn.has(n))
    return bn.get(n);
  const t = we.post(mt(e), { query: Zd }).then((o) => {
    const i = o.data.data._schema;
    return xe(i);
  }).catch((o) => {
    throw console.log(o), bn.delete(n), o;
  });
  return bn.set(n, t), t;
}, Yo = async (e, n, t) => {
  const o = n.limit ? n.limit : 20, i = n.offset ? n.offset : 0, r = n.expandLevel ?? 2, s = n.searchTerms ? ',search:"' + n.searchTerms.trim() + '"' : "", a = t.id, u = await Ka(a, e, r), d = `query ${e}( $filter:${e}Filter, $orderby:${e}orderby ) {
        ${e}(
          filter:$filter,
          limit:${o}, 
          offset:${i}${s},
          orderby:$orderby
          )
          {
            ${u}
          }
          ${e}_agg( filter:$filter${s} ) {
            count
          }
        }`, f = n.filter ? n.filter : {}, y = n.orderby ? n.orderby : {}, C = await we.post(mt(a), {
    query: d,
    variables: { filter: f, orderby: y }
  }).catch((U) => {
    throw console.log(U), U;
  });
  return C == null ? void 0 : C.data.data;
}, ic = async (e, n) => {
  const t = `query ${e} {
        ${e}(
          limit:100000
          orderby: { order: ASC }
          )
          {
          	order 
            name 
            label 
            parent { order name label } 
            children { order name label parent { name } } 
          }
        }`, o = await we.post(mt(n), {
    query: t
  }).catch((i) => {
    throw console.log(i), i;
  });
  return o == null ? void 0 : o.data.data[e];
}, _r = async (e) => (await Be(mt(e), "{_settings{key, value}}"))._settings, Be = async (e, n, t) => {
  const o = { query: n };
  return t && (o.variables = t), we.post(e, o).then((i) => {
    var r;
    return (r = i == null ? void 0 : i.data) == null ? void 0 : r.data;
  }).catch((i) => {
    var s, a, u;
    throw ((u = (a = (s = i.response) == null ? void 0 : s.data) == null ? void 0 : a.errors) == null ? void 0 : u.map((d) => d.message).join(". ")) || i.message;
  });
};
async function Do(e, n, t) {
  const o = await It(t), i = o.tables.find(
    (r) => r.id === n
  );
  if (i != null && i.columns)
    return await i.columns.reduce(
      async (r, s) => {
        let a = await r;
        const u = e[s.id];
        return s.key === 1 && (u || u === 0) && (a[s.id] = await ga(
          u,
          s,
          s.refSchemaId || o.id
        )), a;
      },
      Promise.resolve({})
    );
  throw new Error("Empty columns in metadata");
}
const Gi = JSON, rc = (e) => e.toUpperCase(), sc = (e) => {
  const n = {};
  return e.forEach((t, o) => {
    n[o] = t;
  }), n;
}, ac = (e, n, t) => e.document ? e : {
  document: e,
  variables: n,
  requestHeaders: t,
  signal: void 0
}, lc = (e, n, t) => e.query ? e : {
  query: e,
  variables: n,
  requestHeaders: t,
  signal: void 0
}, uc = (e, n) => e.documents ? e : {
  documents: e,
  requestHeaders: n,
  signal: void 0
}, dc = (e, n, ...t) => {
  const [o, i] = t;
  return e.document ? e : {
    url: e,
    document: n,
    variables: o,
    requestHeaders: i,
    signal: void 0
  };
};
function ro(e, n) {
  if (!!!e)
    throw new Error(n);
}
function cc(e) {
  return typeof e == "object" && e !== null;
}
function fc(e, n) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const pc = /\r\n|[\n\r]/g;
function yi(e, n) {
  let t = 0, o = 1;
  for (const i of e.body.matchAll(pc)) {
    if (typeof i.index == "number" || fc(!1), i.index >= n)
      break;
    t = i.index + i[0].length, o += 1;
  }
  return {
    line: o,
    column: n + 1 - t
  };
}
function hc(e) {
  return ba(
    e.source,
    yi(e.source, e.start)
  );
}
function ba(e, n) {
  const t = e.locationOffset.column - 1, o = "".padStart(t) + e.body, i = n.line - 1, r = e.locationOffset.line - 1, s = n.line + r, a = n.line === 1 ? t : 0, u = n.column + a, d = `${e.name}:${s}:${u}
`, f = o.split(/\r\n|[\n\r]/g), y = f[i];
  if (y.length > 120) {
    const C = Math.floor(u / 80), U = u % 80, g = [];
    for (let A = 0; A < y.length; A += 80)
      g.push(y.slice(A, A + 80));
    return d + Mr([
      [`${s} |`, g[0]],
      ...g.slice(1, C + 1).map((A) => ["|", A]),
      ["|", "^".padStart(U)],
      ["|", g[C + 1]]
    ]);
  }
  return d + Mr([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, f[i - 1]],
    [`${s} |`, y],
    ["|", "^".padStart(u)],
    [`${s + 1} |`, f[i + 1]]
  ]);
}
function Mr(e) {
  const n = e.filter(([o, i]) => i !== void 0), t = Math.max(...n.map(([o]) => o.length));
  return n.map(([o, i]) => o.padStart(t) + (i ? " " + i : "")).join(`
`);
}
function mc(e) {
  const n = e[0];
  return n == null || "kind" in n || "length" in n ? {
    nodes: n,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : n;
}
class Qi extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(n, ...t) {
    var o, i, r;
    const { nodes: s, source: a, positions: u, path: d, originalError: f, extensions: y } = mc(t);
    super(n), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = f ?? void 0, this.nodes = Pr(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const C = Pr(
      (o = this.nodes) === null || o === void 0 ? void 0 : o.map((g) => g.loc).filter((g) => g != null)
    );
    this.source = a ?? (C == null || (i = C[0]) === null || i === void 0 ? void 0 : i.source), this.positions = u ?? (C == null ? void 0 : C.map((g) => g.start)), this.locations = u && a ? u.map((g) => yi(a, g)) : C == null ? void 0 : C.map((g) => yi(g.source, g.start));
    const U = cc(
      f == null ? void 0 : f.extensions
    ) ? f == null ? void 0 : f.extensions : void 0;
    this.extensions = (r = y ?? U) !== null && r !== void 0 ? r : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), f != null && f.stack ? Object.defineProperty(this, "stack", {
      value: f.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Qi) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let n = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (n += `

` + hc(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        n += `

` + ba(this.source, t);
    return n;
  }
  toJSON() {
    const n = {
      message: this.message
    };
    return this.locations != null && (n.locations = this.locations), this.path != null && (n.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (n.extensions = this.extensions), n;
  }
}
function Pr(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function Me(e, n, t) {
  return new Qi(`Syntax Error: ${t}`, {
    source: e,
    positions: [n]
  });
}
class Ac {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(n, t, o) {
    this.start = n.start, this.end = t.end, this.startToken = n, this.endToken = t, this.source = o;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Ca {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(n, t, o, i, r, s) {
    this.kind = n, this.start = t, this.end = o, this.line = i, this.column = r, this.value = s, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const wa = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, gc = new Set(Object.keys(wa));
function Br(e) {
  const n = e == null ? void 0 : e.kind;
  return typeof n == "string" && gc.has(n);
}
var Wt;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Wt || (Wt = {}));
var Ki;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Ki || (Ki = {}));
var re;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(re || (re = {}));
function vi(e) {
  return e === 9 || e === 32;
}
function Sn(e) {
  return e >= 48 && e <= 57;
}
function Fa(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Ra(e) {
  return Fa(e) || e === 95;
}
function yc(e) {
  return Fa(e) || Sn(e) || e === 95;
}
function Kc(e) {
  var n;
  let t = Number.MAX_SAFE_INTEGER, o = null, i = -1;
  for (let s = 0; s < e.length; ++s) {
    var r;
    const a = e[s], u = vc(a);
    u !== a.length && (o = (r = o) !== null && r !== void 0 ? r : s, i = s, s !== 0 && u < t && (t = u));
  }
  return e.map((s, a) => a === 0 ? s : s.slice(t)).slice(
    (n = o) !== null && n !== void 0 ? n : 0,
    i + 1
  );
}
function vc(e) {
  let n = 0;
  for (; n < e.length && vi(e.charCodeAt(n)); )
    ++n;
  return n;
}
function bc(e, n) {
  const t = e.replace(/"""/g, '\\"""'), o = t.split(/\r\n|[\n\r]/g), i = o.length === 1, r = o.length > 1 && o.slice(1).every((U) => U.length === 0 || vi(U.charCodeAt(0))), s = t.endsWith('\\"""'), a = e.endsWith('"') && !s, u = e.endsWith("\\"), d = a || u, f = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || r || s
  );
  let y = "";
  const C = i && vi(e.charCodeAt(0));
  return (f && !C || r) && (y += `
`), y += t, (f || d) && (y += `
`), '"""' + y + '"""';
}
var O;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(O || (O = {}));
class Cc {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(n) {
    const t = new Ca(O.SOF, 0, 0, 0, 0);
    this.source = n, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let n = this.token;
    if (n.kind !== O.EOF)
      do
        if (n.next)
          n = n.next;
        else {
          const t = Fc(this, n.end);
          n.next = t, t.prev = n, n = t;
        }
      while (n.kind === O.COMMENT);
    return n;
  }
}
function wc(e) {
  return e === O.BANG || e === O.DOLLAR || e === O.AMP || e === O.PAREN_L || e === O.PAREN_R || e === O.DOT || e === O.SPREAD || e === O.COLON || e === O.EQUALS || e === O.AT || e === O.BRACKET_L || e === O.BRACKET_R || e === O.BRACE_L || e === O.PIPE || e === O.BRACE_R;
}
function fn(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Oo(e, n) {
  return ka(e.charCodeAt(n)) && Ua(e.charCodeAt(n + 1));
}
function ka(e) {
  return e >= 55296 && e <= 56319;
}
function Ua(e) {
  return e >= 56320 && e <= 57343;
}
function xt(e, n) {
  const t = e.source.body.codePointAt(n);
  if (t === void 0)
    return O.EOF;
  if (t >= 32 && t <= 126) {
    const o = String.fromCodePoint(t);
    return o === '"' ? `'"'` : `"${o}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function _e(e, n, t, o, i) {
  const r = e.line, s = 1 + t - e.lineStart;
  return new Ca(n, t, o, r, s, i);
}
function Fc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n;
  for (; i < o; ) {
    const r = t.charCodeAt(i);
    switch (r) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        t.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return Rc(e, i);
      case 33:
        return _e(e, O.BANG, i, i + 1);
      case 36:
        return _e(e, O.DOLLAR, i, i + 1);
      case 38:
        return _e(e, O.AMP, i, i + 1);
      case 40:
        return _e(e, O.PAREN_L, i, i + 1);
      case 41:
        return _e(e, O.PAREN_R, i, i + 1);
      case 46:
        if (t.charCodeAt(i + 1) === 46 && t.charCodeAt(i + 2) === 46)
          return _e(e, O.SPREAD, i, i + 3);
        break;
      case 58:
        return _e(e, O.COLON, i, i + 1);
      case 61:
        return _e(e, O.EQUALS, i, i + 1);
      case 64:
        return _e(e, O.AT, i, i + 1);
      case 91:
        return _e(e, O.BRACKET_L, i, i + 1);
      case 93:
        return _e(e, O.BRACKET_R, i, i + 1);
      case 123:
        return _e(e, O.BRACE_L, i, i + 1);
      case 124:
        return _e(e, O.PIPE, i, i + 1);
      case 125:
        return _e(e, O.BRACE_R, i, i + 1);
      case 34:
        return t.charCodeAt(i + 1) === 34 && t.charCodeAt(i + 2) === 34 ? Ic(e, i) : Uc(e, i);
    }
    if (Sn(r) || r === 45)
      return kc(e, i, r);
    if (Ra(r))
      return Dc(e, i);
    throw Me(
      e.source,
      i,
      r === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : fn(r) || Oo(t, i) ? `Unexpected character: ${xt(e, i)}.` : `Invalid character: ${xt(e, i)}.`
    );
  }
  return _e(e, O.EOF, o, o);
}
function Rc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n + 1;
  for (; i < o; ) {
    const r = t.charCodeAt(i);
    if (r === 10 || r === 13)
      break;
    if (fn(r))
      ++i;
    else if (Oo(t, i))
      i += 2;
    else
      break;
  }
  return _e(
    e,
    O.COMMENT,
    n,
    i,
    t.slice(n + 1, i)
  );
}
function kc(e, n, t) {
  const o = e.source.body;
  let i = n, r = t, s = !1;
  if (r === 45 && (r = o.charCodeAt(++i)), r === 48) {
    if (r = o.charCodeAt(++i), Sn(r))
      throw Me(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${xt(
          e,
          i
        )}.`
      );
  } else
    i = Wo(e, i, r), r = o.charCodeAt(i);
  if (r === 46 && (s = !0, r = o.charCodeAt(++i), i = Wo(e, i, r), r = o.charCodeAt(i)), (r === 69 || r === 101) && (s = !0, r = o.charCodeAt(++i), (r === 43 || r === 45) && (r = o.charCodeAt(++i)), i = Wo(e, i, r), r = o.charCodeAt(i)), r === 46 || Ra(r))
    throw Me(
      e.source,
      i,
      `Invalid number, expected digit but got: ${xt(
        e,
        i
      )}.`
    );
  return _e(
    e,
    s ? O.FLOAT : O.INT,
    n,
    i,
    o.slice(n, i)
  );
}
function Wo(e, n, t) {
  if (!Sn(t))
    throw Me(
      e.source,
      n,
      `Invalid number, expected digit but got: ${xt(
        e,
        n
      )}.`
    );
  const o = e.source.body;
  let i = n + 1;
  for (; Sn(o.charCodeAt(i)); )
    ++i;
  return i;
}
function Uc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n + 1, r = i, s = "";
  for (; i < o; ) {
    const a = t.charCodeAt(i);
    if (a === 34)
      return s += t.slice(r, i), _e(e, O.STRING, n, i + 1, s);
    if (a === 92) {
      s += t.slice(r, i);
      const u = t.charCodeAt(i + 1) === 117 ? t.charCodeAt(i + 2) === 123 ? Ec(e, i) : Sc(e, i) : Tc(e, i);
      s += u.value, i += u.size, r = i;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (fn(a))
      ++i;
    else if (Oo(t, i))
      i += 2;
    else
      throw Me(
        e.source,
        i,
        `Invalid character within String: ${xt(
          e,
          i
        )}.`
      );
  }
  throw Me(e.source, i, "Unterminated string.");
}
function Ec(e, n) {
  const t = e.source.body;
  let o = 0, i = 3;
  for (; i < 12; ) {
    const r = t.charCodeAt(n + i++);
    if (r === 125) {
      if (i < 5 || !fn(o))
        break;
      return {
        value: String.fromCodePoint(o),
        size: i
      };
    }
    if (o = o << 4 | Cn(r), o < 0)
      break;
  }
  throw Me(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${t.slice(
      n,
      n + i
    )}".`
  );
}
function Sc(e, n) {
  const t = e.source.body, o = Lr(t, n + 2);
  if (fn(o))
    return {
      value: String.fromCodePoint(o),
      size: 6
    };
  if (ka(o) && t.charCodeAt(n + 6) === 92 && t.charCodeAt(n + 7) === 117) {
    const i = Lr(t, n + 8);
    if (Ua(i))
      return {
        value: String.fromCodePoint(o, i),
        size: 12
      };
  }
  throw Me(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${t.slice(n, n + 6)}".`
  );
}
function Lr(e, n) {
  return Cn(e.charCodeAt(n)) << 12 | Cn(e.charCodeAt(n + 1)) << 8 | Cn(e.charCodeAt(n + 2)) << 4 | Cn(e.charCodeAt(n + 3));
}
function Cn(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Tc(e, n) {
  const t = e.source.body;
  switch (t.charCodeAt(n + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw Me(
    e.source,
    n,
    `Invalid character escape sequence: "${t.slice(
      n,
      n + 2
    )}".`
  );
}
function Ic(e, n) {
  const t = e.source.body, o = t.length;
  let i = e.lineStart, r = n + 3, s = r, a = "";
  const u = [];
  for (; r < o; ) {
    const d = t.charCodeAt(r);
    if (d === 34 && t.charCodeAt(r + 1) === 34 && t.charCodeAt(r + 2) === 34) {
      a += t.slice(s, r), u.push(a);
      const f = _e(
        e,
        O.BLOCK_STRING,
        n,
        r + 3,
        // Return a string of the lines joined with U+000A.
        Kc(u).join(`
`)
      );
      return e.line += u.length - 1, e.lineStart = i, f;
    }
    if (d === 92 && t.charCodeAt(r + 1) === 34 && t.charCodeAt(r + 2) === 34 && t.charCodeAt(r + 3) === 34) {
      a += t.slice(s, r), s = r + 1, r += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      a += t.slice(s, r), u.push(a), d === 13 && t.charCodeAt(r + 1) === 10 ? r += 2 : ++r, a = "", s = r, i = r;
      continue;
    }
    if (fn(d))
      ++r;
    else if (Oo(t, r))
      r += 2;
    else
      throw Me(
        e.source,
        r,
        `Invalid character within String: ${xt(
          e,
          r
        )}.`
      );
  }
  throw Me(e.source, r, "Unterminated string.");
}
function Dc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n + 1;
  for (; i < o; ) {
    const r = t.charCodeAt(i);
    if (yc(r))
      ++i;
    else
      break;
  }
  return _e(
    e,
    O.NAME,
    n,
    i,
    t.slice(n, i)
  );
}
const Oc = 10, Ea = 2;
function $i(e) {
  return _o(e, []);
}
function _o(e, n) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return _c(e, n);
    default:
      return String(e);
  }
}
function _c(e, n) {
  if (e === null)
    return "null";
  if (n.includes(e))
    return "[Circular]";
  const t = [...n, e];
  if (Mc(e)) {
    const o = e.toJSON();
    if (o !== e)
      return typeof o == "string" ? o : _o(o, t);
  } else if (Array.isArray(e))
    return Bc(e, t);
  return Pc(e, t);
}
function Mc(e) {
  return typeof e.toJSON == "function";
}
function Pc(e, n) {
  const t = Object.entries(e);
  return t.length === 0 ? "{}" : n.length > Ea ? "[" + Lc(e) + "]" : "{ " + t.map(
    ([i, r]) => i + ": " + _o(r, n)
  ).join(", ") + " }";
}
function Bc(e, n) {
  if (e.length === 0)
    return "[]";
  if (n.length > Ea)
    return "[Array]";
  const t = Math.min(Oc, e.length), o = e.length - t, i = [];
  for (let r = 0; r < t; ++r)
    i.push(_o(e[r], n));
  return o === 1 ? i.push("... 1 more item") : o > 1 && i.push(`... ${o} more items`), "[" + i.join(", ") + "]";
}
function Lc(e) {
  const n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (n === "Object" && typeof e.constructor == "function") {
    const t = e.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return n;
}
const Nc = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", qc = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  Nc ? function(n, t) {
    return n instanceof t;
  } : function(n, t) {
    if (n instanceof t)
      return !0;
    if (typeof n == "object" && n !== null) {
      var o;
      const i = t.prototype[Symbol.toStringTag], r = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in n ? n[Symbol.toStringTag] : (o = n.constructor) === null || o === void 0 ? void 0 : o.name
      );
      if (i === r) {
        const s = $i(n);
        throw new Error(`Cannot use ${i} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Sa {
  constructor(n, t = "GraphQL request", o = {
    line: 1,
    column: 1
  }) {
    typeof n == "string" || ro(!1, `Body must be a string. Received: ${$i(n)}.`), this.body = n, this.name = t, this.locationOffset = o, this.locationOffset.line > 0 || ro(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || ro(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function xc(e) {
  return qc(e, Sa);
}
function Vc(e, n) {
  const t = new jc(e, n), o = t.parseDocument();
  return Object.defineProperty(o, "tokenCount", {
    enumerable: !1,
    value: t.tokenCount
  }), o;
}
class jc {
  constructor(n, t = {}) {
    const { lexer: o, ...i } = t;
    if (o)
      this._lexer = o;
    else {
      const r = xc(n) ? n : new Sa(n);
      this._lexer = new Cc(r);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const n = this.expectToken(O.NAME);
    return this.node(n, {
      kind: re.NAME,
      value: n.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: re.DOCUMENT,
      definitions: this.many(
        O.SOF,
        this.parseDefinition,
        O.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(O.BRACE_L))
      return this.parseOperationDefinition();
    const n = this.peekDescription(), t = n ? this._lexer.lookahead() : this._lexer.token;
    if (n && t.kind === O.BRACE_L)
      throw Me(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (t.kind === O.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (n)
        throw Me(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      switch (t.value) {
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const n = this._lexer.token;
    if (this.peek(O.BRACE_L))
      return this.node(n, {
        kind: re.OPERATION_DEFINITION,
        operation: Wt.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseDescription(), o = this.parseOperationType();
    let i;
    return this.peek(O.NAME) && (i = this.parseName()), this.node(n, {
      kind: re.OPERATION_DEFINITION,
      operation: o,
      description: t,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const n = this.expectToken(O.NAME);
    switch (n.value) {
      case "query":
        return Wt.QUERY;
      case "mutation":
        return Wt.MUTATION;
      case "subscription":
        return Wt.SUBSCRIPTION;
    }
    throw this.unexpected(n);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      O.PAREN_L,
      this.parseVariableDefinition,
      O.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: re.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(O.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(O.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const n = this._lexer.token;
    return this.expectToken(O.DOLLAR), this.node(n, {
      kind: re.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: re.SELECTION_SET,
      selections: this.many(
        O.BRACE_L,
        this.parseSelection,
        O.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(O.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const n = this._lexer.token, t = this.parseName();
    let o, i;
    return this.expectOptionalToken(O.COLON) ? (o = t, i = this.parseName()) : i = t, this.node(n, {
      kind: re.FIELD,
      alias: o,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(O.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(n) {
    const t = n ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(O.PAREN_L, t, O.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(n = !1) {
    const t = this._lexer.token, o = this.parseName();
    return this.expectToken(O.COLON), this.node(t, {
      kind: re.ARGUMENT,
      name: o,
      value: this.parseValueLiteral(n)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const n = this._lexer.token;
    this.expectToken(O.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(O.NAME) ? this.node(n, {
      kind: re.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(n, {
      kind: re.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(n, {
      kind: re.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(n, {
      kind: re.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(n) {
    const t = this._lexer.token;
    switch (t.kind) {
      case O.BRACKET_L:
        return this.parseList(n);
      case O.BRACE_L:
        return this.parseObject(n);
      case O.INT:
        return this.advanceLexer(), this.node(t, {
          kind: re.INT,
          value: t.value
        });
      case O.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: re.FLOAT,
          value: t.value
        });
      case O.STRING:
      case O.BLOCK_STRING:
        return this.parseStringLiteral();
      case O.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: re.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: re.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: re.NULL
            });
          default:
            return this.node(t, {
              kind: re.ENUM,
              value: t.value
            });
        }
      case O.DOLLAR:
        if (n)
          if (this.expectToken(O.DOLLAR), this._lexer.token.kind === O.NAME) {
            const o = this._lexer.token.value;
            throw Me(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${o}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const n = this._lexer.token;
    return this.advanceLexer(), this.node(n, {
      kind: re.STRING,
      value: n.value,
      block: n.kind === O.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(n) {
    const t = () => this.parseValueLiteral(n);
    return this.node(this._lexer.token, {
      kind: re.LIST,
      values: this.any(O.BRACKET_L, t, O.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(n) {
    const t = () => this.parseObjectField(n);
    return this.node(this._lexer.token, {
      kind: re.OBJECT,
      fields: this.any(O.BRACE_L, t, O.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(n) {
    const t = this._lexer.token, o = this.parseName();
    return this.expectToken(O.COLON), this.node(t, {
      kind: re.OBJECT_FIELD,
      name: o,
      value: this.parseValueLiteral(n)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(n) {
    const t = [];
    for (; this.peek(O.AT); )
      t.push(this.parseDirective(n));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(n) {
    const t = this._lexer.token;
    return this.expectToken(O.AT), this.node(t, {
      kind: re.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(n)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const n = this._lexer.token;
    let t;
    if (this.expectOptionalToken(O.BRACKET_L)) {
      const o = this.parseTypeReference();
      this.expectToken(O.BRACKET_R), t = this.node(n, {
        kind: re.LIST_TYPE,
        type: o
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(O.BANG) ? this.node(n, {
      kind: re.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: re.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(O.STRING) || this.peek(O.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const o = this.parseConstDirectives(), i = this.many(
      O.BRACE_L,
      this.parseOperationTypeDefinition,
      O.BRACE_R
    );
    return this.node(n, {
      kind: re.SCHEMA_DEFINITION,
      description: t,
      directives: o,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const n = this._lexer.token, t = this.parseOperationType();
    this.expectToken(O.COLON);
    const o = this.parseNamedType();
    return this.node(n, {
      kind: re.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: o
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const o = this.parseName(), i = this.parseConstDirectives();
    return this.node(n, {
      kind: re.SCALAR_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const o = this.parseName(), i = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(n, {
      kind: re.OBJECT_TYPE_DEFINITION,
      description: t,
      name: o,
      interfaces: i,
      directives: r,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(O.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      O.BRACE_L,
      this.parseFieldDefinition,
      O.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const n = this._lexer.token, t = this.parseDescription(), o = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(O.COLON);
    const r = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(n, {
      kind: re.FIELD_DEFINITION,
      description: t,
      name: o,
      arguments: i,
      type: r,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      O.PAREN_L,
      this.parseInputValueDef,
      O.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const n = this._lexer.token, t = this.parseDescription(), o = this.parseName();
    this.expectToken(O.COLON);
    const i = this.parseTypeReference();
    let r;
    this.expectOptionalToken(O.EQUALS) && (r = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(n, {
      kind: re.INPUT_VALUE_DEFINITION,
      description: t,
      name: o,
      type: i,
      defaultValue: r,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const o = this.parseName(), i = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(n, {
      kind: re.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: o,
      interfaces: i,
      directives: r,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const o = this.parseName(), i = this.parseConstDirectives(), r = this.parseUnionMemberTypes();
    return this.node(n, {
      kind: re.UNION_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i,
      types: r
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(O.EQUALS) ? this.delimitedMany(O.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const o = this.parseName(), i = this.parseConstDirectives(), r = this.parseEnumValuesDefinition();
    return this.node(n, {
      kind: re.ENUM_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i,
      values: r
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      O.BRACE_L,
      this.parseEnumValueDefinition,
      O.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const n = this._lexer.token, t = this.parseDescription(), o = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(n, {
      kind: re.ENUM_VALUE_DEFINITION,
      description: t,
      name: o,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw Me(
        this._lexer.source,
        this._lexer.token.start,
        `${Wn(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const o = this.parseName(), i = this.parseConstDirectives(), r = this.parseInputFieldsDefinition();
    return this.node(n, {
      kind: re.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i,
      fields: r
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      O.BRACE_L,
      this.parseInputValueDef,
      O.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const n = this._lexer.lookahead();
    if (n.kind === O.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(n);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), o = this.optionalMany(
      O.BRACE_L,
      this.parseOperationTypeDefinition,
      O.BRACE_R
    );
    if (t.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: o
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), o = this.parseConstDirectives();
    if (o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: o
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), o = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (o.length === 0 && i.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: o,
      directives: i,
      fields: r
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), o = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (o.length === 0 && i.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: o,
      directives: i,
      fields: r
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), o = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.UNION_TYPE_EXTENSION,
      name: t,
      directives: o,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), o = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.ENUM_TYPE_EXTENSION,
      name: t,
      directives: o,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), o = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: re.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: o,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(O.AT);
    const o = this.parseName(), i = this.parseArgumentDefs(), r = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const s = this.parseDirectiveLocations();
    return this.node(n, {
      kind: re.DIRECTIVE_DEFINITION,
      description: t,
      name: o,
      arguments: i,
      repeatable: r,
      locations: s
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(O.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const n = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Ki, t.value))
      return t;
    throw this.unexpected(n);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const n = this._lexer.token, t = this.expectOptionalToken(O.AT), o = this.parseName();
    let i;
    !t && this.expectOptionalToken(O.DOT) && (i = this.parseName());
    let r;
    return (t || i) && this.expectOptionalToken(O.PAREN_L) && (r = this.parseName(), this.expectToken(O.COLON), this.expectToken(O.PAREN_R)), t ? r ? this.node(n, {
      kind: re.DIRECTIVE_ARGUMENT_COORDINATE,
      name: o,
      argumentName: r
    }) : this.node(n, {
      kind: re.DIRECTIVE_COORDINATE,
      name: o
    }) : i ? r ? this.node(n, {
      kind: re.ARGUMENT_COORDINATE,
      name: o,
      fieldName: i,
      argumentName: r
    }) : this.node(n, {
      kind: re.MEMBER_COORDINATE,
      name: o,
      memberName: i
    }) : this.node(n, {
      kind: re.TYPE_COORDINATE,
      name: o
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(n, t) {
    return this._options.noLocation !== !0 && (t.loc = new Ac(
      n,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(n) {
    return this._lexer.token.kind === n;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(n) {
    const t = this._lexer.token;
    if (t.kind === n)
      return this.advanceLexer(), t;
    throw Me(
      this._lexer.source,
      t.start,
      `Expected ${Ta(n)}, found ${Wn(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(n) {
    return this._lexer.token.kind === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(n) {
    const t = this._lexer.token;
    if (t.kind === O.NAME && t.value === n)
      this.advanceLexer();
    else
      throw Me(
        this._lexer.source,
        t.start,
        `Expected "${n}", found ${Wn(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(n) {
    const t = this._lexer.token;
    return t.kind === O.NAME && t.value === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(n) {
    const t = n ?? this._lexer.token;
    return Me(
      this._lexer.source,
      t.start,
      `Unexpected ${Wn(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(n, t, o) {
    this.expectToken(n);
    const i = [];
    for (; !this.expectOptionalToken(o); )
      i.push(t.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(n, t, o) {
    if (this.expectOptionalToken(n)) {
      const i = [];
      do
        i.push(t.call(this));
      while (!this.expectOptionalToken(o));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(n, t, o) {
    this.expectToken(n);
    const i = [];
    do
      i.push(t.call(this));
    while (!this.expectOptionalToken(o));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(n, t) {
    this.expectOptionalToken(n);
    const o = [];
    do
      o.push(t.call(this));
    while (this.expectOptionalToken(n));
    return o;
  }
  advanceLexer() {
    const { maxTokens: n } = this._options, t = this._lexer.advance();
    if (t.kind !== O.EOF && (++this._tokenCounter, n !== void 0 && this._tokenCounter > n))
      throw Me(
        this._lexer.source,
        t.start,
        `Document contains more that ${n} tokens. Parsing aborted.`
      );
  }
}
function Wn(e) {
  const n = e.value;
  return Ta(e.kind) + (n != null ? ` "${n}"` : "");
}
function Ta(e) {
  return wc(e) ? `"${e}"` : e;
}
function Hc(e) {
  return `"${e.replace(Gc, Qc)}"`;
}
const Gc = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Qc(e) {
  return $c[e.charCodeAt(0)];
}
const $c = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Jc = Object.freeze({});
function zc(e, n, t = wa) {
  const o = /* @__PURE__ */ new Map();
  for (const M of Object.values(re))
    o.set(M, Yc(n, M));
  let i, r = Array.isArray(e), s = [e], a = -1, u = [], d = e, f, y;
  const C = [], U = [];
  do {
    a++;
    const M = a === s.length, L = M && u.length !== 0;
    if (M) {
      if (f = U.length === 0 ? void 0 : C[C.length - 1], d = y, y = U.pop(), L)
        if (r) {
          d = d.slice();
          let N = 0;
          for (const [x, q] of u) {
            const Y = x - N;
            q === null ? (d.splice(Y, 1), N++) : d[Y] = q;
          }
        } else {
          d = { ...d };
          for (const [N, x] of u)
            d[N] = x;
        }
      a = i.index, s = i.keys, u = i.edits, r = i.inArray, i = i.prev;
    } else if (y) {
      if (f = r ? a : s[a], d = y[f], d == null)
        continue;
      C.push(f);
    }
    let B;
    if (!Array.isArray(d)) {
      var g, A;
      Br(d) || ro(!1, `Invalid AST Node: ${$i(d)}.`);
      const N = M ? (g = o.get(d.kind)) === null || g === void 0 ? void 0 : g.leave : (A = o.get(d.kind)) === null || A === void 0 ? void 0 : A.enter;
      if (B = N == null ? void 0 : N.call(n, d, f, y, C, U), B === Jc)
        break;
      if (B === !1) {
        if (!M) {
          C.pop();
          continue;
        }
      } else if (B !== void 0 && (u.push([f, B]), !M))
        if (Br(B))
          d = B;
        else {
          C.pop();
          continue;
        }
    }
    if (B === void 0 && L && u.push([f, d]), M)
      C.pop();
    else {
      var w;
      i = {
        inArray: r,
        index: a,
        keys: s,
        edits: u,
        prev: i
      }, r = Array.isArray(d), s = r ? d : (w = t[d.kind]) !== null && w !== void 0 ? w : [], a = -1, u = [], y && U.push(y), y = d;
    }
  } while (i !== void 0);
  return u.length !== 0 ? u[u.length - 1][1] : e;
}
function Yc(e, n) {
  const t = e[n];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function Wc(e) {
  return zc(e, Zc);
}
const Xc = 80, Zc = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => z(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const n = Xo(e.variableDefinitions) ? de(`(
`, z(e.variableDefinitions, `
`), `
)`) : de("(", z(e.variableDefinitions, ", "), ")"), t = de("", e.description, `
`) + z(
        [
          e.operation,
          z([e.name, n]),
          z(e.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: n, defaultValue: t, directives: o, description: i }) => de("", i, `
`) + e + ": " + n + de(" = ", t) + de(" ", z(o, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => ht(e)
  },
  Field: {
    leave({ alias: e, name: n, arguments: t, directives: o, selectionSet: i }) {
      const r = de("", e, ": ") + n;
      let s = r + de("(", z(t, ", "), ")");
      return s.length > Xc && (s = r + de(`(
`, so(z(t, `
`)), `
)`)), z([s, z(o, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: n }) => "..." + e + de(" ", z(n, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: n, selectionSet: t }) => z(
      [
        "...",
        de("on ", e),
        z(n, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: n,
      variableDefinitions: t,
      directives: o,
      selectionSet: i,
      description: r
    }) => de("", r, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${de("(", z(t, ", "), ")")} on ${n} ${de("", z(o, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: n }) => n ? bc(e) : Hc(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + z(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + z(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: n }) => "@" + e + de("(", z(n, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: n, operationTypes: t }) => de("", e, `
`) + z(["schema", z(n, " "), ht(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: n }) => e + ": " + n
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: n, directives: t }) => de("", e, `
`) + z(["scalar", n, z(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: t, directives: o, fields: i }) => de("", e, `
`) + z(
      [
        "type",
        n,
        de("implements ", z(t, " & ")),
        z(o, " "),
        ht(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: n, arguments: t, type: o, directives: i }) => de("", e, `
`) + n + (Xo(t) ? de(`(
`, so(z(t, `
`)), `
)`) : de("(", z(t, ", "), ")")) + ": " + o + de(" ", z(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: n, type: t, defaultValue: o, directives: i }) => de("", e, `
`) + z(
      [n + ": " + t, de("= ", o), z(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: t, directives: o, fields: i }) => de("", e, `
`) + z(
      [
        "interface",
        n,
        de("implements ", z(t, " & ")),
        z(o, " "),
        ht(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, types: o }) => de("", e, `
`) + z(
      ["union", n, z(t, " "), de("= ", z(o, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, values: o }) => de("", e, `
`) + z(["enum", n, z(t, " "), ht(o)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: n, directives: t }) => de("", e, `
`) + z([n, z(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, fields: o }) => de("", e, `
`) + z(["input", n, z(t, " "), ht(o)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: n, arguments: t, repeatable: o, locations: i }) => de("", e, `
`) + "directive @" + n + (Xo(t) ? de(`(
`, so(z(t, `
`)), `
)`) : de("(", z(t, ", "), ")")) + (o ? " repeatable" : "") + " on " + z(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: n }) => z(
      ["extend schema", z(e, " "), ht(n)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: n }) => z(["extend scalar", e, z(n, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: t, fields: o }) => z(
      [
        "extend type",
        e,
        de("implements ", z(n, " & ")),
        z(t, " "),
        ht(o)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: t, fields: o }) => z(
      [
        "extend interface",
        e,
        de("implements ", z(n, " & ")),
        z(t, " "),
        ht(o)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: n, types: t }) => z(
      [
        "extend union",
        e,
        z(n, " "),
        de("= ", z(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: n, values: t }) => z(["extend enum", e, z(n, " "), ht(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: n, fields: t }) => z(["extend input", e, z(n, " "), ht(t)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: n }) => z([e, de(".", n)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: n, argumentName: t }) => z([e, de(".", n), de("(", t, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => z(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: n }) => z(["@", e, de("(", n, ":)")])
  }
};
function z(e, n = "") {
  var t;
  return (t = e == null ? void 0 : e.filter((o) => o).join(n)) !== null && t !== void 0 ? t : "";
}
function ht(e) {
  return de(`{
`, so(z(e, `
`)), `
}`);
}
function de(e, n, t = "") {
  return n != null && n !== "" ? e + n + t : "";
}
function so(e) {
  return de("  ", e.replace(/\n/g, `
  `));
}
function Xo(e) {
  var n;
  return (n = e == null ? void 0 : e.some((t) => t.includes(`
`))) !== null && n !== void 0 ? n : !1;
}
const Nr = (e) => {
  var o, i;
  let n;
  const t = e.definitions.filter((r) => r.kind === "OperationDefinition");
  return t.length === 1 && (n = (i = (o = t[0]) == null ? void 0 : o.name) == null ? void 0 : i.value), n;
}, Zo = (e) => {
  if (typeof e == "string") {
    let t;
    try {
      const o = Vc(e);
      t = Nr(o);
    } catch {
    }
    return { query: e, operationName: t };
  }
  const n = Nr(e);
  return { query: Wc(e), operationName: n };
};
class Fn extends Error {
  constructor(n, t) {
    const o = `${Fn.extractMessage(n)}: ${JSON.stringify({
      response: n,
      request: t
    })}`;
    super(o), Object.setPrototypeOf(this, Fn.prototype), this.response = n, this.request = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Fn);
  }
  static extractMessage(n) {
    var t, o;
    return ((o = (t = n.errors) == null ? void 0 : t[0]) == null ? void 0 : o.message) ?? `GraphQL Error (Code: ${n.status})`;
  }
}
var wn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ia(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bi = { exports: {} };
(function(e, n) {
  var t = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof wn < "u" && wn, o = function() {
    function r() {
      this.fetch = !1, this.DOMException = t.DOMException;
    }
    return r.prototype = t, new r();
  }();
  (function(r) {
    (function(s) {
      var a = typeof r < "u" && r || typeof self < "u" && self || // eslint-disable-next-line no-undef
      typeof wn < "u" && wn || {}, u = {
        searchParams: "URLSearchParams" in a,
        iterable: "Symbol" in a && "iterator" in Symbol,
        blob: "FileReader" in a && "Blob" in a && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in a,
        arrayBuffer: "ArrayBuffer" in a
      };
      function d(k) {
        return k && DataView.prototype.isPrototypeOf(k);
      }
      if (u.arrayBuffer)
        var f = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], y = ArrayBuffer.isView || function(k) {
          return k && f.indexOf(Object.prototype.toString.call(k)) > -1;
        };
      function C(k) {
        if (typeof k != "string" && (k = String(k)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(k) || k === "")
          throw new TypeError('Invalid character in header field name: "' + k + '"');
        return k.toLowerCase();
      }
      function U(k) {
        return typeof k != "string" && (k = String(k)), k;
      }
      function g(k) {
        var P = {
          next: function() {
            var W = k.shift();
            return { done: W === void 0, value: W };
          }
        };
        return u.iterable && (P[Symbol.iterator] = function() {
          return P;
        }), P;
      }
      function A(k) {
        this.map = {}, k instanceof A ? k.forEach(function(P, W) {
          this.append(W, P);
        }, this) : Array.isArray(k) ? k.forEach(function(P) {
          if (P.length != 2)
            throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + P.length);
          this.append(P[0], P[1]);
        }, this) : k && Object.getOwnPropertyNames(k).forEach(function(P) {
          this.append(P, k[P]);
        }, this);
      }
      A.prototype.append = function(k, P) {
        k = C(k), P = U(P);
        var W = this.map[k];
        this.map[k] = W ? W + ", " + P : P;
      }, A.prototype.delete = function(k) {
        delete this.map[C(k)];
      }, A.prototype.get = function(k) {
        return k = C(k), this.has(k) ? this.map[k] : null;
      }, A.prototype.has = function(k) {
        return this.map.hasOwnProperty(C(k));
      }, A.prototype.set = function(k, P) {
        this.map[C(k)] = U(P);
      }, A.prototype.forEach = function(k, P) {
        for (var W in this.map)
          this.map.hasOwnProperty(W) && k.call(P, this.map[W], W, this);
      }, A.prototype.keys = function() {
        var k = [];
        return this.forEach(function(P, W) {
          k.push(W);
        }), g(k);
      }, A.prototype.values = function() {
        var k = [];
        return this.forEach(function(P) {
          k.push(P);
        }), g(k);
      }, A.prototype.entries = function() {
        var k = [];
        return this.forEach(function(P, W) {
          k.push([W, P]);
        }), g(k);
      }, u.iterable && (A.prototype[Symbol.iterator] = A.prototype.entries);
      function w(k) {
        if (!k._noBody) {
          if (k.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          k.bodyUsed = !0;
        }
      }
      function M(k) {
        return new Promise(function(P, W) {
          k.onload = function() {
            P(k.result);
          }, k.onerror = function() {
            W(k.error);
          };
        });
      }
      function L(k) {
        var P = new FileReader(), W = M(P);
        return P.readAsArrayBuffer(k), W;
      }
      function B(k) {
        var P = new FileReader(), W = M(P), he = /charset=([A-Za-z0-9_-]+)/.exec(k.type), ge = he ? he[1] : "utf-8";
        return P.readAsText(k, ge), W;
      }
      function N(k) {
        for (var P = new Uint8Array(k), W = new Array(P.length), he = 0; he < P.length; he++)
          W[he] = String.fromCharCode(P[he]);
        return W.join("");
      }
      function x(k) {
        if (k.slice)
          return k.slice(0);
        var P = new Uint8Array(k.byteLength);
        return P.set(new Uint8Array(k)), P.buffer;
      }
      function q() {
        return this.bodyUsed = !1, this._initBody = function(k) {
          this.bodyUsed = this.bodyUsed, this._bodyInit = k, k ? typeof k == "string" ? this._bodyText = k : u.blob && Blob.prototype.isPrototypeOf(k) ? this._bodyBlob = k : u.formData && FormData.prototype.isPrototypeOf(k) ? this._bodyFormData = k : u.searchParams && URLSearchParams.prototype.isPrototypeOf(k) ? this._bodyText = k.toString() : u.arrayBuffer && u.blob && d(k) ? (this._bodyArrayBuffer = x(k.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(k) || y(k)) ? this._bodyArrayBuffer = x(k) : this._bodyText = k = Object.prototype.toString.call(k) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof k == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(k) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, u.blob && (this.blob = function() {
          var k = w(this);
          if (k)
            return k;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }), this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var k = w(this);
            return k || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            ) : Promise.resolve(this._bodyArrayBuffer));
          } else {
            if (u.blob)
              return this.blob().then(L);
            throw new Error("could not read as ArrayBuffer");
          }
        }, this.text = function() {
          var k = w(this);
          if (k)
            return k;
          if (this._bodyBlob)
            return B(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(N(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, u.formData && (this.formData = function() {
          return this.text().then(ee);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var Y = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
      function $(k) {
        var P = k.toUpperCase();
        return Y.indexOf(P) > -1 ? P : k;
      }
      function Q(k, P) {
        if (!(this instanceof Q))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        P = P || {};
        var W = P.body;
        if (k instanceof Q) {
          if (k.bodyUsed)
            throw new TypeError("Already read");
          this.url = k.url, this.credentials = k.credentials, P.headers || (this.headers = new A(k.headers)), this.method = k.method, this.mode = k.mode, this.signal = k.signal, !W && k._bodyInit != null && (W = k._bodyInit, k.bodyUsed = !0);
        } else
          this.url = String(k);
        if (this.credentials = P.credentials || this.credentials || "same-origin", (P.headers || !this.headers) && (this.headers = new A(P.headers)), this.method = $(P.method || this.method || "GET"), this.mode = P.mode || this.mode || null, this.signal = P.signal || this.signal || function() {
          if ("AbortController" in a) {
            var se = new AbortController();
            return se.signal;
          }
        }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && W)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(W), (this.method === "GET" || this.method === "HEAD") && (P.cache === "no-store" || P.cache === "no-cache")) {
          var he = /([?&])_=[^&]*/;
          if (he.test(this.url))
            this.url = this.url.replace(he, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
          else {
            var ge = /\?/;
            this.url += (ge.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
          }
        }
      }
      Q.prototype.clone = function() {
        return new Q(this, { body: this._bodyInit });
      };
      function ee(k) {
        var P = new FormData();
        return k.trim().split("&").forEach(function(W) {
          if (W) {
            var he = W.split("="), ge = he.shift().replace(/\+/g, " "), se = he.join("=").replace(/\+/g, " ");
            P.append(decodeURIComponent(ge), decodeURIComponent(se));
          }
        }), P;
      }
      function te(k) {
        var P = new A(), W = k.replace(/\r?\n[\t ]+/g, " ");
        return W.split("\r").map(function(he) {
          return he.indexOf(`
`) === 0 ? he.substr(1, he.length) : he;
        }).forEach(function(he) {
          var ge = he.split(":"), se = ge.shift().trim();
          if (se) {
            var Ie = ge.join(":").trim();
            try {
              P.append(se, Ie);
            } catch (Pe) {
              console.warn("Response " + Pe.message);
            }
          }
        }), P;
      }
      q.call(Q.prototype);
      function le(k, P) {
        if (!(this instanceof le))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (P || (P = {}), this.type = "default", this.status = P.status === void 0 ? 200 : P.status, this.status < 200 || this.status > 599)
          throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300, this.statusText = P.statusText === void 0 ? "" : "" + P.statusText, this.headers = new A(P.headers), this.url = P.url || "", this._initBody(k);
      }
      q.call(le.prototype), le.prototype.clone = function() {
        return new le(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new A(this.headers),
          url: this.url
        });
      }, le.error = function() {
        var k = new le(null, { status: 200, statusText: "" });
        return k.ok = !1, k.status = 0, k.type = "error", k;
      };
      var V = [301, 302, 303, 307, 308];
      le.redirect = function(k, P) {
        if (V.indexOf(P) === -1)
          throw new RangeError("Invalid status code");
        return new le(null, { status: P, headers: { location: k } });
      }, s.DOMException = a.DOMException;
      try {
        new s.DOMException();
      } catch {
        s.DOMException = function(P, W) {
          this.message = P, this.name = W;
          var he = Error(P);
          this.stack = he.stack;
        }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
      }
      function Se(k, P) {
        return new Promise(function(W, he) {
          var ge = new Q(k, P);
          if (ge.signal && ge.signal.aborted)
            return he(new s.DOMException("Aborted", "AbortError"));
          var se = new XMLHttpRequest();
          function Ie() {
            se.abort();
          }
          se.onload = function() {
            var ve = {
              statusText: se.statusText,
              headers: te(se.getAllResponseHeaders() || "")
            };
            ge.url.indexOf("file://") === 0 && (se.status < 200 || se.status > 599) ? ve.status = 200 : ve.status = se.status, ve.url = "responseURL" in se ? se.responseURL : ve.headers.get("X-Request-URL");
            var Ue = "response" in se ? se.response : se.responseText;
            setTimeout(function() {
              W(new le(Ue, ve));
            }, 0);
          }, se.onerror = function() {
            setTimeout(function() {
              he(new TypeError("Network request failed"));
            }, 0);
          }, se.ontimeout = function() {
            setTimeout(function() {
              he(new TypeError("Network request timed out"));
            }, 0);
          }, se.onabort = function() {
            setTimeout(function() {
              he(new s.DOMException("Aborted", "AbortError"));
            }, 0);
          };
          function Pe(ve) {
            try {
              return ve === "" && a.location.href ? a.location.href : ve;
            } catch {
              return ve;
            }
          }
          if (se.open(ge.method, Pe(ge.url), !0), ge.credentials === "include" ? se.withCredentials = !0 : ge.credentials === "omit" && (se.withCredentials = !1), "responseType" in se && (u.blob ? se.responseType = "blob" : u.arrayBuffer && (se.responseType = "arraybuffer")), P && typeof P.headers == "object" && !(P.headers instanceof A || a.Headers && P.headers instanceof a.Headers)) {
            var Le = [];
            Object.getOwnPropertyNames(P.headers).forEach(function(ve) {
              Le.push(C(ve)), se.setRequestHeader(ve, U(P.headers[ve]));
            }), ge.headers.forEach(function(ve, Ue) {
              Le.indexOf(Ue) === -1 && se.setRequestHeader(Ue, ve);
            });
          } else
            ge.headers.forEach(function(ve, Ue) {
              se.setRequestHeader(Ue, ve);
            });
          ge.signal && (ge.signal.addEventListener("abort", Ie), se.onreadystatechange = function() {
            se.readyState === 4 && ge.signal.removeEventListener("abort", Ie);
          }), se.send(typeof ge._bodyInit > "u" ? null : ge._bodyInit);
        });
      }
      return Se.polyfill = !0, a.fetch || (a.fetch = Se, a.Headers = A, a.Request = Q, a.Response = le), s.Headers = A, s.Request = Q, s.Response = le, s.fetch = Se, Object.defineProperty(s, "__esModule", { value: !0 }), s;
    })({});
  })(o), o.fetch.ponyfill = !0, delete o.fetch.polyfill;
  var i = t.fetch ? t : o;
  n = i.fetch, n.default = i.fetch, n.fetch = i.fetch, n.Headers = i.Headers, n.Request = i.Request, n.Response = i.Response, e.exports = n;
})(bi, bi.exports);
var Ko = bi.exports;
const ao = /* @__PURE__ */ Ia(Ko), ef = /* @__PURE__ */ Gl({
  __proto__: null,
  default: ao
}, [Ko]), zt = (e) => {
  let n = {};
  return e && (typeof Headers < "u" && e instanceof Headers || ef && Ko.Headers && e instanceof Ko.Headers ? n = sc(e) : Array.isArray(e) ? e.forEach(([t, o]) => {
    t && o !== void 0 && (n[t] = o);
  }) : n = e), n;
}, qr = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), tf = (e) => {
  if (!Array.isArray(e.query)) {
    const o = e, i = [`query=${encodeURIComponent(qr(o.query))}`];
    return e.variables && i.push(`variables=${encodeURIComponent(o.jsonSerializer.stringify(o.variables))}`), o.operationName && i.push(`operationName=${encodeURIComponent(o.operationName)}`), i.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const n = e, t = e.query.reduce((o, i, r) => (o.push({
    query: qr(i),
    variables: n.variables ? n.jsonSerializer.stringify(n.variables[r]) : void 0
  }), o), []);
  return `query=${encodeURIComponent(n.jsonSerializer.stringify(t))}`;
}, nf = (e) => async (n) => {
  const { url: t, query: o, variables: i, operationName: r, fetch: s, fetchOptions: a, middleware: u } = n, d = { ...n.headers };
  let f = "", y;
  e === "POST" ? (y = rf(o, i, r, a.jsonSerializer), typeof y == "string" && (d["Content-Type"] = "application/json")) : f = tf({
    query: o,
    variables: i,
    operationName: r,
    jsonSerializer: a.jsonSerializer ?? Gi
  });
  const C = {
    method: e,
    headers: d,
    body: y,
    ...a
  };
  let U = t, g = C;
  if (u) {
    const A = await Promise.resolve(u({ ...C, url: t, operationName: r, variables: i })), { url: w, ...M } = A;
    U = w, g = M;
  }
  return f && (U = `${U}?${f}`), await s(U, g);
};
class of {
  constructor(n, t = {}) {
    this.url = n, this.requestConfig = t, this.rawRequest = async (...o) => {
      const [i, r, s] = o, a = lc(i, r, s), { headers: u, fetch: d = ao, method: f = "POST", requestMiddleware: y, responseMiddleware: C, ...U } = this.requestConfig, { url: g } = this;
      a.signal !== void 0 && (U.signal = a.signal);
      const { operationName: A } = Zo(a.query);
      return ei({
        url: g,
        query: a.query,
        variables: a.variables,
        headers: {
          ...zt(ni(u)),
          ...zt(a.requestHeaders)
        },
        operationName: A,
        fetch: d,
        method: f,
        fetchOptions: U,
        middleware: y
      }).then((w) => (C && C(w), w)).catch((w) => {
        throw C && C(w), w;
      });
    };
  }
  async request(n, ...t) {
    const [o, i] = t, r = ac(n, o, i), { headers: s, fetch: a = ao, method: u = "POST", requestMiddleware: d, responseMiddleware: f, ...y } = this.requestConfig, { url: C } = this;
    r.signal !== void 0 && (y.signal = r.signal);
    const { query: U, operationName: g } = Zo(r.document);
    return ei({
      url: C,
      query: U,
      variables: r.variables,
      headers: {
        ...zt(ni(s)),
        ...zt(r.requestHeaders)
      },
      operationName: g,
      fetch: a,
      method: u,
      fetchOptions: y,
      middleware: d
    }).then((A) => (f && f(A), A.data)).catch((A) => {
      throw f && f(A), A;
    });
  }
  // prettier-ignore
  batchRequests(n, t) {
    const o = uc(n, t), { headers: i, ...r } = this.requestConfig;
    o.signal !== void 0 && (r.signal = o.signal);
    const s = o.documents.map(({ document: u }) => Zo(u).query), a = o.documents.map(({ variables: u }) => u);
    return ei({
      url: this.url,
      query: s,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: a,
      headers: {
        ...zt(ni(i)),
        ...zt(o.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? ao,
      method: this.requestConfig.method || "POST",
      fetchOptions: r,
      middleware: this.requestConfig.requestMiddleware
    }).then((u) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(u), u.data)).catch((u) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(u), u;
    });
  }
  setHeaders(n) {
    return this.requestConfig.headers = n, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(n, t) {
    const { headers: o } = this.requestConfig;
    return o ? o[n] = t : this.requestConfig.headers = { [n]: t }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(n) {
    return this.url = n, this;
  }
}
const ei = async (e) => {
  const { query: n, variables: t, fetchOptions: o } = e, i = nf(rc(e.method ?? "post")), r = Array.isArray(e.query), s = await i(e), a = await sf(s, o.jsonSerializer ?? Gi), u = Array.isArray(a) ? !a.some(({ data: f }) => !f) : !!a.data, d = Array.isArray(a) || !a.errors || Array.isArray(a.errors) && !a.errors.length || o.errorPolicy === "all" || o.errorPolicy === "ignore";
  if (s.ok && d && u) {
    const { errors: f, ...y } = (Array.isArray(a), a), C = o.errorPolicy === "ignore" ? y : a;
    return {
      ...r ? { data: C } : C,
      headers: s.headers,
      status: s.status
    };
  } else {
    const f = typeof a == "string" ? {
      error: a
    } : a;
    throw new Fn(
      // @ts-expect-error TODO
      { ...f, status: s.status, headers: s.headers },
      { query: n, variables: t }
    );
  }
};
async function ti(e, n, ...t) {
  const o = dc(e, n, ...t);
  return new of(o.url).request({
    ...o
  });
}
const rf = (e, n, t, o) => {
  const i = o ?? Gi;
  if (!Array.isArray(e))
    return i.stringify({ query: e, variables: n, operationName: t });
  if (typeof n < "u" && !Array.isArray(n))
    throw new Error("Cannot create request body with given variable type, array expected");
  const r = e.reduce((s, a, u) => (s.push({ query: a, variables: n ? n[u] : void 0 }), s), []);
  return i.stringify(r);
}, sf = async (e, n) => {
  let t;
  return e.headers.forEach((o, i) => {
    i.toLowerCase() === "content-type" && (t = o);
  }), t && (t.toLowerCase().startsWith("application/json") || t.toLowerCase().startsWith("application/graphql+json") || t.toLowerCase().startsWith("application/graphql-response+json")) ? n.parse(await e.text()) : e.text();
}, ni = (e) => typeof e == "function" ? e() : e;
class R1 {
  /**
   * @param {string} graphqlUrl the endpoint to query
   */
  constructor(n) {
    this.tableId = "", this.filters = {}, this.column = "", this._schemaTablesInformation = {}, this.selection = ["id", "name"], this.graphqlUrl = "", this.branch = "root", this.limits = {}, this.orderings = {}, this.findInAllColumns = "", this.page = {}, this.aggregateQuery = !1, this.type = "", this.orCount = 0, this.searchFieldsByProperty = {}, this.searchValue = "", this.graphqlUrl = n;
  }
  table(n) {
    return this.tableId = n, this;
  }
  /**
   * @param {string | string[]} columns
   * When you supply an object the Key is the table or REF property and the value is a string or string array
   */
  select(n) {
    let t = [];
    return Array.isArray(n) ? n ? t = this._createPathFromObject("", n) : t = this.selection : t = [n], t.forEach((o) => o.toLowerCase()), this.selection = t, this;
  }
  /**
   * Builds a query for use in EMX2 GraphQL api
   * @param {string} tableId
   * @param {string[]} columns
   * @param {object[]} filters
   * @returns GraphQL query string
   */
  async execute() {
    if (!this.tableId)
      throw Error(
        `You need to provide ${this.tableId ? "columns" : "a table id"}`
      );
    if (this.selection.length === 0) {
      const n = await this.getColumnsForTable(this.tableId);
      this.selection = n;
    }
    return await ti(
      this.graphqlUrl,
      this.aggregateQuery ? this.getAggregateQuery() : this.getQuery()
    );
  }
  /** Executes the query as aggregate */
  aggregate() {
    return this.aggregateQuery = !0, this;
  }
  getQuery() {
    return this._createQuery(this.tableId, this.selection);
  }
  getAggregateQuery() {
    const n = Object.assign([], this.selection);
    return n.push("count"), this._createQuery(`${this.tableId}_agg`, n);
  }
  /**
   * Gets the table information for the current schema
   */
  async getSchemaTablesInformation() {
    if (Object.keys(this._schemaTablesInformation).length)
      return this._schemaTablesInformation;
    const n = await ti(
      this.graphqlUrl,
      `
        {
            _schema {
              tables {
                name,
                columns {
                name,
                columnType
                }
              }
            }
          }
        `
    );
    return this._schemaTablesInformation = n._schema.tables, this._schemaTablesInformation;
  }
  async saveSetting(n, t) {
    const o = typeof t == "string" ? t : JSON.stringify(t);
    return (await ti(
      this.graphqlUrl,
      `
      mutation{
        change(
            settings: {
              key: "${n}",
              value: "${encodeURI(o)}"
            }
        ){
            message
        }
    }
      `
    )).change.message;
  }
  /** returns the columns with adjusted names so it can directly be used to query. */
  async getColumnsForTable(n) {
    return await this.getSchemaTablesInformation(), this._schemaTablesInformation.find((t) => t.id === n).columns.filter(
      (t) => !t.columnType.includes("REF") && !t.columnType.includes("ONTOLOGY")
    );
  }
  /** returns the correct column names and their types. */
  async getColumnsMetadataForTable(n) {
    return await this.getSchemaTablesInformation(), this._schemaTablesInformation.find((t) => t.id === n).columns.map((t) => ({
      id: t.id,
      columnType: t.columnType
    }));
  }
  /**
   * If you want to create a nested query, for example { collections: { name: { like: 'lifelines' } } }
   * then column = 'collections', subcolumn = 'name'
   * @param {string} columnId
   * @returns
   */
  where(n) {
    return this.type = "_and", this.branch = "root", this.column = this._toCamelCase(n), this;
  }
  orWhere(n) {
    return this.orCount = this.orCount + 1, this.type = "_or", this.branch = "root", this.column = this._toCamelCase(n), this;
  }
  /**
   * Works as where, but then for nested properties
   * @param {string} columnId
   * @returns
   */
  filter(n) {
    this.type = "_and";
    const t = n.indexOf(".");
    return this.branch = this._toCamelCase(n.substring(0, t)), this.column = this._toCamelCase(n.substring(t + 1)), this;
  }
  /**
   * Works as orWhere, but then for nested properties
   * @param {string} columnId
   * @returns
   */
  orFilter(n) {
    this.type = "_or";
    const t = n.indexOf(".");
    return this.branch = this._toCamelCase(n.substring(0, t)), this.column = this._toCamelCase(n.substring(t + 1)), this;
  }
  /** Resets all filters, useful for when you want to add filters dynamically */
  resetAllFilters() {
    return this.filters = {}, this.findInAllColumns = "", this.page = {}, this.searchFieldsByProperty = {}, this.searchValue = "", this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {int} amount the amount you want to return
   * @returns
   */
  limit(n, t) {
    let o = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : n;
    return this.limits[o] = t, this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {int} amount the page you want to have starting at 0
   * @returns
   */
  offset(n, t) {
    let o = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : n;
    return this.page[o] = t, this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {string} columnId the name of the column to apply the order to
   * @param {string} direction "asc" or "dsc"
   */
  orderBy(n, t, o) {
    let i = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : this._toCamelCase(n);
    return this.orderings[i] = { column: t, direction: o }, this;
  }
  /**
   * Additional function, which does the same as search but might be more semantic
   * @param {any} value searches this value across all columns, can only be applied to the top level table
   */
  find(n) {
    return this.findInAllColumns = n, this;
  }
  /**
   * @param {any} value searches this value across all columns, can only be applied to the top level table
   */
  search(n) {
    return this.findInAllColumns = n, this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  equals(n) {
    return this._createFilter("equals", n), this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  in(n) {
    return this._createFilter("in", n), this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  notEquals(n) {
    return this._createFilter("not_equals", n), this;
  }
  /** Text, String, Url, Filter */
  orLike(n) {
    return this._createFilter("orLike", n);
  }
  /** Text, String, Url, Filter */
  like(n) {
    return this._createFilter("like", n);
  }
  /** Text, String, Url, Filter */
  notLike(n) {
    return this._createFilter("not_like", n), this;
  }
  /** Text, String, Url, Filter */
  triagramSearch(n) {
    return this._createFilter("triagram_search", n), this;
  }
  /** Text, String, Url, Filter */
  textSearch(n) {
    return this._createFilter("text_search", n), this;
  }
  /** Int, DateTime Filter */
  between(n) {
    return this._createFilter("between", n), this;
  }
  /** Int, DateTime Filter */
  notBetween(n) {
    return this._createFilter("not_between", n), this;
  }
  _toPascalCase(n) {
    return n[0].toUpperCase() + n.substring(1);
  }
  _toCamelCase(n) {
    return n[0].toLowerCase() + n.substring(1);
  }
  _createQuery(n, t) {
    const o = this._generateModifiers("root");
    let i = `{
${n}${o} {
`, r = this._createBranches(t);
    return i = this._generateOutput(r, 1, this.filters, i), i += `  }
}`, i;
  }
  // the best query would be for example"
  // Biobanks(orderby: { name: ASC }, filter: {collections: {_and: [{materials: {name: {like: "BUFFY_COAT"}}}, {materials: {name: {like: "CELL_LINES"}}}]}})
  // but this requires another rewrite ;)
  _createFilterString(n, t) {
    let o = "";
    const i = n && n._and ? n._and.length : 0, r = n && n._or ? n._or.length : 0;
    if (i + r > 1) {
      let s = "";
      n._and.length && n._and.forEach((a) => {
        s.length && (s += ", "), s += `{ _and: [ ${a} ] }`;
      }), n._or.length && (s.length && (s += ", "), n._or.forEach((a) => {
        s.length && !s.endsWith(", ") && (s += ", "), s += `{ _or: [ ${a} ] }`;
      })), o += `_and: [ ${s} ]`;
    } else if (i === 1) {
      const s = n._and;
      o += `_and: [ ${s} ]`;
    } else if (r === 1) {
      const s = n._or;
      o += `_or: [ ${s} ]`;
    }
    if (this.searchValue && Object.keys(this.searchFieldsByProperty).includes(t) && this.searchFieldsByProperty[t].length) {
      let s = "";
      this.searchFieldsByProperty[t].forEach((a) => {
        s.length && (s += ", "), s += this.buildExpandedLike(a, this.searchValue);
      }), o = o.length ? `_and: [ { _or: [ ${s} ] } , { ${o} } ]` : `_or: [ ${s} ]`;
    }
    return o;
  }
  buildExpandedLike(n, t) {
    const o = n.split(".");
    return o.reduce((r, s) => r + `{ ${s}: `, "") + `{ like: "${t}" } }` + " }".repeat(o.length - 1);
  }
  /** Create a nested object to represent the branches and their properties */
  _createBranches(n) {
    let t = {};
    for (let o of n) {
      let i = o.split("."), r = t;
      for (let a = 0; a < i.length - 1; a++) {
        let u = this._toCamelCase(i[a].trim());
        r[u] || (r[u] = {}), r = r[u];
      }
      let s = this._toCamelCase(i[i.length - 1].trim());
      s.indexOf(".") >= 0 ? r[s] = {} : (r.properties || (r.properties = {}), r.properties[s] = !0);
    }
    return t;
  }
  /** Generate the bit inside parentheses */
  _generateModifiers(n) {
    const t = [];
    t.push(
      this.findInAllColumns.length && n === "root" ? `search: "${this.findInAllColumns}"` : ""
    ), t.push(
      this.limits[n] ? `limit: ${this.limits[n]}` : ""
    ), t.push(
      this.page[n] ? `offset: ${this.page[n]}` : ""
    ), t.push(
      this.orderings[n] ? `orderby: { ${this.orderings[n].column}: ${this.orderings[n].direction.toUpperCase()} }` : ""
    );
    const o = this._createFilterString(
      this.filters[n],
      n
    );
    o.length && t.push(`filter: { ${o} }`);
    const i = t.filter((r) => r.length > 0);
    return i.length ? `(${i.join(", ")})` : "";
  }
  _createFilterFromPath(n, t, o) {
    const i = Array.isArray(o) ? o : [o], r = this._getGqlOperator(t), s = n.split(".").reverse();
    if (this.type === "_or" && r === "equals") {
      let a = `{ ${r}: [${i.map(
        (u) => typeof u == "boolean" ? `${u}` : `"${u}"`
      )}] }`;
      for (const u of s)
        a = `{ ${u}: ${a} }`;
      this.filters[this.branch][this.type].push(a);
    } else
      for (const a of i) {
        let u = typeof a == "boolean" ? `${a}` : `"${a}"`, d = `{ ${r}: ${u} }`;
        for (const f of s)
          d = `{ ${f}: ${d} }`;
        this.filters[this.branch][this.type].push(d);
      }
  }
  _getGqlOperator(n) {
    switch (n) {
      case "in":
        return "equals";
      case "orLike":
        return "like";
      default:
        return n;
    }
  }
  /** Private function to create the correct filter syntax. */
  _createFilter(n, t) {
    return this.filters[this.branch] || (this.filters[this.branch] = {
      _and: [],
      _or: []
    }), this._createFilterFromPath(this.column, n, t), this.column = "", this;
  }
  /** Recursively generate the output string for the branches and their properties */
  _generateOutput(n, t, o, i) {
    let r = "    ".repeat(t);
    if (n.properties) {
      let s = n.properties;
      for (let a in s)
        s[a] === !0 && (i += `${r}${a},
`);
      i = `${i.substring(0, i.length - 2)}
`;
    }
    for (let s in n) {
      let a = n[s];
      if (s !== "properties") {
        i = `${i.substring(0, i.length - 1)},
`;
        const u = this._generateModifiers(s);
        i += `${r}${s}${u || ""} {
`, i = this._generateOutput(
          a,
          t + 1,
          o,
          i
        ), i += r + `}
`;
      }
    }
    return i;
  }
  _createPathFromObject(n, t, o = []) {
    for (const i of t)
      if (typeof i == "object") {
        const r = Object.keys(i)[0], s = n ? `${n}.${r}` : r;
        this._createPathFromObject(
          s,
          i[r],
          o
        );
      } else
        !n || n.length === 0 ? o.push(i) : o.push(`${n}.${i}`);
    return o;
  }
}
const D = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [o, i] of n)
    t[o] = i;
  return t;
}, af = {
  name: "ButtonAction",
  props: {
    href: { type: String, required: !1 },
    icon: { type: String, required: !1 },
    target: { type: String, required: !1 },
    disabled: { type: Boolean, required: !1 }
  },
  methods: {
    onClick() {
      window && window.open && this.href ? window.open(this.href, this.target ? this.target : "_self") : this.$emit("click");
    }
  },
  emits: ["click"]
}, lf = ["disabled"];
function uf(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: "btn btn-primary",
    disabled: t.disabled,
    onClick: n[0] || (n[0] = Ke((...s) => r.onClick && r.onClick(...s), ["prevent"]))
  }, [
    j(e.$slots, "default"),
    t.icon ? (l(), c("i", {
      key: 0,
      class: G(["fa fa-fw fa-" + t.icon, "mr-2 ml-0"])
    }, null, 2)) : v("", !0)
  ], 8, lf);
}
const He = /* @__PURE__ */ D(af, [["render", uf]]), df = {
  name: "ButtonAlt",
  extends: He,
  props: {
    light: { type: Boolean, default: !1 },
    icon: {
      type: String,
      required: !1,
      default: () => null
    }
  }
};
function cf(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: G(["btn border-0", t.light ? "btn-outline-light" : "btn-outline-primary"]),
    onClick: n[0] || (n[0] = Ke((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    j(e.$slots, "default"),
    t.icon ? (l(), c("i", {
      key: 0,
      class: G("fa fa-fw fa-" + t.icon)
    }, null, 2)) : v("", !0)
  ], 2);
}
const ot = /* @__PURE__ */ D(df, [["render", cf]]), ff = {}, pf = {
  class: "alert alert-danger",
  role: "alert"
};
function hf(e, n) {
  return l(), c("div", pf, [
    j(e.$slots, "default")
  ]);
}
const it = /* @__PURE__ */ D(ff, [["render", hf]]), mf = {}, Af = {
  class: "alert alert-success",
  role: "alert"
};
function gf(e, n) {
  return l(), c("div", Af, [
    j(e.$slots, "default")
  ]);
}
const pn = /* @__PURE__ */ D(mf, [["render", gf]]), yf = {}, Kf = {
  class: "spinner-border",
  role: "status"
};
function vf(e, n) {
  return l(), c("div", Kf, [...n[0] || (n[0] = [
    p("span", { class: "sr-only" }, "Loading...", -1)
  ])]);
}
const yt = /* @__PURE__ */ D(yf, [["render", vf]]), bf = {
  name: "LayoutModal",
  props: {
    /** When true the modal will be shown */
    show: {
      type: Boolean,
      default: !0
    },
    /** Shown as the title of the model */
    title: { type: String, default: "" },
    isCloseButtonShown: { type: Boolean, default: !0 }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    escapeKeyHandler(e) {
      e.key === "Escape" && this.close();
    }
  },
  beforeMount() {
    document && document.addEventListener && document.addEventListener("keydown", this.escapeKeyHandler);
  },
  beforeDestroy() {
    document && document.removeEventListener && document.removeEventListener("keydown", this.escapeKeyHandler);
  },
  emits: ["close"]
}, Cf = {
  key: 0,
  class: "modal fade show",
  role: "dialog",
  style: { display: "block", overflow: "scroll" },
  tabindex: "-1",
  "aria-modal": "true"
}, wf = {
  key: 0,
  class: "modal-dialog modal-xl",
  role: "document"
}, Ff = { class: "modal-content" }, Rf = { class: "modal-header" }, kf = { class: "modal-title" }, Uf = { class: "modal-body bg-light" }, Ef = { class: "modal-footer" };
function Sf(e, n, t, o, i, r) {
  return l(), c("div", null, [
    t.show ? (l(), c("div", Cf, [
      t.show ? (l(), c("div", wf, [
        p("div", Ff, [
          p("div", Rf, [
            p("h5", kf, E(t.title), 1),
            t.isCloseButtonShown ? (l(), c("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: n[0] || (n[0] = Ke((...s) => r.close && r.close(...s), ["prevent"]))
            }, [...n[1] || (n[1] = [
              p("span", { "aria-hidden": "true" }, "×", -1)
            ])])) : v("", !0)
          ]),
          p("div", Uf, [
            j(e.$slots, "body", {}, void 0, !0)
          ]),
          p("div", Ef, [
            j(e.$slots, "footer", {}, void 0, !0)
          ])
        ])
      ])) : v("", !0)
    ])) : v("", !0)
  ]);
}
const Kt = /* @__PURE__ */ D(bf, [["render", Sf], ["__scopeId", "data-v-84d87320"]]), Ce = {
  name: "BaseInput",
  props: {
    /**
     * Unique identifier https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
     * Has no direct EMX2 implementation but can be constructed by concatenating the table name with the field name
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * Name of the element. For example used by the server to identify the fields in form submits.
     * relates to EMX2 columnId
     */
    name: {
      type: String,
      required: !1
    },
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    },
    /**
     * Caption for an item in a user interface.
     * relates to EMX2 label
     */
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    /**
     * EMX2 description
     */
    description: {
      type: String,
      required: !1
    },
    required: {
      type: [Boolean, String],
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      required: !1,
      default: () => null
    }
  },
  computed: {
    placeholderValue() {
      return this.placeholder;
    }
  },
  emits: ["update:modelValue"]
}, Tf = {
  name: "FormGroup",
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !1
    },
    required: {
      type: [String, Boolean],
      required: !1,
      default: () => !1
    },
    errorMessage: {
      type: String,
      required: !1
    }
  },
  methods: {
    isRequired: Nn,
    hasDescription(e) {
      return e != null && e.length;
    }
  }
}, If = { class: "form-group" }, Df = ["for"], Of = {
  key: 1,
  class: "float-right"
}, _f = {
  key: 2,
  class: "text-danger form-text"
}, Mf = ["id"];
function Pf(e, n, t, o, i, r) {
  return l(), c("div", If, [
    t.label !== null && t.label !== void 0 ? (l(), c("label", {
      key: 0,
      for: t.id
    }, [
      p("b", null, E(t.label), 1)
    ], 8, Df)) : v("", !0),
    r.isRequired(t.required) ? (l(), c("span", Of, " (required) ")) : v("", !0),
    j(e.$slots, "default"),
    t.errorMessage ? (l(), c("small", _f, E(t.errorMessage), 1)) : v("", !0),
    r.hasDescription(t.description) ? (l(), c("small", {
      key: 3,
      id: t.id + "-help-text",
      class: "form-text text-muted"
    }, E(t.description), 9, Mf)) : v("", !0)
  ]);
}
const ke = /* @__PURE__ */ D(Tf, [["render", Pf]]), Bf = {
  name: "InputPassword",
  components: { FormGroup: ke },
  extends: Ce
}, Lf = ["id", "name", "value", "aria-describedby", "placeholder"];
function Nf(e, n, t, o, i, r) {
  const s = K("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      p("input", {
        id: e.id,
        name: e.name,
        value: e.modelValue,
        onInput: n[0] || (n[0] = (a) => e.$emit("update:modelValue", a.target.value)),
        type: "password",
        class: G(["form-control", { "is-invalid": e.errorMessage }]),
        "aria-describedby": e.id,
        placeholder: e.label
      }, null, 42, Lf)
    ]),
    _: 1
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Ji = /* @__PURE__ */ D(Bf, [["render", Nf]]);
var ze = "top", ut = "bottom", dt = "right", Ye = "left", zi = "auto", qn = [ze, ut, dt, Ye], rn = "start", Tn = "end", qf = "clippingParents", Da = "viewport", vn = "popper", xf = "reference", xr = /* @__PURE__ */ qn.reduce(function(e, n) {
  return e.concat([n + "-" + rn, n + "-" + Tn]);
}, []), Oa = /* @__PURE__ */ [].concat(qn, [zi]).reduce(function(e, n) {
  return e.concat([n, n + "-" + rn, n + "-" + Tn]);
}, []), Vf = "beforeRead", jf = "read", Hf = "afterRead", Gf = "beforeMain", Qf = "main", $f = "afterMain", Jf = "beforeWrite", zf = "write", Yf = "afterWrite", Wf = [Vf, jf, Hf, Gf, Qf, $f, Jf, zf, Yf];
function Ft(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function tt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function Vt(e) {
  var n = tt(e).Element;
  return e instanceof n || e instanceof Element;
}
function lt(e) {
  var n = tt(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function Yi(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = tt(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function Xf(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(t) {
    var o = n.styles[t] || {}, i = n.attributes[t] || {}, r = n.elements[t];
    !lt(r) || !Ft(r) || (Object.assign(r.style, o), Object.keys(i).forEach(function(s) {
      var a = i[s];
      a === !1 ? r.removeAttribute(s) : r.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function Zf(e) {
  var n = e.state, t = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow), function() {
    Object.keys(n.elements).forEach(function(o) {
      var i = n.elements[o], r = n.attributes[o] || {}, s = Object.keys(n.styles.hasOwnProperty(o) ? n.styles[o] : t[o]), a = s.reduce(function(u, d) {
        return u[d] = "", u;
      }, {});
      !lt(i) || !Ft(i) || (Object.assign(i.style, a), Object.keys(r).forEach(function(u) {
        i.removeAttribute(u);
      }));
    });
  };
}
const ep = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Xf,
  effect: Zf,
  requires: ["computeStyles"]
};
function wt(e) {
  return e.split("-")[0];
}
var Nt = Math.max, vo = Math.min, sn = Math.round;
function Ci() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function _a() {
  return !/^((?!chrome|android).)*safari/i.test(Ci());
}
function an(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  var o = e.getBoundingClientRect(), i = 1, r = 1;
  n && lt(e) && (i = e.offsetWidth > 0 && sn(o.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && sn(o.height) / e.offsetHeight || 1);
  var s = Vt(e) ? tt(e) : window, a = s.visualViewport, u = !_a() && t, d = (o.left + (u && a ? a.offsetLeft : 0)) / i, f = (o.top + (u && a ? a.offsetTop : 0)) / r, y = o.width / i, C = o.height / r;
  return {
    width: y,
    height: C,
    top: f,
    right: d + y,
    bottom: f + C,
    left: d,
    x: d,
    y: f
  };
}
function Wi(e) {
  var n = an(e), t = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(n.width - t) <= 1 && (t = n.width), Math.abs(n.height - o) <= 1 && (o = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: o
  };
}
function Ma(e, n) {
  var t = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && Yi(t)) {
    var o = n;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function St(e) {
  return tt(e).getComputedStyle(e);
}
function tp(e) {
  return ["table", "td", "th"].indexOf(Ft(e)) >= 0;
}
function Dt(e) {
  return ((Vt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Mo(e) {
  return Ft(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Yi(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Dt(e)
  );
}
function Vr(e) {
  return !lt(e) || // https://github.com/popperjs/popper-core/issues/837
  St(e).position === "fixed" ? null : e.offsetParent;
}
function np(e) {
  var n = /firefox/i.test(Ci()), t = /Trident/i.test(Ci());
  if (t && lt(e)) {
    var o = St(e);
    if (o.position === "fixed")
      return null;
  }
  var i = Mo(e);
  for (Yi(i) && (i = i.host); lt(i) && ["html", "body"].indexOf(Ft(i)) < 0; ) {
    var r = St(i);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || n && r.willChange === "filter" || n && r.filter && r.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function xn(e) {
  for (var n = tt(e), t = Vr(e); t && tp(t) && St(t).position === "static"; )
    t = Vr(t);
  return t && (Ft(t) === "html" || Ft(t) === "body" && St(t).position === "static") ? n : t || np(e) || n;
}
function Xi(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Rn(e, n, t) {
  return Nt(e, vo(n, t));
}
function op(e, n, t) {
  var o = Rn(e, n, t);
  return o > t ? t : o;
}
function Pa() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ba(e) {
  return Object.assign({}, Pa(), e);
}
function La(e, n) {
  return n.reduce(function(t, o) {
    return t[o] = e, t;
  }, {});
}
var ip = function(n, t) {
  return n = typeof n == "function" ? n(Object.assign({}, t.rects, {
    placement: t.placement
  })) : n, Ba(typeof n != "number" ? n : La(n, qn));
};
function rp(e) {
  var n, t = e.state, o = e.name, i = e.options, r = t.elements.arrow, s = t.modifiersData.popperOffsets, a = wt(t.placement), u = Xi(a), d = [Ye, dt].indexOf(a) >= 0, f = d ? "height" : "width";
  if (!(!r || !s)) {
    var y = ip(i.padding, t), C = Wi(r), U = u === "y" ? ze : Ye, g = u === "y" ? ut : dt, A = t.rects.reference[f] + t.rects.reference[u] - s[u] - t.rects.popper[f], w = s[u] - t.rects.reference[u], M = xn(r), L = M ? u === "y" ? M.clientHeight || 0 : M.clientWidth || 0 : 0, B = A / 2 - w / 2, N = y[U], x = L - C[f] - y[g], q = L / 2 - C[f] / 2 + B, Y = Rn(N, q, x), $ = u;
    t.modifiersData[o] = (n = {}, n[$] = Y, n.centerOffset = Y - q, n);
  }
}
function sp(e) {
  var n = e.state, t = e.options, o = t.element, i = o === void 0 ? "[data-popper-arrow]" : o;
  i != null && (typeof i == "string" && (i = n.elements.popper.querySelector(i), !i) || Ma(n.elements.popper, i) && (n.elements.arrow = i));
}
const ap = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: rp,
  effect: sp,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ln(e) {
  return e.split("-")[1];
}
var lp = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function up(e, n) {
  var t = e.x, o = e.y, i = n.devicePixelRatio || 1;
  return {
    x: sn(t * i) / i || 0,
    y: sn(o * i) / i || 0
  };
}
function jr(e) {
  var n, t = e.popper, o = e.popperRect, i = e.placement, r = e.variation, s = e.offsets, a = e.position, u = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, y = e.isFixed, C = s.x, U = C === void 0 ? 0 : C, g = s.y, A = g === void 0 ? 0 : g, w = typeof f == "function" ? f({
    x: U,
    y: A
  }) : {
    x: U,
    y: A
  };
  U = w.x, A = w.y;
  var M = s.hasOwnProperty("x"), L = s.hasOwnProperty("y"), B = Ye, N = ze, x = window;
  if (d) {
    var q = xn(t), Y = "clientHeight", $ = "clientWidth";
    if (q === tt(t) && (q = Dt(t), St(q).position !== "static" && a === "absolute" && (Y = "scrollHeight", $ = "scrollWidth")), q = q, i === ze || (i === Ye || i === dt) && r === Tn) {
      N = ut;
      var Q = y && q === x && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        q[Y]
      );
      A -= Q - o.height, A *= u ? 1 : -1;
    }
    if (i === Ye || (i === ze || i === ut) && r === Tn) {
      B = dt;
      var ee = y && q === x && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        q[$]
      );
      U -= ee - o.width, U *= u ? 1 : -1;
    }
  }
  var te = Object.assign({
    position: a
  }, d && lp), le = f === !0 ? up({
    x: U,
    y: A
  }, tt(t)) : {
    x: U,
    y: A
  };
  if (U = le.x, A = le.y, u) {
    var V;
    return Object.assign({}, te, (V = {}, V[N] = L ? "0" : "", V[B] = M ? "0" : "", V.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + U + "px, " + A + "px)" : "translate3d(" + U + "px, " + A + "px, 0)", V));
  }
  return Object.assign({}, te, (n = {}, n[N] = L ? A + "px" : "", n[B] = M ? U + "px" : "", n.transform = "", n));
}
function dp(e) {
  var n = e.state, t = e.options, o = t.gpuAcceleration, i = o === void 0 ? !0 : o, r = t.adaptive, s = r === void 0 ? !0 : r, a = t.roundOffsets, u = a === void 0 ? !0 : a, d = {
    placement: wt(n.placement),
    variation: ln(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: i,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, jr(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: s,
    roundOffsets: u
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, jr(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const cp = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: dp,
  data: {}
};
var Xn = {
  passive: !0
};
function fp(e) {
  var n = e.state, t = e.instance, o = e.options, i = o.scroll, r = i === void 0 ? !0 : i, s = o.resize, a = s === void 0 ? !0 : s, u = tt(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return r && d.forEach(function(f) {
    f.addEventListener("scroll", t.update, Xn);
  }), a && u.addEventListener("resize", t.update, Xn), function() {
    r && d.forEach(function(f) {
      f.removeEventListener("scroll", t.update, Xn);
    }), a && u.removeEventListener("resize", t.update, Xn);
  };
}
const pp = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: fp,
  data: {}
};
var hp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function lo(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return hp[n];
  });
}
var mp = {
  start: "end",
  end: "start"
};
function Hr(e) {
  return e.replace(/start|end/g, function(n) {
    return mp[n];
  });
}
function Zi(e) {
  var n = tt(e), t = n.pageXOffset, o = n.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: o
  };
}
function er(e) {
  return an(Dt(e)).left + Zi(e).scrollLeft;
}
function Ap(e, n) {
  var t = tt(e), o = Dt(e), i = t.visualViewport, r = o.clientWidth, s = o.clientHeight, a = 0, u = 0;
  if (i) {
    r = i.width, s = i.height;
    var d = _a();
    (d || !d && n === "fixed") && (a = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: a + er(e),
    y: u
  };
}
function gp(e) {
  var n, t = Dt(e), o = Zi(e), i = (n = e.ownerDocument) == null ? void 0 : n.body, r = Nt(t.scrollWidth, t.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Nt(t.scrollHeight, t.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -o.scrollLeft + er(e), u = -o.scrollTop;
  return St(i || t).direction === "rtl" && (a += Nt(t.clientWidth, i ? i.clientWidth : 0) - r), {
    width: r,
    height: s,
    x: a,
    y: u
  };
}
function tr(e) {
  var n = St(e), t = n.overflow, o = n.overflowX, i = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + i + o);
}
function Na(e) {
  return ["html", "body", "#document"].indexOf(Ft(e)) >= 0 ? e.ownerDocument.body : lt(e) && tr(e) ? e : Na(Mo(e));
}
function kn(e, n) {
  var t;
  n === void 0 && (n = []);
  var o = Na(e), i = o === ((t = e.ownerDocument) == null ? void 0 : t.body), r = tt(o), s = i ? [r].concat(r.visualViewport || [], tr(o) ? o : []) : o, a = n.concat(s);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(kn(Mo(s)))
  );
}
function wi(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function yp(e, n) {
  var t = an(e, !1, n === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Gr(e, n, t) {
  return n === Da ? wi(Ap(e, t)) : Vt(n) ? yp(n, t) : wi(gp(Dt(e)));
}
function Kp(e) {
  var n = kn(Mo(e)), t = ["absolute", "fixed"].indexOf(St(e).position) >= 0, o = t && lt(e) ? xn(e) : e;
  return Vt(o) ? n.filter(function(i) {
    return Vt(i) && Ma(i, o) && Ft(i) !== "body";
  }) : [];
}
function vp(e, n, t, o) {
  var i = n === "clippingParents" ? Kp(e) : [].concat(n), r = [].concat(i, [t]), s = r[0], a = r.reduce(function(u, d) {
    var f = Gr(e, d, o);
    return u.top = Nt(f.top, u.top), u.right = vo(f.right, u.right), u.bottom = vo(f.bottom, u.bottom), u.left = Nt(f.left, u.left), u;
  }, Gr(e, s, o));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function qa(e) {
  var n = e.reference, t = e.element, o = e.placement, i = o ? wt(o) : null, r = o ? ln(o) : null, s = n.x + n.width / 2 - t.width / 2, a = n.y + n.height / 2 - t.height / 2, u;
  switch (i) {
    case ze:
      u = {
        x: s,
        y: n.y - t.height
      };
      break;
    case ut:
      u = {
        x: s,
        y: n.y + n.height
      };
      break;
    case dt:
      u = {
        x: n.x + n.width,
        y: a
      };
      break;
    case Ye:
      u = {
        x: n.x - t.width,
        y: a
      };
      break;
    default:
      u = {
        x: n.x,
        y: n.y
      };
  }
  var d = i ? Xi(i) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (r) {
      case rn:
        u[d] = u[d] - (n[f] / 2 - t[f] / 2);
        break;
      case Tn:
        u[d] = u[d] + (n[f] / 2 - t[f] / 2);
        break;
    }
  }
  return u;
}
function In(e, n) {
  n === void 0 && (n = {});
  var t = n, o = t.placement, i = o === void 0 ? e.placement : o, r = t.strategy, s = r === void 0 ? e.strategy : r, a = t.boundary, u = a === void 0 ? qf : a, d = t.rootBoundary, f = d === void 0 ? Da : d, y = t.elementContext, C = y === void 0 ? vn : y, U = t.altBoundary, g = U === void 0 ? !1 : U, A = t.padding, w = A === void 0 ? 0 : A, M = Ba(typeof w != "number" ? w : La(w, qn)), L = C === vn ? xf : vn, B = e.rects.popper, N = e.elements[g ? L : C], x = vp(Vt(N) ? N : N.contextElement || Dt(e.elements.popper), u, f, s), q = an(e.elements.reference), Y = qa({
    reference: q,
    element: B,
    placement: i
  }), $ = wi(Object.assign({}, B, Y)), Q = C === vn ? $ : q, ee = {
    top: x.top - Q.top + M.top,
    bottom: Q.bottom - x.bottom + M.bottom,
    left: x.left - Q.left + M.left,
    right: Q.right - x.right + M.right
  }, te = e.modifiersData.offset;
  if (C === vn && te) {
    var le = te[i];
    Object.keys(ee).forEach(function(V) {
      var Se = [dt, ut].indexOf(V) >= 0 ? 1 : -1, k = [ze, ut].indexOf(V) >= 0 ? "y" : "x";
      ee[V] += le[k] * Se;
    });
  }
  return ee;
}
function bp(e, n) {
  n === void 0 && (n = {});
  var t = n, o = t.placement, i = t.boundary, r = t.rootBoundary, s = t.padding, a = t.flipVariations, u = t.allowedAutoPlacements, d = u === void 0 ? Oa : u, f = ln(o), y = f ? a ? xr : xr.filter(function(g) {
    return ln(g) === f;
  }) : qn, C = y.filter(function(g) {
    return d.indexOf(g) >= 0;
  });
  C.length === 0 && (C = y);
  var U = C.reduce(function(g, A) {
    return g[A] = In(e, {
      placement: A,
      boundary: i,
      rootBoundary: r,
      padding: s
    })[wt(A)], g;
  }, {});
  return Object.keys(U).sort(function(g, A) {
    return U[g] - U[A];
  });
}
function Cp(e) {
  if (wt(e) === zi)
    return [];
  var n = lo(e);
  return [Hr(e), n, Hr(n)];
}
function wp(e) {
  var n = e.state, t = e.options, o = e.name;
  if (!n.modifiersData[o]._skip) {
    for (var i = t.mainAxis, r = i === void 0 ? !0 : i, s = t.altAxis, a = s === void 0 ? !0 : s, u = t.fallbackPlacements, d = t.padding, f = t.boundary, y = t.rootBoundary, C = t.altBoundary, U = t.flipVariations, g = U === void 0 ? !0 : U, A = t.allowedAutoPlacements, w = n.options.placement, M = wt(w), L = M === w, B = u || (L || !g ? [lo(w)] : Cp(w)), N = [w].concat(B).reduce(function(ve, Ue) {
      return ve.concat(wt(Ue) === zi ? bp(n, {
        placement: Ue,
        boundary: f,
        rootBoundary: y,
        padding: d,
        flipVariations: g,
        allowedAutoPlacements: A
      }) : Ue);
    }, []), x = n.rects.reference, q = n.rects.popper, Y = /* @__PURE__ */ new Map(), $ = !0, Q = N[0], ee = 0; ee < N.length; ee++) {
      var te = N[ee], le = wt(te), V = ln(te) === rn, Se = [ze, ut].indexOf(le) >= 0, k = Se ? "width" : "height", P = In(n, {
        placement: te,
        boundary: f,
        rootBoundary: y,
        altBoundary: C,
        padding: d
      }), W = Se ? V ? dt : Ye : V ? ut : ze;
      x[k] > q[k] && (W = lo(W));
      var he = lo(W), ge = [];
      if (r && ge.push(P[le] <= 0), a && ge.push(P[W] <= 0, P[he] <= 0), ge.every(function(ve) {
        return ve;
      })) {
        Q = te, $ = !1;
        break;
      }
      Y.set(te, ge);
    }
    if ($)
      for (var se = g ? 3 : 1, Ie = function(Ue) {
        var ft = N.find(function(fe) {
          var ne = Y.get(fe);
          if (ne)
            return ne.slice(0, Ue).every(function(me) {
              return me;
            });
        });
        if (ft)
          return Q = ft, "break";
      }, Pe = se; Pe > 0; Pe--) {
        var Le = Ie(Pe);
        if (Le === "break") break;
      }
    n.placement !== Q && (n.modifiersData[o]._skip = !0, n.placement = Q, n.reset = !0);
  }
}
const Fp = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: wp,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Qr(e, n, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - t.y,
    right: e.right - n.width + t.x,
    bottom: e.bottom - n.height + t.y,
    left: e.left - n.width - t.x
  };
}
function $r(e) {
  return [ze, dt, ut, Ye].some(function(n) {
    return e[n] >= 0;
  });
}
function Rp(e) {
  var n = e.state, t = e.name, o = n.rects.reference, i = n.rects.popper, r = n.modifiersData.preventOverflow, s = In(n, {
    elementContext: "reference"
  }), a = In(n, {
    altBoundary: !0
  }), u = Qr(s, o), d = Qr(a, i, r), f = $r(u), y = $r(d);
  n.modifiersData[t] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: y
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": y
  });
}
const kp = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Rp
};
function Up(e, n, t) {
  var o = wt(e), i = [Ye, ze].indexOf(o) >= 0 ? -1 : 1, r = typeof t == "function" ? t(Object.assign({}, n, {
    placement: e
  })) : t, s = r[0], a = r[1];
  return s = s || 0, a = (a || 0) * i, [Ye, dt].indexOf(o) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function Ep(e) {
  var n = e.state, t = e.options, o = e.name, i = t.offset, r = i === void 0 ? [0, 0] : i, s = Oa.reduce(function(f, y) {
    return f[y] = Up(y, n.rects, r), f;
  }, {}), a = s[n.placement], u = a.x, d = a.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += u, n.modifiersData.popperOffsets.y += d), n.modifiersData[o] = s;
}
const Sp = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ep
};
function Tp(e) {
  var n = e.state, t = e.name;
  n.modifiersData[t] = qa({
    reference: n.rects.reference,
    element: n.rects.popper,
    placement: n.placement
  });
}
const Ip = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Tp,
  data: {}
};
function Dp(e) {
  return e === "x" ? "y" : "x";
}
function Op(e) {
  var n = e.state, t = e.options, o = e.name, i = t.mainAxis, r = i === void 0 ? !0 : i, s = t.altAxis, a = s === void 0 ? !1 : s, u = t.boundary, d = t.rootBoundary, f = t.altBoundary, y = t.padding, C = t.tether, U = C === void 0 ? !0 : C, g = t.tetherOffset, A = g === void 0 ? 0 : g, w = In(n, {
    boundary: u,
    rootBoundary: d,
    padding: y,
    altBoundary: f
  }), M = wt(n.placement), L = ln(n.placement), B = !L, N = Xi(M), x = Dp(N), q = n.modifiersData.popperOffsets, Y = n.rects.reference, $ = n.rects.popper, Q = typeof A == "function" ? A(Object.assign({}, n.rects, {
    placement: n.placement
  })) : A, ee = typeof Q == "number" ? {
    mainAxis: Q,
    altAxis: Q
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Q), te = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, le = {
    x: 0,
    y: 0
  };
  if (q) {
    if (r) {
      var V, Se = N === "y" ? ze : Ye, k = N === "y" ? ut : dt, P = N === "y" ? "height" : "width", W = q[N], he = W + w[Se], ge = W - w[k], se = U ? -$[P] / 2 : 0, Ie = L === rn ? Y[P] : $[P], Pe = L === rn ? -$[P] : -Y[P], Le = n.elements.arrow, ve = U && Le ? Wi(Le) : {
        width: 0,
        height: 0
      }, Ue = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : Pa(), ft = Ue[Se], fe = Ue[k], ne = Rn(0, Y[P], ve[P]), me = B ? Y[P] / 2 - se - ne - ft - ee.mainAxis : Ie - ne - ft - ee.mainAxis, De = B ? -Y[P] / 2 + se + ne + fe + ee.mainAxis : Pe + ne + fe + ee.mainAxis, Ge = n.elements.arrow && xn(n.elements.arrow), Rt = Ge ? N === "y" ? Ge.clientTop || 0 : Ge.clientLeft || 0 : 0, pt = (V = te == null ? void 0 : te[N]) != null ? V : 0, hn = W + me - pt - Rt, Hn = W + De - pt, Gn = Rn(U ? vo(he, hn) : he, W, U ? Nt(ge, Hn) : ge);
      q[N] = Gn, le[N] = Gn - W;
    }
    if (a) {
      var mn, Qn = N === "x" ? ze : Ye, Ht = N === "x" ? ut : dt, kt = q[x], Gt = x === "y" ? "height" : "width", An = kt + w[Qn], Qt = kt - w[Ht], $t = [ze, Ye].indexOf(M) !== -1, Ot = (mn = te == null ? void 0 : te[x]) != null ? mn : 0, $n = $t ? An : kt - Y[Gt] - $[Gt] - Ot + ee.altAxis, gn = $t ? kt + Y[Gt] + $[Gt] - Ot - ee.altAxis : Qt, Jn = U && $t ? op($n, kt, gn) : Rn(U ? $n : An, kt, U ? gn : Qt);
      q[x] = Jn, le[x] = Jn - kt;
    }
    n.modifiersData[o] = le;
  }
}
const _p = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Op,
  requiresIfExists: ["offset"]
};
function Mp(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Pp(e) {
  return e === tt(e) || !lt(e) ? Zi(e) : Mp(e);
}
function Bp(e) {
  var n = e.getBoundingClientRect(), t = sn(n.width) / e.offsetWidth || 1, o = sn(n.height) / e.offsetHeight || 1;
  return t !== 1 || o !== 1;
}
function Lp(e, n, t) {
  t === void 0 && (t = !1);
  var o = lt(n), i = lt(n) && Bp(n), r = Dt(n), s = an(e, i, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (o || !o && !t) && ((Ft(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  tr(r)) && (a = Pp(n)), lt(n) ? (u = an(n, !0), u.x += n.clientLeft, u.y += n.clientTop) : r && (u.x = er(r))), {
    x: s.left + a.scrollLeft - u.x,
    y: s.top + a.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}
function Np(e) {
  var n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(r) {
    n.set(r.name, r);
  });
  function i(r) {
    t.add(r.name);
    var s = [].concat(r.requires || [], r.requiresIfExists || []);
    s.forEach(function(a) {
      if (!t.has(a)) {
        var u = n.get(a);
        u && i(u);
      }
    }), o.push(r);
  }
  return e.forEach(function(r) {
    t.has(r.name) || i(r);
  }), o;
}
function qp(e) {
  var n = Np(e);
  return Wf.reduce(function(t, o) {
    return t.concat(n.filter(function(i) {
      return i.phase === o;
    }));
  }, []);
}
function xp(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(t) {
      Promise.resolve().then(function() {
        n = void 0, t(e());
      });
    })), n;
  };
}
function Vp(e) {
  var n = e.reduce(function(t, o) {
    var i = t[o.name];
    return t[o.name] = i ? Object.assign({}, i, o, {
      options: Object.assign({}, i.options, o.options),
      data: Object.assign({}, i.data, o.data)
    }) : o, t;
  }, {});
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}
var Jr = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function zr() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return !n.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function jp(e) {
  e === void 0 && (e = {});
  var n = e, t = n.defaultModifiers, o = t === void 0 ? [] : t, i = n.defaultOptions, r = i === void 0 ? Jr : i;
  return function(a, u, d) {
    d === void 0 && (d = r);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Jr, r),
      modifiersData: {},
      elements: {
        reference: a,
        popper: u
      },
      attributes: {},
      styles: {}
    }, y = [], C = !1, U = {
      state: f,
      setOptions: function(M) {
        var L = typeof M == "function" ? M(f.options) : M;
        A(), f.options = Object.assign({}, r, f.options, L), f.scrollParents = {
          reference: Vt(a) ? kn(a) : a.contextElement ? kn(a.contextElement) : [],
          popper: kn(u)
        };
        var B = qp(Vp([].concat(o, f.options.modifiers)));
        return f.orderedModifiers = B.filter(function(N) {
          return N.enabled;
        }), g(), U.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!C) {
          var M = f.elements, L = M.reference, B = M.popper;
          if (zr(L, B)) {
            f.rects = {
              reference: Lp(L, xn(B), f.options.strategy === "fixed"),
              popper: Wi(B)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(ee) {
              return f.modifiersData[ee.name] = Object.assign({}, ee.data);
            });
            for (var N = 0; N < f.orderedModifiers.length; N++) {
              if (f.reset === !0) {
                f.reset = !1, N = -1;
                continue;
              }
              var x = f.orderedModifiers[N], q = x.fn, Y = x.options, $ = Y === void 0 ? {} : Y, Q = x.name;
              typeof q == "function" && (f = q({
                state: f,
                options: $,
                name: Q,
                instance: U
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: xp(function() {
        return new Promise(function(w) {
          U.forceUpdate(), w(f);
        });
      }),
      destroy: function() {
        A(), C = !0;
      }
    };
    if (!zr(a, u))
      return U;
    U.setOptions(d).then(function(w) {
      !C && d.onFirstUpdate && d.onFirstUpdate(w);
    });
    function g() {
      f.orderedModifiers.forEach(function(w) {
        var M = w.name, L = w.options, B = L === void 0 ? {} : L, N = w.effect;
        if (typeof N == "function") {
          var x = N({
            state: f,
            name: M,
            instance: U,
            options: B
          }), q = function() {
          };
          y.push(x || q);
        }
      });
    }
    function A() {
      y.forEach(function(w) {
        return w();
      }), y = [];
    }
    return U;
  };
}
var Hp = [pp, Ip, cp, ep, Sp, Fp, _p, ap, kp], xa = /* @__PURE__ */ jp({
  defaultModifiers: Hp
});
const Gp = {
  props: {
    /** the value of the tooltip. If left empty no tooltip is rendered */
    value: String,
    /** placement of the tooltip conform popperjs. Also determines where the tooltip will stick in case screen is too small.
     * See https://popper.js.org/docs/v1/#popperplacements--codeenumcode
     */
    placement: { type: String, default: "auto-end" }
  },
  data() {
    return {
      popperInstance: null,
      display: !1
    };
  },
  methods: {
    async showTooltip() {
      this.display = !0, await this.$nextTick();
      const e = this.$refs.tooltipContainer, n = this.$refs.toolTip;
      e && n && (this.popperInstance = xa(e, n, {
        strategy: "fixed",
        placement: this.placement
      }));
    },
    async destroyTooltip() {
      var e;
      (e = this.popperInstance) == null || e.destroy(), this.display = !1;
    }
  }
}, Qp = {
  key: 0,
  ref: "toolTip"
}, $p = { class: "mg-tooltip m-1" };
function Jp(e, n, t, o, i, r) {
  return l(), c("span", {
    class: "mg-tooltip-container",
    onMouseenter: n[0] || (n[0] = (...s) => r.showTooltip && r.showTooltip(...s)),
    onMouseleave: n[1] || (n[1] = (...s) => r.destroyTooltip && r.destroyTooltip(...s)),
    ref: "tooltipContainer"
  }, [
    j(e.$slots, "default"),
    t.value && i.display ? (l(), c("div", Qp, [
      p("div", $p, E(t.value), 1)
    ], 512)) : v("", !0)
  ], 544);
}
const un = /* @__PURE__ */ D(Gp, [["render", Jp]]), zp = {
  extends: He,
  components: {
    Tooltip: un
  },
  props: {
    label: String,
    icon: String,
    tooltip: String
  }
}, Yp = {
  key: 0,
  class: "mr-2"
};
function Wp(e, n, t, o, i, r) {
  const s = K("Tooltip");
  return l(), c("button", {
    class: "btn p-0 m-0 btn-outline-primary border-0",
    onClick: n[0] || (n[0] = Ke((...a) => e.onClick && e.onClick(...a), ["prevent"]))
  }, [
    T(s, {
      value: t.tooltip,
      class: "mt-n1 mb-n1 p-1"
    }, {
      default: b(() => [
        t.label ? (l(), c("span", Yp, E(t.label), 1)) : v("", !0),
        p("i", {
          class: G("fas fa-fw fa-" + t.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]);
}
const ct = /* @__PURE__ */ D(zp, [["render", Wp]]), Xp = {
  extends: ct
}, Zp = {
  key: 0,
  class: "mr-2"
};
function eh(e, n, t, o, i, r) {
  const s = K("Tooltip");
  return l(), c("button", {
    class: "btn p-0 m-0 btn-outline-danger border-0",
    onClick: n[0] || (n[0] = (...a) => e.onClick && e.onClick(...a))
  }, [
    T(s, {
      value: e.tooltip,
      class: "p-1 mt-n1 mb-n1"
    }, {
      default: b(() => [
        e.label ? (l(), c("span", Zp, E(e.label), 1)) : v("", !0),
        p("i", {
          class: G("fas fa-fw fa-" + e.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]);
}
const nr = /* @__PURE__ */ D(Xp, [["render", eh]]), th = {}, nh = { class: "input-group" }, oh = {
  key: 0,
  class: "input-group-prepend"
}, ih = {
  key: 1,
  class: "input-group-append"
};
function rh(e, n) {
  return l(), c("div", nh, [
    e.$slots.prepend ? (l(), c("div", oh, [
      j(e.$slots, "prepend")
    ])) : v("", !0),
    j(e.$slots, "default"),
    e.$slots.append ? (l(), c("div", ih, [
      j(e.$slots, "append")
    ])) : v("", !0)
  ]);
}
const Ve = /* @__PURE__ */ D(th, [["render", rh]]), sh = {
  name: "InputString",
  components: { FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  props: {
    stringLength: {
      type: Number,
      default: 255
    }
  },
  computed: {
    stringError() {
      return this.modelValue && this.modelValue.length && this.modelValue.length > this.stringLength ? `Please limit to ${this.stringLength} characters.` : this.errorMessage;
    }
  }
}, ah = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function lh(e, n, t, o, i, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: b(() => [
      T(s, null, {
        prepend: b(() => [
          j(e.$slots, "prepend", {}, void 0, !0)
        ]),
        append: b(() => [
          j(e.$slots, "append", {}, void 0, !0)
        ]),
        default: b(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholderValue,
            readonly: e.readonly
          }, null, 42, ah)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const At = /* @__PURE__ */ D(sh, [["render", lh], ["__scopeId", "data-v-eb9c2ec3"]]), uh = "{_session { email, token, settings{key,value}}}", dh = `mutation change($users:[UsersInput]){
        change(users:$users){
            message
          }
        }`, ch = `mutation createToken($email:String,$tokenName:String){
        createToken(email:$email,tokenName:$tokenName){
            message,token
          }
        }`, fh = Re({
  components: {
    ButtonAction: He,
    InputString: At,
    IconDanger: nr,
    MessageSuccess: pn,
    MessageError: it,
    Tooltip: un
  },
  data() {
    return {
      session: null,
      tokenName: "",
      lastTokenValue: "",
      errorMessage: "",
      successMessage: ""
    };
  },
  computed: {
    accessTokens() {
      var n, t;
      const e = (t = (n = this.session) == null ? void 0 : n.settings) == null ? void 0 : t.find(
        (o) => o.key === "access-tokens" && !!o.value
      );
      return e ? e.value.split(",").filter((o) => o !== "") : [];
    },
    duplicateNameMessage() {
      return this.accessTokens.includes(this.tokenName) ? "Duplicate token name" : "";
    }
  },
  methods: {
    async fetchSession() {
      const e = await Be("/api/graphql", uh);
      this.session = e._session;
    },
    clean() {
      this.errorMessage = "", this.successMessage = "", this.lastTokenValue = "";
    },
    async deleteToken(e) {
      var o;
      this.clean();
      let n = this.accessTokens;
      n.splice(e, 1);
      const t = {
        users: {
          email: (o = this.session) == null ? void 0 : o.email,
          settings: {
            key: "access-tokens",
            value: n.join(",")
          }
        }
      };
      Be("/api/graphql", dh, t).then(() => {
        this.successMessage = "Token removed", this.lastTokenValue = "", this.fetchSession();
      }).catch((i) => {
        this.errorMessage = i.message;
      });
    },
    async createToken() {
      var n;
      this.clean();
      const e = {
        email: (n = this.session) == null ? void 0 : n.email,
        tokenName: this.tokenName
      };
      Be("/api/graphql", ch, e).then((t) => {
        this.successMessage = t.createToken.message, this.lastTokenValue = t.createToken.token, this.tokenName = "", this.fetchSession();
      }).catch((t) => {
        this.errorMessage = t.message;
      });
    },
    copyToClipboard(e) {
      navigator.clipboard.writeText(e);
    }
  },
  mounted() {
    this.fetchSession();
  }
}), ph = { key: 0 }, hh = {
  key: 0,
  style: { cursor: "pointer" }
}, mh = { class: "form-inline" };
function Ah(e, n, t, o, i, r) {
  const s = K("IconDanger"), a = K("Tooltip"), u = K("MessageSuccess"), d = K("MessageError"), f = K("ButtonAction"), y = K("InputString");
  return l(), c("div", null, [
    e.accessTokens.length ? (l(), c("div", ph, [
      n[3] || (n[3] = p("label", null, [
        p("b", null, "Access tokens")
      ], -1)),
      p("ul", null, [
        (l(!0), c(oe, null, ae(e.accessTokens, (C, U) => (l(), c("li", { key: C }, [
          _(E(C) + " ", 1),
          T(s, {
            onClick: (g) => e.deleteToken(U),
            icon: "times"
          }, null, 8, ["onClick"])
        ]))), 128))
      ])
    ])) : v("", !0),
    e.successMessage ? (l(), F(u, { key: 1 }, {
      default: b(() => [
        _(E(e.successMessage) + ". ", 1),
        e.lastTokenValue ? (l(), c("div", hh, [
          p("label", null, [
            p("b", null, [
              n[5] || (n[5] = _(" New token. Please copy for use: ", -1)),
              T(a, {
                value: "Click to copy to clipboard",
                placement: "top",
                onClick: n[0] || (n[0] = Ke((C) => e.copyToClipboard(e.lastTokenValue), ["prevent"]))
              }, {
                default: b(() => [...n[4] || (n[4] = [
                  p("i", {
                    id: "copy-icon",
                    class: "fa fa-clipboard"
                  }, null, -1)
                ])]),
                _: 1
              })
            ])
          ]),
          p("pre", {
            onClick: n[1] || (n[1] = Ke((C) => e.copyToClipboard(e.lastTokenValue), ["prevent"]))
          }, "          " + E(e.lastTokenValue) + `
        `, 1)
        ])) : v("", !0)
      ]),
      _: 1
    })) : v("", !0),
    e.errorMessage ? (l(), F(d, { key: 2 }, {
      default: b(() => [
        _(E(e.errorMessage), 1)
      ]),
      _: 1
    })) : v("", !0),
    n[7] || (n[7] = p("label", null, [
      p("b", null, "Create a token")
    ], -1)),
    p("form", mh, [
      e.tokenName ? (l(), F(f, {
        key: e.tokenName,
        disabled: !!e.duplicateNameMessage,
        onClick: e.createToken
      }, {
        default: b(() => [...n[6] || (n[6] = [
          _(" Create token ", -1)
        ])]),
        _: 1
      }, 8, ["disabled", "onClick"])) : v("", !0),
      T(y, {
        id: "token-name",
        placeholder: "new token name",
        modelValue: e.tokenName,
        "onUpdate:modelValue": n[2] || (n[2] = (C) => e.tokenName = C),
        errorMessage: e.duplicateNameMessage
      }, null, 8, ["modelValue", "errorMessage"])
    ])
  ]);
}
const gh = /* @__PURE__ */ D(fh, [["render", Ah]]), yh = Re({
  components: {
    LayoutModal: Kt,
    ButtonAlt: ot,
    ButtonAction: He,
    InputPassword: Ji,
    MessageError: it,
    MessageSuccess: pn,
    Spinner: yt,
    TokenManager: gh
  },
  props: {
    user: String
  },
  data() {
    return {
      password: null,
      password2: null,
      loading: !1,
      graphqlError: null,
      success: null,
      error: null
    };
  },
  methods: {
    async updatePassword() {
      if (this.password !== this.password2)
        this.error = "Error: Passwords entered must be the same";
      else {
        this.error = null, this.loading = !0;
        const e = await Be(
          "graphql",
          `mutation{changePassword(password: "${this.password}"){status,message}}`
        ).catch((n) => {
          this.graphqlError = JSON.stringify(n);
        });
        e.changePassword.status === "SUCCESS" ? this.success = "Success. Password changed" : this.error = "Password change failed: " + e.changePassword.message, this.loading = !1;
      }
    },
    close() {
      this.error = null, this.$emit("cancel");
    }
  },
  emits: ["cancel"]
});
function Kh(e, n, t, o, i, r) {
  const s = K("Spinner"), a = K("MessageSuccess"), u = K("MessageError"), d = K("InputPassword"), f = K("ButtonAction"), y = K("TokenManager"), C = K("LayoutForm"), U = K("ButtonAlt"), g = K("LayoutModal");
  return e.loading ? (l(), F(s, { key: 0 })) : (l(), F(g, {
    key: 1,
    title: "Change account",
    show: !0,
    onClose: e.close
  }, {
    body: b(() => [
      T(C, null, {
        default: b(() => [
          n[3] || (n[3] = p("h2", null, "Change password", -1)),
          e.success ? (l(), F(a, { key: 0 }, {
            default: b(() => [
              _(E(e.success), 1)
            ]),
            _: 1
          })) : v("", !0),
          e.graphqlError ? (l(), F(u, { key: 1 }, {
            default: b(() => [
              _(E(e.graphqlError), 1)
            ]),
            _: 1
          })) : v("", !0),
          T(d, {
            id: "account-password",
            modelValue: e.password,
            "onUpdate:modelValue": n[0] || (n[0] = (A) => e.password = A),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the password",
            onEnterPressed: e.updatePassword
          }, null, 8, ["modelValue", "onEnterPressed"]),
          T(d, {
            id: "account-password2",
            modelValue: e.password2,
            "onUpdate:modelValue": n[1] || (n[1] = (A) => e.password2 = A),
            label: "Password Repeat",
            placeholder: "Enter password",
            description: "Please enter the password again",
            onEnterPressed: e.updatePassword
          }, null, 8, ["modelValue", "onEnterPressed"]),
          T(f, { onClick: e.updatePassword }, {
            default: b(() => [...n[2] || (n[2] = [
              _("Update password", -1)
            ])]),
            _: 1
          }, 8, ["onClick"]),
          n[4] || (n[4] = p("h2", { class: "mt-4" }, "Manage tokens", -1)),
          T(y)
        ]),
        _: 1
      })
    ]),
    footer: b(() => [
      T(U, { onClick: e.close }, {
        default: b(() => [...n[5] || (n[5] = [
          _("Close", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const vh = /* @__PURE__ */ D(yh, [["render", Kh]]), bh = {
  name: "ButtonOutline",
  extends: He,
  props: {
    light: { type: Boolean, default: !1 }
  }
}, Ch = ["disabled"];
function wh(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: G(t.light ? "btn btn-outline-light" : "btn btn-outline-primary"),
    disabled: e.disabled,
    onClick: n[0] || (n[0] = Ke((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    e.icon ? (l(), c("i", {
      key: 0,
      class: G(["fa-" + e.icon, "fa fa-fw mr-2 ml-0"])
    }, null, 2)) : v("", !0),
    j(e.$slots, "default")
  ], 10, Ch);
}
const Po = /* @__PURE__ */ D(bh, [["render", wh]]), Fh = {
  name: "ButtonAction",
  props: {
    href: String,
    icon: String,
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Rh = ["disabled"];
function kh(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "submit",
    class: "btn btn-primary",
    disabled: t.disabled
  }, [
    j(e.$slots, "default"),
    t.icon ? (l(), c("i", {
      key: 0,
      class: G(["fa fa-fw fa-" + t.icon, "mr-2 ml-0"])
    }, null, 2)) : v("", !0)
  ], 8, Rh);
}
const Uh = /* @__PURE__ */ D(Fh, [["render", kh]]), Eh = {};
function Sh(e, n) {
  return l(), c("form", {
    onSubmit: n[0] || (n[0] = Ke((t) => e.$emit("submit"), ["prevent"]))
  }, [
    j(e.$slots, "default")
  ], 32);
}
const Th = /* @__PURE__ */ D(Eh, [["render", Sh]]), Ih = {
  extends: Ce,
  components: {
    FormGroup: ke
  },
  props: {
    options: Array,
    hideClearButton: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      result: this.modelValue ? [...this.modelValue] : []
    };
  }
}, Dh = ["id", "value", "aria-describedby"], Oh = ["for"];
function _h(e, n, t, o, i, r) {
  const s = K("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    class: "checkbox-form-group",
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      (l(!0), c(oe, null, ae(t.options, (a, u) => (l(), c("div", {
        key: u,
        class: "form-check form-check-inline"
      }, [
        We(p("input", {
          id: `${e.id}-${u}`,
          "onUpdate:modelValue": n[0] || (n[0] = (d) => i.result = d),
          class: "form-check-input",
          type: "checkbox",
          value: a,
          onChange: n[1] || (n[1] = (d) => e.$emit(
            "update:modelValue",
            i.result.filter((f) => f !== null)
          )),
          "aria-describedby": `${e.id}-help`
        }, null, 40, Dh), [
          [ks, i.result]
        ]),
        p("label", {
          class: "form-check-label",
          for: `${e.id}-${u}`
        }, E(a), 9, Oh)
      ]))), 128)),
      t.hideClearButton ? v("", !0) : (l(), c("button", {
        key: 0,
        class: "checkbox-clear-value btn-link btn m-0 p-0",
        onClick: n[2] || (n[2] = Ke((a) => {
          i.result = [], e.$emit("update:modelValue", i.result);
        }, ["prevent"]))
      }, " clear "))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Mh = /* @__PURE__ */ D(Ih, [["render", _h]]), { POLICY_TEXT_KEY: Ph } = Cd, Bh = Re({
  name: "MolgenisSignin",
  components: {
    ButtonAlt: ot,
    InputPassword: Ji,
    InputString: At,
    MessageError: it,
    MessageSuccess: pn,
    FormMolgenis: Th,
    LayoutModal: Kt,
    ButtonSubmit: Uh,
    InputCheckbox: Mh
  },
  data: function() {
    return {
      email: "",
      password: "",
      error: "",
      success: null,
      loading: !1,
      userAgrees: [],
      privacyPolicyLabel: "Agree with privacy policy",
      privacyPolicy: "",
      isPrivacyPolicyEnabled: !1,
      privacyError: "Please agree with the privacy policy"
    };
  },
  methods: {
    async signin() {
      !this.email || !this.password ? this.error = "Email and password should be filled in" : this.isPrivacyPolicyEnabled && this.userAgrees[0] !== this.privacyPolicyLabel ? this.error = this.privacyError : (this.error = "", this.loading = !0, Be(
        "/api/graphql",
        `mutation{signin(email: "${this.email}", password: "${this.password}"){status,message}}`
      ).then(
        (e) => {
          e.signin.status === "SUCCESS" ? (this.success = "Signed in with " + this.email, this.$emit("signin", this.email)) : this.error = e.signin.message;
        }
      ).catch(
        (e) => this.error = "internal server graphqlError" + e
      ), this.loading = !1);
    },
    onSignInFailed(e) {
      this.error = e, this.$emit("signInFailed", this.email);
    },
    onCancel() {
      this.error = "", this.$emit("cancel");
    },
    async fetchPrivacyPolicy() {
      const e = await Be(
        "graphql",
        "{_settings{key, value}}"
      ), n = e._settings.find(
        (o) => o.key === Ph
      );
      this.privacyPolicy = n == null ? void 0 : n.value;
      const t = e._settings.find((o) => o.key === "isPrivacyPolicyEnabled");
      this.isPrivacyPolicyEnabled = (t == null ? void 0 : t.value) === "true";
    }
  },
  watch: {
    async show(e) {
      e === !0 && await this.$nextTick(), this.$refs.email.$el.children[1].focus();
    }
  },
  emits: ["cancel", "signInFailed", "signin"],
  mounted() {
    this.fetchPrivacyPolicy();
  }
}), Lh = { key: 0 };
function Nh(e, n, t, o, i, r) {
  const s = K("MessageSuccess"), a = K("ButtonAlt"), u = K("MessageError"), d = K("InputString"), f = K("InputPassword"), y = K("InputCheckbox"), C = K("FormMolgenis"), U = K("ButtonSubmit"), g = K("LayoutModal");
  return e.success ? (l(), c("div", Lh, [
    T(s, null, {
      default: b(() => [
        _(E(e.success), 1)
      ]),
      _: 1
    }),
    T(a, { onClick: e.onCancel }, {
      default: b(() => [...n[3] || (n[3] = [
        _("Close", -1)
      ])]),
      _: 1
    }, 8, ["onClick"])
  ])) : (l(), F(g, {
    key: 1,
    title: "Sign in",
    show: !0,
    onClose: e.onCancel
  }, {
    body: b(() => [
      T(C, {
        id: "signin-form",
        onSubmit: e.signin
      }, {
        default: b(() => [
          e.error ? (l(), F(u, { key: 0 }, {
            default: b(() => [
              _(E(e.error), 1)
            ]),
            _: 1
          })) : v("", !0),
          T(d, {
            id: "signInFormEmail",
            ref: "email",
            name: "email",
            modelValue: e.email,
            "onUpdate:modelValue": n[0] || (n[0] = (A) => e.email = A),
            label: "Username",
            placeholder: "Enter username",
            description: "Please enter username",
            autofocus: ""
          }, null, 8, ["modelValue"]),
          T(f, {
            id: "signInFormPassword",
            name: "password",
            modelValue: e.password,
            "onUpdate:modelValue": n[1] || (n[1] = (A) => e.password = A),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the provided password",
            onEnterPressed: e.signin
          }, null, 8, ["modelValue", "onEnterPressed"]),
          e.isPrivacyPolicyEnabled ? (l(), c("div", {
            key: 1,
            class: G(["alert", e.error === e.privacyError ? "alert-danger" : "alert-info"]),
            role: "alert"
          }, [
            n[4] || (n[4] = p("b", null, "Privacy policy", -1)),
            p("p", null, E(e.privacyPolicy), 1),
            T(y, {
              class: "mb-0",
              id: "privacy-agreement",
              name: "privacy-agreement",
              required: !0,
              options: [e.privacyPolicyLabel],
              hideClearButton: !0,
              modelValue: e.userAgrees,
              "onUpdate:modelValue": n[2] || (n[2] = (A) => e.userAgrees = A)
            }, null, 8, ["options", "modelValue"])
          ], 2)) : v("", !0)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    footer: b(() => [
      T(a, { onClick: e.onCancel }, {
        default: b(() => [...n[5] || (n[5] = [
          _("Cancel", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]),
      T(U, { form: "signin-form" }, {
        default: b(() => [...n[6] || (n[6] = [
          _(" Sign in ", -1)
        ])]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const qh = /* @__PURE__ */ D(Bh, [["render", Nh]]), xh = {};
function Vh(e, n, t, o, i, r) {
  return l(), c("form", null, [
    j(e.$slots, "default")
  ]);
}
const jh = /* @__PURE__ */ D(xh, [["render", Vh]]), Hh = Re({
  components: {
    ButtonAction: He,
    ButtonAlt: ot,
    InputPassword: Ji,
    InputString: At,
    MessageError: it,
    MessageSuccess: pn,
    LayoutForm: jh,
    Spinner: yt,
    LayoutModal: Kt
  },
  data: function() {
    return {
      email: null,
      password: null,
      passwordRepeat: null,
      loading: !1,
      error: null,
      success: null
    };
  },
  methods: {
    signup() {
      this.email === null || this.password === null || this.passwordRepeat === null ? this.error = "Error: valid email address and password should be filled in" : this.password !== this.passwordRepeat ? this.error = "Error: Passwords entered must be the same" : (this.error = null, this.loading = !0, Be(
        "/api/graphql",
        `mutation{signup(email: "${this.email}", password: "${this.password}"){status,message}}`
      ).then((e) => {
        e.signup.status === "SUCCESS" ? this.success = "Success. Signed up with email: " + this.email : this.error = "Signup failed: " + e.signup.message;
      }).catch((e) => {
        this.error = "Sign up failed: " + e.response.message;
      }), this.loading = !1);
    },
    close() {
      this.error = null, this.$emit("close");
    }
  },
  emits: ["close"]
});
function Gh(e, n, t, o, i, r) {
  const s = K("Spinner"), a = K("MessageSuccess"), u = K("ButtonAlt"), d = K("LayoutModal"), f = K("MessageError"), y = K("InputString"), C = K("InputPassword"), U = K("LayoutForm"), g = K("ButtonAction");
  return e.loading ? (l(), F(s, { key: 0 })) : e.success ? (l(), F(d, {
    key: 1,
    title: "Sign up",
    show: !0
  }, {
    body: b(() => [
      T(a, null, {
        default: b(() => [
          _(E(e.success), 1)
        ]),
        _: 1
      })
    ]),
    footer: b(() => [
      T(u, { onClick: e.close }, {
        default: b(() => [...n[3] || (n[3] = [
          _("Close", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  })) : (l(), F(d, {
    key: 2,
    title: "Sign up",
    show: !0,
    onClose: e.close
  }, {
    body: b(() => [
      T(U, null, {
        default: b(() => [
          e.error ? (l(), F(f, { key: 0 }, {
            default: b(() => [
              _(E(e.error), 1)
            ]),
            _: 1
          })) : v("", !0),
          T(y, {
            id: "signup-email",
            modelValue: e.email,
            "onUpdate:modelValue": n[0] || (n[0] = (A) => e.email = A),
            label: "Email address",
            placeholder: "Enter valid email address",
            description: "Please enter your email address"
          }, null, 8, ["modelValue"]),
          T(C, {
            id: "signup-password",
            modelValue: e.password,
            "onUpdate:modelValue": n[1] || (n[1] = (A) => e.password = A),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the password",
            onEnterPressed: e.signup
          }, null, 8, ["modelValue", "onEnterPressed"]),
          T(C, {
            id: "signup-password-repeat",
            modelValue: e.passwordRepeat,
            "onUpdate:modelValue": n[2] || (n[2] = (A) => e.passwordRepeat = A),
            label: "Password Repeat",
            placeholder: "Enter password",
            description: "Please enter the password again",
            onEnterPressed: e.signup
          }, null, 8, ["modelValue", "onEnterPressed"])
        ]),
        _: 1
      })
    ]),
    footer: b(() => [
      T(u, { onClick: e.close }, {
        default: b(() => [...n[4] || (n[4] = [
          _("Cancel", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]),
      T(g, { onClick: e.signup }, {
        default: b(() => [...n[5] || (n[5] = [
          _("Sign up", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const Qh = /* @__PURE__ */ D(Hh, [["render", Gh]]);
var Yr = {
  expireTimes: "1d",
  path: "; path=/",
  domain: "",
  secure: !1,
  sameSite: "; SameSite=Lax"
}, $h = (
  /** @class */
  function() {
    function e() {
      this.current_default_config = Yr;
    }
    return e.prototype.config = function(n) {
      for (var t in this.current_default_config)
        this.current_default_config[t] = n[t] ? n[t] : Yr[t];
    }, e.prototype.get = function(n) {
      var t = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(n).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      if (t && t.substring(0, 1) === "{" && t.substring(t.length - 1, t.length) === "}")
        try {
          t = JSON.parse(t);
        } catch {
          return t;
        }
      return t;
    }, e.prototype.set = function(n, t, o, i, r, s, a) {
      if (n) {
        if (/^(?:expires|max-age|path|domain|secure|SameSite)$/i.test(n))
          throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + n);
      } else throw new Error("Cookie name is not found in the first argument.");
      t && t.constructor === Object && (t = JSON.stringify(t));
      var u = "";
      if (o == null && (o = this.current_default_config.expireTimes ? this.current_default_config.expireTimes : ""), o && o != 0)
        switch (o.constructor) {
          case Number:
            o === 1 / 0 || o === -1 ? u = "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : u = "; max-age=" + o;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(o)) {
              var d = o.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
              switch (o.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                case "m":
                  u = "; max-age=" + +d * 2592e3;
                  break;
                case "d":
                  u = "; max-age=" + +d * 86400;
                  break;
                case "h":
                  u = "; max-age=" + +d * 3600;
                  break;
                case "min":
                  u = "; max-age=" + +d * 60;
                  break;
                case "s":
                  u = "; max-age=" + d;
                  break;
                case "y":
                  u = "; max-age=" + +d * 31104e3;
                  break;
              }
            } else
              u = "; expires=" + o;
            break;
          case Date:
            u = "; expires=" + o.toUTCString();
            break;
        }
      return document.cookie = encodeURIComponent(n) + "=" + encodeURIComponent(t) + u + (r ? "; domain=" + r : this.current_default_config.domain ? this.current_default_config.domain : "") + (i ? "; path=" + i : this.current_default_config.path ? this.current_default_config.path : "; path=/") + (s == null ? this.current_default_config.secure ? "; Secure" : "" : s ? "; Secure" : "") + (a == null ? this.current_default_config.sameSite ? "; SameSute=" + this.current_default_config.sameSite : "" : a ? "; SameSite=" + a : ""), this;
    }, e.prototype.remove = function(n, t, o) {
      return !n || !this.isKey(n) ? !1 : (document.cookie = encodeURIComponent(n) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (o ? "; domain=" + o : this.current_default_config.domain ? this.current_default_config.domain : "") + (t ? "; path=" + t : this.current_default_config.path ? this.current_default_config.path : "; path=/") + "; SameSite=Lax", !0);
    }, e.prototype.isKey = function(n) {
      return new RegExp("(?:^|;\\s*)" + encodeURIComponent(n).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    }, e.prototype.keys = function() {
      if (!document.cookie)
        return [];
      for (var n = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), t = 0; t < n.length; t++)
        n[t] = decodeURIComponent(n[t]);
      return n;
    }, e;
  }()
), oi = null;
function Va() {
  oi == null && (oi = new $h());
  var e = Us(oi);
  return { cookies: e };
}
const { cookies: Jh } = Va(), zh = {
  name: "LocaleSwitch",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    locales: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      cookies: null
    };
  },
  methods: {
    emit(e) {
      e.target.value !== void 0 ? (Jh.set("MOLGENIS.locale", e.target.value), this.$emit("update:modelValue", e.target.value)) : this.$emit("update:modelValue", "en");
    }
  },
  emits: ["update:modelValue"]
}, Yh = { class: "d-inline-flex from-group" }, Wh = ["modelValue"], Xh = ["selected"];
function Zh(e, n, t, o, i, r) {
  return l(), c("div", Yh, [
    p("select", {
      class: "form-control bg-primary text-white border-0 mr-2 pl-0 pr-0",
      modelValue: t.modelValue,
      onInput: n[0] || (n[0] = (...s) => r.emit && r.emit(...s))
    }, [
      (l(!0), c(oe, null, ae(t.locales, (s) => (l(), c("option", {
        key: s,
        selected: s === t.modelValue
      }, E(s), 9, Xh))), 128))
    ], 40, Wh)
  ]);
}
const em = /* @__PURE__ */ D(zh, [["render", Zh]]), { cookies: tm } = Va(), Wr = `{
  _session { email, admin, roles, schemas, token, settings{key,value} },
  _settings (keys: ["menu", "page.", "cssURL", "logoURL", "isOidcEnabled","locales", "additionalCss", "additionalFooterHtml", "additionalJs"]){ key, value },
  _manifest { ImplementationVersion,SpecificationVersion,DatabaseVersion }
}`, Xr = { locale: "en", settings: {} }, nm = Re({
  components: {
    ButtonOutline: Po,
    MolgenisSignin: qh,
    SignupForm: Qh,
    MolgenisAccount: vh,
    Spinner: yt,
    ButtonAlt: ot,
    LocaleSwitch: em
  },
  props: {
    graphql: {
      default: "graphql",
      type: String
    }
  },
  data: function() {
    return {
      showSigninForm: !1,
      showSignupForm: !1,
      showChangePasswordForm: !1,
      error: null,
      loading: !1,
      session: Xr,
      version: null
    };
  },
  watch: {
    email() {
      this.showSigninForm = !1, this.showSignupForm = !1;
    }
  },
  created() {
    this.reload();
  },
  computed: {
    isOidcEnabled() {
      var e, n;
      return ((n = (e = this.session) == null ? void 0 : e.settings) == null ? void 0 : n.isOidcEnabled) === "true";
    },
    oidcLoginUrl() {
      var n;
      return "/_login" + ((n = window == null ? void 0 : window.location) != null && n.href ? `?redirect=${window.location.href}` : "");
    },
    locales() {
      var e, n;
      if ((n = (e = this.session) == null ? void 0 : e.settings) != null && n.locales) {
        if (Array.isArray(this.session.settings.locales))
          return this.session.settings.locales;
        this.error = 'locales should be array similar to ["en"] but instead was ' + JSON.stringify(this.session.settings.locales);
      }
      return ["en"];
    }
  },
  methods: {
    loadSettings(e) {
      e._settings.forEach((n) => {
        var o, i;
        const t = (o = n.value) != null && o.startsWith("[") || (i = n.value) != null && i.startsWith("{") ? this.parseJson(n.value) : n.value;
        this.session.settings === void 0 && (this.session.settings = {}), this.session.settings[n.key] = t;
      });
    },
    async reload() {
      this.loading = !0;
      const e = await Promise.allSettled([
        Be("/apps/central/graphql", Wr),
        Be(this.graphql, Wr)
      ]), n = e[0].status === "fulfilled" ? e[0].value : this.handleError(e[0].reason), t = e[1].status === "fulfilled" ? e[1].value : this.handleError(e[1].reason);
      if (t && t._session ? this.session = t._session : this.session = Xr, n && n._settings && (this.loadSettings(n), this.session.manifest = n._manifest), t && t._settings && (this.loadSettings(t), this.session.settings && t._settings.find((o) => o.key === "menu") === void 0 && (n == null ? void 0 : n._settings.find((o) => o.key === "menu")) !== void 0 && delete this.session.settings.menu, this.session.manifest = t._manifest), this.session.locale === void 0) {
        const o = tm.get("MOLGENIS.locale");
        o && (this.session.locale = o);
      }
      this.loading = !1, this.$emit("update:modelValue", this.session);
    },
    handleError(e) {
      var n, t, o;
      this.error = "internal server error " + e, (o = (t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : t.errors[0]) != null && o.message ? this.$emit("error", e.response.data.errors[0].message) : this.$emit("error", this.error);
    },
    parseJson(e) {
      try {
        return JSON.parse(e);
      } catch (n) {
        return this.error = "Parsing of settings failed: " + n + ". value: " + e, null;
      }
    },
    changed() {
      this.reload(), this.showSigninForm = !1, this.$emit("update:modelValue", this.session);
    },
    closeSigninForm() {
      this.showSigninForm = !1, this.error = null;
    },
    closeSignupForm() {
      this.showSignupForm = !1, this.error = null;
    },
    async signout() {
      this.loading = !0, this.showSigninForm = !1, (await Be("graphql", "mutation{signout{status}}").catch(
        (n) => this.error = "internal server error" + n
      )).signout.status === "SUCCESS" ? this.session = {} : this.error = "sign out failed", this.loading = !1, this.$emit("update:modelValue", this.session), this.reload();
    }
  },
  emits: ["update:modelValue", "error"]
}), om = { key: 1 }, im = { key: 0 }, rm = { key: 1 };
function sm(e, n, t, o, i, r) {
  const s = K("Spinner"), a = K("ButtonAlt"), u = K("MolgenisAccount"), d = K("ButtonOutline"), f = K("SignupForm"), y = K("MolgenisSignin"), C = K("LocaleSwitch");
  return e.loading ? (l(), F(s, { key: 0 })) : (l(), c("div", om, [
    p("div", null, [
      e.session.email && e.session.email != "anonymous" ? (l(), c("span", im, [
        T(a, {
          onClick: n[0] || (n[0] = (U) => e.showChangePasswordForm = !0),
          class: "text-light"
        }, {
          default: b(() => [
            _(" Hi " + E(e.session.email), 1)
          ]),
          _: 1
        }),
        n[6] || (n[6] = _("  ", -1)),
        e.showChangePasswordForm ? (l(), F(u, {
          key: 0,
          error: e.error,
          onCancel: n[1] || (n[1] = (U) => e.showChangePasswordForm = !1)
        }, null, 8, ["error"])) : v("", !0),
        T(d, {
          onClick: e.signout,
          light: !0
        }, {
          default: b(() => [...n[5] || (n[5] = [
            _("Sign out", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ])) : (l(), c("span", rm, [
        We(T(a, {
          onClick: n[2] || (n[2] = (U) => e.showSignupForm = !0),
          light: !0
        }, {
          default: b(() => [...n[7] || (n[7] = [
            _(" Sign up ", -1)
          ])]),
          _: 1
        }, 512), [
          [Fo, !e.isOidcEnabled]
        ]),
        e.showSignupForm ? (l(), F(f, {
          key: 0,
          error: e.error,
          onClose: e.closeSignupForm
        }, null, 8, ["error", "onClose"])) : v("", !0),
        e.isOidcEnabled ? (l(), F(d, {
          key: 1,
          href: e.oidcLoginUrl,
          light: !0
        }, {
          default: b(() => [...n[8] || (n[8] = [
            _(" Sign in", -1)
          ])]),
          _: 1
        }, 8, ["href"])) : (l(), F(d, {
          key: 2,
          onClick: n[3] || (n[3] = (U) => e.showSigninForm = !0),
          light: !0
        }, {
          default: b(() => [...n[9] || (n[9] = [
            _(" Sign in", -1)
          ])]),
          _: 1
        })),
        e.showSigninForm ? (l(), F(y, {
          key: 3,
          onSignin: e.changed,
          onCancel: e.closeSigninForm
        }, null, 8, ["onSignin", "onCancel"])) : v("", !0)
      ])),
      e.locales.length > 1 ? (l(), F(C, {
        key: 2,
        class: "ml-2",
        modelValue: e.session.locale,
        "onUpdate:modelValue": n[4] || (n[4] = (U) => e.session.locale = U),
        locales: e.locales
      }, null, 8, ["modelValue", "locales"])) : v("", !0)
    ]),
    (l(), F(Et("style"), null, {
      default: b(() => {
        var U, g;
        return [
          _(E((g = (U = e.session) == null ? void 0 : U.settings) == null ? void 0 : g.additionalCss), 1)
        ];
      }),
      _: 1
    }))
  ]));
}
const am = /* @__PURE__ */ D(nm, [["render", sm]]), lm = {
  name: "PersonDetails",
  computed: {
    imgSrc() {
      return `
        data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQ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        `;
    }
  }
}, um = { class: "card" }, dm = { class: "row no-gutters" }, cm = { class: "col-8 small" }, fm = { class: "col-4" }, pm = ["src"];
function hm(e, n, t, o, i, r) {
  return l(), c("div", um, [
    p("div", dm, [
      p("div", cm, [
        j(e.$slots, "details", {}, () => [
          n[0] || (n[0] = p("strong", null, "Anonymous", -1))
        ], !0)
      ]),
      p("div", fm, [
        j(e.$slots, "image", {}, () => [
          p("img", {
            src: r.imgSrc,
            alt: "person-place-holder-image",
            class: "img-thumbnail"
          }, null, 8, pm)
        ], !0)
      ])
    ])
  ]);
}
const mm = /* @__PURE__ */ D(lm, [["render", hm], ["__scopeId", "data-v-283371f3"]]), Am = {
  name: "ContactDisplay",
  components: { PersonDetails: mm },
  props: {
    contact: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    contributionType: {
      type: Array,
      required: !1,
      default: () => []
    },
    contributionDescription: {
      type: String,
      required: !1
    }
  },
  computed: {
    contributions() {
      return [...this.contributionType].sort((e, n) => e.order - n.order).map((e) => e.name).join(",");
    },
    imgSrc() {
      return this.contact.photo && this.contact.photo.url ? this.contact.photo.url : null;
    }
  }
}, gm = { key: 0 }, ym = { key: 1 }, Km = { key: 2 }, vm = { key: 3 }, bm = { key: 4 }, Cm = { key: 0 }, wm = { key: 1 }, Fm = {
  key: 2,
  class: "mt-3"
}, Rm = {
  key: 3,
  class: "mt-3"
}, km = ["src", "alt"];
function Um(e, n, t, o, i, r) {
  const s = K("person-details");
  return l(), F(s, null, Ml({
    details: b(() => [
      p("strong", null, [
        t.contact.title && t.contact.title.name ? (l(), c("span", gm, E(t.contact.title.name), 1)) : v("", !0),
        t.contact.initials ? (l(), c("span", ym, E(t.contact.initials), 1)) : v("", !0),
        t.contact.firstName && t.contact.initials ? (l(), c("span", Km, " (" + E(t.contact.firstName) + ") ", 1)) : t.contact.firstName ? (l(), c("span", vm, E(t.contact.firstName), 1)) : v("", !0),
        t.contact.surname ? (l(), c("span", bm, E(t.contact.surname), 1)) : v("", !0)
      ]),
      r.contributions.length ? (l(), c("div", Cm, E(r.contributions), 1)) : v("", !0),
      t.contact.email ? (l(), c("div", wm, E(t.contact.email), 1)) : v("", !0),
      t.contributionDescription ? (l(), c("div", Fm, [
        p("p", null, E(t.contributionDescription), 1)
      ])) : v("", !0),
      t.contact.department ? (l(), c("div", Rm, [
        p("p", null, E(t.contact.department), 1)
      ])) : v("", !0)
    ]),
    _: 2
  }, [
    r.imgSrc ? {
      name: "image",
      fn: b(() => [
        p("img", {
          src: r.imgSrc,
          alt: t.contact.surname + "-image",
          class: "img-thumbnail"
        }, null, 8, km)
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const k1 = /* @__PURE__ */ D(Am, [["render", Um], ["__scopeId", "data-v-5583439c"]]), Em = {
  name: "GridBlock",
  props: {
    heading: {
      type: String,
      required: !1
    }
  }
}, Sm = { class: "card block" }, Tm = { key: 0 };
function Im(e, n, t, o, i, r) {
  return l(), c("div", Sm, [
    t.heading ? (l(), c("h3", Tm, E(t.heading), 1)) : v("", !0),
    j(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Dm = /* @__PURE__ */ D(Em, [["render", Im], ["__scopeId", "data-v-7318de25"]]), Om = {
  name: "ImageCard",
  props: {
    title: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !1
    },
    linkUrl: {
      type: String,
      required: !1
    },
    linkText: {
      type: String,
      required: !1,
      default: () => "LEARN MORE"
    }
  }
}, _m = { class: "card image-card" }, Mm = { class: "card-body" }, Pm = {
  key: 0,
  class: "card-title"
}, Bm = {
  key: 1,
  class: "card-text"
}, Lm = {
  key: 2,
  class: "card-text"
}, Nm = { class: "text-muted" }, qm = ["href"];
function xm(e, n, t, o, i, r) {
  return l(), c("div", _m, [
    j(e.$slots, "image"),
    p("div", Mm, [
      j(e.$slots, "body", {}, () => [
        t.title ? (l(), c("h5", Pm, E(t.title), 1)) : v("", !0),
        t.description ? (l(), c("p", Bm, E(t.description), 1)) : v("", !0),
        t.linkUrl ? (l(), c("p", Lm, [
          p("small", Nm, [
            p("a", {
              href: t.linkUrl,
              class: "stretched-link"
            }, E(t.linkText), 9, qm)
          ])
        ])) : v("", !0)
      ])
    ])
  ]);
}
const U1 = /* @__PURE__ */ D(Om, [["render", xm]]), Vm = {
  name: "ImageDisplay",
  props: {
    url: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      required: !1,
      default: () => "image"
    },
    id: {
      type: String,
      required: !1
    },
    size: {
      type: Number,
      required: !1
    },
    extension: {
      type: String,
      required: !1
    },
    isClickable: {
      type: Boolean,
      default: () => !1
    }
  }
}, jm = ["src", "alt"];
function Hm(e, n, t, o, i, r) {
  return l(), c("img", {
    src: t.url,
    alt: t.alt,
    class: G(["img-thumbnail", { clickable: t.isClickable }]),
    onClick: n[0] || (n[0] = (s) => e.$emit("clicked", t.id))
  }, null, 10, jm);
}
const E1 = /* @__PURE__ */ D(Vm, [["render", Hm], ["__scopeId", "data-v-b58d7d8b"]]), Gm = {
  props: {
    text: String,
    length: {
      type: Number,
      default: () => 20
    }
  },
  data() {
    return {
      expand: !1
    };
  }
}, Qm = { key: 0 }, $m = { key: 1 }, Jm = { key: 2 }, zm = { key: 3 };
function Ym(e, n, t, o, i, r) {
  return l(), c("div", null, [
    t.text === "undefined" ? (l(), c("span", Qm)) : t.text.length <= t.length ? (l(), c("span", $m, E(t.text), 1)) : i.expand ? (l(), c("span", Jm, [
      _(E(t.text) + " ", 1),
      p("a", {
        onClick: n[0] || (n[0] = Ke((s) => i.expand = !1, ["stop", "prevent"])),
        href: "#"
      }, "...show less ")
    ])) : (l(), c("span", zm, [
      _(E(t.text.slice(0, t.length)) + " ", 1),
      p("a", {
        onClick: n[1] || (n[1] = Ke((s) => i.expand = !0, ["stop", "prevent"])),
        href: "#",
        title: "Expand text"
      }, " ...show more ")
    ]))
  ]);
}
const ja = /* @__PURE__ */ D(Gm, [["render", Ym]]), Wm = {
  name: "KeyValueBlock",
  components: { GridBlock: Dm, ReadMore: ja },
  props: {
    heading: {
      type: String,
      required: !1
    },
    /**
     * List of items
     * Item has:
     * key: String (required)
     * label: String (required)
     * value: String, Number, Boolean, Object
     */
    items: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  computed: {
    computedHeading() {
      return this.heading ? this.heading : this.items.length === 1 ? this.items[0].label : null;
    }
  }
}, Xm = { key: 1 }, Zm = {
  key: 0,
  class: "list-unstyled"
}, eA = { key: 1 };
function tA(e, n, t, o, i, r) {
  const s = K("read-more"), a = K("grid-block");
  return l(), F(a, { heading: r.computedHeading }, {
    default: b(() => [
      t.items.length === 1 && t.items[0].value ? (l(), F(s, {
        key: 0,
        text: t.items[0].value,
        length: 750
      }, null, 8, ["text"])) : t.items.length > 1 ? (l(), c("div", Xm, [
        (l(!0), c(oe, null, ae(t.items, (u, d) => (l(), c("div", { key: d }, [
          p("strong", null, E(u.label), 1),
          Array.isArray(u.value) ? (l(), c("ul", Zm, [
            (l(!0), c(oe, null, ae(u.value, (f, y) => (l(), c("li", { key: y }, E(f), 1))), 128))
          ])) : (l(), c("p", eA, E(u.value), 1))
        ]))), 128))
      ])) : v("", !0)
    ]),
    _: 1
  }, 8, ["heading"]);
}
const S1 = /* @__PURE__ */ D(Wm, [["render", tA]]), nA = {
  name: "LinksList",
  props: {
    /**
     * List of link items
     * Link item has:
     * label: String
     * href: String (required)
     * text: String
     */
    items: {
      type: Array,
      required: !0
    },
    isHorizontal: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  }
}, oA = {
  key: 0,
  class: "font-weight-bold pr-1"
}, iA = ["href"], rA = ["href"];
function sA(e, n, t, o, i, r) {
  return l(), c("ul", {
    class: G(["list-group", { "list-group-horizontal": t.isHorizontal }])
  }, [
    (l(!0), c(oe, null, ae(t.items, (s, a) => (l(), c("li", {
      class: "list-group-item",
      key: a
    }, [
      s.label ? (l(), c("span", oA, E(s.label), 1)) : v("", !0),
      s.text ? (l(), c("a", {
        key: 1,
        href: s.href
      }, E(s.text), 9, iA)) : (l(), c("a", {
        key: 2,
        href: s.href
      }, E(s.href), 9, rA))
    ]))), 128))
  ], 2);
}
const T1 = /* @__PURE__ */ D(nA, [["render", sA], ["__scopeId", "data-v-191b287c"]]), aA = {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      required: !0
    },
    subTitle: {
      type: String,
      required: !1
    },
    subTitleLink: {
      type: [String, Object],
      required: !1
    },
    logoUrl: {
      type: String,
      required: !1
    }
  },
  computed: {
    nTitleColumns() {
      return this.logoUrl ? 9 : 12;
    },
    isVueRouterLink() {
      return this.subTitleLink && typeof this.subTitleLink == "object" || typeof this.subTitleLink == "string" && !(this.subTitleLink.startsWith("http://") || this.subTitleLink.startsWith("https://"));
    }
  }
}, lA = { class: "row" }, uA = {
  key: 0,
  class: "col-3 d-flex flex-row-reverse"
}, dA = ["src"], cA = { key: 0 }, fA = { class: "text-muted" }, pA = ["href"];
function hA(e, n, t, o, i, r) {
  const s = K("router-link");
  return l(), c("div", null, [
    p("div", lA, [
      p("div", {
        class: G("col-" + r.nTitleColumns)
      }, [
        p("h1", null, E(t.title), 1)
      ], 2),
      t.logoUrl ? (l(), c("div", uA, [
        p("img", {
          class: "justify-content-center align-self-center",
          src: t.logoUrl,
          alt: "page logo"
        }, null, 8, dA)
      ])) : v("", !0)
    ]),
    t.subTitle ? (l(), c("h3", cA, [
      p("small", fA, [
        t.subTitleLink && r.isVueRouterLink ? (l(), F(s, Pi(On({ key: 0 }, t.subTitleLink)), {
          default: b(() => [
            _(E(t.subTitle), 1)
          ]),
          _: 1
        }, 16)) : t.subTitleLink && !r.isVueRouterLink ? (l(), c("a", {
          key: 1,
          href: t.subTitleLink
        }, E(t.subTitle), 9, pA)) : (l(), c(oe, { key: 2 }, [
          _(E(t.subTitle), 1)
        ], 64))
      ])
    ])) : v("", !0)
  ]);
}
const I1 = /* @__PURE__ */ D(aA, [["render", hA], ["__scopeId", "data-v-1dd47602"]]), mA = {
  name: "TableDisplay",
  props: {
    /**
     * List of column objects, each object has a label and name
     */
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * List of row objects, each row is a key value object, where the keys refer to the column.name property
     */
    rows: {
      type: Array,
      default: () => []
    },
    isClickable: {
      type: Boolean,
      default: () => !1
    }
  }
}, AA = ["onClick"];
function gA(e, n, t, o, i, r) {
  return l(), c("table", {
    class: G(["table", { "table-hover": t.isClickable }])
  }, [
    p("thead", null, [
      p("tr", null, [
        (l(!0), c(oe, null, ae(t.columns, (s, a) => (l(), c("th", {
          key: a,
          scope: "col"
        }, E(s.label), 1))), 128))
      ])
    ]),
    p("tbody", null, [
      (l(!0), c(oe, null, ae(t.rows, (s, a) => (l(), c("tr", {
        key: a,
        onClick: (u) => e.$emit("row-click", s)
      }, [
        (l(!0), c(oe, null, ae(t.columns, (u, d) => (l(), c("td", { key: d }, E(s[u.name]), 1))), 128))
      ], 8, AA))), 128))
    ])
  ], 2);
}
const D1 = /* @__PURE__ */ D(mA, [["render", gA]]), yA = {
  components: {
    IconAction: ct
  },
  data() {
    return {
      expandedState: this.expanded
    };
  },
  props: {
    title: String,
    conditions: Array,
    expanded: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    count() {
      return Array.isArray(this.conditions) ? this.conditions.length : null;
    }
  }
}, KA = { class: "mb-2 pt-2 border-top bg-white" }, vA = { class: "mb-0 font-weight-bold p-2" }, bA = {
  key: 0,
  class: "badge badge-secondary"
}, CA = {
  key: 0,
  class: "p-2"
};
function wA(e, n, t, o, i, r) {
  const s = K("IconAction");
  return l(), c("div", KA, [
    p("div", {
      class: "filter-header d-flex flex-row justify-content-between",
      onClick: n[0] || (n[0] = (a) => i.expandedState = !i.expandedState)
    }, [
      p("h6", vA, [
        _(E(t.title) + " ", 1),
        r.count > 0 ? (l(), c("span", bA, E(r.count), 1)) : v("", !0)
      ]),
      T(s, {
        class: "ml-auto",
        icon: i.expandedState ? "angle-up" : "angle-down"
      }, null, 8, ["icon"])
    ]),
    j(e.$slots, "header", {}, void 0, !0),
    i.expandedState ? (l(), c("div", CA, [
      j(e.$slots, "default", {}, void 0, !0)
    ])) : v("", !0)
  ]);
}
const FA = /* @__PURE__ */ D(yA, [["render", wA], ["__scopeId", "data-v-6316fb7d"]]), RA = {
  name: "StringFilter",
  components: { InputString: At },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: String,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function kA(e, n, t, o, i, r) {
  const s = K("InputString");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: b(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const rt = /* @__PURE__ */ D(RA, [["render", kA]]), { CODE_MINUS: UA } = Tt, EA = {
  extends: Ce,
  methods: {
    emitIfValid(e) {
      const n = e.target.value;
      isNaN(n) || !n ? this.$emit("update:modelValue", null) : this.$emit("update:modelValue", parseInt(n));
    },
    handleKeyValidity(e) {
      if ((e.which ? e.which : e.keyCode) === UA) {
        const t = Hi(e.target.value);
        typeof t == "string" ? this.$emit("update:modelValue", parseInt(t)) : this.$emit("update:modelValue", t);
      }
      (!ji(e) || e.key === ".") && e.preventDefault();
    },
    isRequired: Nn
  }
}, SA = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function TA(e, n, t, o, i, r) {
  return l(), c("input", {
    id: e.id,
    type: "number",
    step: "1",
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (...s) => r.handleKeyValidity && r.handleKeyValidity(...s)),
    onInput: n[1] || (n[1] = (...s) => r.emitIfValid && r.emitIfValid(...s))
  }, null, 42, SA);
}
const Ha = /* @__PURE__ */ D(EA, [["render", TA]]), IA = {
  components: { BaseIntInput: Ha, FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e === "" ? null : parseInt(e), this.$emit("update:modelValue", t);
    }
  }
};
function DA(e, n, t, o, i, r) {
  const s = K("BaseIntInput"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id + "-from",
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, { class: "d-flex" }, {
        prepend: b(() => [
          j(e.$slots, "prepend")
        ]),
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          T(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const OA = /* @__PURE__ */ D(IA, [["render", DA]]), _A = {
  name: "IntegerFilter",
  components: { InputRangeInt: OA },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function MA(e, n, t, o, i, r) {
  const s = K("InputRangeInt");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: b(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Fi = /* @__PURE__ */ D(_A, [["render", MA]]), { CODE_MINUS: PA, CODE_PERIOD: BA } = Tt, LA = {
  extends: Ce,
  methods: {
    handleInputChanged(e) {
      var t;
      const n = (t = e.target) == null ? void 0 : t.value;
      n ? this.emitIfValid(n) : this.$emit("update:modelValue", null);
    },
    emitIfValid(e) {
      if (e === null) {
        this.$emit("update:modelValue", null);
        return;
      }
      const n = e.replace(",", ""), t = parseFloat(n);
      isNaN(t) ? this.$emit("update:modelValue", e) : this.$emit("update:modelValue", t);
    },
    handleKeyValidity(e) {
      var t, o;
      const n = e.which ?? e.keyCode;
      if (n === PA) {
        const i = Hi((t = e.target) == null ? void 0 : t.value);
        this.emitIfValid(i);
      }
      n === BA && ((o = e.target) == null ? void 0 : o.value.indexOf(".")) > -1 && e.preventDefault(), ji(e) || e.preventDefault();
    },
    isRequired: Nn
  }
}, NA = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function qA(e, n, t, o, i, r) {
  return l(), c("input", {
    id: e.id,
    type: "text",
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (...s) => r.handleKeyValidity && r.handleKeyValidity(...s)),
    onInput: n[1] || (n[1] = (...s) => r.handleInputChanged && r.handleInputChanged(...s))
  }, null, 42, NA);
}
const Ga = /* @__PURE__ */ D(LA, [["render", qA]]), xA = {
  components: { FormGroup: ke, BaseInputDecimal: Ga, InputGroup: Ve },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e, this.$emit("update:modelValue", t);
    }
  }
};
function VA(e, n, t, o, i, r) {
  const s = K("BaseInputDecimal"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id + "-from",
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, { class: "d-flex" }, {
        prepend: b(() => [
          j(e.$slots, "prepend")
        ]),
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          T(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const jA = /* @__PURE__ */ D(xA, [["render", VA]]), HA = {
  name: "DecimalFilter",
  components: { InputRangeDecimal: jA },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function GA(e, n, t, o, i, r) {
  const s = K("InputRangeDecimal");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: b(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Ri = /* @__PURE__ */ D(HA, [["render", GA]]);
var ii = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], Zt = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(e) {
    return typeof console < "u" && console.warn(e);
  },
  getWeek: function(e) {
    var n = new Date(e.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var t = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - t.getTime()) / 864e5 - 3 + (t.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, Dn = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(e) {
    var n = e % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Qe = function(e, n) {
  return n === void 0 && (n = 2), ("000" + e).slice(n * -1);
}, at = function(e) {
  return e === !0 ? 1 : 0;
};
function Zr(e, n) {
  var t;
  return function() {
    var o = this, i = arguments;
    clearTimeout(t), t = setTimeout(function() {
      return e.apply(o, i);
    }, n);
  };
}
var ri = function(e) {
  return e instanceof Array ? e : [e];
};
function je(e, n, t) {
  if (t === !0)
    return e.classList.add(n);
  e.classList.remove(n);
}
function be(e, n, t) {
  var o = window.document.createElement(e);
  return n = n || "", t = t || "", o.className = n, t !== void 0 && (o.textContent = t), o;
}
function Zn(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
}
function Qa(e, n) {
  if (n(e))
    return e;
  if (e.parentNode)
    return Qa(e.parentNode, n);
}
function eo(e, n) {
  var t = be("div", "numInputWrapper"), o = be("input", "numInput " + e), i = be("span", "arrowUp"), r = be("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? o.type = "number" : (o.type = "text", o.pattern = "\\d*"), n !== void 0)
    for (var s in n)
      o.setAttribute(s, n[s]);
  return t.appendChild(o), t.appendChild(i), t.appendChild(r), t;
}
function Ze(e) {
  try {
    if (typeof e.composedPath == "function") {
      var n = e.composedPath();
      return n[0];
    }
    return e.target;
  } catch {
    return e.target;
  }
}
var si = function() {
}, bo = function(e, n, t) {
  return t.months[n ? "shorthand" : "longhand"][e];
}, QA = {
  D: si,
  F: function(e, n, t) {
    e.setMonth(t.months.longhand.indexOf(n));
  },
  G: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  H: function(e, n) {
    e.setHours(parseFloat(n));
  },
  J: function(e, n) {
    e.setDate(parseFloat(n));
  },
  K: function(e, n, t) {
    e.setHours(e.getHours() % 12 + 12 * at(new RegExp(t.amPM[1], "i").test(n)));
  },
  M: function(e, n, t) {
    e.setMonth(t.months.shorthand.indexOf(n));
  },
  S: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  U: function(e, n) {
    return new Date(parseFloat(n) * 1e3);
  },
  W: function(e, n, t) {
    var o = parseInt(n), i = new Date(e.getFullYear(), 0, 2 + (o - 1) * 7, 0, 0, 0, 0);
    return i.setDate(i.getDate() - i.getDay() + t.firstDayOfWeek), i;
  },
  Y: function(e, n) {
    e.setFullYear(parseFloat(n));
  },
  Z: function(e, n) {
    return new Date(n);
  },
  d: function(e, n) {
    e.setDate(parseFloat(n));
  },
  h: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  i: function(e, n) {
    e.setMinutes(parseFloat(n));
  },
  j: function(e, n) {
    e.setDate(parseFloat(n));
  },
  l: si,
  m: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  n: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  s: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  u: function(e, n) {
    return new Date(parseFloat(n));
  },
  w: si,
  y: function(e, n) {
    e.setFullYear(2e3 + parseFloat(n));
  }
}, _t = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, Un = {
  Z: function(e) {
    return e.toISOString();
  },
  D: function(e, n, t) {
    return n.weekdays.shorthand[Un.w(e, n, t)];
  },
  F: function(e, n, t) {
    return bo(Un.n(e, n, t) - 1, !1, n);
  },
  G: function(e, n, t) {
    return Qe(Un.h(e, n, t));
  },
  H: function(e) {
    return Qe(e.getHours());
  },
  J: function(e, n) {
    return n.ordinal !== void 0 ? e.getDate() + n.ordinal(e.getDate()) : e.getDate();
  },
  K: function(e, n) {
    return n.amPM[at(e.getHours() > 11)];
  },
  M: function(e, n) {
    return bo(e.getMonth(), !0, n);
  },
  S: function(e) {
    return Qe(e.getSeconds());
  },
  U: function(e) {
    return e.getTime() / 1e3;
  },
  W: function(e, n, t) {
    return t.getWeek(e);
  },
  Y: function(e) {
    return Qe(e.getFullYear(), 4);
  },
  d: function(e) {
    return Qe(e.getDate());
  },
  h: function(e) {
    return e.getHours() % 12 ? e.getHours() % 12 : 12;
  },
  i: function(e) {
    return Qe(e.getMinutes());
  },
  j: function(e) {
    return e.getDate();
  },
  l: function(e, n) {
    return n.weekdays.longhand[e.getDay()];
  },
  m: function(e) {
    return Qe(e.getMonth() + 1);
  },
  n: function(e) {
    return e.getMonth() + 1;
  },
  s: function(e) {
    return e.getSeconds();
  },
  u: function(e) {
    return e.getTime();
  },
  w: function(e) {
    return e.getDay();
  },
  y: function(e) {
    return String(e.getFullYear()).substring(2);
  }
}, $a = function(e) {
  var n = e.config, t = n === void 0 ? Zt : n, o = e.l10n, i = o === void 0 ? Dn : o, r = e.isMobile, s = r === void 0 ? !1 : r;
  return function(a, u, d) {
    var f = d || i;
    return t.formatDate !== void 0 && !s ? t.formatDate(a, u, f) : u.split("").map(function(y, C, U) {
      return Un[y] && U[C - 1] !== "\\" ? Un[y](a, f, t) : y !== "\\" ? y : "";
    }).join("");
  };
}, ki = function(e) {
  var n = e.config, t = n === void 0 ? Zt : n, o = e.l10n, i = o === void 0 ? Dn : o;
  return function(r, s, a, u) {
    if (!(r !== 0 && !r)) {
      var d = u || i, f, y = r;
      if (r instanceof Date)
        f = new Date(r.getTime());
      else if (typeof r != "string" && r.toFixed !== void 0)
        f = new Date(r);
      else if (typeof r == "string") {
        var C = s || (t || Zt).dateFormat, U = String(r).trim();
        if (U === "today")
          f = /* @__PURE__ */ new Date(), a = !0;
        else if (t && t.parseDate)
          f = t.parseDate(r, C);
        else if (/Z$/.test(U) || /GMT$/.test(U))
          f = new Date(r);
        else {
          for (var g = void 0, A = [], w = 0, M = 0, L = ""; w < C.length; w++) {
            var B = C[w], N = B === "\\", x = C[w - 1] === "\\" || N;
            if (_t[B] && !x) {
              L += _t[B];
              var q = new RegExp(L).exec(r);
              q && (g = !0) && A[B !== "Y" ? "push" : "unshift"]({
                fn: QA[B],
                val: q[++M]
              });
            } else N || (L += ".");
          }
          f = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), A.forEach(function(Y) {
            var $ = Y.fn, Q = Y.val;
            return f = $(f, Q, d) || f;
          }), f = g ? f : void 0;
        }
      }
      if (!(f instanceof Date && !isNaN(f.getTime()))) {
        t.errorHandler(new Error("Invalid date provided: " + y));
        return;
      }
      return a === !0 && f.setHours(0, 0, 0, 0), f;
    }
  };
};
function et(e, n, t) {
  return t === void 0 && (t = !0), t !== !1 ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : e.getTime() - n.getTime();
}
var $A = function(e, n, t) {
  return e > Math.min(n, t) && e < Math.max(n, t);
}, ai = function(e, n, t) {
  return e * 3600 + n * 60 + t;
}, JA = function(e) {
  var n = Math.floor(e / 3600), t = (e - n * 3600) / 60;
  return [n, t, e - n * 3600 - t * 60];
}, zA = {
  DAY: 864e5
};
function li(e) {
  var n = e.defaultHour, t = e.defaultMinute, o = e.defaultSeconds;
  if (e.minDate !== void 0) {
    var i = e.minDate.getHours(), r = e.minDate.getMinutes(), s = e.minDate.getSeconds();
    n < i && (n = i), n === i && t < r && (t = r), n === i && t === r && o < s && (o = e.minDate.getSeconds());
  }
  if (e.maxDate !== void 0) {
    var a = e.maxDate.getHours(), u = e.maxDate.getMinutes();
    n = Math.min(n, a), n === a && (t = Math.min(u, t)), n === a && t === u && (o = e.maxDate.getSeconds());
  }
  return { hours: n, minutes: t, seconds: o };
}
typeof Object.assign != "function" && (Object.assign = function(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  if (!e)
    throw TypeError("Cannot convert undefined or null to object");
  for (var o = function(a) {
    a && Object.keys(a).forEach(function(u) {
      return e[u] = a[u];
    });
  }, i = 0, r = n; i < r.length; i++) {
    var s = r[i];
    o(s);
  }
  return e;
});
var Ne = function() {
  return Ne = Object.assign || function(e) {
    for (var n, t = 1, o = arguments.length; t < o; t++) {
      n = arguments[t];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, Ne.apply(this, arguments);
}, es = function() {
  for (var e = 0, n = 0, t = arguments.length; n < t; n++) e += arguments[n].length;
  for (var o = Array(e), i = 0, n = 0; n < t; n++)
    for (var r = arguments[n], s = 0, a = r.length; s < a; s++, i++)
      o[i] = r[s];
  return o;
}, YA = 300;
function WA(e, n) {
  var t = {
    config: Ne(Ne({}, Zt), Oe.defaultConfig),
    l10n: Dn
  };
  t.parseDate = ki({ config: t.config, l10n: t.l10n }), t._handlers = [], t.pluginElements = [], t.loadedPlugins = [], t._bind = A, t._setHoursFromDate = C, t._positionCalendar = Ht, t.changeMonth = Ie, t.changeYear = fe, t.clear = Pe, t.close = Le, t.onMouseOver = Rt, t._createElement = be, t.createDay = q, t.destroy = ve, t.isEnabled = ne, t.jumpToDate = L, t.updateValue = Ut, t.open = hn, t.redraw = An, t.set = $n, t.setDate = Jn, t.toggle = Cl;
  function o() {
    t.utils = {
      getDaysInMonth: function(h, m) {
        return h === void 0 && (h = t.currentMonth), m === void 0 && (m = t.currentYear), h === 1 && (m % 4 === 0 && m % 100 !== 0 || m % 400 === 0) ? 29 : t.l10n.daysInMonth[h];
      }
    };
  }
  function i() {
    t.element = t.input = e, t.isOpen = !1, Gn(), Qn(), vl(), Kl(), o(), t.isMobile || x(), M(), (t.selectedDates.length || t.config.noCalendar) && (t.config.enableTime && C(t.config.noCalendar ? t.latestSelectedDateObj : void 0), Ut(!1)), a();
    var h = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !t.isMobile && h && Ht(), Ee("onReady");
  }
  function r() {
    var h;
    return ((h = t.calendarContainer) === null || h === void 0 ? void 0 : h.getRootNode()).activeElement || document.activeElement;
  }
  function s(h) {
    return h.bind(t);
  }
  function a() {
    var h = t.config;
    h.weekNumbers === !1 && h.showMonths === 1 || h.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (t.calendarContainer !== void 0 && (t.calendarContainer.style.visibility = "hidden", t.calendarContainer.style.display = "block"), t.daysContainer !== void 0) {
        var m = (t.days.offsetWidth + 1) * h.showMonths;
        t.daysContainer.style.width = m + "px", t.calendarContainer.style.width = m + (t.weekWrapper !== void 0 ? t.weekWrapper.offsetWidth : 0) + "px", t.calendarContainer.style.removeProperty("visibility"), t.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function u(h) {
    if (t.selectedDates.length === 0) {
      var m = t.config.minDate === void 0 || et(/* @__PURE__ */ new Date(), t.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(t.config.minDate.getTime()), R = li(t.config);
      m.setHours(R.hours, R.minutes, R.seconds, m.getMilliseconds()), t.selectedDates = [m], t.latestSelectedDateObj = m;
    }
    h !== void 0 && h.type !== "blur" && Rl(h);
    var I = t._input.value;
    y(), Ut(), t._input.value !== I && t._debouncedChange();
  }
  function d(h, m) {
    return h % 12 + 12 * at(m === t.l10n.amPM[1]);
  }
  function f(h) {
    switch (h % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return h % 12;
    }
  }
  function y() {
    if (!(t.hourElement === void 0 || t.minuteElement === void 0)) {
      var h = (parseInt(t.hourElement.value.slice(-2), 10) || 0) % 24, m = (parseInt(t.minuteElement.value, 10) || 0) % 60, R = t.secondElement !== void 0 ? (parseInt(t.secondElement.value, 10) || 0) % 60 : 0;
      t.amPM !== void 0 && (h = d(h, t.amPM.textContent));
      var I = t.config.minTime !== void 0 || t.config.minDate && t.minDateHasTime && t.latestSelectedDateObj && et(t.latestSelectedDateObj, t.config.minDate, !0) === 0, H = t.config.maxTime !== void 0 || t.config.maxDate && t.maxDateHasTime && t.latestSelectedDateObj && et(t.latestSelectedDateObj, t.config.maxDate, !0) === 0;
      if (t.config.maxTime !== void 0 && t.config.minTime !== void 0 && t.config.minTime > t.config.maxTime) {
        var J = ai(t.config.minTime.getHours(), t.config.minTime.getMinutes(), t.config.minTime.getSeconds()), pe = ai(t.config.maxTime.getHours(), t.config.maxTime.getMinutes(), t.config.maxTime.getSeconds()), Z = ai(h, m, R);
        if (Z > pe && Z < J) {
          var ye = JA(J);
          h = ye[0], m = ye[1], R = ye[2];
        }
      } else {
        if (H) {
          var X = t.config.maxTime !== void 0 ? t.config.maxTime : t.config.maxDate;
          h = Math.min(h, X.getHours()), h === X.getHours() && (m = Math.min(m, X.getMinutes())), m === X.getMinutes() && (R = Math.min(R, X.getSeconds()));
        }
        if (I) {
          var ue = t.config.minTime !== void 0 ? t.config.minTime : t.config.minDate;
          h = Math.max(h, ue.getHours()), h === ue.getHours() && m < ue.getMinutes() && (m = ue.getMinutes()), m === ue.getMinutes() && (R = Math.max(R, ue.getSeconds()));
        }
      }
      U(h, m, R);
    }
  }
  function C(h) {
    var m = h || t.latestSelectedDateObj;
    m && m instanceof Date && U(m.getHours(), m.getMinutes(), m.getSeconds());
  }
  function U(h, m, R) {
    t.latestSelectedDateObj !== void 0 && t.latestSelectedDateObj.setHours(h % 24, m, R || 0, 0), !(!t.hourElement || !t.minuteElement || t.isMobile) && (t.hourElement.value = Qe(t.config.time_24hr ? h : (12 + h) % 12 + 12 * at(h % 12 === 0)), t.minuteElement.value = Qe(m), t.amPM !== void 0 && (t.amPM.textContent = t.l10n.amPM[at(h >= 12)]), t.secondElement !== void 0 && (t.secondElement.value = Qe(R)));
  }
  function g(h) {
    var m = Ze(h), R = parseInt(m.value) + (h.delta || 0);
    (R / 1e3 > 1 || h.key === "Enter" && !/[^\d]/.test(R.toString())) && fe(R);
  }
  function A(h, m, R, I) {
    if (m instanceof Array)
      return m.forEach(function(H) {
        return A(h, H, R, I);
      });
    if (h instanceof Array)
      return h.forEach(function(H) {
        return A(H, m, R, I);
      });
    h.addEventListener(m, R, I), t._handlers.push({
      remove: function() {
        return h.removeEventListener(m, R, I);
      }
    });
  }
  function w() {
    Ee("onChange");
  }
  function M() {
    if (t.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(R) {
      Array.prototype.forEach.call(t.element.querySelectorAll("[data-" + R + "]"), function(I) {
        return A(I, "click", t[R]);
      });
    }), t.isMobile) {
      bl();
      return;
    }
    var h = Zr(pt, 50);
    if (t._debouncedChange = Zr(w, YA), t.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && A(t.daysContainer, "mouseover", function(R) {
      t.config.mode === "range" && Rt(Ze(R));
    }), A(t._input, "keydown", Ge), t.calendarContainer !== void 0 && A(t.calendarContainer, "keydown", Ge), !t.config.inline && !t.config.static && A(window, "resize", h), window.ontouchstart !== void 0 ? A(window.document, "touchstart", ft) : A(window.document, "mousedown", ft), A(window.document, "focus", ft, { capture: !0 }), t.config.clickOpens === !0 && (A(t._input, "focus", t.open), A(t._input, "click", t.open)), t.daysContainer !== void 0 && (A(t.monthNav, "click", Fl), A(t.monthNav, ["keyup", "increment"], g), A(t.daysContainer, "click", $t)), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0) {
      var m = function(R) {
        return Ze(R).select();
      };
      A(t.timeContainer, ["increment"], u), A(t.timeContainer, "blur", u, { capture: !0 }), A(t.timeContainer, "click", B), A([t.hourElement, t.minuteElement], ["focus", "click"], m), t.secondElement !== void 0 && A(t.secondElement, "focus", function() {
        return t.secondElement && t.secondElement.select();
      }), t.amPM !== void 0 && A(t.amPM, "click", function(R) {
        u(R);
      });
    }
    t.config.allowInput && A(t._input, "blur", De);
  }
  function L(h, m) {
    var R = h !== void 0 ? t.parseDate(h) : t.latestSelectedDateObj || (t.config.minDate && t.config.minDate > t.now ? t.config.minDate : t.config.maxDate && t.config.maxDate < t.now ? t.config.maxDate : t.now), I = t.currentYear, H = t.currentMonth;
    try {
      R !== void 0 && (t.currentYear = R.getFullYear(), t.currentMonth = R.getMonth());
    } catch (J) {
      J.message = "Invalid date supplied: " + R, t.config.errorHandler(J);
    }
    m && t.currentYear !== I && (Ee("onYearChange"), V()), m && (t.currentYear !== I || t.currentMonth !== H) && Ee("onMonthChange"), t.redraw();
  }
  function B(h) {
    var m = Ze(h);
    ~m.className.indexOf("arrow") && N(h, m.classList.contains("arrowUp") ? 1 : -1);
  }
  function N(h, m, R) {
    var I = h && Ze(h), H = R || I && I.parentNode && I.parentNode.firstChild, J = xo("increment");
    J.delta = m, H && H.dispatchEvent(J);
  }
  function x() {
    var h = window.document.createDocumentFragment();
    if (t.calendarContainer = be("div", "flatpickr-calendar"), t.calendarContainer.tabIndex = -1, !t.config.noCalendar) {
      if (h.appendChild(P()), t.innerContainer = be("div", "flatpickr-innerContainer"), t.config.weekNumbers) {
        var m = se(), R = m.weekWrapper, I = m.weekNumbers;
        t.innerContainer.appendChild(R), t.weekNumbers = I, t.weekWrapper = R;
      }
      t.rContainer = be("div", "flatpickr-rContainer"), t.rContainer.appendChild(he()), t.daysContainer || (t.daysContainer = be("div", "flatpickr-days"), t.daysContainer.tabIndex = -1), le(), t.rContainer.appendChild(t.daysContainer), t.innerContainer.appendChild(t.rContainer), h.appendChild(t.innerContainer);
    }
    t.config.enableTime && h.appendChild(W()), je(t.calendarContainer, "rangeMode", t.config.mode === "range"), je(t.calendarContainer, "animate", t.config.animate === !0), je(t.calendarContainer, "multiMonth", t.config.showMonths > 1), t.calendarContainer.appendChild(h);
    var H = t.config.appendTo !== void 0 && t.config.appendTo.nodeType !== void 0;
    if ((t.config.inline || t.config.static) && (t.calendarContainer.classList.add(t.config.inline ? "inline" : "static"), t.config.inline && (!H && t.element.parentNode ? t.element.parentNode.insertBefore(t.calendarContainer, t._input.nextSibling) : t.config.appendTo !== void 0 && t.config.appendTo.appendChild(t.calendarContainer)), t.config.static)) {
      var J = be("div", "flatpickr-wrapper");
      t.element.parentNode && t.element.parentNode.insertBefore(J, t.element), J.appendChild(t.element), t.altInput && J.appendChild(t.altInput), J.appendChild(t.calendarContainer);
    }
    !t.config.static && !t.config.inline && (t.config.appendTo !== void 0 ? t.config.appendTo : window.document.body).appendChild(t.calendarContainer);
  }
  function q(h, m, R, I) {
    var H = ne(m, !0), J = be("span", h, m.getDate().toString());
    return J.dateObj = m, J.$i = I, J.setAttribute("aria-label", t.formatDate(m, t.config.ariaDateFormat)), h.indexOf("hidden") === -1 && et(m, t.now) === 0 && (t.todayDateElem = J, J.classList.add("today"), J.setAttribute("aria-current", "date")), H ? (J.tabIndex = -1, Vo(m) && (J.classList.add("selected"), t.selectedDateElem = J, t.config.mode === "range" && (je(J, "startRange", t.selectedDates[0] && et(m, t.selectedDates[0], !0) === 0), je(J, "endRange", t.selectedDates[1] && et(m, t.selectedDates[1], !0) === 0), h === "nextMonthDay" && J.classList.add("inRange")))) : J.classList.add("flatpickr-disabled"), t.config.mode === "range" && wl(m) && !Vo(m) && J.classList.add("inRange"), t.weekNumbers && t.config.showMonths === 1 && h !== "prevMonthDay" && I % 7 === 6 && t.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + t.config.getWeek(m) + "</span>"), Ee("onDayCreate", J), J;
  }
  function Y(h) {
    h.focus(), t.config.mode === "range" && Rt(h);
  }
  function $(h) {
    for (var m = h > 0 ? 0 : t.config.showMonths - 1, R = h > 0 ? t.config.showMonths : -1, I = m; I != R; I += h)
      for (var H = t.daysContainer.children[I], J = h > 0 ? 0 : H.children.length - 1, pe = h > 0 ? H.children.length : -1, Z = J; Z != pe; Z += h) {
        var ye = H.children[Z];
        if (ye.className.indexOf("hidden") === -1 && ne(ye.dateObj))
          return ye;
      }
  }
  function Q(h, m) {
    for (var R = h.className.indexOf("Month") === -1 ? h.dateObj.getMonth() : t.currentMonth, I = m > 0 ? t.config.showMonths : -1, H = m > 0 ? 1 : -1, J = R - t.currentMonth; J != I; J += H)
      for (var pe = t.daysContainer.children[J], Z = R - t.currentMonth === J ? h.$i + m : m < 0 ? pe.children.length - 1 : 0, ye = pe.children.length, X = Z; X >= 0 && X < ye && X != (m > 0 ? ye : -1); X += H) {
        var ue = pe.children[X];
        if (ue.className.indexOf("hidden") === -1 && ne(ue.dateObj) && Math.abs(h.$i - X) >= Math.abs(m))
          return Y(ue);
      }
    t.changeMonth(H), ee($(H), 0);
  }
  function ee(h, m) {
    var R = r(), I = me(R || document.body), H = h !== void 0 ? h : I ? R : t.selectedDateElem !== void 0 && me(t.selectedDateElem) ? t.selectedDateElem : t.todayDateElem !== void 0 && me(t.todayDateElem) ? t.todayDateElem : $(m > 0 ? 1 : -1);
    H === void 0 ? t._input.focus() : I ? Q(H, m) : Y(H);
  }
  function te(h, m) {
    for (var R = (new Date(h, m, 1).getDay() - t.l10n.firstDayOfWeek + 7) % 7, I = t.utils.getDaysInMonth((m - 1 + 12) % 12, h), H = t.utils.getDaysInMonth(m, h), J = window.document.createDocumentFragment(), pe = t.config.showMonths > 1, Z = pe ? "prevMonthDay hidden" : "prevMonthDay", ye = pe ? "nextMonthDay hidden" : "nextMonthDay", X = I + 1 - R, ue = 0; X <= I; X++, ue++)
      J.appendChild(q("flatpickr-day " + Z, new Date(h, m - 1, X), X, ue));
    for (X = 1; X <= H; X++, ue++)
      J.appendChild(q("flatpickr-day", new Date(h, m, X), X, ue));
    for (var Fe = H + 1; Fe <= 42 - R && (t.config.showMonths === 1 || ue % 7 !== 0); Fe++, ue++)
      J.appendChild(q("flatpickr-day " + ye, new Date(h, m + 1, Fe % H), Fe, ue));
    var bt = be("div", "dayContainer");
    return bt.appendChild(J), bt;
  }
  function le() {
    if (t.daysContainer !== void 0) {
      Zn(t.daysContainer), t.weekNumbers && Zn(t.weekNumbers);
      for (var h = document.createDocumentFragment(), m = 0; m < t.config.showMonths; m++) {
        var R = new Date(t.currentYear, t.currentMonth, 1);
        R.setMonth(t.currentMonth + m), h.appendChild(te(R.getFullYear(), R.getMonth()));
      }
      t.daysContainer.appendChild(h), t.days = t.daysContainer.firstChild, t.config.mode === "range" && t.selectedDates.length === 1 && Rt();
    }
  }
  function V() {
    if (!(t.config.showMonths > 1 || t.config.monthSelectorType !== "dropdown")) {
      var h = function(I) {
        return t.config.minDate !== void 0 && t.currentYear === t.config.minDate.getFullYear() && I < t.config.minDate.getMonth() ? !1 : !(t.config.maxDate !== void 0 && t.currentYear === t.config.maxDate.getFullYear() && I > t.config.maxDate.getMonth());
      };
      t.monthsDropdownContainer.tabIndex = -1, t.monthsDropdownContainer.innerHTML = "";
      for (var m = 0; m < 12; m++)
        if (h(m)) {
          var R = be("option", "flatpickr-monthDropdown-month");
          R.value = new Date(t.currentYear, m).getMonth().toString(), R.textContent = bo(m, t.config.shorthandCurrentMonth, t.l10n), R.tabIndex = -1, t.currentMonth === m && (R.selected = !0), t.monthsDropdownContainer.appendChild(R);
        }
    }
  }
  function Se() {
    var h = be("div", "flatpickr-month"), m = window.document.createDocumentFragment(), R;
    t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? R = be("span", "cur-month") : (t.monthsDropdownContainer = be("select", "flatpickr-monthDropdown-months"), t.monthsDropdownContainer.setAttribute("aria-label", t.l10n.monthAriaLabel), A(t.monthsDropdownContainer, "change", function(pe) {
      var Z = Ze(pe), ye = parseInt(Z.value, 10);
      t.changeMonth(ye - t.currentMonth), Ee("onMonthChange");
    }), V(), R = t.monthsDropdownContainer);
    var I = eo("cur-year", { tabindex: "-1" }), H = I.getElementsByTagName("input")[0];
    H.setAttribute("aria-label", t.l10n.yearAriaLabel), t.config.minDate && H.setAttribute("min", t.config.minDate.getFullYear().toString()), t.config.maxDate && (H.setAttribute("max", t.config.maxDate.getFullYear().toString()), H.disabled = !!t.config.minDate && t.config.minDate.getFullYear() === t.config.maxDate.getFullYear());
    var J = be("div", "flatpickr-current-month");
    return J.appendChild(R), J.appendChild(I), m.appendChild(J), h.appendChild(m), {
      container: h,
      yearElement: H,
      monthElement: R
    };
  }
  function k() {
    Zn(t.monthNav), t.monthNav.appendChild(t.prevMonthNav), t.config.showMonths && (t.yearElements = [], t.monthElements = []);
    for (var h = t.config.showMonths; h--; ) {
      var m = Se();
      t.yearElements.push(m.yearElement), t.monthElements.push(m.monthElement), t.monthNav.appendChild(m.container);
    }
    t.monthNav.appendChild(t.nextMonthNav);
  }
  function P() {
    return t.monthNav = be("div", "flatpickr-months"), t.yearElements = [], t.monthElements = [], t.prevMonthNav = be("span", "flatpickr-prev-month"), t.prevMonthNav.innerHTML = t.config.prevArrow, t.nextMonthNav = be("span", "flatpickr-next-month"), t.nextMonthNav.innerHTML = t.config.nextArrow, k(), Object.defineProperty(t, "_hidePrevMonthArrow", {
      get: function() {
        return t.__hidePrevMonthArrow;
      },
      set: function(h) {
        t.__hidePrevMonthArrow !== h && (je(t.prevMonthNav, "flatpickr-disabled", h), t.__hidePrevMonthArrow = h);
      }
    }), Object.defineProperty(t, "_hideNextMonthArrow", {
      get: function() {
        return t.__hideNextMonthArrow;
      },
      set: function(h) {
        t.__hideNextMonthArrow !== h && (je(t.nextMonthNav, "flatpickr-disabled", h), t.__hideNextMonthArrow = h);
      }
    }), t.currentYearElement = t.yearElements[0], zn(), t.monthNav;
  }
  function W() {
    t.calendarContainer.classList.add("hasTime"), t.config.noCalendar && t.calendarContainer.classList.add("noCalendar");
    var h = li(t.config);
    t.timeContainer = be("div", "flatpickr-time"), t.timeContainer.tabIndex = -1;
    var m = be("span", "flatpickr-time-separator", ":"), R = eo("flatpickr-hour", {
      "aria-label": t.l10n.hourAriaLabel
    });
    t.hourElement = R.getElementsByTagName("input")[0];
    var I = eo("flatpickr-minute", {
      "aria-label": t.l10n.minuteAriaLabel
    });
    if (t.minuteElement = I.getElementsByTagName("input")[0], t.hourElement.tabIndex = t.minuteElement.tabIndex = -1, t.hourElement.value = Qe(t.latestSelectedDateObj ? t.latestSelectedDateObj.getHours() : t.config.time_24hr ? h.hours : f(h.hours)), t.minuteElement.value = Qe(t.latestSelectedDateObj ? t.latestSelectedDateObj.getMinutes() : h.minutes), t.hourElement.setAttribute("step", t.config.hourIncrement.toString()), t.minuteElement.setAttribute("step", t.config.minuteIncrement.toString()), t.hourElement.setAttribute("min", t.config.time_24hr ? "0" : "1"), t.hourElement.setAttribute("max", t.config.time_24hr ? "23" : "12"), t.hourElement.setAttribute("maxlength", "2"), t.minuteElement.setAttribute("min", "0"), t.minuteElement.setAttribute("max", "59"), t.minuteElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(R), t.timeContainer.appendChild(m), t.timeContainer.appendChild(I), t.config.time_24hr && t.timeContainer.classList.add("time24hr"), t.config.enableSeconds) {
      t.timeContainer.classList.add("hasSeconds");
      var H = eo("flatpickr-second");
      t.secondElement = H.getElementsByTagName("input")[0], t.secondElement.value = Qe(t.latestSelectedDateObj ? t.latestSelectedDateObj.getSeconds() : h.seconds), t.secondElement.setAttribute("step", t.minuteElement.getAttribute("step")), t.secondElement.setAttribute("min", "0"), t.secondElement.setAttribute("max", "59"), t.secondElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(be("span", "flatpickr-time-separator", ":")), t.timeContainer.appendChild(H);
    }
    return t.config.time_24hr || (t.amPM = be("span", "flatpickr-am-pm", t.l10n.amPM[at((t.latestSelectedDateObj ? t.hourElement.value : t.config.defaultHour) > 11)]), t.amPM.title = t.l10n.toggleTitle, t.amPM.tabIndex = -1, t.timeContainer.appendChild(t.amPM)), t.timeContainer;
  }
  function he() {
    t.weekdayContainer ? Zn(t.weekdayContainer) : t.weekdayContainer = be("div", "flatpickr-weekdays");
    for (var h = t.config.showMonths; h--; ) {
      var m = be("div", "flatpickr-weekdaycontainer");
      t.weekdayContainer.appendChild(m);
    }
    return ge(), t.weekdayContainer;
  }
  function ge() {
    if (t.weekdayContainer) {
      var h = t.l10n.firstDayOfWeek, m = es(t.l10n.weekdays.shorthand);
      h > 0 && h < m.length && (m = es(m.splice(h, m.length), m.splice(0, h)));
      for (var R = t.config.showMonths; R--; )
        t.weekdayContainer.children[R].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + m.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function se() {
    t.calendarContainer.classList.add("hasWeeks");
    var h = be("div", "flatpickr-weekwrapper");
    h.appendChild(be("span", "flatpickr-weekday", t.l10n.weekAbbreviation));
    var m = be("div", "flatpickr-weeks");
    return h.appendChild(m), {
      weekWrapper: h,
      weekNumbers: m
    };
  }
  function Ie(h, m) {
    m === void 0 && (m = !0);
    var R = m ? h : h - t.currentMonth;
    R < 0 && t._hidePrevMonthArrow === !0 || R > 0 && t._hideNextMonthArrow === !0 || (t.currentMonth += R, (t.currentMonth < 0 || t.currentMonth > 11) && (t.currentYear += t.currentMonth > 11 ? 1 : -1, t.currentMonth = (t.currentMonth + 12) % 12, Ee("onYearChange"), V()), le(), Ee("onMonthChange"), zn());
  }
  function Pe(h, m) {
    if (h === void 0 && (h = !0), m === void 0 && (m = !0), t.input.value = "", t.altInput !== void 0 && (t.altInput.value = ""), t.mobileInput !== void 0 && (t.mobileInput.value = ""), t.selectedDates = [], t.latestSelectedDateObj = void 0, m === !0 && (t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth()), t.config.enableTime === !0) {
      var R = li(t.config), I = R.hours, H = R.minutes, J = R.seconds;
      U(I, H, J);
    }
    t.redraw(), h && Ee("onChange");
  }
  function Le() {
    t.isOpen = !1, t.isMobile || (t.calendarContainer !== void 0 && t.calendarContainer.classList.remove("open"), t._input !== void 0 && t._input.classList.remove("active")), Ee("onClose");
  }
  function ve() {
    t.config !== void 0 && Ee("onDestroy");
    for (var h = t._handlers.length; h--; )
      t._handlers[h].remove();
    if (t._handlers = [], t.mobileInput)
      t.mobileInput.parentNode && t.mobileInput.parentNode.removeChild(t.mobileInput), t.mobileInput = void 0;
    else if (t.calendarContainer && t.calendarContainer.parentNode)
      if (t.config.static && t.calendarContainer.parentNode) {
        var m = t.calendarContainer.parentNode;
        if (m.lastChild && m.removeChild(m.lastChild), m.parentNode) {
          for (; m.firstChild; )
            m.parentNode.insertBefore(m.firstChild, m);
          m.parentNode.removeChild(m);
        }
      } else
        t.calendarContainer.parentNode.removeChild(t.calendarContainer);
    t.altInput && (t.input.type = "text", t.altInput.parentNode && t.altInput.parentNode.removeChild(t.altInput), delete t.altInput), t.input && (t.input.type = t.input._type, t.input.classList.remove("flatpickr-input"), t.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(R) {
      try {
        delete t[R];
      } catch {
      }
    });
  }
  function Ue(h) {
    return t.calendarContainer.contains(h);
  }
  function ft(h) {
    if (t.isOpen && !t.config.inline) {
      var m = Ze(h), R = Ue(m), I = m === t.input || m === t.altInput || t.element.contains(m) || h.path && h.path.indexOf && (~h.path.indexOf(t.input) || ~h.path.indexOf(t.altInput)), H = !I && !R && !Ue(h.relatedTarget), J = !t.config.ignoredFocusElements.some(function(pe) {
        return pe.contains(m);
      });
      H && J && (t.config.allowInput && t.setDate(t._input.value, !1, t.config.altInput ? t.config.altFormat : t.config.dateFormat), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0 && t.input.value !== "" && t.input.value !== void 0 && u(), t.close(), t.config && t.config.mode === "range" && t.selectedDates.length === 1 && t.clear(!1));
    }
  }
  function fe(h) {
    if (!(!h || t.config.minDate && h < t.config.minDate.getFullYear() || t.config.maxDate && h > t.config.maxDate.getFullYear())) {
      var m = h, R = t.currentYear !== m;
      t.currentYear = m || t.currentYear, t.config.maxDate && t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth = Math.min(t.config.maxDate.getMonth(), t.currentMonth) : t.config.minDate && t.currentYear === t.config.minDate.getFullYear() && (t.currentMonth = Math.max(t.config.minDate.getMonth(), t.currentMonth)), R && (t.redraw(), Ee("onYearChange"), V());
    }
  }
  function ne(h, m) {
    var R;
    m === void 0 && (m = !0);
    var I = t.parseDate(h, void 0, m);
    if (t.config.minDate && I && et(I, t.config.minDate, m !== void 0 ? m : !t.minDateHasTime) < 0 || t.config.maxDate && I && et(I, t.config.maxDate, m !== void 0 ? m : !t.maxDateHasTime) > 0)
      return !1;
    if (!t.config.enable && t.config.disable.length === 0)
      return !0;
    if (I === void 0)
      return !1;
    for (var H = !!t.config.enable, J = (R = t.config.enable) !== null && R !== void 0 ? R : t.config.disable, pe = 0, Z = void 0; pe < J.length; pe++) {
      if (Z = J[pe], typeof Z == "function" && Z(I))
        return H;
      if (Z instanceof Date && I !== void 0 && Z.getTime() === I.getTime())
        return H;
      if (typeof Z == "string") {
        var ye = t.parseDate(Z, void 0, !0);
        return ye && ye.getTime() === I.getTime() ? H : !H;
      } else if (typeof Z == "object" && I !== void 0 && Z.from && Z.to && I.getTime() >= Z.from.getTime() && I.getTime() <= Z.to.getTime())
        return H;
    }
    return !H;
  }
  function me(h) {
    return t.daysContainer !== void 0 ? h.className.indexOf("hidden") === -1 && h.className.indexOf("flatpickr-disabled") === -1 && t.daysContainer.contains(h) : !1;
  }
  function De(h) {
    var m = h.target === t._input, R = t._input.value.trimEnd() !== jo();
    m && R && !(h.relatedTarget && Ue(h.relatedTarget)) && t.setDate(t._input.value, !0, h.target === t.altInput ? t.config.altFormat : t.config.dateFormat);
  }
  function Ge(h) {
    var m = Ze(h), R = t.config.wrap ? e.contains(m) : m === t._input, I = t.config.allowInput, H = t.isOpen && (!I || !R), J = t.config.inline && R && !I;
    if (h.keyCode === 13 && R) {
      if (I)
        return t.setDate(t._input.value, !0, m === t.altInput ? t.config.altFormat : t.config.dateFormat), t.close(), m.blur();
      t.open();
    } else if (Ue(m) || H || J) {
      var pe = !!t.timeContainer && t.timeContainer.contains(m);
      switch (h.keyCode) {
        case 13:
          pe ? (h.preventDefault(), u(), Qt()) : $t(h);
          break;
        case 27:
          h.preventDefault(), Qt();
          break;
        case 8:
        case 46:
          R && !t.config.allowInput && (h.preventDefault(), t.clear());
          break;
        case 37:
        case 39:
          if (!pe && !R) {
            h.preventDefault();
            var Z = r();
            if (t.daysContainer !== void 0 && (I === !1 || Z && me(Z))) {
              var ye = h.keyCode === 39 ? 1 : -1;
              h.ctrlKey ? (h.stopPropagation(), Ie(ye), ee($(1), 0)) : ee(void 0, ye);
            }
          } else t.hourElement && t.hourElement.focus();
          break;
        case 38:
        case 40:
          h.preventDefault();
          var X = h.keyCode === 40 ? 1 : -1;
          t.daysContainer && m.$i !== void 0 || m === t.input || m === t.altInput ? h.ctrlKey ? (h.stopPropagation(), fe(t.currentYear - X), ee($(1), 0)) : pe || ee(void 0, X * 7) : m === t.currentYearElement ? fe(t.currentYear - X) : t.config.enableTime && (!pe && t.hourElement && t.hourElement.focus(), u(h), t._debouncedChange());
          break;
        case 9:
          if (pe) {
            var ue = [
              t.hourElement,
              t.minuteElement,
              t.secondElement,
              t.amPM
            ].concat(t.pluginElements).filter(function(Xe) {
              return Xe;
            }), Fe = ue.indexOf(m);
            if (Fe !== -1) {
              var bt = ue[Fe + (h.shiftKey ? -1 : 1)];
              h.preventDefault(), (bt || t._input).focus();
            }
          } else !t.config.noCalendar && t.daysContainer && t.daysContainer.contains(m) && h.shiftKey && (h.preventDefault(), t._input.focus());
          break;
      }
    }
    if (t.amPM !== void 0 && m === t.amPM)
      switch (h.key) {
        case t.l10n.amPM[0].charAt(0):
        case t.l10n.amPM[0].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[0], y(), Ut();
          break;
        case t.l10n.amPM[1].charAt(0):
        case t.l10n.amPM[1].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[1], y(), Ut();
          break;
      }
    (R || Ue(m)) && Ee("onKeyDown", h);
  }
  function Rt(h, m) {
    if (m === void 0 && (m = "flatpickr-day"), !(t.selectedDates.length !== 1 || h && (!h.classList.contains(m) || h.classList.contains("flatpickr-disabled")))) {
      for (var R = h ? h.dateObj.getTime() : t.days.firstElementChild.dateObj.getTime(), I = t.parseDate(t.selectedDates[0], void 0, !0).getTime(), H = Math.min(R, t.selectedDates[0].getTime()), J = Math.max(R, t.selectedDates[0].getTime()), pe = !1, Z = 0, ye = 0, X = H; X < J; X += zA.DAY)
        ne(new Date(X), !0) || (pe = pe || X > H && X < J, X < I && (!Z || X > Z) ? Z = X : X > I && (!ye || X < ye) && (ye = X));
      var ue = Array.from(t.rContainer.querySelectorAll("*:nth-child(-n+" + t.config.showMonths + ") > ." + m));
      ue.forEach(function(Fe) {
        var bt = Fe.dateObj, Xe = bt.getTime(), yn = Z > 0 && Xe < Z || ye > 0 && Xe > ye;
        if (yn) {
          Fe.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(Jt) {
            Fe.classList.remove(Jt);
          });
          return;
        } else if (pe && !yn)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(Jt) {
          Fe.classList.remove(Jt);
        }), h !== void 0 && (h.classList.add(R <= t.selectedDates[0].getTime() ? "startRange" : "endRange"), I < R && Xe === I ? Fe.classList.add("startRange") : I > R && Xe === I && Fe.classList.add("endRange"), Xe >= Z && (ye === 0 || Xe <= ye) && $A(Xe, I, R) && Fe.classList.add("inRange"));
      });
    }
  }
  function pt() {
    t.isOpen && !t.config.static && !t.config.inline && Ht();
  }
  function hn(h, m) {
    if (m === void 0 && (m = t._positionElement), t.isMobile === !0) {
      if (h) {
        h.preventDefault();
        var R = Ze(h);
        R && R.blur();
      }
      t.mobileInput !== void 0 && (t.mobileInput.focus(), t.mobileInput.click()), Ee("onOpen");
      return;
    } else if (t._input.disabled || t.config.inline)
      return;
    var I = t.isOpen;
    t.isOpen = !0, I || (t.calendarContainer.classList.add("open"), t._input.classList.add("active"), Ee("onOpen"), Ht(m)), t.config.enableTime === !0 && t.config.noCalendar === !0 && t.config.allowInput === !1 && (h === void 0 || !t.timeContainer.contains(h.relatedTarget)) && setTimeout(function() {
      return t.hourElement.select();
    }, 50);
  }
  function Hn(h) {
    return function(m) {
      var R = t.config["_" + h + "Date"] = t.parseDate(m, t.config.dateFormat), I = t.config["_" + (h === "min" ? "max" : "min") + "Date"];
      R !== void 0 && (t[h === "min" ? "minDateHasTime" : "maxDateHasTime"] = R.getHours() > 0 || R.getMinutes() > 0 || R.getSeconds() > 0), t.selectedDates && (t.selectedDates = t.selectedDates.filter(function(H) {
        return ne(H);
      }), !t.selectedDates.length && h === "min" && C(R), Ut()), t.daysContainer && (An(), R !== void 0 ? t.currentYearElement[h] = R.getFullYear().toString() : t.currentYearElement.removeAttribute(h), t.currentYearElement.disabled = !!I && R !== void 0 && I.getFullYear() === R.getFullYear());
    };
  }
  function Gn() {
    var h = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], m = Ne(Ne({}, JSON.parse(JSON.stringify(e.dataset || {}))), n), R = {};
    t.config.parseDate = m.parseDate, t.config.formatDate = m.formatDate, Object.defineProperty(t.config, "enable", {
      get: function() {
        return t.config._enable;
      },
      set: function(ue) {
        t.config._enable = mr(ue);
      }
    }), Object.defineProperty(t.config, "disable", {
      get: function() {
        return t.config._disable;
      },
      set: function(ue) {
        t.config._disable = mr(ue);
      }
    });
    var I = m.mode === "time";
    if (!m.dateFormat && (m.enableTime || I)) {
      var H = Oe.defaultConfig.dateFormat || Zt.dateFormat;
      R.dateFormat = m.noCalendar || I ? "H:i" + (m.enableSeconds ? ":S" : "") : H + " H:i" + (m.enableSeconds ? ":S" : "");
    }
    if (m.altInput && (m.enableTime || I) && !m.altFormat) {
      var J = Oe.defaultConfig.altFormat || Zt.altFormat;
      R.altFormat = m.noCalendar || I ? "h:i" + (m.enableSeconds ? ":S K" : " K") : J + (" h:i" + (m.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(t.config, "minDate", {
      get: function() {
        return t.config._minDate;
      },
      set: Hn("min")
    }), Object.defineProperty(t.config, "maxDate", {
      get: function() {
        return t.config._maxDate;
      },
      set: Hn("max")
    });
    var pe = function(ue) {
      return function(Fe) {
        t.config[ue === "min" ? "_minTime" : "_maxTime"] = t.parseDate(Fe, "H:i:S");
      };
    };
    Object.defineProperty(t.config, "minTime", {
      get: function() {
        return t.config._minTime;
      },
      set: pe("min")
    }), Object.defineProperty(t.config, "maxTime", {
      get: function() {
        return t.config._maxTime;
      },
      set: pe("max")
    }), m.mode === "time" && (t.config.noCalendar = !0, t.config.enableTime = !0), Object.assign(t.config, R, m);
    for (var Z = 0; Z < h.length; Z++)
      t.config[h[Z]] = t.config[h[Z]] === !0 || t.config[h[Z]] === "true";
    ii.filter(function(ue) {
      return t.config[ue] !== void 0;
    }).forEach(function(ue) {
      t.config[ue] = ri(t.config[ue] || []).map(s);
    }), t.isMobile = !t.config.disableMobile && !t.config.inline && t.config.mode === "single" && !t.config.disable.length && !t.config.enable && !t.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var Z = 0; Z < t.config.plugins.length; Z++) {
      var ye = t.config.plugins[Z](t) || {};
      for (var X in ye)
        ii.indexOf(X) > -1 ? t.config[X] = ri(ye[X]).map(s).concat(t.config[X]) : typeof m[X] > "u" && (t.config[X] = ye[X]);
    }
    m.altInputClass || (t.config.altInputClass = mn().className + " " + t.config.altInputClass), Ee("onParseConfig");
  }
  function mn() {
    return t.config.wrap ? e.querySelector("[data-input]") : e;
  }
  function Qn() {
    typeof t.config.locale != "object" && typeof Oe.l10ns[t.config.locale] > "u" && t.config.errorHandler(new Error("flatpickr: invalid locale " + t.config.locale)), t.l10n = Ne(Ne({}, Oe.l10ns.default), typeof t.config.locale == "object" ? t.config.locale : t.config.locale !== "default" ? Oe.l10ns[t.config.locale] : void 0), _t.D = "(" + t.l10n.weekdays.shorthand.join("|") + ")", _t.l = "(" + t.l10n.weekdays.longhand.join("|") + ")", _t.M = "(" + t.l10n.months.shorthand.join("|") + ")", _t.F = "(" + t.l10n.months.longhand.join("|") + ")", _t.K = "(" + t.l10n.amPM[0] + "|" + t.l10n.amPM[1] + "|" + t.l10n.amPM[0].toLowerCase() + "|" + t.l10n.amPM[1].toLowerCase() + ")";
    var h = Ne(Ne({}, n), JSON.parse(JSON.stringify(e.dataset || {})));
    h.time_24hr === void 0 && Oe.defaultConfig.time_24hr === void 0 && (t.config.time_24hr = t.l10n.time_24hr), t.formatDate = $a(t), t.parseDate = ki({ config: t.config, l10n: t.l10n });
  }
  function Ht(h) {
    if (typeof t.config.position == "function")
      return void t.config.position(t, h);
    if (t.calendarContainer !== void 0) {
      Ee("onPreCalendarPosition");
      var m = h || t._positionElement, R = Array.prototype.reduce.call(t.calendarContainer.children, function(Ol, _l) {
        return Ol + _l.offsetHeight;
      }, 0), I = t.calendarContainer.offsetWidth, H = t.config.position.split(" "), J = H[0], pe = H.length > 1 ? H[1] : null, Z = m.getBoundingClientRect(), ye = window.innerHeight - Z.bottom, X = J === "above" || J !== "below" && ye < R && Z.top > R, ue = window.pageYOffset + Z.top + (X ? -R - 2 : m.offsetHeight + 2);
      if (je(t.calendarContainer, "arrowTop", !X), je(t.calendarContainer, "arrowBottom", X), !t.config.inline) {
        var Fe = window.pageXOffset + Z.left, bt = !1, Xe = !1;
        pe === "center" ? (Fe -= (I - Z.width) / 2, bt = !0) : pe === "right" && (Fe -= I - Z.width, Xe = !0), je(t.calendarContainer, "arrowLeft", !bt && !Xe), je(t.calendarContainer, "arrowCenter", bt), je(t.calendarContainer, "arrowRight", Xe);
        var yn = window.document.body.offsetWidth - (window.pageXOffset + Z.right), Jt = Fe + I > window.document.body.offsetWidth, kl = yn + I > window.document.body.offsetWidth;
        if (je(t.calendarContainer, "rightMost", Jt), !t.config.static)
          if (t.calendarContainer.style.top = ue + "px", !Jt)
            t.calendarContainer.style.left = Fe + "px", t.calendarContainer.style.right = "auto";
          else if (!kl)
            t.calendarContainer.style.left = "auto", t.calendarContainer.style.right = yn + "px";
          else {
            var Ho = kt();
            if (Ho === void 0)
              return;
            var Ul = window.document.body.offsetWidth, El = Math.max(0, Ul / 2 - I / 2), Sl = ".flatpickr-calendar.centerMost:before", Tl = ".flatpickr-calendar.centerMost:after", Il = Ho.cssRules.length, Dl = "{left:" + Z.left + "px;right:auto;}";
            je(t.calendarContainer, "rightMost", !1), je(t.calendarContainer, "centerMost", !0), Ho.insertRule(Sl + "," + Tl + Dl, Il), t.calendarContainer.style.left = El + "px", t.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function kt() {
    for (var h = null, m = 0; m < document.styleSheets.length; m++) {
      var R = document.styleSheets[m];
      if (R.cssRules) {
        try {
          R.cssRules;
        } catch {
          continue;
        }
        h = R;
        break;
      }
    }
    return h ?? Gt();
  }
  function Gt() {
    var h = document.createElement("style");
    return document.head.appendChild(h), h.sheet;
  }
  function An() {
    t.config.noCalendar || t.isMobile || (V(), zn(), le());
  }
  function Qt() {
    t._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(t.close, 0) : t.close();
  }
  function $t(h) {
    h.preventDefault(), h.stopPropagation();
    var m = function(ue) {
      return ue.classList && ue.classList.contains("flatpickr-day") && !ue.classList.contains("flatpickr-disabled") && !ue.classList.contains("notAllowed");
    }, R = Qa(Ze(h), m);
    if (R !== void 0) {
      var I = R, H = t.latestSelectedDateObj = new Date(I.dateObj.getTime()), J = (H.getMonth() < t.currentMonth || H.getMonth() > t.currentMonth + t.config.showMonths - 1) && t.config.mode !== "range";
      if (t.selectedDateElem = I, t.config.mode === "single")
        t.selectedDates = [H];
      else if (t.config.mode === "multiple") {
        var pe = Vo(H);
        pe ? t.selectedDates.splice(parseInt(pe), 1) : t.selectedDates.push(H);
      } else t.config.mode === "range" && (t.selectedDates.length === 2 && t.clear(!1, !1), t.latestSelectedDateObj = H, t.selectedDates.push(H), et(H, t.selectedDates[0], !0) !== 0 && t.selectedDates.sort(function(ue, Fe) {
        return ue.getTime() - Fe.getTime();
      }));
      if (y(), J) {
        var Z = t.currentYear !== H.getFullYear();
        t.currentYear = H.getFullYear(), t.currentMonth = H.getMonth(), Z && (Ee("onYearChange"), V()), Ee("onMonthChange");
      }
      if (zn(), le(), Ut(), !J && t.config.mode !== "range" && t.config.showMonths === 1 ? Y(I) : t.selectedDateElem !== void 0 && t.hourElement === void 0 && t.selectedDateElem && t.selectedDateElem.focus(), t.hourElement !== void 0 && t.hourElement !== void 0 && t.hourElement.focus(), t.config.closeOnSelect) {
        var ye = t.config.mode === "single" && !t.config.enableTime, X = t.config.mode === "range" && t.selectedDates.length === 2 && !t.config.enableTime;
        (ye || X) && Qt();
      }
      w();
    }
  }
  var Ot = {
    locale: [Qn, ge],
    showMonths: [k, a, he],
    minDate: [L],
    maxDate: [L],
    positionElement: [Ar],
    clickOpens: [
      function() {
        t.config.clickOpens === !0 ? (A(t._input, "focus", t.open), A(t._input, "click", t.open)) : (t._input.removeEventListener("focus", t.open), t._input.removeEventListener("click", t.open));
      }
    ]
  };
  function $n(h, m) {
    if (h !== null && typeof h == "object") {
      Object.assign(t.config, h);
      for (var R in h)
        Ot[R] !== void 0 && Ot[R].forEach(function(I) {
          return I();
        });
    } else
      t.config[h] = m, Ot[h] !== void 0 ? Ot[h].forEach(function(I) {
        return I();
      }) : ii.indexOf(h) > -1 && (t.config[h] = ri(m));
    t.redraw(), Ut(!0);
  }
  function gn(h, m) {
    var R = [];
    if (h instanceof Array)
      R = h.map(function(I) {
        return t.parseDate(I, m);
      });
    else if (h instanceof Date || typeof h == "number")
      R = [t.parseDate(h, m)];
    else if (typeof h == "string")
      switch (t.config.mode) {
        case "single":
        case "time":
          R = [t.parseDate(h, m)];
          break;
        case "multiple":
          R = h.split(t.config.conjunction).map(function(I) {
            return t.parseDate(I, m);
          });
          break;
        case "range":
          R = h.split(t.l10n.rangeSeparator).map(function(I) {
            return t.parseDate(I, m);
          });
          break;
      }
    else
      t.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(h)));
    t.selectedDates = t.config.allowInvalidPreload ? R : R.filter(function(I) {
      return I instanceof Date && ne(I, !1);
    }), t.config.mode === "range" && t.selectedDates.sort(function(I, H) {
      return I.getTime() - H.getTime();
    });
  }
  function Jn(h, m, R) {
    if (m === void 0 && (m = !1), R === void 0 && (R = t.config.dateFormat), h !== 0 && !h || h instanceof Array && h.length === 0)
      return t.clear(m);
    gn(h, R), t.latestSelectedDateObj = t.selectedDates[t.selectedDates.length - 1], t.redraw(), L(void 0, m), C(), t.selectedDates.length === 0 && t.clear(!1), Ut(m), m && Ee("onChange");
  }
  function mr(h) {
    return h.slice().map(function(m) {
      return typeof m == "string" || typeof m == "number" || m instanceof Date ? t.parseDate(m, void 0, !0) : m && typeof m == "object" && m.from && m.to ? {
        from: t.parseDate(m.from, void 0),
        to: t.parseDate(m.to, void 0)
      } : m;
    }).filter(function(m) {
      return m;
    });
  }
  function Kl() {
    t.selectedDates = [], t.now = t.parseDate(t.config.now) || /* @__PURE__ */ new Date();
    var h = t.config.defaultDate || ((t.input.nodeName === "INPUT" || t.input.nodeName === "TEXTAREA") && t.input.placeholder && t.input.value === t.input.placeholder ? null : t.input.value);
    h && gn(h, t.config.dateFormat), t._initialDate = t.selectedDates.length > 0 ? t.selectedDates[0] : t.config.minDate && t.config.minDate.getTime() > t.now.getTime() ? t.config.minDate : t.config.maxDate && t.config.maxDate.getTime() < t.now.getTime() ? t.config.maxDate : t.now, t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth(), t.selectedDates.length > 0 && (t.latestSelectedDateObj = t.selectedDates[0]), t.config.minTime !== void 0 && (t.config.minTime = t.parseDate(t.config.minTime, "H:i")), t.config.maxTime !== void 0 && (t.config.maxTime = t.parseDate(t.config.maxTime, "H:i")), t.minDateHasTime = !!t.config.minDate && (t.config.minDate.getHours() > 0 || t.config.minDate.getMinutes() > 0 || t.config.minDate.getSeconds() > 0), t.maxDateHasTime = !!t.config.maxDate && (t.config.maxDate.getHours() > 0 || t.config.maxDate.getMinutes() > 0 || t.config.maxDate.getSeconds() > 0);
  }
  function vl() {
    if (t.input = mn(), !t.input) {
      t.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    t.input._type = t.input.type, t.input.type = "text", t.input.classList.add("flatpickr-input"), t._input = t.input, t.config.altInput && (t.altInput = be(t.input.nodeName, t.config.altInputClass), t._input = t.altInput, t.altInput.placeholder = t.input.placeholder, t.altInput.disabled = t.input.disabled, t.altInput.required = t.input.required, t.altInput.tabIndex = t.input.tabIndex, t.altInput.type = "text", t.input.setAttribute("type", "hidden"), !t.config.static && t.input.parentNode && t.input.parentNode.insertBefore(t.altInput, t.input.nextSibling)), t.config.allowInput || t._input.setAttribute("readonly", "readonly"), Ar();
  }
  function Ar() {
    t._positionElement = t.config.positionElement || t._input;
  }
  function bl() {
    var h = t.config.enableTime ? t.config.noCalendar ? "time" : "datetime-local" : "date";
    t.mobileInput = be("input", t.input.className + " flatpickr-mobile"), t.mobileInput.tabIndex = 1, t.mobileInput.type = h, t.mobileInput.disabled = t.input.disabled, t.mobileInput.required = t.input.required, t.mobileInput.placeholder = t.input.placeholder, t.mobileFormatStr = h === "datetime-local" ? "Y-m-d\\TH:i:S" : h === "date" ? "Y-m-d" : "H:i:S", t.selectedDates.length > 0 && (t.mobileInput.defaultValue = t.mobileInput.value = t.formatDate(t.selectedDates[0], t.mobileFormatStr)), t.config.minDate && (t.mobileInput.min = t.formatDate(t.config.minDate, "Y-m-d")), t.config.maxDate && (t.mobileInput.max = t.formatDate(t.config.maxDate, "Y-m-d")), t.input.getAttribute("step") && (t.mobileInput.step = String(t.input.getAttribute("step"))), t.input.type = "hidden", t.altInput !== void 0 && (t.altInput.type = "hidden");
    try {
      t.input.parentNode && t.input.parentNode.insertBefore(t.mobileInput, t.input.nextSibling);
    } catch {
    }
    A(t.mobileInput, "change", function(m) {
      t.setDate(Ze(m).value, !1, t.mobileFormatStr), Ee("onChange"), Ee("onClose");
    });
  }
  function Cl(h) {
    if (t.isOpen === !0)
      return t.close();
    t.open(h);
  }
  function Ee(h, m) {
    if (t.config !== void 0) {
      var R = t.config[h];
      if (R !== void 0 && R.length > 0)
        for (var I = 0; R[I] && I < R.length; I++)
          R[I](t.selectedDates, t.input.value, t, m);
      h === "onChange" && (t.input.dispatchEvent(xo("change")), t.input.dispatchEvent(xo("input")));
    }
  }
  function xo(h) {
    var m = document.createEvent("Event");
    return m.initEvent(h, !0, !0), m;
  }
  function Vo(h) {
    for (var m = 0; m < t.selectedDates.length; m++) {
      var R = t.selectedDates[m];
      if (R instanceof Date && et(R, h) === 0)
        return "" + m;
    }
    return !1;
  }
  function wl(h) {
    return t.config.mode !== "range" || t.selectedDates.length < 2 ? !1 : et(h, t.selectedDates[0]) >= 0 && et(h, t.selectedDates[1]) <= 0;
  }
  function zn() {
    t.config.noCalendar || t.isMobile || !t.monthNav || (t.yearElements.forEach(function(h, m) {
      var R = new Date(t.currentYear, t.currentMonth, 1);
      R.setMonth(t.currentMonth + m), t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? t.monthElements[m].textContent = bo(R.getMonth(), t.config.shorthandCurrentMonth, t.l10n) + " " : t.monthsDropdownContainer.value = R.getMonth().toString(), h.value = R.getFullYear().toString();
    }), t._hidePrevMonthArrow = t.config.minDate !== void 0 && (t.currentYear === t.config.minDate.getFullYear() ? t.currentMonth <= t.config.minDate.getMonth() : t.currentYear < t.config.minDate.getFullYear()), t._hideNextMonthArrow = t.config.maxDate !== void 0 && (t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth + 1 > t.config.maxDate.getMonth() : t.currentYear > t.config.maxDate.getFullYear()));
  }
  function jo(h) {
    var m = h || (t.config.altInput ? t.config.altFormat : t.config.dateFormat);
    return t.selectedDates.map(function(R) {
      return t.formatDate(R, m);
    }).filter(function(R, I, H) {
      return t.config.mode !== "range" || t.config.enableTime || H.indexOf(R) === I;
    }).join(t.config.mode !== "range" ? t.config.conjunction : t.l10n.rangeSeparator);
  }
  function Ut(h) {
    h === void 0 && (h = !0), t.mobileInput !== void 0 && t.mobileFormatStr && (t.mobileInput.value = t.latestSelectedDateObj !== void 0 ? t.formatDate(t.latestSelectedDateObj, t.mobileFormatStr) : ""), t.input.value = jo(t.config.dateFormat), t.altInput !== void 0 && (t.altInput.value = jo(t.config.altFormat)), h !== !1 && Ee("onValueUpdate");
  }
  function Fl(h) {
    var m = Ze(h), R = t.prevMonthNav.contains(m), I = t.nextMonthNav.contains(m);
    R || I ? Ie(R ? -1 : 1) : t.yearElements.indexOf(m) >= 0 ? m.select() : m.classList.contains("arrowUp") ? t.changeYear(t.currentYear + 1) : m.classList.contains("arrowDown") && t.changeYear(t.currentYear - 1);
  }
  function Rl(h) {
    h.preventDefault();
    var m = h.type === "keydown", R = Ze(h), I = R;
    t.amPM !== void 0 && R === t.amPM && (t.amPM.textContent = t.l10n.amPM[at(t.amPM.textContent === t.l10n.amPM[0])]);
    var H = parseFloat(I.getAttribute("min")), J = parseFloat(I.getAttribute("max")), pe = parseFloat(I.getAttribute("step")), Z = parseInt(I.value, 10), ye = h.delta || (m ? h.which === 38 ? 1 : -1 : 0), X = Z + pe * ye;
    if (typeof I.value < "u" && I.value.length === 2) {
      var ue = I === t.hourElement, Fe = I === t.minuteElement;
      X < H ? (X = J + X + at(!ue) + (at(ue) && at(!t.amPM)), Fe && N(void 0, -1, t.hourElement)) : X > J && (X = I === t.hourElement ? X - J - at(!t.amPM) : H, Fe && N(void 0, 1, t.hourElement)), t.amPM && ue && (pe === 1 ? X + Z === 23 : Math.abs(X - Z) > pe) && (t.amPM.textContent = t.l10n.amPM[at(t.amPM.textContent === t.l10n.amPM[0])]), I.value = Qe(X);
    }
  }
  return i(), t;
}
function en(e, n) {
  for (var t = Array.prototype.slice.call(e).filter(function(s) {
    return s instanceof HTMLElement;
  }), o = [], i = 0; i < t.length; i++) {
    var r = t[i];
    try {
      if (r.getAttribute("data-fp-omit") !== null)
        continue;
      r._flatpickr !== void 0 && (r._flatpickr.destroy(), r._flatpickr = void 0), r._flatpickr = WA(r, n || {}), o.push(r._flatpickr);
    } catch (s) {
      console.error(s);
    }
  }
  return o.length === 1 ? o[0] : o;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(e) {
  return en(this, e);
}, HTMLElement.prototype.flatpickr = function(e) {
  return en([this], e);
});
var Oe = function(e, n) {
  return typeof e == "string" ? en(window.document.querySelectorAll(e), n) : e instanceof Node ? en([e], n) : en(e, n);
};
Oe.defaultConfig = {};
Oe.l10ns = {
  en: Ne({}, Dn),
  default: Ne({}, Dn)
};
Oe.localize = function(e) {
  Oe.l10ns.default = Ne(Ne({}, Oe.l10ns.default), e);
};
Oe.setDefaults = function(e) {
  Oe.defaultConfig = Ne(Ne({}, Oe.defaultConfig), e);
};
Oe.parseDate = ki({});
Oe.formatDate = $a({});
Oe.compareDates = et;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(e) {
  return en(this, e);
});
Date.prototype.fp_incr = function(e) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof e == "string" ? parseInt(e, 10) : e));
};
typeof window < "u" && (window.flatpickr = Oe);
const Ja = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], XA = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function ts(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function ns(e) {
  return e instanceof Array ? e : [e];
}
function ui(e) {
  return e && e.length ? e : null;
}
const os = [...Ja, ...XA], ZA = ["locale", "showMonths"], eg = Re({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return Bi("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...os.map(ts)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => Ja
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = Oe(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let e = Object.assign({}, this.config);
      this.events.forEach((t) => {
        let o = Oe.defaultConfig[t] || [], i = (...r) => {
          this.$emit(ts(t), ...r);
        };
        e[t] = ns(e[t] || []).concat(o, i);
      });
      const n = this.onClose.bind(this);
      return e.onClose = ns(e.onClose || []).concat(n), e.defaultDate = this.modelValue || e.defaultDate, e;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(e) {
      const n = e.target;
      po().then(() => {
        this.$emit("update:modelValue", ui(n.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(e) {
      this.$emit("blur", ui(e.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(e, n) {
      this.$emit("update:modelValue", n);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(e) {
      e ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(e) {
        if (!this.fp)
          return;
        let n = Object.assign({}, e);
        os.forEach((t) => {
          delete n[t];
        }), this.fp.set(n), ZA.forEach((t) => {
          typeof n[t] < "u" && this.fp.set(t, n[t]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(e) {
      var n;
      !this.$el || e === ui(this.$el.value) || (n = this.fp) === null || n === void 0 || n.setDate(e, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
}), tg = {
  extends: Ce,
  components: {
    FlatPickr: eg
  },
  props: {
    readonly: { type: Boolean, default: !1 },
    config: {
      type: Object,
      required: !0
    }
  }
}, ng = ["id", "required"];
function og(e, n, t, o, i, r) {
  const s = K("FlatPickr");
  return t.readonly ? We((l(), c("input", {
    key: 0,
    id: e.id,
    readonly: "",
    "onUpdate:modelValue": n[0] || (n[0] = (a) => e.modelValue = a),
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    required: e.required
  }, null, 10, ng)), [
    [Li, e.modelValue]
  ]) : (l(), F(s, {
    key: 1,
    id: e.id,
    modelValue: e.modelValue,
    style: { background: "white" },
    class: "form-control active",
    config: t.config,
    placeholder: e.placeholder,
    disabled: t.readonly,
    onInput: n[1] || (n[1] = (a) => e.$emit("update:modelValue", a.target.value))
  }, null, 8, ["id", "modelValue", "config", "placeholder", "disabled"]));
}
const za = /* @__PURE__ */ D(tg, [["render", og]]), ig = {
  components: { BaseInputDate: za, FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    },
    readonly: { type: Boolean, default: !1 }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e, this.$emit("update:modelValue", t);
    }
  },
  computed: {
    config() {
      return {
        wrap: !1,
        dateFormat: "Y-m-d",
        allowInput: !1,
        clickOpens: !this.readonly
      };
    }
  }
};
function rg(e, n, t, o, i, r) {
  const s = K("BaseInputDate"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, { class: "d-flex" }, {
        prepend: b(() => [
          j(e.$slots, "prepend")
        ]),
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            readonly: t.readonly,
            config: r.config,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: "m-0"
          }, null, 8, ["id", "modelValue", "readonly", "config"]),
          T(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            readonly: t.readonly,
            config: r.config,
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: "m-0"
          }, null, 8, ["id", "modelValue", "readonly", "config"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Ya = /* @__PURE__ */ D(ig, [["render", rg]]), sg = {
  name: "DateFilter",
  components: { InputRangeDate: Ya },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function ag(e, n, t, o, i, r) {
  const s = K("InputRangeDate");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: b(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Ui = /* @__PURE__ */ D(sg, [["render", ag]]), lg = {
  extends: Ce,
  components: {
    BaseInputDate: za,
    FormGroup: ke,
    InputGroup: Ve
  },
  props: {
    readonly: { type: Boolean, default: !1 }
  },
  computed: {
    config() {
      return {
        wrap: !1,
        dateFormat: "Y-m-d",
        allowInput: !1,
        clickOpens: !this.readonly
      };
    }
  }
};
function ug(e, n, t, o, i, r) {
  const s = K("BaseInputDate"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, null, {
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: t.readonly,
            class: G({ "is-invalid": e.errorMessage }),
            required: e.required,
            config: r.config,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "class", "required", "config"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Bo = /* @__PURE__ */ D(lg, [["render", ug]]), Lo = {
  name: "InputDateTime",
  extends: Bo,
  computed: {
    config() {
      return {
        wrap: !0,
        dateFormat: "Y-m-dTH:i:S",
        allowInput: !1,
        enableTime: !0,
        clickOpens: !this.readonly
      };
    }
  }
}, dg = {
  components: { InputDateTime: Lo, FormGroup: ke },
  extends: Ya
}, cg = { class: "d-flex" };
function fg(e, n, t, o, i, r) {
  const s = K("InputDateTime"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      p("div", cg, [
        T(s, {
          id: e.id + "-from",
          modelValue: e.modelValue[0],
          readonly: e.readonly,
          "onUpdate:modelValue": n[0] || (n[0] = (u) => e.emitValue(u, 0)),
          placeholder: "from",
          class: "m-0"
        }, null, 8, ["id", "modelValue", "readonly"]),
        T(s, {
          id: e.id + "-to",
          modelValue: e.modelValue[1],
          readonly: e.readonly,
          "onUpdate:modelValue": n[1] || (n[1] = (u) => e.emitValue(u, 1)),
          placeholder: "to",
          class: "m-0"
        }, null, 8, ["id", "modelValue", "readonly"])
      ])
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const pg = /* @__PURE__ */ D(dg, [["render", fg]]), hg = {
  name: "DateTimeFilter",
  components: { InputRangeDateTime: pg },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  }
};
function mg(e, n, t, o, i, r) {
  const s = K("InputRangeDateTime");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: b(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Ei = /* @__PURE__ */ D(hg, [["render", mg]]), Ag = {
  name: "InputRadio",
  extends: Ce,
  components: { FormGroup: ke },
  props: {
    options: {
      type: Array,
      required: !0
    },
    isClearable: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  data() {
    return {
      radioValue: this.modelValue,
      isMouseOver: !1
    };
  },
  watch: {
    radioValue() {
      this.$emit("update:modelValue", this.radioValue);
    },
    value(e) {
      this.radioValue = e;
    }
  },
  computed: {
    isClearShown() {
      return this.isClearable !== void 0 && this.isClearable === !1 ? !1 : this.isMouseOver && this.radioValue !== null && this.radioValue !== void 0;
    }
  }
}, gg = ["id", "aria-describedby", "value"], yg = ["for"], Kg = { class: "input-group-append" };
function vg(e, n, t, o, i, r) {
  const s = K("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    class: "radio-form-group",
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      p("div", {
        class: "input-group",
        onMouseenter: n[2] || (n[2] = (a) => i.isMouseOver = !0),
        onMouseleave: n[3] || (n[3] = (a) => i.isMouseOver = !1)
      }, [
        (l(!0), c(oe, null, ae(t.options, (a, u) => (l(), c("div", {
          key: u,
          class: "form-check form-check-inline"
        }, [
          We(p("input", {
            class: G(["form-check-input", { "is-invalid": e.errorMessage }]),
            type: "radio",
            id: e.id + u,
            "aria-describedby": e.id + "Help",
            value: a,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => i.radioValue = d)
          }, null, 10, gg), [
            [Pl, i.radioValue]
          ]),
          p("label", {
            class: "form-check-label",
            for: e.id + u
          }, E(a), 9, yg)
        ]))), 128)),
        p("div", Kg, [
          We(p("button", {
            class: "btn btn-link radio-clear-value",
            onClick: n[1] || (n[1] = (a) => i.radioValue = null)
          }, " clear ", 512), [
            [Fo, r.isClearShown]
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Wa = /* @__PURE__ */ D(Ag, [["render", vg], ["__scopeId", "data-v-3d7775e5"]]), bg = {
  name: "InputBoolean",
  components: { InputRadio: Wa },
  extends: Ce,
  props: {
    inplace: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !0 }
  },
  methods: {
    insertValue(e) {
      return e === !0 ? "Yes" : e === !1 ? "No" : null;
    },
    returnValue(e) {
      return e === "Yes" ? !0 : e === "No" ? !1 : null;
    }
  }
}, Cg = { key: 0 }, wg = ["id", "checked", "aria-describedby"], Fg = ["for"];
function Rg(e, n, t, o, i, r) {
  const s = K("InputRadio");
  return t.inplace ? (l(), c("div", Cg, [
    p("input", {
      id: e.id,
      checked: e.modelValue,
      type: "checkbox",
      "aria-describedby": e.id + "Help",
      onChange: n[0] || (n[0] = (a) => e.$emit("update:modelValue", a.target.checked))
    }, null, 40, wg),
    p("label", {
      class: "ml-1",
      for: e.id
    }, E(e.label), 9, Fg)
  ])) : (l(), F(s, On({ key: 1 }, e.$props, {
    id: e.id,
    modelValue: r.insertValue(e.modelValue),
    options: ["Yes", "No"],
    isClearable: t.isClearable,
    "onUpdate:modelValue": n[1] || (n[1] = (a) => e.$emit("update:modelValue", r.returnValue(a)))
  }), null, 16, ["id", "modelValue", "isClearable"]));
}
const No = /* @__PURE__ */ D(bg, [["render", Rg]]), kg = {
  name: "BooleanFilter",
  components: { InputBoolean: No },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Boolean,
      required: !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function Ug(e, n, t, o, i, r) {
  const s = K("InputBoolean");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    onClearCondition: n[0] || (n[0] = (a) => e.$emit("clearCondition"))
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Si = /* @__PURE__ */ D(kg, [["render", Ug]]), Eg = {
  props: {
    label: String
  }
}, Sg = { class: "btn btn-sm btn-outline-primary mr-2 mb-2" };
function Tg(e, n, t, o, i, r) {
  return l(), c("button", Sg, [
    _(E(t.label) + "  ", 1),
    n[0] || (n[0] = p("i", { class: "fa fa-times" }, null, -1))
  ]);
}
const Xa = /* @__PURE__ */ D(Eg, [["render", Tg]]), is = {
  add: "plus",
  edit: "pencil-alt",
  delete: "trash",
  clone: "copy"
}, Ig = {
  components: {
    IconAction: ct,
    IconDanger: nr
  },
  props: {
    type: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(is).includes(e);
      }
    }
  },
  computed: {
    icon() {
      return is[this.type];
    }
  },
  emits: ["add", "edit", "delete", "clone"]
};
function Dg(e, n, t, o, i, r) {
  return l(), c("span", null, [
    (l(), F(Et(t.type === "delete" ? "IconDanger" : "IconAction"), {
      icon: r.icon,
      onClick: n[0] || (n[0] = (s) => e.$emit(t.type))
    }, null, 8, ["icon"]))
  ]);
}
const jt = /* @__PURE__ */ D(Ig, [["render", Dg]]), Za = /* @__PURE__ */ Re({
  __name: "RowButtonAdd",
  props: {
    id: {},
    tableId: {},
    schemaId: {},
    label: { default: "" },
    defaultValue: {},
    visibleColumns: {}
  },
  emits: ["close", "update:newRow"],
  setup(e, { emit: n }) {
    const t = Es({
      loader: () => Promise.resolve().then(() => fl)
    });
    let o = Ae(!1);
    const i = n;
    function r() {
      o.value = !1, i("close");
    }
    return (s, a) => (l(), c("span", null, [
      e.label !== "" ? (l(), F(Po, {
        key: 0,
        onClick: a[0] || (a[0] = (u) => ho(o) ? o.value = !0 : o = !0)
      }, {
        default: b(() => [
          _(E(e.label), 1)
        ]),
        _: 1
      })) : (l(), F(jt, {
        key: 1,
        type: "add",
        onAdd: a[1] || (a[1] = (u) => ho(o) ? o.value = !0 : o = !0)
      })),
      ie(o) ? (l(), F(ie(t), {
        key: 2,
        id: e.id + "add-modal",
        tableId: e.tableId,
        isModalShown: ie(o),
        schemaId: e.schemaId,
        defaultValue: e.defaultValue,
        visibleColumns: e.visibleColumns,
        applyDefaultValues: !0,
        onClose: r,
        "onUpdate:newRow": a[2] || (a[2] = (u) => s.$emit("update:newRow", u))
      }, null, 8, ["id", "tableId", "isModalShown", "schemaId", "defaultValue", "visibleColumns"])) : v("", !0)
    ]));
  }
}), el = /* @__PURE__ */ Re({
  __name: "StringDisplay",
  props: {
    data: { type: [String, Object, Number, Boolean] }
  },
  setup(e) {
    return (n, t) => (l(), c("div", null, E(e.data), 1));
  }
}), Og = {
  name: "FileDisplay",
  props: {
    data: {
      type: [Object],
      required: !0
    },
    metadata: {
      type: Object,
      required: !0
    }
  },
  computed: {
    fileSize() {
      const e = ["", "k", "M", "G", "T", "P", "E"], n = Math.log10(this.data.size) / 3 | 0;
      if (n == 0)
        return this.data.size;
      var t = e[n], o = Math.pow(10, n * 3), i = this.data.size / o;
      return i.toFixed(1) + t;
    }
  }
}, _g = ["href"];
function Mg(e, n, t, o, i, r) {
  var s;
  return t.data.id ? (l(), c("a", {
    key: 0,
    href: t.data.url,
    target: "_blank"
  }, E((s = t.data) != null && s.filename ? t.data.filename : t.metadata.name + "." + t.data.extension) + " (" + E(r.fileSize) + ") ", 9, _g)) : v("", !0);
}
const tl = /* @__PURE__ */ D(Og, [["render", Mg]]), Pg = /* @__PURE__ */ Re({
  __name: "TextDisplay",
  props: {
    data: {}
  },
  setup(e) {
    return (n, t) => (l(), F(ja, { text: e.data }, null, 8, ["text"]));
  }
}), Bg = {
  name: "ObjectDisplay",
  props: {
    data: {
      type: [Object],
      required: !0
    },
    metadata: {
      type: [Object]
    }
  },
  computed: {
    hasTemplate() {
      return !!this.metadata.refLabel || !!this.metadata.refLabelDefault;
    },
    asTemplate() {
      const e = Object.keys(this.data), n = Object.values(this.data), t = this.metadata.refLabel ? this.metadata.refLabel : this.metadata.refLabelDefault;
      try {
        return new Function(...e, "return `" + t + "`;")(...n);
      } catch (o) {
        const i = JSON.stringify(e), r = JSON.stringify(n);
        return `${o.message} we got keys: ${i} vals: ${r} and template: ${t}`;
      }
    },
    asDotSeparatedString() {
      let e = "";
      return Object.keys(this.data).forEach((n) => {
        this.data[n] === null || (typeof this.data[n] == "object" ? e += on(this.data[n]) : e += "." + this.data[n]);
      }), e.replace(/^\./, "");
    }
  }
}, Lg = { key: 0 }, Ng = { key: 1 };
function qg(e, n, t, o, i, r) {
  return r.hasTemplate ? (l(), c("span", Lg, E(r.asTemplate), 1)) : (l(), c("span", Ng, E(r.asDotSeparatedString), 1));
}
const or = /* @__PURE__ */ D(Bg, [["render", qg]]), xg = {
  name: "EmailDisplay",
  props: {
    data: {
      type: String,
      required: !0
    }
  }
}, Vg = ["href"];
function jg(e, n, t, o, i, r) {
  return l(), c("a", {
    href: `mailto:${t.data}`
  }, E(t.data), 9, Vg);
}
const ir = /* @__PURE__ */ D(xg, [["render", jg]]), Hg = {
  name: "HyperlinkDisplay",
  props: {
    data: {
      type: String,
      required: !0
    }
  }
}, Gg = ["href"];
function Qg(e, n, t, o, i, r) {
  return l(), c("a", {
    target: "_blank",
    href: t.data
  }, E(t.data), 9, Gg);
}
const rr = /* @__PURE__ */ D(Hg, [["render", Qg]]), $g = {
  REF_ARRAY: "ObjectDisplay",
  MULTISELECT: "ObjectDisplay",
  CHECKBOX: "ObjectDisplay",
  ONTOLOGY_ARRAY: "ObjectDisplay",
  REFBACK: "ObjectDisplay",
  EMAIL_ARRAY: "EmailDisplay",
  HYPERLINK_ARRAY: "HyperlinkDisplay"
}, Jg = {
  name: "ListDisplay",
  components: { ObjectDisplay: or, StringDisplay: el, EmailDisplay: ir, HyperlinkDisplay: rr },
  data() {
    return {
      isFolded: !0
    };
  },
  props: {
    data: {
      type: [Array],
      required: !0
    },
    metadata: {
      type: Object,
      required: !0
    },
    foldCuttOff: {
      type: Number,
      required: !1,
      default: () => 3
    }
  },
  computed: {
    cellTypeComponentName() {
      return $g[this.metadata.columnType] || "StringDisplay";
    },
    visibleListItems() {
      return this.isFolded ? this.data.slice(0, this.foldCuttOff) : this.data;
    }
  },
  methods: {
    onFoldClicked(e) {
      this.isFolded = !this.isFolded, e.target.blur(), e.target.parentElement.blur();
    }
  }
}, zg = {
  key: 0,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-down",
  class: "svg-inline--fa fa-chevron-down fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, Yg = {
  key: 1,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-up",
  class: "svg-inline--fa fa-chevron-up fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};
function Wg(e, n, t, o, i, r) {
  return l(), c("div", null, [
    We(p("button", {
      onClick: n[0] || (n[0] = Ke((...s) => r.onFoldClicked && r.onFoldClicked(...s), ["stop", "prevent"])),
      class: "btn btn-sm float-right fold-btn"
    }, [
      p("template", null, [
        i.isFolded ? (l(), c("svg", zg, [...n[1] || (n[1] = [
          p("path", {
            fill: "currentColor",
            d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
          }, null, -1)
        ])])) : (l(), c("svg", Yg, [...n[2] || (n[2] = [
          p("path", {
            fill: "currentColor",
            d: "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
          }, null, -1)
        ])]))
      ])
    ], 512), [
      [Fo, t.data.length > t.foldCuttOff]
    ]),
    (l(!0), c(oe, null, ae(r.visibleListItems, (s, a) => (l(), c("div", { key: a }, [
      (l(), F(Et(r.cellTypeComponentName), {
        data: s,
        metadata: t.metadata
      }, null, 8, ["data", "metadata"]))
    ]))), 128))
  ]);
}
const Xg = /* @__PURE__ */ D(Jg, [["render", Wg], ["__scopeId", "data-v-44c19699"]]), Zg = {
  FILE: "FileDisplay",
  TEXT: "TextDisplay",
  JSON: "TextDisplay",
  REFBACK: "ListDisplay",
  MULTISELECT: "ListDisplay",
  CHECKBOX: "ListDisplay",
  REF: "ObjectDisplay",
  SELECT: "ObjectDisplay",
  RADIO: "ObjectDisplay",
  ONTOLOGY: "ObjectDisplay",
  EMAIL: "EmailDisplay",
  HYPERLINK: "HyperlinkDisplay"
}, ey = Re({
  name: "DataDisplayCell",
  components: {
    StringDisplay: el,
    FileDisplay: tl,
    TextDisplay: Pg,
    ListDisplay: Xg,
    ObjectDisplay: or,
    EmailDisplay: ir,
    HyperlinkDisplay: rr
  },
  props: {
    data: {
      type: [String, Object, Array, Number, Boolean],
      required: !1
    },
    metadata: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cellTypeComponentName() {
      return this.isArrayType ? "ListDisplay" : Zg[this.metadata.columnType] || "StringDisplay";
    },
    isArrayType() {
      return this.metadata.columnType.includes("ARRAY") || this.metadata.columnType === "MULTISELECT" || this.metadata.columnType === "CHECKBOX";
    },
    isEmpty() {
      return this.data === void 0 || this.data === null || Array.isArray(this.data) && this.data.length === 0;
    }
  }
});
function ty(e, n, t, o, i, r) {
  return e.isEmpty ? v("", !0) : (l(), F(Et(e.cellTypeComponentName), {
    key: 0,
    data: e.data,
    metadata: e.metadata
  }, null, 8, ["data", "metadata"]));
}
const nl = /* @__PURE__ */ D(ey, [["render", ty]]), ny = {
  name: "TableRow",
  components: { DataDisplayCell: nl },
  props: {
    row: {
      type: Object,
      required: !0
    },
    columns: { type: Array, required: !0 },
    tableId: { type: String, required: !0 },
    client: { type: Object, required: !0 },
    showSelect: { type: Boolean, required: !1 },
    selection: { type: Array, required: !1 }
  },
  data() {
    return {
      rowKey: null
    };
  },
  computed: {
    isSelected() {
      var e;
      return !!((e = this.selection) != null && e.find((n) => n && this.rowKey && Xt(n, this.rowKey)));
    }
  },
  methods: {
    isRefType: go,
    async convertRowToPrimaryKey(e) {
      return await this.client.convertRowToPrimaryKey(e, this.tableId);
    },
    onColumnClick(e) {
      this.$emit("column-click", e);
    },
    onCellClick(e) {
      const n = this.row[e.id];
      n && this.$emit("cellClick", {
        cellValue: xe(n),
        column: xe(e)
      });
    },
    onRowClick() {
      if (this.showSelect) {
        const e = this.isSelected ? "deselect" : "select";
        this.$emit(e, ci(this.rowKey));
      } else
        this.$emit("rowClick", ci(this.rowKey));
    },
    hasRowheader() {
      return this.showSelect || !!this.$slots.rowheader;
    }
  },
  mounted() {
    this.client.convertRowToPrimaryKey(this.row, this.tableId).then((e) => {
      this.rowKey = e;
    }).catch((e) => {
      console.log(e);
    });
  }
}, oy = { key: 0 }, iy = { style: { display: "flex" } }, ry = {
  key: 0,
  class: "form-check form-check-inline mr-1"
}, sy = ["checked"], ay = {
  key: 0,
  class: "fas fa-user-edit"
}, ly = ["onClick"];
function uy(e, n, t, o, i, r) {
  const s = K("DataDisplayCell");
  return l(), c("tr", {
    class: G(
      (r.isSelected ? "table-primary" : "table-hover") + (t.row.mg_draft ? "alert alert-warning" : "")
    )
  }, [
    r.hasRowheader ? (l(), c("td", oy, [
      p("div", iy, [
        t.showSelect ? (l(), c("div", ry, [
          p("input", {
            type: "checkbox",
            class: "form-check-input position-static",
            checked: r.isSelected,
            onClick: n[0] || (n[0] = (...a) => r.onRowClick && r.onRowClick(...a))
          }, null, 8, sy)
        ])) : v("", !0),
        j(e.$slots, "rowheader", {
          row: t.row,
          rowKey: i.rowKey
        }, void 0, !0)
      ]),
      t.row.mg_draft ? (l(), c("i", ay, "draft")) : v("", !0)
    ])) : v("", !0),
    (l(!0), c(oe, null, ae(t.columns, (a) => (l(), c("td", {
      key: a.id + r.isSelected,
      style: Ro([{ cursor: "pointer" }, a.showColumn ? "" : "display: none"]),
      onClick: (u) => {
        r.onRowClick(), r.onCellClick(a);
      },
      class: G({ refType: r.isRefType(a.columnType) })
    }, [
      T(s, {
        data: t.row[a.id],
        metadata: a
      }, null, 8, ["data", "metadata"])
    ], 14, ly))), 128))
  ], 2);
}
const dy = /* @__PURE__ */ D(ny, [["render", uy], ["__scopeId", "data-v-e0c9e76a"]]), cy = {
  components: { TableRow: dy },
  props: {
    selection: { type: Array, required: !1 },
    /** column metadata, two-way binded to allow for reorder
     * TODO: handle this through events since props are meant to be 1-way
     */
    columns: { type: Array, default: () => [] },
    tableMetadata: { type: Object, required: !1 },
    /** if tableMetadata is not supplied table id should be set */
    tableId: { type: String, required: !1 },
    data: { type: Array, default: () => [] },
    showSelect: { type: Boolean, default: !1 },
    schemaId: { type: String, required: !1 }
  },
  data() {
    return {
      client: nt.newClient(this.schemaId)
    };
  },
  computed: {
    dataColumns() {
      return this.columns.filter(
        (n) => n.columnType !== "HEADING" && n.columnType !== "SECTION"
      ).map((n) => (n.showColumn == null && (n.showColumn = !0), n));
    }
  },
  methods: {
    hasColheader() {
      return this.showSelect || !!this.$slots.colheader;
    },
    onColumnClick(e) {
      this.$emit("column-click", e);
    },
    onRowSelect(e) {
      this.$emit("select", e), this.$emit("update:selection", [...ci(this.selection), e]);
    },
    onRowDeselect(e) {
      const n = JSON.stringify(
        e,
        Object.keys(e).sort()
      ), t = this.selection.map(
        (o) => JSON.stringify(o, Object.keys(o).sort())
      ).findIndex((o) => o === n);
      this.$emit("deselect", e), this.$emit("update:selection", this.selection.toSpliced(t, 1));
    }
  }
}, fy = { style: { "overflow-x": "scroll" } }, py = { class: "table table-sm bg-white table-bordered table-hover" }, hy = {
  key: 0,
  slot: "header",
  scope: "col",
  style: { width: "1px" }
}, my = { style: { "text-align": "left", "font-weight": "normal" } }, Ay = ["onClick"], gy = { key: 0 }, yy = ["colspan"];
function Ky(e, n, t, o, i, r) {
  const s = K("TableRow");
  return l(), c("div", fy, [
    p("table", py, [
      p("thead", null, [
        r.hasColheader ? (l(), c("th", hy, [
          n[2] || (n[2] = p("h6", { class: "mb-0 mt-2 d-inline" }, "#", -1)),
          p("span", my, [
            j(e.$slots, "rowcolheader", {}, void 0, !0)
          ])
        ])) : v("", !0),
        (l(!0), c(oe, null, ae(r.dataColumns, (a) => (l(), c("th", {
          key: a.id + a.showColumn,
          scope: "col",
          class: "column-drag-header",
          style: Ro(a.showColumn ? "" : "display: none")
        }, [
          p("h6", {
            class: "mb-0 align-text-bottom text-nowrap",
            onClick: (u) => r.onColumnClick(a)
          }, [
            _(E(a.name) + " ", 1),
            j(e.$slots, "colheader", { col: a }, void 0, !0)
          ], 8, Ay)
        ], 4))), 128))
      ]),
      p("tbody", null, [
        t.data && !t.data.length ? (l(), c("tr", gy, [
          p("td", {
            colspan: r.dataColumns.length + 1,
            class: "alert-warning"
          }, " No results found ", 8, yy)
        ])) : (l(!0), c(oe, { key: 1 }, ae(t.data, (a) => (l(), F(s, {
          row: a,
          columns: r.dataColumns,
          tableId: t.tableId || t.tableMetadata.id,
          client: i.client,
          showSelect: t.showSelect,
          selection: t.selection,
          onCellClick: n[0] || (n[0] = (u) => e.$emit("cellClick", u)),
          onRowClick: n[1] || (n[1] = (u) => e.$emit("rowClick", u)),
          onSelect: r.onRowSelect,
          onDeselect: r.onRowDeselect
        }, {
          rowheader: b((u) => [
            j(e.$slots, "rowheader", {
              row: u.row,
              rowKey: u.rowKey
            }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["row", "columns", "tableId", "client", "showSelect", "selection", "onSelect", "onDeselect"]))), 256))
      ])
    ])
  ]);
}
const sr = /* @__PURE__ */ D(cy, [["render", Ky], ["__scopeId", "data-v-3a1e9256"]]), vy = ["id", "aria-describedby", "placeholder"], ar = /* @__PURE__ */ Re({
  __name: "InputSearch",
  props: {
    modelValue: {},
    isClearBtnShown: { type: Boolean, default: !1 },
    isEmitOnType: { type: Boolean, default: !1 },
    id: {},
    label: {},
    description: {},
    errorMessage: {},
    placeholder: { default: "Search" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = Ae(t.modelValue || ""), i = n;
    function r(u) {
      (u.key === "Enter" || t.isEmitOnType) && s();
    }
    function s() {
      i("update:modelValue", o.value);
    }
    function a() {
      o.value = "", s();
    }
    return (u, d) => (l(), F(ke, {
      id: e.id,
      label: e.label,
      description: e.description,
      errorMessage: e.errorMessage
    }, {
      default: b(() => [
        T(Ve, null, {
          append: b(() => [
            e.isClearBtnShown ? (l(), c("button", {
              key: 0,
              onClick: a,
              class: "btn btn-outline-primary",
              type: "button"
            }, [...d[1] || (d[1] = [
              p("i", { class: "fas fa-fw fa-times" }, null, -1)
            ])])) : v("", !0),
            p("button", {
              onClick: s,
              class: "btn btn-outline-primary",
              type: "button"
            }, [...d[2] || (d[2] = [
              p("i", { class: "fas fa-fw fa-search" }, null, -1)
            ])])
          ]),
          default: b(() => [
            We(p("input", {
              id: e.id,
              ref: e.id,
              "onUpdate:modelValue": d[0] || (d[0] = (f) => o.value = f),
              type: "text",
              class: "form-control",
              "aria-describedby": e.id,
              placeholder: e.placeholder,
              onKeyup: r
            }, null, 40, vy), [
              [Li, o.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "label", "description", "errorMessage"]));
  }
}), by = Re({
  props: {
    /** current page */
    modelValue: { type: Number, default: 1 },
    /** total records, i.e. sql count */
    count: { type: Number, required: !0 },
    /** number of records per page, i.e. sql limit */
    limit: { type: Number, default: 10 }
  },
  methods: {
    emitValue(e, n) {
      n || this.$emit("update:modelValue", e);
    },
    rowRange(e, n, t) {
      if (t === 0)
        return "-";
      {
        const o = (e - 1) * n + 1, i = Math.min(t, e * n);
        return `${o} - ${i} of ${t}`;
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.count / this.limit);
    },
    isFirstPage() {
      return this.modelValue === 1;
    },
    isLastPage() {
      return this.modelValue === this.totalPages || this.count === 0;
    }
  },
  watch: {
    value() {
      this.modelValue < 1 && this.$emit("update:modelValue", 1);
    },
    count() {
      this.modelValue > this.totalPages && this.$emit("update:modelValue", 1);
    }
  },
  created() {
    this.modelValue < 1 && this.$emit("update:modelValue", 1);
  }
}), Cy = { "aria-label": "Pagination" }, wy = { class: "pagination justify-content-center mb-0" }, Fy = { class: "page-item disabled" }, Ry = {
  class: "page-link text-nowrap",
  href: "#"
};
function ky(e, n, t, o, i, r) {
  return l(), c("nav", Cy, [
    p("ul", wy, [
      p("li", {
        class: G(["page-item", { disabled: e.isFirstPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[0] || (n[0] = Ke((s) => e.emitValue(1, e.isFirstPage), ["prevent"]))
        }, [...n[4] || (n[4] = [
          p("span", { "aria-hidden": "true" }, "«", -1),
          p("span", { class: "sr-only" }, "First", -1)
        ])])
      ], 2),
      p("li", {
        class: G(["page-item", { disabled: e.isFirstPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[1] || (n[1] = Ke((s) => e.emitValue(Math.max(e.modelValue - 1, 1), e.isFirstPage), ["prevent"]))
        }, [...n[5] || (n[5] = [
          p("span", { "aria-hidden": "true" }, "‹", -1),
          p("span", { class: "sr-only" }, "Previous", -1)
        ])])
      ], 2),
      p("li", Fy, [
        p("a", Ry, E(e.rowRange(e.modelValue, e.limit, e.count)), 1)
      ]),
      p("li", {
        class: G(["page-item", { disabled: e.isLastPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[2] || (n[2] = Ke((s) => e.emitValue(Math.min(e.modelValue + 1, e.totalPages), e.isLastPage), ["prevent"]))
        }, [...n[6] || (n[6] = [
          p("span", { "aria-hidden": "true" }, "›", -1),
          p("span", { class: "sr-only" }, "Next", -1)
        ])])
      ], 2),
      p("li", {
        class: G(["page-item", { disabled: e.isLastPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[3] || (n[3] = Ke((s) => e.emitValue(e.totalPages, e.isLastPage), ["prevent"]))
        }, [...n[7] || (n[7] = [
          p("span", { "aria-hidden": "true" }, "»", -1),
          p("span", { class: "sr-only" }, "Last", -1)
        ])])
      ], 2)
    ])
  ]);
}
const ol = /* @__PURE__ */ D(by, [["render", ky]]), Uy = {
  name: "RowButtonEdit",
  components: {
    RowButton: jt,
    EditModal: Es(() => Promise.resolve().then(() => fl))
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    },
    pkey: {
      type: Object
    },
    visibleColumns: {
      type: Array,
      required: !1,
      default: () => null
    }
  },
  data() {
    return {
      isModalShown: !1
    };
  },
  methods: {
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function Ey(e, n, t, o, i, r) {
  const s = K("RowButton"), a = K("EditModal");
  return l(), c("span", null, [
    T(s, {
      type: "edit",
      onEdit: n[0] || (n[0] = (u) => i.isModalShown = !0)
    }),
    i.isModalShown ? (l(), F(a, {
      key: 0,
      id: t.id + "edit-modal",
      tableId: t.tableId,
      pkey: t.pkey,
      isModalShown: i.isModalShown,
      schemaId: t.schemaId,
      visibleColumns: t.visibleColumns,
      onClose: r.handleClose
    }, null, 8, ["id", "tableId", "pkey", "isModalShown", "schemaId", "visibleColumns", "onClose"])) : v("", !0)
  ]);
}
const Sy = /* @__PURE__ */ D(Uy, [["render", Ey]]), Ty = {
  extends: He
};
function Iy(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: "btn btn-danger",
    onClick: n[0] || (n[0] = Ke((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    j(e.$slots, "default")
  ]);
}
const Dy = /* @__PURE__ */ D(Ty, [["render", Iy]]), Oy = {
  name: "ConfirmModal",
  components: {
    LayoutModal: Kt,
    ButtonAlt: ot,
    ButtonAction: He,
    ButtonDanger: Dy
  },
  props: {
    title: {
      type: String,
      required: !1
    },
    actionLabel: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !1
    },
    tableLabel: {
      type: String,
      required: !1
    },
    pkey: Object,
    actionType: {
      type: String,
      required: !1,
      default: () => "primary"
      // or danger
    }
  },
  methods: {
    flattenObject: on
  },
  computed: {
    pkeyAsString() {
      return this.flattenObject(this.pkey);
    }
  }
}, _y = { key: 1 }, My = { key: 0 }, Py = { key: 1 };
function By(e, n, t, o, i, r) {
  const s = K("ButtonAlt"), a = K("ButtonDanger"), u = K("ButtonAction"), d = K("LayoutModal");
  return l(), F(d, {
    title: t.title,
    onClose: n[3] || (n[3] = (f) => e.$emit("close"))
  }, {
    body: b(() => [
      e.$slots.default ? j(e.$slots, "default", { key: 0 }) : (l(), c("div", _y, [
        _(E(t.actionLabel) + " ", 1),
        p("strong", null, [
          t.tableId ? (l(), c("span", My, E(t.tableLabel), 1)) : v("", !0),
          t.pkey ? (l(), c("span", Py, "(" + E(r.pkeyAsString) + ")", 1)) : v("", !0)
        ]),
        n[4] || (n[4] = p("br", null, null, -1)),
        n[5] || (n[5] = _("Are you sure ? ", -1)),
        n[6] || (n[6] = p("br", null, null, -1))
      ]))
    ]),
    footer: b(() => [
      T(s, {
        onClick: n[0] || (n[0] = (f) => e.$emit("close"))
      }, {
        default: b(() => [...n[7] || (n[7] = [
          _("Close", -1)
        ])]),
        _: 1
      }),
      t.actionType === "danger" ? (l(), F(a, {
        key: 0,
        onClick: n[1] || (n[1] = (f) => e.$emit("confirmed"))
      }, {
        default: b(() => [
          _(E(t.actionLabel), 1)
        ]),
        _: 1
      })) : (l(), F(u, {
        key: 1,
        onClick: n[2] || (n[2] = (f) => e.$emit("confirmed"))
      }, {
        default: b(() => [
          _(E(t.actionLabel), 1)
        ]),
        _: 1
      }))
    ]),
    _: 3
  }, 8, ["title"]);
}
const lr = /* @__PURE__ */ D(Oy, [["render", By]]), Ly = {
  name: "RowButtonDelete",
  components: { RowButton: jt, ConfirmModal: lr },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    tableLabel: {
      type: String,
      required: !0
    },
    pkey: {
      type: Object
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isModalShown: !1,
      client: null
    };
  },
  methods: {
    async handleExecuteDelete() {
      this.client || (this.client = nt.newClient(this.schemaId)), await this.client.deleteRow(this.pkey, this.tableId).then(() => {
        this.$emit("success", {
          deletedKey: this.pkey,
          deleteFrom: this.tableId
        });
      }).catch((e) => {
        var t, o, i, r;
        const n = (o = (t = e == null ? void 0 : e.response) == null ? void 0 : t.data) != null && o.errors && Array.isArray((r = (i = e == null ? void 0 : e.response) == null ? void 0 : i.data) == null ? void 0 : r.errors) ? e.response.data.errors[0].message : "Failed to delete row data from table ";
        this.$emit("error", { errorMessage: n, error: e });
      }), this.handleClose();
    },
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function Ny(e, n, t, o, i, r) {
  const s = K("RowButton"), a = K("ConfirmModal");
  return l(), c("span", null, [
    T(s, {
      type: "delete",
      onDelete: n[0] || (n[0] = (u) => i.isModalShown = !0)
    }),
    i.isModalShown ? (l(), F(a, {
      key: 0,
      title: "Delete from " + t.tableId,
      actionLabel: "Delete",
      actionType: "danger",
      tableId: t.tableId,
      tableLable: t.tableLabel,
      pkey: t.pkey,
      onClose: r.handleClose,
      onConfirmed: r.handleExecuteDelete
    }, null, 8, ["title", "tableId", "tableLable", "pkey", "onClose", "onConfirmed"])) : v("", !0)
  ]);
}
const qy = /* @__PURE__ */ D(Ly, [["render", Ny]]), xy = {
  name: "TableSearch",
  components: {
    TableMolgenis: sr,
    MessageError: it,
    InputSearch: ar,
    Pagination: ol,
    Spinner: yt,
    RowButtonAdd: Za,
    RowButtonEdit: Sy,
    RowButtonDelete: qy
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !0
    },
    selection: { type: Array, default: () => [] },
    /** enables checkbox to select rows */
    showSelect: {
      type: Boolean,
      default: !1
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    showColumns: {
      type: Array
    },
    canEdit: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: Object,
      required: !1
    }
  },
  data: function() {
    return {
      page: 1,
      limit: 20,
      count: 0,
      loading: !0,
      graphqlError: "",
      searchTerms: "",
      tableMetadata: {},
      data: void 0
    };
  },
  computed: {
    showHeaderIfNeeded() {
      return this.showHeader || this.count > this.limit;
    },
    columnsVisible() {
      var e;
      return (e = this.tableMetadata) == null ? void 0 : e.columns.filter(
        (n) => this.showColumns == null && !n.id.startsWith("mg_") || this.showColumns != null && this.showColumns.includes(n.id)
      );
    }
  },
  methods: {
    select(e) {
      this.$emit("select", e);
    },
    selectNew(e) {
      this.$emit("update:newRow", e);
    },
    deselect(e) {
      this.$emit("deselect", e);
    },
    async loadData() {
      this.loading = !0;
      const e = {
        limit: this.limit,
        offset: this.limit * (this.page - 1),
        searchTerms: this.searchTerms,
        filter: this.filter
      }, n = nt.newClient(this.schemaId), t = await n.fetchTableData(this.tableId, e).catch(() => this.graphqlError = "Failed to load data");
      this.tableMetadata = await n.fetchTableMetaData(this.tableId), this.data = t[this.tableId], this.count = t[`${this.tableId}_agg`].count, this.loading = !1;
    }
  },
  watch: {
    page() {
      this.loadData();
    },
    searchTerms() {
      this.loadData();
    }
  },
  async mounted() {
    this.loadData();
  },
  emits: ["select", "update:newRow", "deselect"]
}, Vy = {
  key: 1,
  style: { "text-align": "center" }
}, jy = {
  key: 0,
  class: "form-inline justify-content-between mb-2 bg-white"
}, Hy = { key: 2 };
function Gy(e, n, t, o, i, r) {
  const s = K("MessageError"), a = K("InputSearch"), u = K("Pagination"), d = K("Spinner"), f = K("RowButtonAdd"), y = K("RowButtonEdit"), C = K("RowButtonDelete"), U = K("TableMolgenis");
  return l(), c("div", null, [
    e.graphqlError ? (l(), F(s, { key: 0 }, {
      default: b(() => [
        _(E(e.graphqlError), 1)
      ]),
      _: 1
    })) : (l(), c("div", Vy, [
      r.showHeaderIfNeeded ? (l(), c("form", jy, [
        t.tableId ? (l(), F(a, {
          key: 0,
          id: "input-search",
          modelValue: e.searchTerms,
          "onUpdate:modelValue": n[0] || (n[0] = (g) => e.searchTerms = g)
        }, null, 8, ["modelValue"])) : v("", !0),
        T(u, {
          class: "ml-2",
          modelValue: e.page,
          "onUpdate:modelValue": n[1] || (n[1] = (g) => e.page = g),
          limit: e.limit,
          count: e.count
        }, null, 8, ["modelValue", "limit", "count"])
      ])) : v("", !0),
      e.loading ? (l(), F(d, { key: 1 })) : (l(), c("div", Hy, [
        T(U, {
          schemaId: t.schemaId,
          selection: t.selection,
          tableMetadata: e.tableMetadata,
          columns: r.columnsVisible,
          data: e.data,
          showSelect: t.showSelect,
          onSelect: r.select,
          onDeselect: r.deselect
        }, {
          header: b(() => [
            j(e.$slots, "colheader", Pi(Ss(e.$props))),
            p("label", null, E(e.count) + " records found", 1)
          ]),
          rowcolheader: b(() => [
            t.canEdit ? (l(), F(f, {
              key: 0,
              id: "row-button-add-" + t.tableId,
              tableId: t.tableId,
              schemaId: t.schemaId,
              onClose: r.loadData,
              "onUpdate:newRow": r.selectNew,
              class: "d-inline p-0"
            }, null, 8, ["id", "tableId", "schemaId", "onClose", "onUpdate:newRow"])) : v("", !0)
          ]),
          colheader: b(() => [
            j(e.$slots, "colheader", On(e.$props, {
              canEdit: t.canEdit,
              reload: r.loadData,
              schemaId: t.schemaId
            }))
          ]),
          rowheader: b((g) => [
            j(e.$slots, "rowheader", {
              row: g.row,
              metadata: e.tableMetadata,
              rowKey: g.rowKey
            }),
            t.canEdit ? (l(), F(y, {
              key: 0,
              id: "row-button-edit-" + t.tableId,
              tableId: t.tableId,
              schemaId: t.schemaId,
              pkey: g.rowKey,
              onClose: r.loadData,
              class: "text-left"
            }, null, 8, ["id", "tableId", "schemaId", "pkey", "onClose"])) : v("", !0),
            t.canEdit ? (l(), F(C, {
              key: 1,
              id: "row-button-del-" + t.tableId,
              tableId: t.tableId,
              tableLabel: e.tableMetadata.label,
              schemaId: t.schemaId,
              pkey: g.rowKey,
              onClose: r.loadData
            }, null, 8, ["id", "tableId", "tableLabel", "schemaId", "pkey", "onClose"])) : v("", !0)
          ]),
          _: 3
        }, 8, ["schemaId", "selection", "tableMetadata", "columns", "data", "showSelect", "onSelect", "onDeselect"])
      ]))
    ]))
  ]);
}
const il = /* @__PURE__ */ D(xy, [["render", Gy]]), Qy = {
  extends: Ce,
  data: function() {
    return {
      client: null,
      showSelect: !1,
      data: [],
      selection: xe(this.modelValue),
      count: 0,
      tableMetadata: null,
      loading: !1
    };
  },
  components: {
    FilterWell: Xa,
    TableSearch: il,
    LayoutModal: Kt,
    FormGroup: ke,
    ButtonOutline: Po,
    Spinner: yt,
    RowButtonAdd: Za,
    Tooltip: un
  },
  props: {
    schemaId: {
      type: String,
      required: !1,
      default: ""
    },
    filter: Object,
    orderby: Object,
    multipleColumns: Boolean,
    maxNum: { type: Number, default: 11 },
    tableId: {
      type: String,
      required: !0
    },
    refLabel: {
      type: String,
      required: !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    title() {
      var n;
      return "Select " + (((n = this.tableMetadata) == null ? void 0 : n.label) || this.tableId);
    },
    showMultipleColumns() {
      return this.multipleColumns && this.count > 12;
    }
  },
  methods: {
    applyJsTemplate: yo,
    deselect(e) {
      this.selection = this.selection.filter(
        (n) => !Xt(n, e)
      ), this.emitSelection();
    },
    clearValue() {
      this.selection = [], this.emitSelection();
    },
    handleUpdateSelection(e) {
      this.selection = [...e], this.emitSelection();
    },
    select(e) {
      this.selection = [...this.selection, e], this.emitSelection();
    },
    async selectNew(e) {
      const n = await Yt(
        e,
        this.tableId,
        this.schemaId
      );
      this.selection = [...this.selection, n], this.emitSelection(), this.loadOptions();
    },
    emitSelection() {
      this.$emit("update:modelValue", this.selection);
    },
    openSelect() {
      this.showSelect = !0;
    },
    toggle(e) {
      var n;
      (n = this.selection) != null && n.some(
        (t) => Xt(t, e)
      ) ? this.selection = this.selection.filter(
        (t) => !Xt(t, e)
      ) : this.selection = [...this.selection, e], this.emitSelection();
    },
    closeSelect() {
      this.loadOptions(), this.showSelect = !1;
    },
    async loadOptions() {
      if (!this.client) {
        console.error("Tried loading options before client is initialised");
        return;
      }
      this.loading = !0;
      const e = {
        limit: this.maxNum,
        filter: this.filter,
        orderby: this.orderby
      }, n = await this.client.fetchTableData(this.tableId, e), o = (n[this.tableId] || []).map(
        async (i) => Yt(i, this.tableId, this.schemaId)
      );
      this.count = n[this.tableId + "_agg"].count, this.data = await Promise.all(o), this.loading = !1, this.$emit("optionsLoaded", this.data);
    }
  },
  watch: {
    async modelValue() {
      const e = xe(this.modelValue).map(
        async (n) => Yt(n, this.tableId, this.schemaId)
      );
      this.selection = await Promise.all(e);
    },
    filter() {
      this.loading || this.loadOptions();
    }
  },
  async created() {
    if (this.loading = !0, this.client = nt.newClient(this.schemaId), this.tableMetadata = await this.client.fetchTableMetaData(this.tableId), await this.loadOptions(), this.loading = !0, !this.modelValue)
      this.selection = [];
    else {
      const e = xe(this.modelValue).map(
        async (n) => Yt(n, this.tableId, this.schemaId)
      );
      this.selection = await Promise.all(e);
    }
    this.loading = !1;
  },
  emits: ["optionsLoaded", "update:modelValue"]
}, $y = ["id", "name", "value"], Jy = ["for", "onClick"], zy = { key: 2 }, Yy = { class: "m-1" };
function Wy(e, n, t, o, i, r) {
  const s = K("FilterWell"), a = K("ButtonAlt"), u = K("Spinner"), d = K("RowButtonAdd"), f = K("ButtonOutline"), y = K("TableSearch"), C = K("LayoutModal"), U = K("FormGroup");
  return l(), F(U, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      p("div", null, [
        p("div", null, [
          p("div", null, [
            (l(!0), c(oe, null, ae(e.selection, (g) => (l(), F(s, {
              key: JSON.stringify(g),
              label: r.applyJsTemplate(g, t.refLabel),
              onClick: (A) => r.deselect(g)
            }, null, 8, ["label", "onClick"]))), 128))
          ]),
          Array.isArray(e.modelValue) && e.modelValue.length ? (l(), F(a, {
            key: 0,
            class: "pl-1",
            icon: "fa fa-clear",
            onClick: r.clearValue
          }, {
            default: b(() => [...n[3] || (n[3] = [
              _(" clear selection ", -1)
            ])]),
            _: 1
          }, 8, ["onClick"])) : v("", !0)
        ]),
        p("div", {
          class: G(
            r.showMultipleColumns ? "d-flex align-content-stretch flex-wrap" : ""
          )
        }, [
          e.loading ? (l(), F(u, { key: 0 })) : e.data.length ? (l(!0), c(oe, { key: 1 }, ae(e.data, (g, A) => (l(), c("div", {
            class: G(["form-check custom-control custom-checkbox", r.showMultipleColumns ? "col-12 col-md-6 col-lg-4" : ""]),
            key: A
          }, [
            We(p("input", {
              id: `${e.id}-${JSON.stringify(g)}`,
              name: e.id,
              type: "checkbox",
              value: g,
              "onUpdate:modelValue": n[0] || (n[0] = (w) => e.selection = w),
              onChange: n[1] || (n[1] = (...w) => r.emitSelection && r.emitSelection(...w)),
              class: G(["form-check-input", { "is-invalid": e.errorMessage }])
            }, null, 42, $y), [
              [ks, e.selection]
            ]),
            p("label", {
              class: "form-check-label",
              for: `${e.id}-${JSON.stringify(g)}`,
              onClick: Ke((w) => r.toggle(g), ["prevent"])
            }, E(r.applyJsTemplate(g, t.refLabel)), 9, Jy)
          ], 2))), 128)) : (l(), c("div", zy, "No entries found for " + E(e.label), 1))
        ], 2),
        p("div", Yy, [
          t.canEdit ? (l(), F(d, {
            key: 0,
            id: "add-entry",
            label: `Add new ${e.label}`,
            tableId: t.tableId,
            schemaId: t.schemaId,
            "onUpdate:newRow": r.selectNew,
            class: "mr-1"
          }, null, 8, ["label", "tableId", "schemaId", "onUpdate:newRow"])) : v("", !0),
          T(f, {
            class: G(r.showMultipleColumns ? "col-12 col-md-6 col-lg-4" : ""),
            icon: "fa fa-search",
            onClick: r.openSelect
          }, {
            default: b(() => [
              _(E(e.count > t.maxNum ? `Show all ${e.count} options with details ` : "More details "), 1)
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ]),
        e.showSelect ? (l(), F(C, {
          key: 0,
          title: r.title,
          onClose: r.closeSelect
        }, {
          body: b(() => [
            T(y, {
              selection: e.selection,
              "onUpdate:selection": n[2] || (n[2] = (g) => e.selection = g),
              schemaId: t.schemaId,
              tableId: t.tableId,
              canEdit: t.canEdit,
              showSelect: !0,
              filter: t.filter,
              limit: 10,
              onSelect: r.select,
              onDeselect: r.deselect,
              "onUpdate:newRow": r.selectNew
            }, null, 8, ["selection", "schemaId", "tableId", "canEdit", "filter", "onSelect", "onDeselect", "onUpdate:newRow"])
          ]),
          footer: b(() => [
            T(a, { onClick: r.closeSelect }, {
              default: b(() => [...n[4] || (n[4] = [
                _("Close", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["title", "onClose"])) : v("", !0)
      ])
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const uo = /* @__PURE__ */ D(Qy, [["render", Wy]]), Xy = {
  name: "RefListFilter",
  components: { InputRefList: uo },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Object,
      required: !1
    },
    schemaId: {
      required: !1,
      type: String
    },
    tableId: {
      type: String,
      required: !0
    },
    refLabel: {
      type: String,
      required: !0
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  }
};
function Zy(e, n, t, o, i, r) {
  const s = K("InputRefList");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    tableId: t.tableId,
    schemaId: t.schemaId,
    refLabel: t.refLabel
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "tableId", "schemaId", "refLabel"]);
}
const co = /* @__PURE__ */ D(Xy, [["render", Zy]]), eK = {
  name: "InputOntologySubtree",
  props: {
    terms: {
      type: Array,
      required: !0,
      default: () => []
    },
    isMultiSelect: { type: Boolean, default: !1 }
  },
  methods: {
    countVisibleChildren(e) {
      return e.children ? e.children.filter((n) => n.visible).length : 0;
    },
    getExpandState(e) {
      return this.countVisibleChildren(e) == 0 ? "fas fa-angle-right invisible" : e.expanded ? "fas fa-angle-down" : "fas fa-angle-right";
    },
    //expensive?
    getAllChildNames(e) {
      let n = [];
      return e.children && e.children.forEach((t) => {
        n.push(t.name), n = n.concat(this.getAllChildNames(t));
      }), n;
    },
    getSelectState(e) {
      return e.selected === "complete" ? this.isMultiSelect ? "fas fa-check-square" : "fas fa-check-circle" : e.selected === "partial" ? this.isMultiSelect ? "far fa-check-square" : "far fa-circle" : this.isMultiSelect ? "far fa-square" : "far fa-circle";
    },
    toggleExpandOrSelect(e) {
      e.children ? this.toggleExpand(e) : this.toggleSelect(e);
    },
    toggleSelect(e) {
      e.selected === "complete" ? this.$emit("deselect", e.name) : this.$emit("select", e.name);
    },
    toggleExpand(e) {
      this.$emit("toggleExpand", e.name);
    }
  }
}, tK = { style: { "list-style-type": "none" } }, nK = ["onClick"], oK = ["onClick"], iK = ["onClick"], rK = { key: 0 }, sK = { key: 0 }, aK = {
  key: 1,
  class: "text-muted"
}, lK = { key: 2 };
function uK(e, n, t, o, i, r) {
  const s = K("InputOntologySubtree", !0);
  return l(), c("ul", tK, [
    (l(!0), c(oe, null, ae(t.terms.filter((a) => a.visible).sort((a, u) => a.order - u.order), (a) => (l(), c("li", {
      key: a.name + a.selected + a.expanded
    }, [
      p("span", {
        onClick: Ke((u) => r.toggleExpand(a), ["stop"])
      }, [
        p("i", {
          class: G(["fa-fw pl-2 pt-1 ml-3", r.getExpandState(a)]),
          role: "button"
        }, null, 2)
      ], 8, nK),
      p("span", {
        onClick: Ke((u) => r.toggleSelect(a), ["stop"])
      }, [
        a.selectable ? (l(), c("i", {
          key: 0,
          class: G(["fa-fw text-primary pl-2 pt-1", r.getSelectState(a)]),
          role: "button"
        }, null, 2)) : v("", !0)
      ], 8, oK),
      p("span", {
        onClick: Ke((u) => r.toggleExpandOrSelect(a), ["stop"]),
        class: "flex-grow-1 pl-2",
        role: "button"
      }, [
        _(E(a.label ? a.label : a.name) + " ", 1),
        a.code ? (l(), c("span", rK, [
          n[3] || (n[3] = _(" (", -1)),
          a.codesystem ? (l(), c("span", sK, E(a.codesystem) + ": ", 1)) : v("", !0),
          _(" " + E(a.code) + ") ", 1)
        ])) : v("", !0),
        a.definition ? (l(), c("small", aK, [
          p("i", null, " - " + E(a.definition), 1)
        ])) : v("", !0),
        a.children && r.countVisibleChildren(a) > 0 ? (l(), c("span", lK, " (" + E(r.countVisibleChildren(a)) + ") ", 1)) : v("", !0)
      ], 8, iK),
      a.expanded ? (l(), F(s, {
        key: 0,
        terms: a.children,
        isMultiSelect: t.isMultiSelect,
        onSelect: n[0] || (n[0] = (u) => e.$emit("select", u)),
        onDeselect: n[1] || (n[1] = (u) => e.$emit("deselect", u)),
        onToggleExpand: n[2] || (n[2] = (u) => e.$emit("toggleExpand", u))
      }, null, 8, ["terms", "isMultiSelect"])) : v("", !0)
    ]))), 128))
  ]);
}
const dK = /* @__PURE__ */ D(eK, [["render", uK]]);
var rl = { exports: {} };
(function(e, n) {
  (function(t, o) {
    e.exports = o();
  })(wn, function() {
    var t = "__v-click-outside", o = typeof window < "u", i = typeof navigator < "u", r = o && ("ontouchstart" in window || i && navigator.msMaxTouchPoints > 0) ? ["touchstart"] : ["click"], s = function(f) {
      var y = f.event, C = f.handler;
      (0, f.middleware)(y) && C(y);
    }, a = function(f, y) {
      var C = function(L) {
        var B = typeof L == "function";
        if (!B && typeof L != "object") throw new Error("v-click-outside: Binding value must be a function or an object");
        return { handler: B ? L : L.handler, middleware: L.middleware || function(N) {
          return N;
        }, events: L.events || r, isActive: L.isActive !== !1, detectIframe: L.detectIframe !== !1, capture: !!L.capture };
      }(y.value), U = C.handler, g = C.middleware, A = C.detectIframe, w = C.capture;
      if (C.isActive) {
        if (f[t] = C.events.map(function(L) {
          return { event: L, srcTarget: document.documentElement, handler: function(B) {
            return function(N) {
              var x = N.el, q = N.event, Y = N.handler, $ = N.middleware, Q = q.path || q.composedPath && q.composedPath();
              (Q ? Q.indexOf(x) < 0 : !x.contains(q.target)) && s({ event: q, handler: Y, middleware: $ });
            }({ el: f, event: B, handler: U, middleware: g });
          }, capture: w };
        }), A) {
          var M = { event: "blur", srcTarget: window, handler: function(L) {
            return function(B) {
              var N = B.el, x = B.event, q = B.handler, Y = B.middleware;
              setTimeout(function() {
                var $ = document.activeElement;
                $ && $.tagName === "IFRAME" && !N.contains($) && s({ event: x, handler: q, middleware: Y });
              }, 0);
            }({ el: f, event: L, handler: U, middleware: g });
          }, capture: w };
          f[t] = [].concat(f[t], [M]);
        }
        f[t].forEach(function(L) {
          var B = L.event, N = L.srcTarget, x = L.handler;
          return setTimeout(function() {
            f[t] && N.addEventListener(B, x, w);
          }, 0);
        });
      }
    }, u = function(f) {
      (f[t] || []).forEach(function(y) {
        return y.srcTarget.removeEventListener(y.event, y.handler, y.capture);
      }), delete f[t];
    }, d = o ? { beforeMount: a, updated: function(f, y) {
      var C = y.value, U = y.oldValue;
      JSON.stringify(C) !== JSON.stringify(U) && (u(f), a(f, { value: C }));
    }, unmounted: u } : {};
    return { install: function(f) {
      f.directive("click-outside", d);
    }, directive: d };
  });
})(rl);
var cK = rl.exports;
const qo = /* @__PURE__ */ Ia(cK), fK = {
  extends: Ce,
  components: {
    FormGroup: ke,
    InputOntologySubtree: dK,
    MessageError: it,
    Spinner: yt
  },
  directives: {
    clickOutside: qo.directive
  },
  props: {
    /** if you don't want to use autoload using table you can provide options via 'items'. Should be format [{name:a, parent:b},{name:b}]
     */
    options: {
      type: Array,
      default: null
    },
    /** show as pulldown. When false, shows always expanded*/
    showExpanded: {
      type: Boolean,
      default: !1
    },
    isMultiSelect: {
      type: Boolean,
      default: !1
    },
    tableId: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      error: null,
      // used for drop down focus state
      focus: !1,
      //huge object with all the terms, flattened
      //includes also its children
      terms: {},
      search: null,
      //we use key to force updates
      key: 1,
      //use to block to many search results
      searchResultCount: 0,
      data: [],
      loading: !0
    };
  },
  computed: {
    rootTerms() {
      return this.terms ? Object.values(this.terms).filter(
        (n) => !n.parent && n.visible
      ) : [];
    },
    selectionWithoutChildren() {
      let e = [];
      return this.key && this.rootTerms.forEach((n) => {
        e.push(...sl(n));
      }), e;
    }
  },
  methods: {
    toggleExpand(e) {
      this.terms[e].expanded = !this.terms[e].expanded, this.key++;
    },
    loseFocusWhenClickedOutside() {
      this.focus && !this.showExpanded && (this.focus = !1);
    },
    toggleFocus() {
      this.showExpanded || (this.focus = !this.focus, this.focus && this.$refs.search.focus());
    },
    getParents(e) {
      let n = [], t = e.parent;
      for (; t; )
        n.push(this.terms[t.name]), this.terms[t.name].parent && //check for parent that are indirect parent of themselves
        !n.includes(this.terms[t.name].parent.name) ? t = this.terms[t.name].parent : t = null;
      return n;
    },
    getChildren(e) {
      return this.data.filter(
        (n) => {
          var t;
          return ((t = n.parent) == null ? void 0 : t.name) === e;
        }
      );
    },
    getAllChildren(e) {
      let n = [];
      return e.children && (n = e.children, e.children.forEach(
        (t) => n = n.concat(this.getAllChildren(t))
      )), n;
    },
    select(e) {
      this.isMultiSelect || Object.keys(this.terms).forEach(
        (t) => this.terms[t].selected = "unselected"
      );
      let n = this.terms[e];
      n.selected = "complete", this.isMultiSelect && (this.getAllChildren(n).forEach(
        (t) => t.selected = "complete"
      ), this.getParents(n).forEach((t) => {
        t.children.every(
          (o) => o.selected === "complete"
        ) ? t.selected = "complete" : t.selected = "partial";
      })), this.emitValue(), this.$refs.search.focus(), this.isMultiSelect || (this.focus = !1), this.key++;
    },
    deselect(e) {
      if (this.isMultiSelect) {
        let n = this.terms[e];
        n.selected = "unselected", this.getAllChildren(this.terms[e]).forEach(
          (t) => t.selected = "unselected"
        ), this.getParents(n).forEach((t) => {
          t.children.some(
            (o) => o.selected === "complete"
          ) ? t.selected = "partial" : t.selected = "unselected";
        });
      } else
        Object.keys(this.terms).forEach(
          (n) => this.terms[n].selected = "unselected"
        );
      this.emitValue(), this.$refs.search.focus(), this.key++;
    },
    clearSelection() {
      this.terms && Object.values(this.terms).forEach(
        (e) => e.selected = "unselected"
      ), this.emitValue(), this.$refs.search.focus(), this.key++;
    },
    emitValue() {
      let e = Object.values(this.terms).filter((n) => n.selected === "complete").map((n) => ({ name: n.name }));
      this.isMultiSelect ? this.$emit("update:modelValue", e) : this.$emit("update:modelValue", e[0] || null);
    },
    applySelection(e) {
      if (Object.keys(this.terms).forEach(
        (n) => this.terms[n].selected = "unselected"
      ), e && this.isMultiSelect)
        e.forEach((n) => {
          let t = this.terms[n.name];
          t && (this.getAllChildren(t).length == 0 && (t.selected = "complete"), this.isMultiSelect && (this.getAllChildren(t).forEach(
            (o) => o.selected = "complete"
          ), this.getParents(t).forEach((o) => {
            o.children.every(
              (i) => i.selected === "complete"
            ) ? o.selected = "complete" : o.selected = "partial";
          })));
        });
      else if (e) {
        let n = this.terms[e.name];
        n && (n.selected = "complete", this.getParents(n).forEach((t) => {
          t.selected = "partial";
        }));
      }
      this.key++;
    }
  },
  watch: {
    search() {
      if (this.searchResultCount = 0, this.search) {
        Object.values(this.terms).forEach((n) => {
          n.visible = !1, n.selectable = !1;
        });
        let e = this.search.trim().split(/[\s,:]+/).filter((n) => n.trim().length > 0).map((n) => n.toLowerCase());
        Object.values(this.terms).forEach((n) => {
          if (e.every(
            (t) => {
              var o, i, r, s;
              return n.name.toLowerCase().includes(t) || ((o = n.label) == null ? void 0 : o.toLowerCase().includes(t)) || ((i = n.definition) == null ? void 0 : i.toLowerCase().includes(t)) || ((r = n.code) == null ? void 0 : r.toLowerCase().includes(t)) || ((s = n.codesystem) == null ? void 0 : s.toLowerCase().includes(t));
            }
          )) {
            if (n.visible = !0, n.selectable = !0, this.searchResultCount++, n.parent) {
              let t = this.terms[n.parent.name];
              for (; t && !t.visible; )
                t.visible = !0, t.parent && (t = this.terms[t.parent.name]);
            }
            this.getAllChildren(n).forEach((t) => {
              t.visible = !0, t.selectable = !0;
            });
          }
        });
      } else
        Object.values(this.terms).forEach((e) => {
          e.visible = !0, e.selectable = !0, this.searchResultCount++;
        });
      Object.values(this.terms).filter((e) => e.visible).length < 50 && Object.values(this.terms).filter((e) => e.visible && e.children).forEach((e) => e.expanded = !0), this.key++;
    },
    modelValue: {
      deep: !0,
      handler() {
        this.applySelection(this.modelValue), this.key++;
      }
    },
    data() {
      if (this.data) {
        this.searchResultCount = 0;
        let e = {};
        this.data.forEach((n) => {
          e[n.name] ? (e[n.name].definition = n.definition, e[n.name].label = n.label, e[n.name].code = n.code, e[n.name].codesystem = n.codesystem, e[n.name].order = n.order) : e[n.name] = {
            name: n.name,
            visible: !0,
            selectable: !0,
            selected: "unselected",
            definition: n.definition,
            code: n.code,
            codesystem: n.codesystem,
            label: n.label,
            order: n.order
          }, n.parent && (e[n.name].parent = n.parent, e[n.parent.name] || (e[n.parent.name] = {
            name: n.parent.name,
            visible: !0,
            selectable: !0,
            selected: "unselected"
          }), e[n.parent.name].children || (e[n.parent.name].children = []), e[n.parent.name].children.push(e[n.name])), this.searchResultCount++;
        }), this.terms = e, this.applySelection(this.modelValue);
      }
    }
  },
  async mounted() {
    if (this.tableId) {
      const e = nt.newClient(this.schemaId);
      this.data = await e.fetchOntologyOptions(this.tableId);
    }
  },
  created() {
    this.options ? (this.data = this.options, this.loading = !1) : this.limit = 1e5;
  }
};
function sl(e) {
  let n = [];
  return e.selected === "complete" ? n.push(e) : e.children && e.children.forEach(
    (t) => n.push(...sl(t))
  ), n;
}
const pK = ["onClick"], hK = {
  key: 0,
  class: "input-group-prepend"
}, mK = ["placeholder"], AK = { class: "d-inline-block float-right" }, gK = {
  key: 0,
  class: "p-2 fa fa-times",
  style: { "vertical-align": "middle" }
}, yK = {
  key: 0,
  class: "p-2 fa fa-caret-down",
  style: { "vertical-align": "middle" }
}, KK = {
  key: 0,
  class: "pl-4"
}, vK = { key: 3 };
function bK(e, n, t, o, i, r) {
  const s = K("MessageError"), a = K("InputOntologySubtree"), u = K("Spinner"), d = K("FormGroup"), f = ko("click-outside");
  return l(), F(d, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      i.error ? (l(), F(s, { key: 0 }, {
        default: b(() => [
          _(E(i.error), 1)
        ]),
        _: 1
      })) : (l(), c("div", {
        key: 1,
        class: G(["p-0 m-0", { dropdown: !t.showExpanded, "border rounded": !t.showExpanded }])
      }, [
        p("div", {
          class: "border-0 text-left form-control",
          style: { height: "auto", cursor: "pointer" },
          onClick: n[5] || (n[5] = (...y) => r.toggleFocus && r.toggleFocus(...y))
        }, [
          (l(!0), c(oe, null, ae(r.selectionWithoutChildren.sort(
            (y, C) => y.order - C.order
          ), (y) => (l(), c("span", {
            class: "btn btn-sm btn-primary text-white mr-1",
            key: y,
            onClick: Ke((C) => r.deselect(y.name), ["stop"])
          }, [
            _(E(y.label ? y.label : y.name) + " ", 1),
            n[6] || (n[6] = p("span", { class: "fa fa-times" }, null, -1))
          ], 8, pK))), 128)),
          t.showExpanded && r.selectionWithoutChildren.length > 0 ? (l(), c("i", {
            key: 0,
            class: "p-2 fa fa-times",
            style: { "vertical-align": "middle" },
            onClick: n[0] || (n[0] = Ke((...y) => r.clearSelection && r.clearSelection(...y), ["stop"]))
          })) : v("", !0),
          p("span", {
            class: G({ "input-group": t.showExpanded })
          }, [
            t.showExpanded ? (l(), c("div", hK, [...n[7] || (n[7] = [
              p("button", {
                class: "btn border-right-0 border btn-outline-primary",
                type: "button"
              }, [
                p("i", { class: "fa fa-search" })
              ], -1)
            ])])) : v("", !0),
            We(p("input", {
              type: "text",
              ref: "search",
              placeholder: i.focus || t.showExpanded ? "Type to search" : "",
              class: G({
                "form-control": t.showExpanded,
                "border-0": !t.showExpanded
              }),
              "onUpdate:modelValue": n[1] || (n[1] = (y) => i.search = y),
              onClick: n[2] || (n[2] = Ke(() => {
              }, ["stop"])),
              onFocus: n[3] || (n[3] = (y) => i.focus = !0)
            }, null, 42, mK), [
              [Li, i.search]
            ])
          ], 2),
          p("span", AK, [
            p("span", {
              onClick: n[4] || (n[4] = Ke((...y) => r.clearSelection && r.clearSelection(...y), ["prevent", "stop"])),
              style: { cursor: "pointer" }
            }, [
              !t.showExpanded && r.selectionWithoutChildren.length > 0 ? (l(), c("i", gK)) : v("", !0)
            ]),
            t.showExpanded ? v("", !0) : (l(), c("i", yK))
          ])
        ]),
        i.focus || t.showExpanded ? We((l(), c("div", {
          key: 0,
          class: G(["w-100 show p-0 overflow-auto", { "dropdown-menu": !t.showExpanded }])
        }, [
          i.search && Object.keys(i.terms).length > 50 && i.searchResultCount >= 0 ? (l(), c("span", KK, " found " + E(i.searchResultCount) + " terms. ", 1)) : v("", !0),
          r.rootTerms.length > 0 ? (l(), F(a, {
            key: i.key,
            terms: r.rootTerms,
            isMultiSelect: t.isMultiSelect,
            onSelect: r.select,
            onDeselect: r.deselect,
            onToggleExpand: r.toggleExpand,
            style: { "max-height": "100vh" },
            class: "pt-2 pl-0"
          }, null, 8, ["terms", "isMultiSelect", "onSelect", "onDeselect", "onToggleExpand"])) : i.loading ? (l(), F(u, { key: 2 })) : (l(), c("div", vK, "No results found"))
        ], 2)), [
          [f, r.loseFocusWhenClickedOutside]
        ]) : v("", !0)
      ], 2))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Co = /* @__PURE__ */ D(fK, [["render", bK]]), CK = {
  name: "InputOntologyFilter",
  components: { InputOntology: Co },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Object,
      required: !1
    },
    schemaId: {
      required: !1,
      type: String
    },
    tableId: {
      type: String,
      required: !0
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  }
};
function wK(e, n, t, o, i, r) {
  const s = K("InputOntology");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    tableId: t.tableId,
    schemaId: t.schemaId,
    isMultiSelect: !0,
    showExpanded: !0
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "tableId", "schemaId"]);
}
const Ti = /* @__PURE__ */ D(CK, [["render", wK]]), { CODE_MINUS: FK } = Tt, RK = {
  extends: Ce,
  methods: {
    emitIfValid(e) {
      const n = e.target.value;
      n != null && n.length ? this.$emit("update:modelValue", n) : this.$emit("update:modelValue", null);
    },
    handleKeyValidity(e) {
      (e.which ?? e.keyCode) === FK && this.$emit("update:modelValue", Hi(e.target.value)), ji(e) || e.preventDefault();
    },
    isRequired: Nn
  },
  emits: ["update:modelValue"]
}, kK = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function UK(e, n, t, o, i, r) {
  return l(), c("input", {
    id: e.id,
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (s) => r.handleKeyValidity(s)),
    onInput: n[1] || (n[1] = (s) => r.emitIfValid(s))
  }, null, 42, kK);
}
const al = /* @__PURE__ */ D(RK, [["render", UK]]), EK = {
  components: { BaseInputLong: al, FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e === "" ? null : e, this.$emit("update:modelValue", t);
    }
  }
};
function SK(e, n, t, o, i, r) {
  const s = K("BaseInputLong"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id + "-from",
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, { class: "d-flex" }, {
        prepend: b(() => [
          j(e.$slots, "prepend")
        ]),
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          T(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const TK = /* @__PURE__ */ D(EK, [["render", SK]]), IK = {
  name: "LongFilter",
  components: { InputRangeLong: TK },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function DK(e, n, t, o, i, r) {
  const s = K("InputRangeLong");
  return l(), F(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: b(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const rs = /* @__PURE__ */ D(IK, [["render", DK]]), ss = {
  STRING: rt,
  STRING_ARRAY: rt,
  EMAIL: rt,
  EMAIL_ARRAY: rt,
  HYPERLINK: rt,
  HYPERLINK_ARRAY: rt,
  TEXT: rt,
  TEXT_ARRAY: rt,
  JSON: rt,
  UUID: rt,
  UUID_ARRAY: rt,
  INT: Fi,
  INT_ARRAY: Fi,
  DECIMAL: Ri,
  DECIMAL_ARRAY: Ri,
  LONG: rs,
  LONG_ARRAY: rs,
  DATE: Ui,
  DATE_ARRAY: Ui,
  DATETIME: Ei,
  DATETIME_ARRAY: Ei,
  BOOL: Si,
  BOOl_ARRAY: Si,
  REF: co,
  REFBACK: co,
  REF_ARRAY: co,
  ONTOLOGY: Ti,
  ONTOLOGY_ARRAY: Ti
}, OK = {
  name: "FilterInput",
  components: {
    StringFilter: rt,
    IntegerFilter: Fi,
    DecimalFilter: Ri,
    DateFilter: Ui,
    DateTimeFilter: Ei,
    BooleanFilter: Si,
    RefListFilter: co,
    OntologyFilter: Ti
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    columnType: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(ss).includes(e);
      }
    },
    conditions: {
      type: Array,
      required: !0
    },
    tableId: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    refLabel: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      // used to add new empty field when adding conditions
      fieldCount: this.isMultiConditionFilter ? 1 : this.conditions.length || 1
    };
  },
  computed: {
    filterType() {
      return ss[this.columnType];
    },
    isMultiConditionFilter() {
      return [
        "REF",
        "REF_ARRAY",
        "REFBACK",
        "ONTOLOGY",
        "ONTOLOGY_ARRAY"
      ].includes(this.columnType);
    }
  },
  methods: {
    updateCondition(e, n) {
      if (this.isMultiConditionFilter)
        this.$emit("updateConditions", xe(n));
      else if (!this.conditions.length)
        this.$emit("updateConditions", [n]);
      else {
        let t = xe(this.conditions);
        t[e] = n, this.$emit("updateConditions", t);
      }
    },
    clearCondition(e) {
      let n = [...this.conditions];
      n.splice(e, 1), this.$emit("updateConditions", n), this.fieldCount > 1 && this.fieldCount--;
    }
  },
  watch: {
    conditions(e) {
      this.fieldCount = this.isMultiConditionFilter ? 1 : e.length || 1;
    }
  },
  emits: ["updateConditions"]
}, _K = { key: 0 };
function MK(e, n, t, o, i, r) {
  return l(), c("div", null, [
    r.isMultiConditionFilter ? (l(), c("div", _K, [
      (l(), F(Et(r.filterType), {
        id: t.id,
        condition: t.conditions,
        onUpdateCondition: n[0] || (n[0] = (s) => r.updateCondition(e.index - 1, s)),
        tableId: t.tableId,
        schemaId: t.schemaId,
        refLabel: t.refLabel
      }, null, 40, ["id", "condition", "tableId", "schemaId", "refLabel"]))
    ])) : (l(!0), c(oe, { key: 1 }, ae(i.fieldCount, (s) => (l(), c("div", { key: s }, [
      (l(), F(Et(r.filterType), {
        id: t.id + s,
        condition: t.conditions[s - 1],
        onUpdateCondition: (a) => r.updateCondition(s - 1, a),
        onClearCondition: (a) => r.clearCondition(s - 1),
        onAddCondition: n[1] || (n[1] = (a) => i.fieldCount++),
        showAddButton: s === t.conditions.length,
        tableId: t.tableId,
        schemaId: t.schemaId
      }, null, 40, ["id", "condition", "onUpdateCondition", "onClearCondition", "showAddButton", "tableId", "schemaId"]))
    ]))), 128))
  ]);
}
const PK = /* @__PURE__ */ D(OK, [["render", MK]]), BK = {
  name: "FilterSidebar",
  components: {
    FilterInput: PK,
    FilterContainer: FA
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  computed: {
    visibleFilters() {
      return this.filters.filter(
        (e) => e.showFilter && !["HEADING", "SECTION"].includes(e.columnType)
      );
    }
  },
  methods: {
    handleUpdateFilter(e, n) {
      let t = [...this.visibleFilters];
      t[e].conditions = n, this.$emit("updateFilters", t);
    }
  }
}, LK = { class: "sidebar-container" };
function NK(e, n, t, o, i, r) {
  const s = K("FilterInput"), a = K("FilterContainer");
  return l(), c("div", LK, [
    (l(!0), c(oe, null, ae(r.visibleFilters, (u, d) => (l(), F(a, {
      key: u.id,
      title: u.label,
      conditions: u.conditions
    }, {
      default: b(() => [
        T(s, {
          id: "filter-" + u.id,
          conditions: r.visibleFilters[d].conditions,
          onUpdateConditions: (f) => r.handleUpdateFilter(d, f),
          columnType: u.columnType,
          tableId: u.refTableId,
          schemaId: u.refSchemaId ? u.refSchemaId : t.schemaId,
          refLabel: u.refLabel ? u.refLabel : u.refLabelDefault
        }, null, 8, ["id", "conditions", "onUpdateConditions", "columnType", "tableId", "schemaId", "refLabel"])
      ]),
      _: 2
    }, 1032, ["title", "conditions"]))), 128))
  ]);
}
const qK = /* @__PURE__ */ D(BK, [["render", NK], ["__scopeId", "data-v-8ea81881"]]), xK = {
  props: {
    /** two-way bindable array of column metadata. Will add 'conditions' property to hold filter values */
    filters: { type: Array, default: () => [] }
  },
  components: {
    FilterWell: Xa
  },
  computed: {
    countFilters() {
      let e = 0;
      return Array.isArray(this.filters) && this.filters.forEach((n) => {
        Array.isArray(n.conditions) && n.conditions.forEach((t) => {
          Array.isArray(t) ? (t[0] !== null || t[1] != null) && e++ : t != null && e++;
        });
      }), e;
    }
  },
  methods: {
    renderValue(e) {
      return typeof e == "object" && e !== null ? this.flattenObject(e) : e;
    },
    flattenObject(e) {
      let n = "";
      return Object.keys(e).forEach((t) => {
        e[t] === null || (typeof e[t] == "object" ? n += this.flattenObject(e[t]) : n += " " + e[t]);
      }), n;
    },
    remove(e, n) {
      let t = this.filters;
      t[e].conditions.splice(n, 1), this.$emit("updateFilters", t);
    },
    removeAll() {
      let e = this.filters;
      for (var n in e)
        Array.isArray(e[n].conditions) && e[n].conditions.splice(0);
      this.$emit("updateFilters", e);
    }
  }
}, VK = { key: 0 }, jK = { class: "d-flex align-items-center" }, HK = { key: 0 }, GK = { key: 1 };
function QK(e, n, t, o, i, r) {
  const s = K("FilterWell");
  return l(), c("span", null, [
    r.countFilters > 0 ? (l(), c("div", VK, [
      p("div", jK, [
        _(E(r.countFilters) + " filter " + E(r.countFilters > 1 ? "s" : "") + " ( ", 1),
        p("button", {
          type: "button",
          onClick: n[0] || (n[0] = (...a) => r.removeAll && r.removeAll(...a)),
          class: "btn btn-link pl-0 pr-0"
        }, " remove all filters "),
        n[1] || (n[1] = _(" ) : ", -1))
      ]),
      (l(!0), c(oe, null, ae(t.filters, (a, u) => (l(), c("span", {
        key: a.id
      }, [
        (l(!0), c(oe, null, ae(a.conditions, (d, f) => (l(), c("span", { key: f }, [
          Array.isArray(d) ? (l(), c("span", HK, [
            d[0] !== null && d[1] !== null ? (l(), F(s, {
              key: 0,
              onClick: (y) => r.remove(u, f),
              label: d[0] + " < " + a.label + " < " + d[1]
            }, null, 8, ["onClick", "label"])) : d[0] !== null ? (l(), F(s, {
              key: 1,
              onClick: (y) => r.remove(u, f),
              label: d[0] + " < " + a.id
            }, null, 8, ["onClick", "label"])) : d[1] !== null ? (l(), F(s, {
              key: 2,
              onClick: (y) => r.remove(u, f),
              label: a.label + " < " + d[1]
            }, null, 8, ["onClick", "label"])) : v("", !0)
          ])) : (l(), c("span", GK, [
            T(s, {
              onClick: (y) => r.remove(u, f),
              label: a.label + " = " + r.renderValue(d)
            }, null, 8, ["onClick", "label"])
          ]))
        ]))), 128))
      ]))), 128))
    ])) : v("", !0)
  ]);
}
const $K = /* @__PURE__ */ D(xK, [["render", QK]]), JK = {
  extends: Ce,
  components: {
    FormGroup: ke,
    BaseInputDecimal: Ga,
    InputGroup: Ve
  }
};
function zK(e, n, t, o, i, r) {
  const s = K("BaseInputDecimal"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, null, {
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id,
            modelValue: e.modelValue,
            class: G({ "is-invalid": e.errorMessage }),
            placeholder: e.placeholder,
            required: e.required,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "class", "placeholder", "required"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const ur = /* @__PURE__ */ D(JK, [["render", zK]]), YK = {
  name: "InputEmail",
  components: { FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  props: {
    stringLength: {
      type: Number,
      default: 255
    },
    additionalValidValidationStrings: {
      type: Array,
      default: []
    }
  },
  computed: {
    stringError() {
      return typeof this.modelValue == "string" ? this.modelValue.length > this.stringLength ? `Please limit to ${this.stringLength} characters.` : this.validateEmail(this.modelValue) ? this.errorMessage : "Please enter a valid email address" : this.errorMessage;
    }
  },
  methods: {
    validateEmail(e) {
      return this.additionalValidValidationStrings.includes(e) || (e == null ? void 0 : e.match(Tt.EMAIL_REGEX));
    }
  }
}, WK = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function XK(e, n, t, o, i, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: b(() => [
      T(s, null, {
        append: b(() => [
          j(e.$slots, "append", {}, void 0, !0)
        ]),
        default: b(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, WK)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const ll = /* @__PURE__ */ D(YK, [["render", XK], ["__scopeId", "data-v-d474af2a"]]), ZK = {
  name: "InputHyperlink",
  components: { FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  computed: {
    stringError() {
      return typeof this.modelValue == "string" ? this.validateHyperlink(this.modelValue) ? this.errorMessage : "Please enter a valid hyperlink" : this.errorMessage;
    }
  },
  methods: {
    validateHyperlink(e) {
      return e == null ? void 0 : e.match(Tt.HYPERLINK_REGEX);
    }
  }
}, ev = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function tv(e, n, t, o, i, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: b(() => [
      T(s, null, {
        append: b(() => [
          j(e.$slots, "append", {}, void 0, !0)
        ]),
        default: b(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (u) => {
              var d;
              return (
                //@ts-ignore
                e.$emit("update:modelValue", (d = u.target) == null ? void 0 : d.value)
              );
            }),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, ev)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const ul = /* @__PURE__ */ D(ZK, [["render", tv], ["__scopeId", "data-v-09994973"]]), nv = {
  extends: Ce,
  components: {
    FormGroup: ke,
    BaseInputInt: Ha,
    InputGroup: Ve
  }
};
function ov(e, n, t, o, i, r) {
  const s = K("BaseInputInt"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, null, {
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: e.readonly,
            required: e.required,
            class: G({ "is-invalid": e.errorMessage }),
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const dr = /* @__PURE__ */ D(nv, [["render", ov]]), iv = {
  extends: Ce,
  components: {
    FormGroup: ke,
    BaseInputLong: al,
    InputGroup: Ve
  }
};
function rv(e, n, t, o, i, r) {
  const s = K("BaseInputLong"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, null, {
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          T(s, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: e.readonly,
            required: e.required,
            class: G({ "is-invalid": e.errorMessage }),
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const cr = /* @__PURE__ */ D(iv, [["render", rv]]), sv = {
  extends: Ce,
  components: {
    FormGroup: ke,
    InputGroup: Ve
  },
  methods: {
    resizeTextarea(e) {
      e.target.style.height = "auto", e.target.style.height = e.target.scrollHeight + "px";
    }
  },
  mounted() {
    const e = this.$refs.textarea;
    po(() => {
      e.setAttribute(
        "style",
        "height:" + e.scrollHeight + "px;overflow-y:hidden;"
      );
    }), e.addEventListener("input", this.resizeTextarea);
  },
  beforeDestroy() {
    this.$refs.textarea.addEventListener("input", this.resizeTextarea);
  }
}, av = ["value", "aria-describedby", "placeholder", "readonly"];
function lv(e, n, t, o, i, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(s, null, {
        append: b(() => [
          j(e.$slots, "append")
        ]),
        default: b(() => [
          p("textarea", {
            ref: "textarea",
            value: e.modelValue,
            class: G(["form-control", { "is-invalid": e.errorMessage }]),
            "aria-describedby": e.id + "Help",
            placeholder: e.placeholder,
            readonly: e.readonly,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value))
          }, null, 42, av)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Vn = /* @__PURE__ */ D(sv, [["render", lv]]), uv = {
  name: "ArrayInput",
  extends: Ce,
  components: { FormGroup: ke },
  data() {
    var e;
    return { values: (e = this.modelValue) != null && e.length ? this.modelValue : [null] };
  },
  props: {
    columnType: {
      type: String,
      required: !0
    }
  },
  computed: {
    inputType() {
      return {
        BOOL_ARRAY: No,
        DATE_ARRAY: Bo,
        DATETIME_ARRAY: Lo,
        DECIMAL_ARRAY: ur,
        PERIOD_ARRAY: At,
        EMAIL_ARRAY: ll,
        HYPERLINK_ARRAY: ul,
        INT_ARRAY: dr,
        LONG_ARRAY: cr,
        STRING_ARRAY: At,
        TEXT_ARRAY: Vn,
        UUID_ARRAY: At
      }[this.columnType];
    }
  },
  methods: {
    addItem(e) {
      this.values.splice(e + 1, 0, null), this.$emit("update:modelValue", this.values);
    },
    clearInput(e) {
      this.values.length > 1 && this.values.splice(e, 1), this.$emit("update:modelValue", this.values);
    },
    handleUpdate(e, n) {
      this.values[n] = e, this.$emit("update:modelValue", this.values);
    }
  },
  emits: ["update:modelValue"]
}, dv = ["onClick"], cv = ["onClick"];
function fv(e, n, t, o, i, r) {
  const s = K("FormGroup");
  return l(), F(s, {
    id: e.id + "-0",
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      (l(!0), c(oe, null, ae(i.values, (a, u) => (l(), c("div", { key: u }, [
        (l(), F(Et(r.inputType), {
          id: e.id + "-" + u,
          modelValue: i.values[u],
          showAddButton: u === i.values.length,
          "onUpdate:modelValue": (d) => r.handleUpdate(d, u)
        }, {
          append: b(() => [
            i.values.length > 1 ? (l(), c("button", {
              key: 0,
              onClick: (d) => r.clearInput(u),
              class: "btn btn-outline-primary",
              type: "button"
            }, [...n[0] || (n[0] = [
              p("i", { class: "fas fa-fw fa-times" }, null, -1)
            ])], 8, dv)) : v("", !0),
            p("button", {
              onClick: (d) => r.addItem(u),
              class: "btn btn-outline-primary",
              type: "button"
            }, [...n[1] || (n[1] = [
              p("i", { class: "fas fa-fw fa-plus" }, null, -1)
            ])], 8, cv)
          ]),
          _: 2
        }, 1032, ["id", "modelValue", "showAddButton", "onUpdate:modelValue"]))
      ]))), 128))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const st = /* @__PURE__ */ D(uv, [["render", fv]]), pv = {
  directives: {
    clickOutside: qo.directive
  },
  props: {
    label: { type: String, required: !0 },
    icon: { type: String, default: "" },
    isMenuItem: { type: Boolean, required: !1 },
    placement: { type: String, default: "bottom-start" },
    closeOnClick: { type: Boolean, default: !1 }
  },
  data() {
    return {
      display: !1,
      popperInstance: null
    };
  },
  methods: {
    handleOnClick() {
      this.closeOnClick && (this.display = !this.display);
    },
    async toggle() {
      if (this.display = !this.display, this.display) {
        await this.$nextTick();
        const e = this.$refs.showInputButton, n = this.$refs.dropdown;
        this.popperInstance = xa(e, n, {
          placement: this.placement,
          modifiers: { offset: { offset: "0,2px" } }
        });
      } else
        this.popperInstance.destroy();
    }
  }
}, hv = { key: 0 };
function mv(e, n, t, o, i, r) {
  const s = ko("click-outside");
  return l(), c("span", null, [
    p("button", {
      type: "button",
      ref: "showInputButton",
      class: G(["btn btn-outline-primary", { "dropdown-toggle": !t.icon, "nav-link": t.isMenuItem }]),
      onClick: n[0] || (n[0] = (...a) => r.toggle && r.toggle(...a))
    }, [
      t.label ? (l(), c("span", hv, E(t.label), 1)) : v("", !0),
      t.icon ? (l(), c("span", {
        key: 1,
        class: G("fa fa-" + t.icon + " fa-lg ml-2")
      }, null, 2)) : v("", !0)
    ], 2),
    i.display ? We((l(), c("span", {
      key: 0,
      class: "mg-dropdown-drop bg-white border rounded",
      ref: "dropdown",
      onClick: n[1] || (n[1] = (...a) => r.handleOnClick && r.handleOnClick(...a))
    }, [
      j(e.$slots, "default", { close: r.toggle }, void 0, !0)
    ])), [
      [s, r.toggle]
    ]) : v("", !0)
  ]);
}
const fr = /* @__PURE__ */ D(pv, [["render", mv], ["__scopeId", "data-v-5663ccf8"]]), Av = {
  components: { IconAction: ct },
  name: "InlineInput",
  props: {
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    }
  },
  data() {
    return {
      isEditing: !1,
      isInputFieldVisible: !1
    };
  },
  methods: {
    onfocusout() {
      this.isInputFieldVisible && (this.isEditing = !1, this.isInputFieldVisible = !1);
    },
    async openAndFocusInput() {
      this.isEditing = !0, this.isEditing = !0, await this.$nextTick(), this.isInputFieldVisible = !0;
      const e = this.$refs.inlineInput.querySelector("input");
      e == null || e.focus();
    }
  }
}, gv = { key: 0 };
function yv(e, n, t, o, i, r) {
  const s = K("IconAction");
  return l(), c("span", {
    onFocusout: n[2] || (n[2] = (...a) => r.onfocusout && r.onfocusout(...a)),
    ref: "inlineInput"
  }, [
    i.isEditing ? (l(), c("span", gv, [
      j(e.$slots, "default", {}, void 0, !0)
    ])) : (l(), c("span", {
      key: 1,
      onClick: n[0] || (n[0] = (a) => r.openAndFocusInput()),
      class: "editable"
    }, [
      j(e.$slots, "display", {}, () => [
        _(E(t.modelValue), 1)
      ], !0)
    ])),
    i.isEditing ? v("", !0) : (l(), F(s, {
      key: 2,
      icon: "pencil-alt",
      onClick: n[1] || (n[1] = (a) => r.openAndFocusInput())
    }))
  ], 544);
}
const Kv = /* @__PURE__ */ D(Av, [["render", yv], ["__scopeId", "data-v-de78a1fe"]]), vv = {
  extends: Ce,
  components: { FormGroup: ke },
  data() {
    var e;
    return {
      filename: this.modelValue instanceof File ? (e = this.modelValue) == null ? void 0 : e.name : ""
    };
  },
  props: {
    modelValue: {
      default: null
    }
  },
  methods: {
    handleFileUpload(e) {
      var t;
      const n = e.target;
      n != null && n.files && (this.filename = (t = n.files[0]) == null ? void 0 : t.name, this.$emit("update:modelValue", n.files[0]));
    },
    clearInput() {
      this.filename = null, this.$emit("update:modelValue", null);
    }
  }
}, bv = { class: "input-group" }, Cv = ["id"], wv = ["placeholder"], Fv = { class: "input-group-append" }, Rv = { class: "input-group-append" }, kv = { key: 0 }, Uv = ["href"];
function Ev(e, n, t, o, i, r) {
  const s = K("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => {
      var a;
      return [
        p("div", bv, [
          p("input", {
            id: e.id,
            ref: "file",
            type: "file",
            style: { display: "none" },
            onChange: n[0] || (n[0] = (...u) => r.handleFileUpload && r.handleFileUpload(...u))
          }, null, 40, Cv),
          p("input", {
            class: G(["form-control active", { "is-invalid": e.errorMessage }]),
            placeholder: i.filename,
            onClick: n[1] || (n[1] = (u) => e.$refs.file.click()),
            onKeydown: n[2] || (n[2] = Ke(() => {
            }, ["prevent"]))
          }, null, 42, wv),
          p("div", Fv, [
            p("button", {
              class: "btn bg-transparent text-primary",
              type: "button",
              title: "Toggle",
              "data-toggle": "",
              onClick: n[3] || (n[3] = (...u) => r.clearInput && r.clearInput(...u)),
              style: { "margin-left": "-40px", "z-index": "100" }
            }, [...n[5] || (n[5] = [
              p("i", { class: "fa fa-times" }, [
                p("span", {
                  "aria-hidden": "true",
                  class: "sr-only"
                }, "Clear")
              ], -1)
            ])])
          ]),
          p("div", Rv, [
            p("button", {
              class: "btn btn-outline-primary",
              type: "button",
              title: "Toggle",
              "data-toggle": "",
              onClick: n[4] || (n[4] = (u) => e.$refs.file.click())
            }, " Browse ")
          ])
        ]),
        t.modelValue ? (l(), c("div", kv, [
          t.modelValue && t.modelValue.url ? (l(), c("a", {
            key: 0,
            href: t.modelValue.url
          }, " Previous value: " + E((a = t.modelValue) != null && a.filename ? t.modelValue.filename : t.modelValue.id + "." + t.modelValue.extension), 9, Uv)) : v("", !0)
        ])) : v("", !0)
      ];
    }),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const dl = /* @__PURE__ */ D(vv, [["render", Ev]]), Sv = {
  components: { IconAction: ct },
  props: {
    inplace: Boolean,
    label: String,
    columnType: String,
    description: String,
    editMeta: Boolean
  },
  data() {
    return { focusLabel: !1, focusDescription: !1 };
  },
  methods: {
    toggleFocusLabel() {
      this.focusLabel = !this.focusLabel;
    },
    toggleFocusDescription() {
      this.focusDescription = !this.focusDescription;
    },
    stripHtml(e) {
      return e && e.replace(
        /(<\/?(?:h1|h2|h3|h4|p|label|a)[^>]*>)|<[^>]+>/gi,
        "$1"
      );
    }
  },
  emits: ["update:description", "update:label"]
}, Tv = {
  key: 0,
  class: "d-flex form-group bg-white rounded pt-4 pb-1 mb-1"
}, Iv = { key: 0 }, Dv = ["value"], Ov = {
  key: 2,
  class: "d-flex form-group bg-white rounded pb-1 mb-1"
}, _v = ["value", "aria-describedby"];
function Mv(e, n, t, o, i, r) {
  const s = K("IconAction");
  return l(), c("div", null, [
    i.focusLabel ? (l(), c("input", {
      key: 1,
      value: t.label,
      class: "form-control",
      onInput: n[0] || (n[0] = (a) => e.$emit("update:label", a.target.value)),
      onBlur: n[1] || (n[1] = (...a) => r.toggleFocusLabel && r.toggleFocusLabel(...a))
    }, null, 40, Dv)) : (l(), c("span", Tv, [
      t.label !== "_top" ? (l(), c("h1", Iv, E(t.label), 1)) : v("", !0),
      t.inplace || t.editMeta ? (l(), F(s, {
        key: 1,
        class: "hoverIcon align-top",
        icon: "pencil-alt",
        onClick: r.toggleFocusLabel
      }, null, 8, ["onClick"])) : v("", !0)
    ])),
    i.focusDescription ? (l(), c("textarea", {
      key: 3,
      value: t.description,
      class: G({
        "form-control": !0
      }),
      "aria-describedby": e.id + "Help",
      onInput: n[2] || (n[2] = (a) => e.$emit("update:description", a.target.value)),
      onBlur: n[3] || (n[3] = (...a) => r.toggleFocusDescription && r.toggleFocusDescription(...a))
    }, null, 40, _v)) : (l(), c("div", Ov, [
      p("p", null, E(t.description), 1),
      t.inplace || t.editMeta ? (l(), F(s, {
        key: 0,
        class: "hoverIcon align-top",
        icon: "pencil-alt",
        onClick: r.toggleFocusDescription
      }, null, 8, ["onClick"])) : v("", !0)
    ]))
  ]);
}
const Ii = /* @__PURE__ */ D(Sv, [["render", Mv]]), Pv = {}, Bv = {
  class: "alert alert-warning",
  role: "alert"
};
function Lv(e, n) {
  return l(), c("div", Bv, [
    j(e.$slots, "default")
  ]);
}
const Nv = /* @__PURE__ */ D(Pv, [["render", Lv]]), qv = {
  name: "InputRefBack",
  extends: Ce,
  components: {
    FormGroup: ke,
    TableMolgenis: sr,
    RowButton: jt,
    Spinner: yt,
    MessageWarning: Nv,
    ConfirmModal: lr,
    MessageError: it
  },
  props: {
    /** name of the table from which is referred back to this field */
    tableId: {
      type: String,
      required: !0
    },
    /** id of the column in the other table */
    refBackId: {
      type: String,
      required: !0
    },
    /**
     * primary key of the current table that refback should point to
     * when empty ( in case of draft , add message is shown instead of the table)
     *  */
    pkey: {
      type: [Object, null],
      required: !0
    },
    expressionData: {
      type: Object,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    /**
     * if table (that has a column that is referred to by this table) can be edited
     *  */
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  data() {
    return {
      client: null,
      tableMetadata: null,
      data: null,
      isLoading: !1,
      isEditModalShown: !1,
      isDeleteModalShown: !1,
      editMode: "add",
      // add, edit, clone
      editRowPrimaryKey: null,
      graphqlError: null,
      defaultValue: null
    };
  },
  computed: {
    graphqlFilter() {
      return {
        [this.refBackId]: {
          equals: this.pkey
        }
      };
    },
    visibleColumnIds() {
      return this.visibleColumns.map((e) => e.id);
    },
    visibleColumns() {
      return this.tableMetadata && this.tableMetadata.columns ? this.tableMetadata.columns.filter(
        (e) => e.id != this.refBackId && !e.id.startsWith("mg_")
      ) : [];
    },
    hasPrimaryKey() {
      return this.pkey ? !!Object.values(this.pkey).length : !1;
    }
  },
  methods: {
    async reload() {
      this.isLoading = !0;
      const e = await this.client.fetchTableDataValues(this.tableId, {
        filter: this.graphqlFilter
      });
      this.data = ya(e, this.tableMetadata), this.isLoading = !1;
    },
    handleRowAction(e, n) {
      this.editMode = e, this.editRowPrimaryKey = n, this.isEditModalShown = !0;
    },
    handleModalClose() {
      this.isEditModalShown = !1, this.reload();
    },
    handleDeleteRowRequest(e) {
      this.editRowPrimaryKey = e, this.isDeleteModalShown = !0;
    },
    async handleExecuteDelete() {
      this.isDeleteModalShown = !1, await this.client.deleteRow(this.editRowPrimaryKey, this.tableId).catch(this.handleError).then(this.reload());
      let e = this.modelValue.filter(
        (n) => !Xt(n, this.editRowPrimaryKey)
      );
      this.$emit("update:modelValue", e);
    },
    handleError(e) {
      var n, t;
      Array.isArray((t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : t.errors) ? this.graphqlError = e.response.data.errors[0].message : this.graphqlError = e, this.loading = !1;
    }
  },
  mounted: async function() {
    this.client = nt.newClient(this.schemaId), this.isLoading = !0, this.tableMetadata = await this.client.fetchTableMetaData(this.tableId).catch((e) => this.graphqlError = e.message), this.defaultValue = new Object(), this.defaultValue[this.refBackId] = this.expressionData, await this.reload();
  }
};
function xv(e, n, t, o, i, r) {
  const s = K("Spinner"), a = K("RowButton"), u = K("TableMolgenis"), d = K("MessageWarning"), f = K("MessageError"), y = K("EditModal"), C = K("ConfirmModal"), U = K("FormGroup");
  return l(), F(U, Pi(Ss(e.$props)), {
    default: b(() => [
      i.isLoading ? (l(), F(s, { key: 0 })) : r.hasPrimaryKey ? (l(), F(u, {
        key: 1,
        schemaId: t.schemaId,
        data: i.data,
        columns: r.visibleColumns,
        "table-metadata": i.tableMetadata,
        style: { "overflow-x": "scroll" }
      }, {
        rowcolheader: b(() => [
          j(e.$slots, "rowcolheader", On(e.$props, {
            canEdit: t.canEdit,
            reload: r.reload,
            schemaId: t.schemaId
          })),
          t.canEdit ? (l(), F(a, {
            key: 0,
            type: "add",
            onAdd: n[0] || (n[0] = (g) => r.handleRowAction("add")),
            class: "d-inline p-0"
          })) : v("", !0)
        ]),
        rowheader: b((g) => [
          j(e.$slots, "rowheader", {
            row: g.row,
            metadata: i.tableMetadata,
            rowKey: g.rowKey
          }),
          t.canEdit ? (l(), F(a, {
            key: 0,
            type: "edit",
            table: t.tableId,
            schemaId: t.schemaId,
            "visible-columns": r.visibleColumnIds,
            pkey: g.rowKey,
            onClose: r.reload,
            onEdit: (A) => r.handleRowAction("edit", g.rowKey)
          }, null, 8, ["table", "schemaId", "visible-columns", "pkey", "onClose", "onEdit"])) : v("", !0),
          t.canEdit ? (l(), F(a, {
            key: 1,
            type: "clone",
            table: t.tableId,
            schemaId: t.schemaId,
            pkey: g.rowKey,
            "visible-columns": r.visibleColumnIds,
            onClose: r.reload,
            onClone: (A) => r.handleRowAction("clone", g.rowKey)
          }, null, 8, ["table", "schemaId", "pkey", "visible-columns", "onClose", "onClone"])) : v("", !0),
          t.canEdit ? (l(), F(a, {
            key: 2,
            type: "delete",
            onDelete: (A) => r.handleDeleteRowRequest(g.rowKey)
          }, null, 8, ["onDelete"])) : v("", !0)
        ]),
        _: 3
      }, 8, ["schemaId", "data", "columns", "table-metadata"])) : (l(), F(d, { key: 2 }, {
        default: b(() => [...n[2] || (n[2] = [
          _(" This can only be filled in after you have saved (or saved draft). ", -1)
        ])]),
        _: 1
      })),
      i.graphqlError ? (l(), F(f, { key: 3 }, {
        default: b(() => [
          _(E(i.graphqlError), 1)
        ]),
        _: 1
      })) : v("", !0),
      i.isEditModalShown ? (l(), F(y, {
        key: 4,
        isModalShown: !0,
        id: t.tableId + "-edit-modal",
        tableId: t.tableId,
        pkey: i.editRowPrimaryKey,
        visibleColumns: r.visibleColumnIds,
        clone: i.editMode === "clone",
        schemaId: t.schemaId,
        defaultValue: i.defaultValue,
        applyDefaultValues: !0,
        onClose: r.handleModalClose
      }, null, 8, ["id", "tableId", "pkey", "visibleColumns", "clone", "schemaId", "defaultValue", "onClose"])) : v("", !0),
      i.isDeleteModalShown ? (l(), F(C, {
        key: 5,
        title: "Delete from " + t.tableId,
        actionLabel: "Delete",
        actionType: "danger",
        tableId: t.tableId,
        tableLabel: i.tableMetadata.label,
        pkey: i.editRowPrimaryKey,
        onClose: n[1] || (n[1] = (g) => i.isDeleteModalShown = !1),
        onConfirmed: r.handleExecuteDelete
      }, null, 8, ["title", "tableId", "tableLabel", "pkey", "onConfirmed"])) : v("", !0)
    ]),
    _: 3
  }, 16);
}
const cl = /* @__PURE__ */ D(qv, [["render", xv]]), Vv = {
  name: "InputRefSelect",
  extends: Ce,
  data: function() {
    return {
      showSelect: !1
    };
  },
  components: {
    TableSearch: il,
    LayoutModal: Kt,
    FormGroup: ke,
    ButtonAction: He,
    ButtonAlt: ot,
    InputGroup: Ve
  },
  props: {
    tableId: String,
    schemaId: {
      type: String,
      required: !1
    },
    filter: Object,
    refLabel: {
      type: String,
      required: !0
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  computed: {
    title() {
      return "Select " + this.tableId;
    }
  },
  methods: {
    applyJsTemplate: yo,
    async select(e) {
      this.showSelect = !1, this.$emit("update:modelValue", await e);
    }
  }
}, jv = ["value", "readonly"];
function Hv(e, n, t, o, i, r) {
  const s = K("ButtonAction"), a = K("TableSearch"), u = K("ButtonAlt"), d = K("LayoutModal"), f = K("InputGroup"), y = K("FormGroup");
  return l(), F(y, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(f, null, {
        append: b(() => [
          e.modelValue && !this.readonly ? (l(), c("button", {
            key: 0,
            onClick: n[2] || (n[2] = (C) => e.$emit("update:modelValue", null)),
            class: "btn btn-outline-primary",
            type: "button"
          }, [...n[7] || (n[7] = [
            p("i", { class: "fas fa-fw fa-times" }, null, -1)
          ])])) : v("", !0)
        ]),
        default: b(() => [
          p("input", {
            class: G(["form-control", { "is-invalid": e.errorMessage }]),
            onClick: n[0] || (n[0] = (C) => e.showSelect = !this.readonly),
            onFocus: n[1] || (n[1] = (C) => e.showSelect = !this.readonly),
            value: r.applyJsTemplate(e.modelValue, t.refLabel),
            readonly: e.readonly
          }, null, 42, jv),
          e.showSelect ? (l(), F(d, {
            key: 0,
            title: r.title,
            onClose: n[6] || (n[6] = (C) => e.showSelect = !1)
          }, {
            body: b(() => [
              T(a, {
                tableId: t.tableId,
                filter: t.filter,
                schemaId: t.schemaId,
                canEdit: t.canEdit,
                onSelect: n[3] || (n[3] = (C) => r.select(C)),
                onDeselect: n[4] || (n[4] = (C) => e.deselect(e.selectIdx))
              }, {
                rowheader: b((C) => [
                  T(s, {
                    onClick: (U) => r.select(C.row)
                  }, {
                    default: b(() => [...n[8] || (n[8] = [
                      _(" Select ", -1)
                    ])]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["tableId", "filter", "schemaId", "canEdit"])
            ]),
            footer: b(() => [
              T(u, {
                onClick: n[5] || (n[5] = (C) => e.showSelect = !1)
              }, {
                default: b(() => [...n[9] || (n[9] = [
                  _("Close", -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])) : v("", !0)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const fo = /* @__PURE__ */ D(Vv, [["render", Hv]]), Gv = {
  name: "InputJson",
  components: { FormGroup: ke, InputGroup: Ve },
  extends: Ce,
  props: {
    modelValue: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    stringError() {
      if (typeof this.modelValue == "string") {
        try {
          if (!Aa(JSON.parse(this.modelValue)))
            return "Root element must be an object or array";
        } catch {
          return "Please enter valid JSON";
        }
        return this.errorMessage;
      } else
        return this.errorMessage;
    }
  }
}, Qv = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function $v(e, n, t, o, i, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: b(() => [
      T(s, null, {
        default: b(() => [
          p("textarea", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: t.modelValue,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, Qv)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Jv = /* @__PURE__ */ D(Gv, [["render", $v], ["__scopeId", "data-v-8abd8c88"]]), zv = {
  AUTO_ID: At,
  HEADING: Ii,
  SECTION: Ii,
  EMAIL: ll,
  HYPERLINK: ul,
  STRING: At,
  TEXT: Vn,
  JSON: Jv,
  INT: dr,
  LONG: cr,
  DECIMAL: ur,
  BOOL: No,
  DATE: Bo,
  REF: fo,
  //bootstrap will be deprecated so here we don't differentiate
  SELECT: fo,
  RADIO: fo,
  REFBACK: cl,
  FILE: dl,
  DATETIME: Lo,
  PERIOD: At,
  ONTOLOGY: Co,
  EMAIL_ARRAY: st,
  BOOL_ARRAY: st,
  DATE_ARRAY: st,
  DATETIME_ARRAY: st,
  PERIOD_ARRAY: st,
  DECIMAL_ARRAY: st,
  HYPERLINK_ARRAY: st,
  INT_ARRAY: st,
  LONG_ARRAY: st,
  ONTOLOGY_ARRAY: Co,
  REF_ARRAY: uo,
  //bootstrap will be deprecated so here we don't differentiate
  CHECKBOX: uo,
  MULTISELECT: uo,
  STRING_ARRAY: st,
  TEXT_ARRAY: st
}, Yv = {
  name: "FormInput",
  extends: Ce,
  props: {
    columnType: {
      type: String,
      required: !0
    },
    inplace: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    description: {
      type: String,
      default: null
    },
    editMeta: {
      type: Boolean,
      required: !1
    },
    filter: {
      type: Object,
      required: !1
    },
    pkey: {
      type: Object,
      required: !1,
      default: () => null
    },
    expressionData: {
      type: Object,
      required: !1
    },
    refBackId: {
      type: String,
      required: !1
    },
    refBackType: {
      type: String,
      required: !1
    },
    refLabel: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    tableId: {
      type: String,
      required: !1
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !0
    }
  },
  components: {
    InlineInput: Kv,
    ArrayInput: st,
    InputString: At,
    InputInt: dr,
    InputLong: cr,
    InputDecimal: ur,
    InputBoolean: No,
    InputDate: Bo,
    InputDateTime: Lo,
    InputFile: dl,
    InputText: Vn,
    InputHeading: Ii,
    InputOntology: Co,
    InputRefBack: cl,
    InputRefSelect: fo
  },
  computed: {
    typeToInput() {
      return zv[this.columnType];
    }
  },
  methods: {
    handleUpdate(e) {
      this.$emit("update:modelValue", e);
    }
  }
}, Wv = { key: 1 };
function Xv(e, n, t, o, i, r) {
  return l(), F(Et(t.inplace ? "InlineInput" : "span"), {
    value: e.modelValue,
    id: e.id
  }, {
    default: b(() => [
      r.typeToInput ? (l(), F(Et(r.typeToInput), On({
        key: 0,
        isMultiSelect: t.columnType === "ONTOLOGY_ARRAY"
      }, e.$props, { "onUpdate:modelValue": r.handleUpdate }), null, 16, ["isMultiSelect", "onUpdate:modelValue"])) : (l(), c("div", Wv, "UNSUPPORTED TYPE '" + E(t.columnType) + "'", 1))
    ]),
    _: 1
  }, 8, ["value", "id"]);
}
const Zv = /* @__PURE__ */ D(Yv, [["render", Xv]]), { AUTO_ID: eb } = Tt, tb = {
  name: "RowEdit",
  data() {
    return {
      internalValues: xe(
        this.defaultValue ? this.defaultValue : this.modelValue
      ),
      refFilter: {}
    };
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    // id: used as html id for components
    id: {
      type: String,
      required: !0
    },
    // tableId: name of the molgenis table loaded
    tableId: {
      type: String,
      required: !0
    },
    // defines the form structure
    tableMetaData: {
      type: Object,
      required: !0
    },
    // pkey:  when updating existing record, this is the primary key value
    pkey: { type: Object },
    // clone: when you want to clone instead of update
    clone: {
      type: Boolean,
      required: !1
    },
    // visibleColumns:  visible columns, useful if you only want to allow partial edit (column of object)
    // examples ['name','description']
    visibleColumns: {
      type: Array,
      required: !1
    },
    // defaultValue: when creating new record, this is initialization value
    defaultValue: {
      type: Object,
      required: !1
    },
    // object with the whole schema, needed to create refLink filter
    schemaMetaData: {
      type: Object,
      required: !0
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    errorPerColumn: {
      type: Object,
      default: () => ({})
    },
    applyDefaultValues: {
      type: Boolean,
      default: () => !1
    }
  },
  emits: ["update:modelValue"],
  components: {
    FormInput: Zv
  },
  computed: {
    shownColumnsWithoutMeta() {
      var n;
      return ((n = this == null ? void 0 : this.tableMetaData) != null && n.columns ? this.tableMetaData.columns.filter(
        (t) => {
          var o;
          return !((o = t.id) != null && o.startsWith("mg_")) && t.id !== "_mg_top_of_form";
        }
      ) : []).filter(this.showColumn);
    }
  },
  methods: {
    showColumn(e) {
      return e.refLinkId ? this.internalValues[e.refLinkId] : (this.visibleColumns ? this.visibleColumns.includes(e.id) : !0) && this.isVisible(e) && e.id !== "mg_tableclass";
    },
    isVisible(e) {
      try {
        return Vi(
          e,
          this.internalValues,
          this.tableMetaData
        );
      } catch (n) {
        return console.log("isVisible expression error: ", n), this.errorPerColumn[e.id] = n, !0;
      }
    },
    applyComputed() {
      this.tableMetaData.columns.forEach((e) => {
        if (e.computed && e.columnType !== eb)
          try {
            this.internalValues[e.id] = nn(
              e.computed,
              this.internalValues,
              this.tableMetaData
            );
          } catch (n) {
            console.log("Computed expression failed: ", n), this.errorPerColumn[e.id] = "Computed expression failed: " + n;
          }
      });
    },
    //update reflink filters and reset values if reflink changes
    async updateRefLinks(e) {
      const n = this.tableMetaData.columns.filter(
        (t) => this.internalValues[e.id] && t.refLinkId === e.id
      );
      for (const t of n) {
        const i = this.schemaMetaData.tables.find(
          (r) => r.id === t.refTableId
        ).columns.filter(
          (r) => r.key === 1 && r.refTableId === e.refTableId
        );
        for (const r of i)
          this.internalValues[t.id] = null, this.refFilter[t.id] = {
            [r.id]: {
              equals: await Do(
                this.internalValues[e.id],
                r.refTableId,
                r.refSchemaId || this.schemaMetaData.schemaId
              )
            }
          };
      }
    },
    handleModelValueUpdate(e, n) {
      this.internalValues[n.id] = e, this.updateRefLinks(n), this.onValuesUpdate();
    },
    onValuesUpdate() {
      this.applyComputed(), this.$emit("update:modelValue", this.internalValues);
    }
  },
  watch: {
    tableMetaData: {
      handler() {
        this.onValuesUpdate();
      },
      deep: !0
    }
  },
  created() {
    this.tableMetaData.columns.forEach((e) => {
      if (this.applyDefaultValues && e.defaultValue && !this.internalValues[e.id])
        if (e.defaultValue.startsWith("="))
          try {
            this.internalValues[e.id] = nn(
              "(" + e.defaultValue.substr(1) + ")",
              this.internalValues,
              this.tableMetaData
            );
          } catch (n) {
            this.errorPerColumn[e.id] = "Default value expression failed: " + n;
          }
        else e.columnType === "BOOL" ? this.internalValues[e.id] = nb(
          e.defaultValue
        ) : this.internalValues[e.id] = e.defaultValue;
    }), this.onValuesUpdate();
  }
};
function nb(e) {
  return e === "TRUE" || e === "true" || e === !0 ? !0 : e === "FALSE" || e === "false" || e === !1 ? !1 : void 0;
}
function ob(e, n, t, o, i, r) {
  const s = K("FormInput");
  return l(), c("div", null, [
    (l(!0), c(oe, null, ae(r.shownColumnsWithoutMeta, (a) => (l(), F(s, {
      key: JSON.stringify(a),
      id: `${t.id}-${a.id}`,
      modelValue: i.internalValues[a.id],
      expressionData: i.internalValues,
      columnType: a.columnType,
      description: a.description,
      errorMessage: t.errorPerColumn[a.id],
      label: a.formLabel ?? a.label,
      schemaId: a.refSchemaId || t.schemaMetaData.id,
      pkey: t.pkey,
      readonly: a.readonly || t.pkey && a.key === 1 && !t.clone || a.computed !== void 0 && a.computed.trim() !== "",
      refBackId: a.refBackId,
      refLabel: a.refLabel || a.refLabelDefault,
      required: a.required,
      tableId: a.refTableId,
      canEdit: t.canEdit,
      filter: i.refFilter[a.id],
      "onUpdate:modelValue": (u) => r.handleModelValueUpdate(u, a)
    }, null, 8, ["id", "modelValue", "expressionData", "columnType", "description", "errorMessage", "label", "schemaId", "pkey", "readonly", "refBackId", "refLabel", "required", "tableId", "canEdit", "filter", "onUpdate:modelValue"]))), 128))
  ]);
}
const ib = /* @__PURE__ */ D(tb, [["render", ob]]), rb = { class: "w-100" }, sb = {
  class: "d-flex",
  style: { gap: "0.5rem" }
}, ab = /* @__PURE__ */ Re({
  __name: "RowEditFooter",
  props: {
    tableLabel: { default: "" },
    successMessage: {},
    errorMessage: {},
    saveDraftDisabledMessage: {},
    saveDisabledMessage: {}
  },
  setup(e) {
    const n = e, {
      tableLabel: t,
      successMessage: o,
      errorMessage: i,
      saveDraftDisabledMessage: r,
      saveDisabledMessage: s
    } = _n(n);
    return (a, u) => (l(), c("div", rb, [
      p("div", null, [
        ie(o) ? (l(), F(pn, { key: 0 }, {
          default: b(() => [
            _(E(ie(o)), 1)
          ]),
          _: 1
        })) : v("", !0)
      ]),
      p("div", null, [
        ie(i) ? (l(), F(it, { key: 0 }, {
          default: b(() => [
            _(E(ie(i)), 1)
          ]),
          _: 1
        })) : v("", !0)
      ]),
      p("div", sb, [
        j(a.$slots, "default"),
        T(ot, {
          onClick: u[0] || (u[0] = (d) => a.$emit("cancel"))
        }, {
          default: b(() => [...u[3] || (u[3] = [
            _(" Close", -1)
          ])]),
          _: 1
        }),
        T(un, {
          name: "disabled-draft-tooltip",
          value: ie(r) ? ie(r) : "",
          placement: "bottom"
        }, {
          default: b(() => [
            T(Po, {
              onClick: u[1] || (u[1] = (d) => a.$emit("saveDraft")),
              disabled: !!ie(r),
              class: "mr-2 pr-3"
            }, {
              default: b(() => [...u[4] || (u[4] = [
                _(" Save draft ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["value"]),
        T(un, {
          name: "disabled-save-tooltip",
          value: ie(s) ? ie(s) : "",
          placement: "bottom"
        }, {
          default: b(() => [
            T(He, {
              onClick: u[2] || (u[2] = (d) => a.$emit("save")),
              disabled: !!ie(s)
            }, {
              default: b(() => [
                _(" Save " + E(ie(t)), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]));
  }
}), lb = {
  key: 0,
  class: "container"
}, ub = { class: "row" }, db = {
  key: 0,
  class: "col-2 border-left chapter-menu overflow-auto",
  style: { "max-height": "calc(100vh - 200px)" }
}, cb = ["onClick"], fb = { class: "mr-auto" }, pb = { key: 0 }, hb = /* @__PURE__ */ Re({
  __name: "EditModal",
  props: {
    id: {},
    tableId: {},
    isModalShown: { type: Boolean },
    schemaId: {},
    pkey: {},
    clone: { type: Boolean, default: !1 },
    visibleColumns: {},
    useChapters: { type: [Boolean, null], default: null },
    defaultValue: { default: null },
    applyDefaultValues: { type: Boolean }
  },
  emits: ["update:newRow", "close"],
  setup(e, { emit: n }) {
    const t = e, {
      applyDefaultValues: o,
      clone: i,
      defaultValue: r,
      id: s,
      pkey: a,
      schemaId: u,
      tableId: d,
      useChapters: f,
      visibleColumns: y
    } = t, { isModalShown: C } = _n(t), { IS_CHAPTERS_ENABLED_FIELD_NAME: U } = Tt, g = Ae({}), A = Ae({}), w = Ae(), M = Ae(), L = Ae(), B = Ae(""), N = Ae(!1), x = Ae(1), q = Ae(), Y = Ae(""), $ = n, Q = Te(() => {
      var fe;
      return (fe = w.value) == null ? void 0 : fe.label;
    }), ee = Te(() => a && i ? "copy" : a ? "update" : "insert"), te = Te(
      () => `${ee.value} into table: ${Q.value} (${d})`
    ), le = Te(() => {
      var Rt;
      const me = qd(
        ((Rt = w.value) == null ? void 0 : Rt.columns) || [],
        y
      ).filter(
        (pt) => {
          if (w.value)
            try {
              return Vi(pt, g.value, w.value);
            } catch (hn) {
              return A.value[pt.id] = hn, !0;
            }
        }
      ).filter(
        (pt) => !pt.id.startsWith("mg_")
      );
      return xd(me).filter(
        (pt) => pt.length > 1
      );
    }), V = Te(() => le.value.map((fe) => {
      const ne = fe.filter(
        (me) => !!A.value[me]
      );
      return {
        style: Vd(fe, A.value),
        errorFields: ne
      };
    })), Se = Te(() => {
      var ne;
      return ((ne = w.value) == null ? void 0 : ne.columns.some(
        (me) => me.key === 1 && me.columnType !== "AUTO_ID" && !P(g.value[me.id])
      )) ? "Cannot save draft: primary key is required" : "";
    }), k = Te(() => q.value && le.value.length > 1);
    Ts(async () => {
      var ne;
      N.value = !1, L.value = nt.newClient(u), M.value = await L.value.fetchSchemaMetaData();
      const fe = await L.value.fetchSettings();
      if (f === null ? q.value = ((ne = fe.find(
        (me) => me.key === U
      )) == null ? void 0 : ne.value) !== "false" : q.value = !!f, w.value = await L.value.fetchTableMetaData(d), a) {
        const me = await Le();
        i ? g.value = Nd(w.value, me) : g.value = me;
      }
      g.value = { ...g.value, ...xe(r) }, Ue(), N.value = !0;
    });
    function P(fe) {
      return fe != null && fe !== "";
    }
    function W(fe) {
      x.value = fe;
    }
    function he() {
      se({ ...g.value, mg_draft: !1 });
    }
    function ge() {
      se({ ...g.value, mg_draft: !0 });
    }
    async function se(fe) {
      var De, Ge;
      B.value = "";
      let ne;
      const me = Ie(
        fe,
        w.value
      );
      a && !i ? ne = await ((De = L.value) == null ? void 0 : De.updateDataRow(me, d, u).catch(Pe)) : ne = await ((Ge = L.value) == null ? void 0 : Ge.insertDataRow(me, d, u).catch(Pe)), ne && ($("update:newRow", fe), ve());
    }
    function Ie(fe, ne) {
      if (ne) {
        let me = { ...fe };
        return ne.columns.forEach((De) => {
          De.columnType === "REFBACK" && delete me[De.id];
        }), me;
      } else
        return fe;
    }
    function Pe(fe) {
      var ne, me, De, Ge;
      ((ne = fe.response) == null ? void 0 : ne.status) === 403 ? B.value = "Schema doesn't exist or permission denied. Do you need to Sign In?" : B.value = ((Ge = (De = (me = fe.response) == null ? void 0 : me.data) == null ? void 0 : De.errors[0]) == null ? void 0 : Ge.message) || "An Error occurred during save";
    }
    async function Le() {
      var fe;
      if (a) {
        const ne = await ((fe = L.value) == null ? void 0 : fe.fetchRowData(d, a));
        if (!ne)
          B.value = `Error, unable to fetch data for this row (${a})`;
        else
          return ne;
      } else
        B.value = "No row key provided";
    }
    function ve() {
      B.value = "", $("close");
    }
    function Ue() {
      w.value && (A.value = Td(w.value, g.value)), Y.value = jd(A.value);
    }
    function ft(fe) {
      var me;
      const ne = (me = w.value) == null ? void 0 : me.columns.find(
        (De) => De.id === fe
      );
      return (ne == null ? void 0 : ne.label) || (ne == null ? void 0 : ne.id) || fe;
    }
    return (fe, ne) => (l(), F(Kt, {
      title: te.value,
      show: ie(C),
      onClose: ve
    }, {
      body: b(() => [
        N.value && w.value ? (l(), c("div", lb, [
          p("div", ub, [
            p("div", {
              class: G(["overflow-auto mr-n3", { "col-10": k.value, "col-12": !k.value }]),
              style: { "max-height": "calc(100vh - 200px)" }
            }, [
              M.value ? (l(), F(ib, {
                key: 0,
                id: ie(s),
                modelValue: g.value,
                "onUpdate:modelValue": [
                  ne[0] || (ne[0] = (me) => g.value = me),
                  Ue
                ],
                pkey: ie(a),
                tableId: ie(d),
                tableMetaData: w.value,
                schemaMetaData: M.value,
                visibleColumns: q.value ? le.value[x.value - 1] : ie(y),
                clone: ie(i),
                errorPerColumn: A.value,
                applyDefaultValues: ie(o)
              }, null, 8, ["id", "modelValue", "pkey", "tableId", "tableMetaData", "schemaMetaData", "visibleColumns", "clone", "errorPerColumn", "applyDefaultValues"])) : v("", !0)
            ], 2),
            k.value ? (l(), c("div", db, [
              ne[3] || (ne[3] = p("div", { class: "mb-1" }, [
                p("b", null, "Chapters")
              ], -1)),
              (l(!0), c(oe, null, ae(le.value, (me, De) => (l(), c("div", null, [
                T(un, {
                  name: `chapter-${me[0]}-error-tooltip`,
                  value: V.value[De].errorFields.length ? `errors in:
${V.value[De].errorFields}` : "",
                  placement: "left"
                }, {
                  default: b(() => [
                    p("button", {
                      type: "button",
                      class: G(["btn btn-link", { "font-weight-bold": De + 1 === x.value }]),
                      onClick: (Ge) => W(De + 1),
                      style: Ro(V.value[De].style)
                    }, E(ft(me[0])), 15, cb)
                  ]),
                  _: 2
                }, 1032, ["name", "value"])
              ]))), 256))
            ])) : v("", !0)
          ])
        ])) : v("", !0)
      ]),
      footer: b(() => [
        T(ab, {
          id: ie(s) + "-footer",
          tableLabel: Q.value,
          errorMessage: B.value,
          saveDisabledMessage: Y.value,
          saveDraftDisabledMessage: Se.value,
          onCancel: ve,
          onSaveDraft: ge,
          onSave: he
        }, {
          default: b(() => [
            p("div", fb, [
              k.value ? (l(), c("div", pb, [
                T(He, {
                  onClick: ne[1] || (ne[1] = (me) => W(x.value - 1)),
                  disabled: x.value <= 1,
                  class: "mr-2 pr-3"
                }, {
                  default: b(() => [...ne[4] || (ne[4] = [
                    p("i", {
                      class: G("fas fa-fw fa-chevron-left")
                    }, null, -1),
                    _(" Previous ", -1)
                  ])]),
                  _: 1
                }, 8, ["disabled"]),
                T(He, {
                  onClick: ne[2] || (ne[2] = (me) => W(x.value + 1)),
                  disabled: x.value >= le.value.length,
                  class: "pl-3"
                }, {
                  default: b(() => [...ne[5] || (ne[5] = [
                    _(" Next ", -1),
                    p("i", {
                      class: G("fas fa-fw fa-chevron-right")
                    }, null, -1)
                  ])]),
                  _: 1
                }, 8, ["disabled"])
              ])) : v("", !0)
            ])
          ]),
          _: 1
        }, 8, ["id", "tableLabel", "errorMessage", "saveDisabledMessage", "saveDraftDisabledMessage"])
      ]),
      _: 1
    }, 8, ["title", "show"]));
  }
}), pr = /* @__PURE__ */ D(hb, [["__scopeId", "data-v-51141af3"]]), fl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pr
}, Symbol.toStringTag, { value: "Module" })), mb = {
  directives: {
    clickOutside: qo.directive
  },
  props: {
    buttonText: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    closeSelf(e) {
      this.$refs.HtmlDropdownMain.removeAttribute("open");
    }
  },
  computed: {
    buttonstateClass() {
      return this.active ? "bg-secondary text-white" : "border border-secondary";
    },
    containerstateClass() {
      return this.active ? "text-dark" : "";
    }
  }
};
function Ab(e, n, t, o, i, r) {
  const s = ko("click-outside");
  return l(), c("details", {
    class: G(["dropdown-button p-0", r.buttonstateClass]),
    ref: "HtmlDropdownMain"
  }, [
    p("summary", null, [
      _(E(t.buttonText) + " ", 1),
      j(e.$slots, "counter", {}, void 0, !0),
      n[2] || (n[2] = p("span", { class: "fa-solid fa-caret-down" }, null, -1))
    ]),
    We((l(), c("div", null, [
      p("div", {
        class: G(["dropdown bg-white", r.containerstateClass]),
        onClick: n[0] || (n[0] = Ke(() => {
        }, ["stop"]))
      }, [
        j(e.$slots, "default", {}, void 0, !0)
      ], 2),
      p("div", {
        class: "close",
        onClick: n[1] || (n[1] = (...a) => r.closeSelf && r.closeSelf(...a))
      })
    ])), [
      [s, r.closeSelf]
    ])
  ], 2);
}
const O1 = /* @__PURE__ */ D(mb, [["render", Ab], ["__scopeId", "data-v-49b9263b"]]), gb = {}, yb = { style: { display: "flex", "align-self": "flex-end" } };
function Kb(e, n, t, o, i, r) {
  return l(), c("div", yb, [
    p("label", null, [
      j(e.$slots, "default")
    ])
  ]);
}
const _1 = /* @__PURE__ */ D(gb, [["render", Kb]]), vb = {
  name: "Info",
  data() {
    return {
      show: !1
    };
  }
}, bb = { class: "tooltip-inner" };
function Cb(e, n, t, o, i, r) {
  return l(), c("div", null, [
    p("span", {
      onMouseenter: n[0] || (n[0] = (s) => i.show = !0),
      onMouseleave: n[1] || (n[1] = (s) => i.show = !1)
    }, [...n[2] || (n[2] = [
      p("i", { class: "fa fa-question-circle text-primary" }, null, -1)
    ])], 32),
    p("div", {
      class: G(["tooltip bs-tooltip-top", { show: i.show }])
    }, [
      p("span", bb, [
        p("span", null, [
          j(e.$slots, "default")
        ])
      ]),
      n[3] || (n[3] = p("span", { class: "arrow" }, null, -1))
    ], 2)
  ]);
}
const M1 = /* @__PURE__ */ D(vb, [["render", Cb]]), wb = {
  name: "InfoPopover",
  props: {
    boldText: {
      type: Boolean,
      default: !1
    },
    faIcon: {
      type: String,
      default: "fa-question-circle"
    },
    textColor: {
      type: String,
      default: "text-info"
    },
    iconBeforeLabel: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    popoverPlacement: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      isActive: !1
    };
  },
  computed: {
    placementClass() {
      return `tooltip-${this.popoverPlacement}`;
    }
  },
  methods: {
    activateTooltip() {
      this.updateTooltipPlacement(), this.isActive = !0;
    },
    deactivateTooltip() {
      this.isActive = !1;
    },
    updateTooltipPlacement() {
      if (!this.$refs.tooltipTrigger || !this.$refs.tooltipContent)
        return;
      const e = this.$refs.tooltipTrigger.getBoundingClientRect(), n = this.$refs.tooltipContent.getBoundingClientRect(), t = this.calculatePlacementStyle(
        e,
        n
      );
      Object.assign(this.$refs.tooltipContent.style, t);
    },
    calculatePlacementStyle(e, n) {
      const t = {};
      switch (this.popoverPlacement) {
        case "right":
          t.left = `${e.right + window.scrollX + 8}px`, t.top = `${e.top + window.scrollY - (n.height - e.height) / 2}px`;
          break;
        case "left":
          t.right = `${window.innerWidth - e.left + window.scrollX - 8}px`, t.top = `${e.top + window.scrollY - (n.height - e.height) / 2}px`;
          break;
        case "bottom":
          t.top = `${e.bottom + window.scrollY + 8}px`, t.left = `${e.left + window.scrollX - (n.width - e.width) / 2}px`;
          break;
        default:
          t.top = `${e.top - n.height - 8 + window.scrollY}px`, t.left = `${e.left + window.scrollX - (n.width - e.width) / 2}px`;
          break;
      }
      return t;
    }
  }
}, Fb = { key: 0 }, Rb = { key: 1 };
function kb(e, n, t, o, i, r) {
  return l(), c("span", {
    class: G({ "font-weight-bold": t.boldText })
  }, [
    p("div", {
      class: "w3tooltip",
      tabindex: "0",
      onClick: n[0] || (n[0] = Ke(() => {
      }, ["prevent"])),
      onMouseenter: n[1] || (n[1] = (...s) => r.activateTooltip && r.activateTooltip(...s)),
      onMouseleave: n[2] || (n[2] = (...s) => r.deactivateTooltip && r.deactivateTooltip(...s)),
      onFocus: n[3] || (n[3] = (...s) => r.activateTooltip && r.activateTooltip(...s)),
      onBlur: n[4] || (n[4] = (...s) => r.deactivateTooltip && r.deactivateTooltip(...s)),
      ref: "tooltipTrigger"
    }, [
      t.label && !t.iconBeforeLabel ? (l(), c("span", Fb, E(t.label), 1)) : v("", !0),
      p("span", {
        class: G(["fa d-inline-block", [
          t.label ? t.iconBeforeLabel ? "mr-1" : "ml-1" : "",
          t.faIcon,
          t.textColor
        ]]),
        "aria-hidden": "true"
      }, null, 2),
      t.label && t.iconBeforeLabel ? (l(), c("span", Rb, E(t.label), 1)) : v("", !0)
    ], 544),
    (l(), F(Bl, { to: "body" }, [
      p("span", {
        class: G(["tooltiptext", [r.placementClass, { active: i.isActive }]]),
        ref: "tooltipContent"
      }, [
        j(e.$slots, "default", {}, void 0, !0)
      ], 2)
    ]))
  ], 2);
}
const P1 = /* @__PURE__ */ D(wb, [["render", kb], ["__scopeId", "data-v-b1569d5a"]]), Ub = {
  extends: Ce,
  components: {
    FormGroup: ke,
    MessageError: it
  },
  props: {
    options: { type: Array, required: !0 },
    noOptionsProvidedMessage: { type: String, default: "No options provided" }
  },
  methods: {
    updateModelValue: function(e) {
      this.$emit("update:modelValue", e == "" ? null : e);
    }
  }
}, Eb = ["id", "modelValue", "readonly"], Sb = ["selected"], Tb = ["value", "selected"], Ib = ["id", "value"];
function Db(e, n, t, o, i, r) {
  const s = K("MessageError"), a = K("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      !t.options || !t.options.length ? (l(), F(s, { key: 0 }, {
        default: b(() => [
          _(E(t.noOptionsProvidedMessage), 1)
        ]),
        _: 1
      })) : e.readonly ? (l(), c("input", {
        key: 2,
        id: e.id,
        class: "form-control",
        type: "text",
        readonly: "",
        value: e.modelValue
      }, null, 8, Ib)) : (l(), c("select", {
        key: 1,
        id: e.id,
        modelValue: e.modelValue,
        readonly: e.readonly,
        class: "form-control",
        onChange: n[0] || (n[0] = (u) => r.updateModelValue(u.target.value))
      }, [
        e.required ? v("", !0) : (l(), c("option", {
          key: 0,
          selected: e.modelValue === void 0 || e.modelValue === null
        }, E(e.placeholder), 9, Sb)),
        (l(!0), c(oe, null, ae(t.options, (u, d) => (l(), c("option", {
          key: d + u,
          value: u,
          selected: e.modelValue == u
        }, E(u), 9, Tb))), 128))
      ], 40, Eb))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const En = /* @__PURE__ */ D(Ub, [["render", Db]]), Ob = {
  directives: {
    clickOutside: qo.directive
  },
  extends: Ce,
  components: {
    IconAction: ct
  },
  props: {
    options: Array
  },
  data() {
    return {
      focus: !1
    };
  },
  methods: {
    select(e) {
      this.toggleFocus(), this.$emit("update:modelValue", e);
    },
    toggleFocus() {
      this.focus = !this.focus;
    }
  }
}, _b = {
  key: 0,
  class: "dropdown show"
}, Mb = { class: "dropdown-menu show" }, Pb = ["onClick"];
function Bb(e, n, t, o, i, r) {
  const s = K("IconAction"), a = ko("click-outside");
  return l(), c("span", null, [
    i.focus ? We((l(), c("span", _b, [
      p("span", Mb, [
        e.required ? v("", !0) : (l(), c("button", {
          class: "btn btn-link dropdown-item",
          key: "empty-option",
          onClick: n[0] || (n[0] = Ke((u) => r.select(void 0), ["prevent"]))
        }, "   ")),
        (l(!0), c(oe, null, ae(t.options, (u) => (l(), c("button", {
          class: G(["btn btn-link dropdown-item", { "text-primary": e.modelValue === u }]),
          key: u,
          onClick: Ke((d) => r.select(u), ["prevent"])
        }, E(u), 11, Pb))), 128))
      ])
    ])), [
      [a, r.toggleFocus]
    ]) : v("", !0),
    p("span", {
      onClick: n[1] || (n[1] = (...u) => r.toggleFocus && r.toggleFocus(...u)),
      onMouseover: n[2] || (n[2] = (u) => e.hover = !0),
      onMouseleave: n[3] || (n[3] = (u) => e.hover = !1),
      class: "inline-select"
    }, [
      _(E(e.modelValue) + " ", 1),
      T(s, {
        icon: "pencil-alt",
        class: "hoverIcon"
      })
    ], 32)
  ]);
}
const B1 = /* @__PURE__ */ D(Ob, [["render", Bb], ["__scopeId", "data-v-25a3f2e9"]]), Lb = {
  extends: Ce,
  //gives us 'options'
  components: {
    InputSelect: En,
    InputText: Vn,
    FormGroup: ke,
    InputGroup: Ve
  },
  props: {
    locales: {
      type: Array,
      default: () => ["en"]
    }
  },
  data() {
    return {
      localeSelect: void 0
      //for selecting locale
    };
  },
  mounted() {
    const e = Array.isArray(this.modelValue) ? xe(this.modelValue) : [{ locale: "en", value: "" }], n = Nb(this.locales, e);
    this.$emit("update:modelValue", n);
  }
};
function Nb(e, n) {
  let t = [...n];
  return e.forEach((o) => {
    o && !n.find((i) => i.locale === o) && t.push({ locale: o, value: "" }), n.find((i) => i.locale === "en") || t.push({ locale: o, value: "en" });
  }), t;
}
const qb = { class: "table table-bordered table-sm mb-0" }, xb = {
  key: 0,
  class: "pt-0 td-shrink text-right"
}, Vb = { class: "p-0" };
function jb(e, n, t, o, i, r) {
  const s = K("InputText"), a = K("InputGroup"), u = K("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: b(() => [
      T(a, null, {
        default: b(() => [
          p("table", qb, [
            (l(!0), c(oe, null, ae(e.modelValue, (d, f) => (l(), c("tr", null, [
              e.modelValue.length > 1 ? (l(), c("td", xb, E(d.locale) + ": ", 1)) : v("", !0),
              p("td", Vb, [
                T(s, {
                  id: e.id + ":" + d.locale,
                  modelValue: e.modelValue[f].value,
                  "onUpdate:modelValue": (y) => e.modelValue[f].value = y,
                  class: "mb-0",
                  onInput: n[0] || (n[0] = () => {
                  })
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
              ])
            ]))), 256))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const L1 = /* @__PURE__ */ D(Lb, [["render", jb]]), Hb = {
  props: {
    text: {
      type: String,
      required: !0
    }
  }
}, Gb = { class: "tooltip-component" }, Qb = { class: "tooltip-text px-2" };
function $b(e, n, t, o, i, r) {
  return l(), c("div", Gb, [
    j(e.$slots, "default", {}, () => [
      n[0] || (n[0] = _(" Default ", -1))
    ], !0),
    p("div", Qb, E(t.text), 1)
  ]);
}
const N1 = /* @__PURE__ */ D(Hb, [["render", $b], ["__scopeId", "data-v-fa2001de"]]);
/*!
  * vue-router v4.4.3
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */
const Jb = typeof document < "u", zb = () => {
}, wo = Array.isArray;
function as(e) {
  const n = Array.from(arguments).slice(1);
  console.warn.apply(console, ["[Vue Router warn]: " + e].concat(n));
}
function ls(e, n) {
  return (e.aliasOf || e) === (n.aliasOf || n);
}
function Yb(e, n) {
  if (Object.keys(e).length !== Object.keys(n).length)
    return !1;
  for (const t in e)
    if (!Wb(e[t], n[t]))
      return !1;
  return !0;
}
function Wb(e, n) {
  return wo(e) ? us(e, n) : wo(n) ? us(n, e) : e === n;
}
function us(e, n) {
  return wo(n) ? e.length === n.length && e.every((t, o) => t === n[o]) : e.length === 1 && e[0] === n;
}
var ds;
(function(e) {
  e.pop = "pop", e.push = "push";
})(ds || (ds = {}));
var cs;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(cs || (cs = {}));
function fs(e) {
  return typeof e == "string" || e && typeof e == "object";
}
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var ps;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(ps || (ps = {}));
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
const pl = Symbol(process.env.NODE_ENV !== "production" ? "router" : ""), Xb = Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
function hs(e) {
  const n = fi(pl), t = fi(Xb);
  let o = !1, i = null;
  const r = Te(() => {
    const f = ie(e.to);
    return process.env.NODE_ENV !== "production" && (!o || f !== i) && (fs(f) || (o ? as(`Invalid value for prop "to" in useLink()
- to:`, f, `
- previous to:`, i, `
- props:`, e) : as(`Invalid value for prop "to" in useLink()
- to:`, f, `
- props:`, e)), i = f, o = !0), n.resolve(f);
  }), s = Te(() => {
    const { matched: f } = r.value, { length: y } = f, C = f[y - 1], U = t.matched;
    if (!C || !U.length)
      return -1;
    const g = U.findIndex(ls.bind(null, C));
    if (g > -1)
      return g;
    const A = ms(f[y - 2]);
    return (
      // we are dealing with nested routes
      y > 1 && // if the parent and matched route have the same path, this link is
      // referring to the empty child. Or we currently are on a different
      // child of the same parent
      ms(C) === A && // avoid comparing the child with its parent
      U[U.length - 1].path !== A ? U.findIndex(ls.bind(null, f[y - 2])) : g
    );
  }), a = Te(() => s.value > -1 && nC(t.params, r.value.params)), u = Te(() => s.value > -1 && s.value === t.matched.length - 1 && Yb(t.params, r.value.params));
  function d(f = {}) {
    return tC(f) ? n[ie(e.replace) ? "replace" : "push"](
      ie(e.to)
      // avoid uncaught errors are they are logged anyway
    ).catch(zb) : Promise.resolve();
  }
  if (process.env.NODE_ENV !== "production" && Jb) {
    const f = Ll();
    if (f) {
      const y = {
        route: r.value,
        isActive: a.value,
        isExactActive: u.value,
        error: null
      };
      f.__vrl_devtools = f.__vrl_devtools || [], f.__vrl_devtools.push(y), Nl(() => {
        y.route = r.value, y.isActive = a.value, y.isExactActive = u.value, y.error = fs(ie(e.to)) ? null : 'Invalid "to" value';
      }, { flush: "post" });
    }
  }
  return {
    route: r,
    href: Te(() => r.value.href),
    isActive: a,
    isExactActive: u,
    navigate: d
  };
}
const Zb = /* @__PURE__ */ Re({
  name: "RouterLink",
  compatConfig: { MODE: 3 },
  props: {
    to: {
      type: [String, Object],
      required: !0
    },
    replace: Boolean,
    activeClass: String,
    // inactiveClass: String,
    exactActiveClass: String,
    custom: Boolean,
    ariaCurrentValue: {
      type: String,
      default: "page"
    }
  },
  useLink: hs,
  setup(e, { slots: n }) {
    const t = Us(hs(e)), { options: o } = fi(pl), i = Te(() => ({
      [As(e.activeClass, o.linkActiveClass, "router-link-active")]: t.isActive,
      // [getLinkClass(
      //   props.inactiveClass,
      //   options.linkInactiveClass,
      //   'router-link-inactive'
      // )]: !link.isExactActive,
      [As(e.exactActiveClass, o.linkExactActiveClass, "router-link-exact-active")]: t.isExactActive
    }));
    return () => {
      const r = n.default && n.default(t);
      return e.custom ? r : Bi("a", {
        "aria-current": t.isExactActive ? e.ariaCurrentValue : null,
        href: t.href,
        // this would override user added attrs but Vue will still add
        // the listener, so we end up triggering both
        onClick: t.navigate,
        class: i.value
      }, r);
    };
  }
}), eC = Zb;
function tC(e) {
  if (!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) && !e.defaultPrevented && !(e.button !== void 0 && e.button !== 0)) {
    if (e.currentTarget && e.currentTarget.getAttribute) {
      const n = e.currentTarget.getAttribute("target");
      if (/\b_blank\b/i.test(n))
        return;
    }
    return e.preventDefault && e.preventDefault(), !0;
  }
}
function nC(e, n) {
  for (const t in n) {
    const o = n[t], i = e[t];
    if (typeof o == "string") {
      if (o !== i)
        return !1;
    } else if (!wo(i) || i.length !== o.length || o.some((r, s) => r !== i[s]))
      return !1;
  }
  return !0;
}
function ms(e) {
  return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
const As = (e, n, t) => e ?? n ?? t, oC = {
  name: "Breadcrumb",
  components: {
    InputSearch: ar,
    RouterLink: eC
  },
  props: {
    /* list of crumbs, map of  {'label':'url'} */
    crumbs: Object,
    /* list of dropdown, map of  {'label':'url'} */
    dropdown: Object,
    useRouterLink: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showDropdown: !1,
      dropdownSearch: ""
    };
  },
  computed: {
    lastKey() {
      return Object.keys(this.crumbs)[Object.keys(this.crumbs).length - 1];
    },
    dropdownFiltered() {
      return this.dropdownSearch ? Object.fromEntries(
        Object.entries(this.dropdown).filter(
          ([e, n]) => e.toLowerCase().includes(this.dropdownSearch.toLowerCase())
        )
      ) : this.dropdown;
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
  }
}, iC = { "aria-label": "breadcrumb" }, rC = { class: "breadcrumb" }, sC = {
  key: 0,
  class: "router-link"
}, aC = {
  key: 0,
  "aria-current": "page"
}, lC = {
  key: 1,
  class: "atag"
}, uC = {
  key: 0,
  "aria-current": "page"
}, dC = ["href"], cC = { class: "dropdown" }, fC = { key: 0 }, pC = {
  key: 0,
  class: "router-link"
}, hC = {
  key: 1,
  class: "atag"
}, mC = ["href"], AC = { key: 2 };
function gC(e, n, t, o, i, r) {
  const s = K("router-link"), a = K("InputSearch");
  return l(), c("nav", iC, [
    p("ol", rC, [
      (l(!0), c(oe, null, ae(t.crumbs, (u, d, f) => (l(), c("li", {
        key: d,
        class: G(["breadcrumb-item", { active: d === r.lastKey }])
      }, [
        t.useRouterLink ? (l(), c("span", sC, [
          d === r.lastKey ? (l(), c("a", aC, E(d), 1)) : (l(), F(s, {
            key: 1,
            to: u
          }, {
            default: b(() => [
              _(E(d), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        ])) : (l(), c("span", lC, [
          d === r.lastKey ? (l(), c("a", uC, E(d), 1)) : (l(), c("a", {
            key: 1,
            href: u
          }, E(d), 9, dC))
        ])),
        p("span", cC, [
          t.dropdown && f === 0 ? (l(), c("span", fC, [
            p("i", {
              class: "text-primary dropdown-toggle dropdown-toggle-split pr-0",
              onClick: n[0] || (n[0] = (...y) => r.toggleDropdown && r.toggleDropdown(...y))
            }),
            p("div", {
              class: G(["dropdown-menu", { show: i.showDropdown }])
            }, [
              T(a, {
                id: "breadcrumb-dropdown-search",
                modelValue: i.dropdownSearch,
                "onUpdate:modelValue": n[1] || (n[1] = (y) => i.dropdownSearch = y),
                isClearBtnShown: !0,
                isEmitOnType: !0
              }, null, 8, ["modelValue"]),
              t.useRouterLink ? (l(), c("span", pC, [
                (l(!0), c(oe, null, ae(r.dropdownFiltered, (y, C, U) => (l(), F(s, {
                  class: "dropdown-item text-primary",
                  to: y,
                  key: `${U}_routerlink`
                }, {
                  default: b(() => [
                    _(E(C), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))), 128))
              ])) : (l(), c("span", hC, [
                (l(!0), c(oe, null, ae(r.dropdownFiltered, (y, C, U) => (l(), c("a", {
                  class: "dropdown-item text-primary",
                  href: y,
                  key: U
                }, E(C), 9, mC))), 128))
              ])),
              Object.keys(r.dropdownFiltered).length === 0 ? (l(), c("span", AC, " nothing found ")) : v("", !0)
            ], 2)
          ])) : v("", !0)
        ])
      ], 2))), 128))
    ])
  ]);
}
const yC = /* @__PURE__ */ D(oC, [["render", gC]]);
function KC(e) {
  return ql() ? (xl(e), !0) : !1;
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var hl = CC, gs = wC, vC = decodeURIComponent, bC = encodeURIComponent, to = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function CC(e, n) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var t = {}, o = n || {}, i = e.split(";"), r = o.decode || vC, s = 0; s < i.length; s++) {
    var a = i[s], u = a.indexOf("=");
    if (!(u < 0)) {
      var d = a.substring(0, u).trim();
      if (t[d] == null) {
        var f = a.substring(u + 1, a.length).trim();
        f[0] === '"' && (f = f.slice(1, -1)), t[d] = FC(f, r);
      }
    }
  }
  return t;
}
function wC(e, n, t) {
  var o = t || {}, i = o.encode || bC;
  if (typeof i != "function")
    throw new TypeError("option encode is invalid");
  if (!to.test(e))
    throw new TypeError("argument name is invalid");
  var r = i(n);
  if (r && !to.test(r))
    throw new TypeError("argument val is invalid");
  var s = e + "=" + r;
  if (o.maxAge != null) {
    var a = o.maxAge - 0;
    if (isNaN(a) || !isFinite(a))
      throw new TypeError("option maxAge is invalid");
    s += "; Max-Age=" + Math.floor(a);
  }
  if (o.domain) {
    if (!to.test(o.domain))
      throw new TypeError("option domain is invalid");
    s += "; Domain=" + o.domain;
  }
  if (o.path) {
    if (!to.test(o.path))
      throw new TypeError("option path is invalid");
    s += "; Path=" + o.path;
  }
  if (o.expires) {
    if (typeof o.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    s += "; Expires=" + o.expires.toUTCString();
  }
  if (o.httpOnly && (s += "; HttpOnly"), o.secure && (s += "; Secure"), o.sameSite) {
    var u = typeof o.sameSite == "string" ? o.sameSite.toLowerCase() : o.sameSite;
    switch (u) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return s;
}
function FC(e, n) {
  try {
    return n(e);
  } catch {
    return e;
  }
}
function RC() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function kC(e, n) {
  return typeof e == "string" ? hl(e, n) : typeof e == "object" && e !== null ? e : {};
}
function UC(e, n) {
  return typeof n > "u" && (n = !e || e[0] !== "{" && e[0] !== "[" && e[0] !== '"'), !n;
}
function ys(e, n) {
  n === void 0 && (n = {});
  var t = EC(e);
  if (UC(t, n.doNotParse))
    try {
      return JSON.parse(t);
    } catch {
    }
  return e;
}
function EC(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
var Mt = function() {
  return Mt = Object.assign || function(e) {
    for (var n, t = 1, o = arguments.length; t < o; t++) {
      n = arguments[t];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, Mt.apply(this, arguments);
}, SC = (
  /** @class */
  function() {
    function e(n, t) {
      var o = this;
      this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = kC(n, t), new Promise(function() {
        o.HAS_DOCUMENT_COOKIE = RC();
      }).catch(function() {
      });
    }
    return e.prototype._updateBrowserValues = function(n) {
      this.HAS_DOCUMENT_COOKIE && (this.cookies = hl(document.cookie, n));
    }, e.prototype._emitChange = function(n) {
      for (var t = 0; t < this.changeListeners.length; ++t)
        this.changeListeners[t](n);
    }, e.prototype.get = function(n, t, o) {
      return t === void 0 && (t = {}), this._updateBrowserValues(o), ys(this.cookies[n], t);
    }, e.prototype.getAll = function(n, t) {
      n === void 0 && (n = {}), this._updateBrowserValues(t);
      var o = {};
      for (var i in this.cookies)
        o[i] = ys(this.cookies[i], n);
      return o;
    }, e.prototype.set = function(n, t, o) {
      var i;
      typeof t == "object" && (t = JSON.stringify(t)), this.cookies = Mt(Mt({}, this.cookies), (i = {}, i[n] = t, i)), this.HAS_DOCUMENT_COOKIE && (document.cookie = gs(n, t, o)), this._emitChange({ name: n, value: t, options: o });
    }, e.prototype.remove = function(n, t) {
      var o = t = Mt(Mt({}, t), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
      this.cookies = Mt({}, this.cookies), delete this.cookies[n], this.HAS_DOCUMENT_COOKIE && (document.cookie = gs(n, "", o)), this._emitChange({ name: n, value: void 0, options: t });
    }, e.prototype.addChangeListener = function(n) {
      this.changeListeners.push(n);
    }, e.prototype.removeChangeListener = function(n) {
      var t = this.changeListeners.indexOf(n);
      t >= 0 && this.changeListeners.splice(t, 1);
    }, e;
  }()
);
function TC(e, { doNotParse: n = !1, autoUpdateDependencies: t = !1 } = {}, o = new SC()) {
  const i = t ? [...e || []] : e;
  let r = o.getAll({ doNotParse: !0 });
  const s = Ae(0), a = () => {
    const u = o.getAll({ doNotParse: !0 });
    IC(
      i || null,
      u,
      r
    ) && s.value++, r = u;
  };
  return o.addChangeListener(a), KC(() => {
    o.removeChangeListener(a);
  }), {
    /**
     * Reactive get cookie by name. If **autoUpdateDependencies = true** then it will update watching dependencies
     */
    get: (...u) => (t && i && !i.includes(u[0]) && i.push(u[0]), s.value, o.get(u[0], { doNotParse: n, ...u[1] })),
    /**
     * Reactive get all cookies
     */
    getAll: (...u) => (s.value, o.getAll({ doNotParse: n, ...u[0] })),
    set: (...u) => o.set(...u),
    remove: (...u) => o.remove(...u),
    addChangeListener: (...u) => o.addChangeListener(...u),
    removeChangeListener: (...u) => o.removeChangeListener(...u)
  };
}
function IC(e, n, t) {
  if (!e)
    return !0;
  for (const o of e)
    if (n[o] !== t[o])
      return !0;
  return !1;
}
/**
* @vue/shared v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Di = (e) => typeof e == "function", DC = Object.prototype.toString, OC = (e) => DC.call(e), di = (e) => OC(e) === "[object Object]";
function Oi(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function Ks(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _i(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ks(Object(t), !0).forEach(function(o) {
      Oi(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ks(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
var _C = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(o, i) {
    if (!(typeof document > "u")) {
      var r = document.head || document.getElementsByTagName("head")[0], s = document.createElement("script");
      if (s.async = !0, s.src = n, s.defer = t.defer, t.preconnectOrigin) {
        var a = document.createElement("link");
        a.href = t.preconnectOrigin, a.rel = "preconnect", r.appendChild(a);
      }
      r.appendChild(s), s.onload = o, s.onerror = i;
    }
  });
}, MC = function e(n) {
  for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    o[i - 1] = arguments[i];
  if (!o.length)
    return n;
  var r = o.shift();
  if (!(!di(n) || !di(r))) {
    for (var s in r)
      di(r[s]) ? (n[s] || Object.assign(n, Oi({}, s, {})), e(n[s], r[s])) : Object.assign(n, Oi({}, s, r[s]));
    return e.apply(void 0, [n].concat(o));
  }
}, jn = function() {
  return !(typeof window > "u" || typeof document > "u");
}, vs = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  !jn() || process.env.NODE_ENV === "production" || t && console.warn("[vue-gtag] ".concat(n));
}, PC = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return vs('Missing "appName" property inside the plugin options.', n.app_name == null), vs('Missing "name" property in the route.', n.screen_name == null), n;
};
function BC() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", t = e.split("/"), o = n.split("/");
  return t[0] === "" && n[n.length - 1] === "/" && t.shift(), o.join("/") + t.join("/");
}
var LC = function() {
  return {
    bootstrap: !0,
    onReady: null,
    onError: null,
    onBeforeTrack: null,
    onAfterTrack: null,
    pageTrackerTemplate: null,
    customResourceURL: "https://www.googletagmanager.com/gtag/js",
    customPreconnectOrigin: "https://www.googletagmanager.com",
    deferScriptLoad: !1,
    pageTrackerExcludedRoutes: [],
    pageTrackerEnabled: !0,
    enabled: !0,
    disableScriptLoad: !1,
    pageTrackerScreenviewEnabled: !1,
    appName: null,
    pageTrackerUseFullPath: !1,
    pageTrackerPrependBase: !0,
    pageTrackerSkipSamePath: !0,
    globalDataLayerName: "dataLayer",
    globalObjectName: "gtag",
    defaultGroupName: "default",
    includes: null,
    config: {
      id: null,
      params: {
        send_page_view: !1
      }
    }
  };
}, ml = {}, NC = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = LC();
  ml = MC(t, n);
}, vt = function() {
  return ml;
}, Mi = function() {
  var e, n = vt(), t = n.globalObjectName;
  !jn() || typeof window[t] > "u" || (e = window)[t].apply(e, arguments);
}, bs = function(n, t) {
  jn() && (window["ga-disable-".concat(n)] = t);
}, qC = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, n = vt(), t = n.config, o = n.includes;
  bs(t.id, e), Array.isArray(o) && o.forEach(function(i) {
    return bs(i.id, e);
  });
}, xC = function() {
  qC(!0);
}, VC, hr = function() {
  return VC;
}, Al = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = vt(), o = t.includes, i = t.defaultGroupName;
  n.send_to == null && Array.isArray(o) && o.length && (n.send_to = o.map(function(r) {
    return r.id;
  }).concat(i)), Mi("event", e, n);
}, jC = function(e) {
  if (jn()) {
    var n;
    if (typeof e == "string")
      n = {
        page_path: e
      };
    else if (e.path || e.fullPath) {
      var t = vt(), o = t.pageTrackerUseFullPath, i = t.pageTrackerPrependBase, r = hr(), s = r && r.options.base, a = o ? e.fullPath : e.path;
      n = _i(_i({}, e.name && {
        page_title: e.name
      }), {}, {
        page_path: i ? BC(a, s) : a
      });
    } else
      n = e;
    n.page_location == null && (n.page_location = window.location.href), n.send_page_view == null && (n.send_page_view = !0), Al("page_view", n);
  }
}, HC = function(e) {
  var n = vt(), t = n.appName;
  if (e) {
    var o;
    typeof e == "string" ? o = {
      screen_name: e
    } : o = e, o.app_name = o.app_name || t, Al("screen_view", o);
  }
}, GC = function() {
  if (jn()) {
    var e = vt(), n = e.enabled, t = e.globalObjectName, o = e.globalDataLayerName;
    return window[t] == null && (window[o] = window[o] || [], window[t] = function() {
      window[o].push(arguments);
    }), window[t]("js", /* @__PURE__ */ new Date()), n || xC(), window[t];
  }
}, Cs = function(n) {
  return _i({
    send_page_view: !1
  }, n);
}, gl = function() {
  var e = vt(), n = e.config, t = e.includes;
  Mi("config", n.id, Cs(n.params)), Array.isArray(t) && t.forEach(function(o) {
    Mi("config", o.id, Cs(o.params));
  });
}, ws = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = vt(), o = t.appName, i = t.pageTrackerTemplate, r = t.pageTrackerScreenviewEnabled, s = t.pageTrackerSkipSamePath;
  if (!(s && e.path === n.path)) {
    var a = e;
    if (Di(i) ? a = i(e, n) : r && (a = PC({
      app_name: o,
      screen_name: e.name
    })), r) {
      HC(a);
      return;
    }
    jC(a);
  }
}, Fs = function(n) {
  var t = vt(), o = t.pageTrackerExcludedRoutes;
  return o.includes(n.path) || o.includes(n.name);
}, QC = function() {
  var e = vt(), n = e.onBeforeTrack, t = e.onAfterTrack, o = hr();
  o.isReady().then(function() {
    po().then(function() {
      var i = o.currentRoute;
      gl(), !Fs(i.value) && ws(i.value);
    }), o.afterEach(function(i, r) {
      po().then(function() {
        Fs(i) || (Di(n) && n(i, r), ws(i, r), Di(t) && t(i, r));
      });
    });
  });
}, $C = function() {
  var e = vt(), n = e.onReady, t = e.onError, o = e.globalObjectName, i = e.globalDataLayerName, r = e.config, s = e.customResourceURL, a = e.customPreconnectOrigin, u = e.deferScriptLoad, d = e.pageTrackerEnabled, f = e.disableScriptLoad, y = !!(d && hr());
  if (GC(), y ? QC() : gl(), !f)
    return _C("".concat(s, "?id=").concat(r.id, "&l=").concat(i), {
      preconnectOrigin: a,
      defer: u
    }).then(function() {
      n && n(window[o]);
    }).catch(function(C) {
      return t && t(C), C;
    });
};
const JC = {
  name: "GTag",
  props: {
    tagId: {
      type: String,
      required: !0
    }
  },
  methods: {
    enablePlugin(e) {
      NC({
        config: { id: e }
      }), $C().then((n) => {
        console.log("start analytics for tagId: " + e);
      });
    }
  },
  async mounted() {
    this.enablePlugin(this.tagId);
  }
};
function zC(e, n, t, o, i, r) {
  return l(), c("div");
}
const YC = /* @__PURE__ */ D(JC, [["render", zC]]), WC = ["innerHTML"], XC = { key: 1 }, ZC = {
  __name: "CookieWall",
  props: {
    title: {
      type: String,
      default: "Would you like a cookie?"
    },
    acceptLabel: {
      type: String,
      default: "Accept"
    },
    rejectLabel: {
      type: String,
      default: "No thanks"
    },
    analyticsId: {
      type: String
    },
    htmlContentString: {
      type: String | null,
      default: null
    }
  },
  emits: ["acceptCookie"],
  setup(e, { emit: n }) {
    const t = TC(["mg_allow_analytics"]), o = n;
    let i = Ae(!1);
    const r = Te(() => t.get("mg_allow_analytics") === void 0), s = {
      path: "/",
      maxAge: 1704085200,
      // one year,
      httpOnly: !1
    };
    function a() {
      t.set("mg_allow_analytics", !0, s), o("acceptCookie", !0), window.location.reload();
    }
    function u() {
      t.set("mg_allow_analytics", !1, s), o("acceptCookie", !1);
    }
    function d() {
      i.value = !0, o("acceptCookie", void 0);
    }
    const f = Te(() => t.get("mg_allow_analytics") === !0);
    return (y, C) => (l(), c(oe, null, [
      T(Kt, {
        title: e.title,
        onClose: d,
        show: r.value && !ie(i)
      }, {
        body: b(() => [
          e.htmlContentString ? (l(), c("div", {
            key: 0,
            innerHTML: e.htmlContentString
          }, null, 8, WC)) : (l(), c("div", XC, [...C[0] || (C[0] = [
            p("p", null, ' We use cookies and similar technologies to enhance your browsing experience, analyze website traffic, and personalize content. By clicking "Accept," you consent to the use of cookies. ', -1),
            p("p", null, " We value your privacy and are committed to protecting your personal information. Our use of cookies is solely for improving your experience on our website and ensuring its functionality. We do not sell or share your data with third parties. ", -1)
          ])]))
        ]),
        footer: b(() => [
          T(ot, { onClick: u }, {
            default: b(() => [
              _(E(e.rejectLabel), 1)
            ]),
            _: 1
          }),
          T(He, { onClick: a }, {
            default: b(() => [
              _(E(e.acceptLabel), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "show"]),
      f.value ? (l(), F(YC, {
        key: 0,
        tagId: e.analyticsId
      }, null, 8, ["tagId"])) : v("", !0)
    ], 64));
  }
}, ew = {
  components: {
    IconAction: ct
  },
  props: {
    /** Title that is shown on the card (optional) */
    title: String,
    /** If the cared should be collapsed **/
    collapse: { type: Boolean, default: !1 }
  },
  data: function() {
    return {
      fullscreen: !1,
      collapsed: !0
    };
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen;
    },
    toggleCollapse() {
      this.collapse && (this.collapsed = !this.collapsed);
    }
  },
  computed: {
    bodyheight() {
      if (this.$refs.header && this.fullscreen) {
        let e = this.$refs.header.clientHeight, n = this.$refs.footer.clientHeight;
        return `height: calc(100vh - ${e + n}px)`;
      }
      return "";
    }
  }
}, tw = { key: 0 };
function nw(e, n, t, o, i, r) {
  const s = K("IconAction");
  return l(), c("div", {
    class: G(["card", { "card-fullscreen": e.fullscreen }])
  }, [
    p("div", {
      ref: "header",
      class: "card-header text-center",
      onClick: n[0] || (n[0] = (...a) => r.toggleCollapse && r.toggleCollapse(...a))
    }, [
      t.title ? (l(), c("h4", tw, E(t.title), 1)) : v("", !0),
      j(e.$slots, "header", {}, void 0, !0),
      t.collapse ? v("", !0) : (l(), F(s, {
        key: 1,
        class: "card-fullscreen-icon",
        icon: e.fullscreen ? "compress" : "expand",
        onClick: r.toggle
      }, null, 8, ["icon", "onClick"]))
    ], 512),
    !this.collapse || !e.collapsed ? (l(), c("div", {
      key: 0,
      class: "card-body",
      style: Ro(r.bodyheight)
    }, [
      j(e.$slots, "default", {}, void 0, !0)
    ], 4)) : v("", !0)
  ], 2);
}
const q1 = /* @__PURE__ */ D(ew, [["render", nw], ["__scopeId", "data-v-adf17920"]]), ow = {
  name: "MolgenisFooter"
}, iw = { class: "text-center" };
function rw(e, n, t, o, i, r) {
  return l(), c("div", iw, [
    n[0] || (n[0] = Vl('<div data-v-4613be74> This database was created using the <a href="http://molgenis.org" data-v-4613be74>MOLGENIS</a>  <a href="http://github.com/molgenis/molgenis-emx2" data-v-4613be74> molgenis-emx2 </a> open source software (license: <a href="https://github.com/molgenis/molgenis-emx2/blob/master/LICENSE" data-v-4613be74>LGPLv3</a>). </div><div data-v-4613be74> Please cite <a href="https://www.ncbi.nlm.nih.gov/pubmed/30165396" data-v-4613be74> Van der Velde et al (2018)</a> or <a href="https://www.ncbi.nlm.nih.gov/pubmed/21210979" data-v-4613be74> Swertz et al (2010)</a> on use. </div>', 2)),
    j(e.$slots, "default", {}, void 0, !0)
  ]);
}
const sw = /* @__PURE__ */ D(ow, [["render", rw], ["__scopeId", "data-v-4613be74"]]), aw = {
  components: {
    ButtonDropdown: fr
  },
  props: {
    /** the navbar items in format {name:'name', href:'href',role:[], submenu:[]}.
     * If href is null then you will return to baseURL.
     * Href is prefixed with 'baseURL' unless startwith 'http' or '/'.
     * If role then menu items are filtered based on session.roles.
     * Submenu is optional
     */
    items: Array,
    /** logo to show*/
    logo: String,
    /** session information, so we can check role permissions */
    session: Object,
    /** prefix for relative href. Will default to schema name, i.e. first directory in path, e.g. "/pet store/ */
    baseURL: {
      type: String,
      default: () => {
        let e = window.location.pathname.split("/")[1];
        return "/" + (e ? e + "/" : "");
      }
    }
  },
  data: function() {
    return {
      toggleMenuBar: !1
    };
  },
  computed: {
    permittedItems() {
      return this.items.filter(this.permitted);
    },
    homeUrl() {
      const e = (t) => t.find((o) => {
        if (o.href)
          return o;
        if (o.submenu)
          return e(o.submenu.filter(this.permitted));
      }), n = e(this.permittedItems);
      return n ? this.addBaseUrl(n.href) : this.baseURL;
    }
  },
  methods: {
    addBaseUrl(e) {
      return e && (e.startsWith("http://") || e.startsWith("https://") || e.startsWith("/") || e.startsWith("..")) ? e : this.baseURL + (e || "");
    },
    navigate(e) {
      return window.location.href = e, e.includes("#") && window.location.reload(!0), !1;
    },
    permitted(e) {
      var n, t, o, i, r, s, a, u;
      return !e.role || (n = this.session) != null && n.admin || e.role === "Signed in" && ((t = this.session) == null ? void 0 : t.email) !== "anonymous" ? !0 : e.role === "Viewer" ? (i = (o = this.session) == null ? void 0 : o.roles) == null ? void 0 : i.some(
        (d) => ["Viewer", "Editor", "Manager", "Owner"].includes(d)
      ) : e.role === "Editor" ? (s = (r = this.session) == null ? void 0 : r.roles) == null ? void 0 : s.some(
        (d) => ["Editor", "Manager", "Owner"].includes(d)
      ) : e.role === "Manager" ? (u = (a = this.session) == null ? void 0 : a.roles) == null ? void 0 : u.some(
        (d) => ["Manager", "Owner"].includes(d)
      ) : !1;
    }
  }
}, lw = { class: "navbar bg-primary navbar-expand-lg navbar-dark" }, uw = {
  key: 0,
  class: "navbar-brand",
  href: "/"
}, dw = ["src"], cw = {
  key: 0,
  class: "navbar-nav"
}, fw = ["href", "target", "onClick"], pw = ["href", "target", "onClick"];
function hw(e, n, t, o, i, r) {
  const s = K("ButtonDropdown");
  return l(), c("nav", lw, [
    p("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNav",
      "aria-controls": "navbarNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation",
      onClick: n[0] || (n[0] = (a) => e.toggleMenuBar = !e.toggleMenuBar)
    }, [...n[1] || (n[1] = [
      p("span", { class: "navbar-toggler-icon" }, null, -1)
    ])]),
    t.logo ? (l(), c("a", uw, [
      p("img", {
        src: t.logo,
        alt: "brand-logo",
        height: "30"
      }, null, 8, dw)
    ])) : v("", !0),
    p("div", {
      class: G(["collapse navbar-collapse", { show: e.toggleMenuBar }]),
      id: "navbarNav"
    }, [
      t.items ? (l(), c("ul", cw, [
        (l(!0), c(oe, null, ae(r.permittedItems, (a) => (l(), c("li", {
          key: a.label,
          class: G(["nav-item", {
            active: a.active,
            dropdown: a.submenu
          }])
        }, [
          a.submenu && a.submenu.length > 0 ? (l(), F(s, {
            key: 0,
            class: "nav-item",
            label: a.label,
            icon: "caret-down",
            isMenuItem: !0
          }, {
            default: b(() => [
              (l(!0), c(oe, null, ae(a.submenu, (u) => (l(), c("a", {
                class: "dropdown-item",
                href: r.addBaseUrl(u.href),
                key: u.label,
                target: u.newWindow ? "_blank" : "_self",
                onClick: (d) => r.navigate(r.addBaseUrl(u.href))
              }, E(u.label), 9, fw))), 128))
            ]),
            _: 2
          }, 1032, ["label"])) : (l(), c("a", {
            key: 1,
            class: "nav-link",
            href: r.addBaseUrl(a.href),
            target: a.newWindow ? "_blank" : "_self",
            onClick: (u) => r.navigate(r.addBaseUrl(a.href))
          }, E(a.label), 9, pw))
        ], 2))), 128))
      ])) : v("", !0)
    ], 2),
    j(e.$slots, "default")
  ]);
}
const mw = /* @__PURE__ */ D(aw, [["render", hw]]), Aw = { style: { "background-color": "#f4f4f4" } }, gw = { style: { "min-height": "calc(100vh - 70px)" } }, yw = {
  class: "container-fluid p-3",
  style: { "padding-bottom": "50px" }
}, Kw = { key: 0 }, vw = ["innerHTML"], bw = { key: 0 }, Cw = ["href"], ww = { key: 0 }, x1 = /* @__PURE__ */ Re({
  __name: "Molgenis",
  props: {
    title: {},
    menuItems: { default: () => [] },
    showCrumbs: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "error"],
  setup(e, { emit: n }) {
    const t = [
      {
        label: "Tables",
        href: "tables",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Schema",
        href: "schema",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Up/Download",
        href: "updownload",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Reports",
        href: "reports",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Jobs & Scripts",
        href: "tasks",
        role: "Manager",
        submenu: []
      },
      {
        label: "Graphql",
        href: "graphql-playground",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Settings",
        href: "settings",
        role: "Manager",
        submenu: []
      },
      {
        label: "Help",
        href: "docs",
        role: "Viewer",
        submenu: []
      }
    ], o = e, i = Ae([]);
    o.menuItems.length ? i.value = g(o.menuItems) : i.value = g(t);
    const r = n, s = Ae(null), a = Ae(null), u = Ae(Date.now()), d = Ae(null), f = Ae(null), y = Te(() => {
      var w;
      let A = {
        "list all databases": "/apps/central/"
      };
      return (w = s.value) != null && w.schemas && s.value.schemas.sort(
        (M, L) => M.localeCompare(L, void 0, { sensitivity: "base" })
      ).forEach((M) => {
        A[M] = "/" + M + "/index";
      }), A;
    }), C = Te(() => {
      var w;
      let A = {};
      if (window && location) {
        let M = decodeURI(
          window.location.pathname.replace(location.search, "")
        ).split("/"), L = "/";
        if (window.location.pathname != "/apps/central/") {
          let B = "index";
          M.forEach((N) => {
            N !== "" && (L += N + "/", A[N] = L + B, B = "");
          });
        }
        M = decodeURI((w = location == null ? void 0 : location.hash) == null ? void 0 : w.split("?")[0]).substr(1).split("/"), L += "#", M.forEach((B) => {
          B !== "" && (L += "/" + B, A[B] = L);
        });
      }
      return A;
    }), U = Te(() => a.value ?? "/apps/molgenis-components/assets/img/molgenis_logo_white.png");
    mo(
      s,
      (A) => {
        var M, L, B;
        (M = A == null ? void 0 : A.settings) != null && M.logoURL && (a.value = A.settings.logoURL);
        const w = (L = A == null ? void 0 : A.settings) == null ? void 0 : L.additionalJs;
        if (w)
          try {
            eval == null || (0, eval)(`(function() {"use strict"; ${w}})()`);
          } catch (N) {
            console.log(N);
          }
        !o.menuItems.length && ((B = A == null ? void 0 : A.settings) != null && B.menu) && (i.value = A.settings.menu), r("update:modelValue", A);
      },
      { deep: !0 }
    ), mo(
      () => o.menuItems,
      (A) => {
        A.length ? i.value = g(A) : i.value = g(t);
      }
    );
    function g(A) {
      var B, N;
      const w = (N = (B = window == null ? void 0 : window.location) == null ? void 0 : B.pathname.split("/")) == null ? void 0 : N.filter(Boolean)[0];
      if (!w || w === "apps")
        return A;
      function M(x) {
        let q = `/${w}/${x}`, Y = q.indexOf("#");
        return Y !== -1 && q.substring(Y - 1, Y) !== "/" && (q = q.substring(0, Y) + "/" + q.substring(Y, q == null ? void 0 : q.length)), Y = q.indexOf("#"), Y !== -1 || q.endsWith("/") ? q : q + "/";
      }
      return A.map((x) => (x.href = M(x.href), x.submenu = x.submenu.map((q) => (q.href = M(q.href), q)), x));
    }
    return Ts(async () => {
      const w = await nt.newClient().fetchSettings(), M = w.find(
        (B) => B.key === "ANALYTICS_ID"
      );
      d.value = M ? M.value : null;
      const L = w.find(
        (B) => B.key === "ANALYTICS_COOKIE_WALL_CONTENT"
      );
      f.value = L ? L.value : null;
    }), (A, w) => {
      var M, L, B, N;
      return l(), c("div", Aw, [
        A.$slots.banner ? j(A.$slots, "banner", { key: 0 }) : v("", !0),
        d.value ? (l(), F(ZC, {
          key: 1,
          analyticsId: d.value,
          htmlContentString: f.value
        }, null, 8, ["analyticsId", "htmlContentString"])) : v("", !0),
        p("div", gw, [
          T(mw, {
            logo: U.value,
            active: "My search",
            items: i.value,
            session: s.value ?? void 0
          }, {
            default: b(() => [
              (l(), F(am, {
                modelValue: s.value,
                "onUpdate:modelValue": w[0] || (w[0] = (x) => s.value = x),
                key: u.value,
                onError: w[1] || (w[1] = (x) => A.$emit("error", x))
              }, null, 8, ["modelValue"]))
            ]),
            _: 1
          }, 8, ["logo", "items", "session"]),
          e.showCrumbs && Object.keys(C.value).length > 1 ? (l(), F(yC, {
            key: 0,
            crumbs: C.value,
            dropdown: y.value
          }, null, 8, ["crumbs", "dropdown"])) : v("", !0),
          p("main", yw, [
            e.title ? (l(), c("h1", Kw, E(e.title), 1)) : v("", !0),
            j(A.$slots, "default")
          ])
        ]),
        p("footer", null, [
          (L = (M = s.value) == null ? void 0 : M.settings) != null && L.additionalFooterHtml ? (l(), c("div", {
            key: 0,
            innerHTML: (N = (B = s.value) == null ? void 0 : B.settings) == null ? void 0 : N.additionalFooterHtml
          }, null, 8, vw)) : v("", !0),
          A.$slots.footer ? j(A.$slots, "footer", { key: 1 }) : v("", !0),
          T(sw, null, {
            default: b(() => {
              var x;
              return [
                (x = s.value) != null && x.manifest ? (l(), c("span", bw, [
                  w[2] || (w[2] = _(" Software version: ", -1)),
                  p("a", {
                    href: "https://github.com/molgenis/molgenis-emx2/releases/tag/" + s.value.manifest.SpecificationVersion
                  }, E(s.value.manifest.SpecificationVersion), 9, Cw),
                  w[3] || (w[3] = _(". ", -1)),
                  s.value.manifest.DatabaseVersion ? (l(), c("span", ww, " Database version: " + E(s.value.manifest.DatabaseVersion) + ". ", 1)) : v("", !0)
                ])) : v("", !0)
              ];
            }),
            _: 1
          })
        ])
      ]);
    };
  }
}), Fw = {
  components: { ButtonAlt: ot },
  props: {
    title: { type: String, default: "debug" }
  },
  data() {
    return { show: !1 };
  },
  computed: {
    showLabel() {
      return "show " + this.title;
    },
    hideLabel() {
      return "hide " + this.title;
    }
  }
}, Rw = { key: 0 };
function kw(e, n, t, o, i, r) {
  const s = K("ButtonAlt");
  return i.show ? (l(), c("div", Rw, [
    T(s, {
      onClick: n[0] || (n[0] = (a) => i.show = !1)
    }, {
      default: b(() => [
        _(E(r.hideLabel), 1)
      ]),
      _: 1
    }),
    j(e.$slots, "default")
  ])) : (l(), F(s, {
    key: 1,
    onClick: n[1] || (n[1] = (a) => i.show = !0)
  }, {
    default: b(() => [
      _(E(r.showLabel) + " ", 1),
      n[2] || (n[2] = p("br", null, null, -1))
    ]),
    _: 1
  }));
}
const V1 = /* @__PURE__ */ D(Fw, [["render", kw]]), Uw = {
  props: {
    open: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    bodyClass: {
      type: String,
      required: !1
    }
  },
  watch: {
    open(e) {
      e ? (this.$refs.modal.setAttribute("open", ""), document.getElementsByTagName("body")[0].style.overflow = "hidden") : (this.$refs.modal.removeAttribute("open"), document.getElementsByTagName("body")[0].style.removeProperty("overflow"));
    }
  }
}, Ew = { ref: "modal" }, Sw = { class: "d-flex pt-4" };
function Tw(e, n, t, o, i, r) {
  return l(), c("dialog", Ew, [
    p("article", {
      class: G(["border border-black bg-white p-2", t.bodyClass])
    }, [
      j(e.$slots, "default", {}, void 0, !0),
      j(e.$slots, "modal-footer", {}, () => [
        p("div", Sw, [
          p("button", {
            class: "btn btn-primary",
            onClick: n[0] || (n[0] = (s) => e.$emit("save"))
          }, "Save"),
          p("button", {
            class: "btn btn-dark ml-auto",
            onClick: n[1] || (n[1] = (s) => e.$emit("close"))
          }, " Cancel ")
        ])
      ], !0)
    ], 2)
  ], 512);
}
const j1 = /* @__PURE__ */ D(Uw, [["render", Tw], ["__scopeId", "data-v-32fc409a"]]), Iw = { class: "tabs-header row justify-content-start" }, Dw = ["onClick"], Ow = { class: "tabs-content" }, _w = /* @__PURE__ */ Re({
  __name: "Tabs",
  props: {
    tabIds: {}
  },
  setup(e) {
    const n = Ae(e.tabIds[0]);
    function t(o) {
      n.value = o;
    }
    return (o, i) => (l(), c("div", null, [
      p("ul", Iw, [
        (l(!0), c(oe, null, ae(e.tabIds, (r) => (l(), c("li", {
          key: r,
          class: G(["tabs-item", { selected: n.value === r }]),
          onClick: (s) => t(r)
        }, [
          j(o.$slots, `${r}-header`, {}, void 0, !0)
        ], 10, Dw))), 128)),
        i[0] || (i[0] = p("li", { class: "filler-line col" }, null, -1))
      ]),
      (l(!0), c(oe, null, ae(e.tabIds, (r) => We((l(), c("div", Ow, [
        j(o.$slots, `${r}-body`, {}, void 0, !0)
      ], 512)), [
        [Fo, r === n.value]
      ])), 256))
    ]));
  }
}), H1 = /* @__PURE__ */ D(_w, [["__scopeId", "data-v-22817d43"]]), Mw = {
  props: {
    row: Object,
    template: String
  },
  render() {
    const e = {
      template: `<div>${this.template}</div>`,
      data: () => ({
        row: this.row
      })
    };
    return Bi(e);
  }
}, Pw = {
  name: "TableStickyHeaders",
  props: {
    columns: Array,
    rows: Array,
    data: Object
  }
}, Bw = {
  role: "region",
  class: "border border-light"
}, Lw = { class: "table table-sm bg-white table-bordered table-hover" }, Nw = { class: "rotated-title" };
function qw(e, n, t, o, i, r) {
  return l(), c("div", Bw, [
    p("table", Lw, [
      p("thead", null, [
        p("tr", null, [
          n[0] || (n[0] = p("th", null, null, -1)),
          (l(!0), c(oe, null, ae(t.columns, (s, a) => (l(), c("th", {
            key: `head-${a}`
          }, [
            p("div", Nw, [
              p("span", null, [
                j(e.$slots, "column", { value: s }, () => [
                  _(E(s), 1)
                ], !0)
              ])
            ])
          ]))), 128))
        ])
      ]),
      p("tbody", null, [
        (l(!0), c(oe, null, ae(t.rows, (s, a) => (l(), c("tr", {
          key: `tr-${a}`
        }, [
          p("th", null, [
            j(e.$slots, "row", { value: s }, () => [
              _(E(s), 1)
            ], !0)
          ]),
          (l(!0), c(oe, null, ae(t.columns, (u, d) => (l(), c("td", {
            key: `td-${d}`
          }, [
            j(e.$slots, "cell", {
              value: t.data[s][u]
            }, () => [
              _(E(t.data[s][u]), 1)
            ], !0)
          ]))), 128))
        ]))), 128))
      ])
    ])
  ]);
}
const xw = /* @__PURE__ */ D(Pw, [["render", qw], ["__scopeId", "data-v-877018ce"]]), Vw = {
  key: 1,
  class: "alert alert-warning"
}, jw = {
  key: 2,
  class: "border d-inline-block p-2 bg-white"
}, Hw = { class: "aggregate-options" }, Gw = { key: 0 }, Qw = { key: 1 }, $w = {
  key: 0,
  class: "alert alert-danger"
}, Jw = {
  key: 1,
  class: "alert alert-warning"
}, zw = {
  key: 0,
  class: "text-center text-black-50"
}, Yw = { key: 1 }, Ww = { key: 2 }, Xw = /* @__PURE__ */ Re({
  __name: "AggregateTable",
  props: {
    canView: { type: Boolean },
    schemaId: {},
    allColumns: {},
    tableId: {},
    minimumValue: { default: 1 },
    graphqlFilter: { default: () => ({}) }
  },
  setup(e) {
    var Y;
    const n = ["INT", "LONG", "DECIMAL"], t = e, o = Ae(""), i = Ae(""), r = Ae([]), s = Ae(!1), a = Ae("count"), u = Ae(
      ((Y = t.allColumns.find(($) => n.includes($.columnType))) == null ? void 0 : Y.id) || ""
    ), d = Ae([]), f = Ae([]), y = Ae({}), C = Ae(!1), U = Ae(void 0), g = Ae(nt.newClient(t.schemaId)), A = Te(() => t.allColumns.filter(($) => n.includes($.columnType)).map(($) => $.id)), w = Te(() => t.allColumns.reduce(($, Q) => ($[Q.id] = Q, $), {}));
    x();
    async function M() {
      if (s.value = !0, U.value = void 0, d.value = [], f.value = [], y.value = {}, a.value === "sum" && !u.value) {
        s.value = !1;
        return;
      }
      const $ = await L(
        w.value[i.value]
      ), Q = await L(
        w.value[o.value]
      );
      g.value.fetchAggregateData(
        t.tableId,
        {
          id: o.value,
          column: Q
        },
        {
          id: i.value,
          column: $
        },
        t.graphqlFilter,
        a.value === "sum" ? "_sum" : "count",
        u.value
      ).then((ee) => {
        ee && ee[t.tableId + "_groupBy"] ? (ee[t.tableId + "_groupBy"].forEach(
          (te) => B(te)
        ), C.value = !f.value.length) : C.value = !0, s.value = !1;
      }).catch((ee) => {
        U.value = ee, s.value = !1;
      });
    }
    async function L($) {
      if ($.columnType.startsWith("ONTOLOGY"))
        return "name";
      if ($.columnType === "REFBACK") {
        const le = await g.value.getPrimaryKeyFields(
          t.schemaId,
          t.tableId
        );
        return `${$.refBackId} { ${le.join(",")} }`;
      }
      const Q = $.refSchemaId || t.schemaId, ee = $.refTableId || t.tableId, te = await g.value.getPrimaryKeyFields(Q, ee);
      if (te.length)
        return te.join(",");
      throw new Error(
        `Could not determine primary key for column ${$.id} in table ${ee}`
      );
    }
    function B($) {
      const Q = w.value[i.value], ee = w.value[o.value], te = N(ee, $), le = N(Q, $), V = a.value === "sum" ? $._sum[u.value] : $[a.value];
      y.value[le] ? y.value[le][te] = V : y.value[le] = { [te]: V }, f.value.includes(te) || f.value.push(te), d.value.includes(le) || d.value.push(le);
    }
    function N($, Q) {
      var te;
      const ee = Q[$.id];
      return ee ? $.columnType === "REFBACK" ? ((te = ee[$.refBackId]) == null ? void 0 : te.name) || "not specified" : (ee == null ? void 0 : ee.name) || "not specified" : "not specified";
    }
    function x() {
      var $;
      t.allColumns.length > 0 && (r.value = q(
        t.allColumns,
        t.canView
      )), ($ = r.value) != null && $.length && (o.value = r.value[0], i.value = r.value[1] || r.value[0], M());
    }
    function q($, Q) {
      return $.filter((ee) => ee.columnType.startsWith("REF") && Q || ee.columnType.startsWith("ONTOLOGY") || ee.columnType === "RADIO" && Q).map((ee) => ee.id);
    }
    return ($, Q) => {
      const ee = K("Spinner");
      return l(), c("div", null, [
        s.value ? (l(), F(ee, {
          key: 0,
          class: "m-3"
        })) : r.value.length === 0 ? (l(), c("div", Vw, " Not enough input to create an aggregate table. Need at least 1 column with permission that can be used as group by. ")) : (l(), c("div", jw, [
          p("div", Hw, [
            p("table", null, [
              p("tbody", null, [
                p("tr", null, [
                  Q[4] || (Q[4] = p("td", null, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3",
                      for: "aggregate-column-select"
                    }, " Column: ")
                  ], -1)),
                  p("td", null, [
                    T(En, {
                      class: "mb-0",
                      id: "aggregate-column-select",
                      modelValue: o.value,
                      "onUpdate:modelValue": [
                        Q[0] || (Q[0] = (te) => o.value = te),
                        M
                      ],
                      options: r.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                p("tr", null, [
                  Q[5] || (Q[5] = p("td", null, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0",
                      for: "aggregate-row-select"
                    }, " Row: ")
                  ], -1)),
                  p("td", null, [
                    T(En, {
                      class: "mb-2",
                      id: "aggregate-row-select",
                      modelValue: i.value,
                      "onUpdate:modelValue": [
                        Q[1] || (Q[1] = (te) => i.value = te),
                        M
                      ],
                      options: r.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                A.value.length ? (l(), c("tr", Gw, [
                  Q[6] || (Q[6] = p("td", { class: "align-top" }, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3 pt-0",
                      for: "aggregate-column-select"
                    }, " Aggregate function: ")
                  ], -1)),
                  p("td", null, [
                    T(Wa, {
                      id: "input-radio-2",
                      modelValue: a.value,
                      "onUpdate:modelValue": [
                        Q[2] || (Q[2] = (te) => a.value = te),
                        M
                      ],
                      options: ["count", "sum"],
                      isClearable: !1
                    }, null, 8, ["modelValue"])
                  ])
                ])) : v("", !0),
                a.value === "sum" ? (l(), c("tr", Qw, [
                  Q[7] || (Q[7] = p("td", { class: "align-top" }, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3 pt-0",
                      for: "aggregate-column-select"
                    }, " Summation field: ")
                  ], -1)),
                  p("td", null, [
                    T(En, {
                      class: "mb-2",
                      id: "aggregate-row-select",
                      modelValue: u.value,
                      "onUpdate:modelValue": [
                        Q[3] || (Q[3] = (te) => u.value = te),
                        M
                      ],
                      options: A.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])) : v("", !0)
              ])
            ])
          ]),
          U.value ? (l(), c("div", $w, E(U.value), 1)) : C.value ? (l(), c("div", Jw, " No results found ")) : (l(), F(xw, {
            key: 2,
            columns: f.value,
            rows: d.value,
            data: y.value,
            class: "mb-n3"
          }, {
            column: b((te) => [
              _(E(te.value), 1)
            ]),
            row: b((te) => [
              _(E(te.value), 1)
            ]),
            cell: b((te) => [
              te.value ? te.value < e.minimumValue ? (l(), c("div", Yw, "﹤" + E(e.minimumValue), 1)) : (l(), c("div", Ww, E(te.value), 1)) : (l(), c("div", zw, "-"))
            ]),
            _: 1
          }, 8, ["columns", "rows", "data"]))
        ]))
      ]);
    };
  }
}), Zw = {
  props: {
    row: Object,
    col: Object
  },
  components: {
    HyperlinkDisplay: rr,
    EmailDisplay: ir,
    FileDisplay: tl
  },
  methods: {
    applyJsTemplate: yo,
    getValue(e, n) {
      return this.getRefLabel(e) ? yo(n[e.id], this.getRefLabel(e)) : n[e.id];
    },
    getRefLabel(e) {
      return e.refLabel ? e.refLabel : e.refLabelDefault;
    }
  }
}, e0 = { key: 0 }, t0 = { key: 2 }, n0 = { key: 1 }, o0 = { key: 3 };
function i0(e, n, t, o, i, r) {
  const s = K("HyperlinkDisplay"), a = K("EmailDisplay"), u = K("FileDisplay");
  return t.row[t.col.id] && Array.isArray(t.row[t.col.id]) ? (l(), c("span", e0, [
    (l(!0), c(oe, null, ae(t.row[t.col.id], (d, f) => (l(), c("span", {
      key: f,
      class: "pr-1"
    }, [
      t.col.columnType === "HYPERLINK_ARRAY" ? (l(), F(s, {
        key: 0,
        data: d
      }, null, 8, ["data"])) : t.col.columnType === "EMAIL_ARRAY" ? (l(), F(a, {
        key: 1,
        data: d
      }, null, 8, ["data"])) : (l(), c("span", t0, E(r.getRefLabel(t.col) ? r.applyJsTemplate(d, r.getRefLabel(t.col)) : d), 1))
    ]))), 128))
  ])) : t.row[t.col.id] ? (l(), c("span", n0, [
    t.col.columnType === "HYPERLINK" ? (l(), F(s, {
      key: 0,
      data: t.row[t.col.id]
    }, null, 8, ["data"])) : t.col.columnType === "EMAIL" ? (l(), F(a, {
      key: 1,
      data: t.row[t.col.id]
    }, null, 8, ["data"])) : t.col.columnType === "FILE" ? (l(), F(u, {
      key: 2,
      data: t.row[t.col.id],
      metadata: t.col
    }, null, 8, ["data", "metadata"])) : (l(), c("span", o0, E(r.getValue(t.col, t.row)), 1))
  ])) : v("", !0);
}
const r0 = /* @__PURE__ */ D(Zw, [["render", i0]]), s0 = {
  components: {
    RenderValue: r0,
    RowButton: jt,
    VueTemplate: Mw
  },
  props: {
    columns: Array,
    tableId: String,
    row: Object,
    template: String,
    canEdit: Boolean
  },
  methods: {
    getKey(e) {
      let n = {};
      return this.columns.filter((t) => t.key == 1).map((t) => n[t.id] = e[t.id]), n;
    },
    showItem(e, n) {
      return n.showColumn && e[n.id] && n.id != "mg_tableclass";
    }
  }
}, a0 = { class: "card" }, l0 = { class: "card-text" }, u0 = { class: "float-right" }, d0 = { key: 1 }, c0 = {
  key: 0,
  class: "pr-3 pb-1"
}, f0 = {
  key: 1,
  class: "pl-3"
};
function p0(e, n, t, o, i, r) {
  const s = K("RowButton"), a = K("VueTemplate"), u = K("RenderValue");
  return l(), c("div", a0, [
    p("div", {
      class: "card-body",
      onClick: n[4] || (n[4] = (d) => e.$emit("click", t.row))
    }, [
      p("div", l0, [
        p("span", u0, [
          t.canEdit ? (l(), F(s, {
            key: 0,
            type: "edit",
            class: "d-inline",
            tableId: t.tableId,
            pkey: r.getKey(t.row),
            onClose: n[0] || (n[0] = (d) => e.$emit("reload")),
            onEdit: n[1] || (n[1] = (d) => e.$emit("edit", t.row))
          }, null, 8, ["tableId", "pkey"])) : v("", !0),
          t.canEdit ? (l(), F(s, {
            key: 1,
            type: "delete",
            class: "mt-0",
            tableId: t.tableId,
            pkey: r.getKey(t.row),
            onClose: n[2] || (n[2] = (d) => e.$emit("reload")),
            onDelete: n[3] || (n[3] = (d) => e.$emit("delete", t.row))
          }, null, 8, ["tableId", "pkey"])) : v("", !0)
        ]),
        t.template ? (l(), F(a, {
          key: 0,
          template: t.template,
          row: t.row
        }, null, 8, ["template", "row"])) : (l(), c("dl", d0, [
          (l(!0), c(oe, null, ae(t.columns, (d) => (l(), c(oe, {
            key: d.id
          }, [
            r.showItem(t.row, d) ? (l(), c(oe, { key: 0 }, [
              r.showItem(t.row, d) ? (l(), c("dt", c0, E(d.label), 1)) : v("", !0),
              r.showItem(t.row, d) ? (l(), c("dd", f0, [
                T(u, {
                  col: d,
                  row: t.row
                }, null, 8, ["col", "row"])
              ])) : v("", !0)
            ], 64)) : v("", !0)
          ], 64))), 128))
        ]))
      ])
    ])
  ]);
}
const h0 = /* @__PURE__ */ D(s0, [["render", p0], ["__scopeId", "data-v-bc109320"]]), m0 = Re({
  name: "RecordCards",
  components: { RowCard: h0 },
  props: {
    id: { type: String, required: !0 },
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    tableId: { type: String, required: !0 },
    canEdit: { type: Boolean, default: !1 },
    template: { type: String, required: !1 }
  }
}), A0 = {
  key: 0,
  class: "alert alert-warning"
};
function g0(e, n, t, o, i, r) {
  const s = K("RowCard");
  return l(), c("div", null, [
    e.data.length ? (l(!0), c(oe, { key: 1 }, ae(e.data, (a, u) => (l(), F(s, {
      key: e.id + "-" + u,
      row: a,
      columns: e.columns,
      tableId: e.tableId,
      "can-edit": e.canEdit,
      template: e.template,
      onReload: n[0] || (n[0] = (d) => e.$emit("reload")),
      onEdit: n[1] || (n[1] = (d) => e.$emit("edit", d)),
      onDelete: n[2] || (n[2] = (d) => e.$emit("delete", d)),
      onClick: n[3] || (n[3] = (d) => e.$emit("click", d))
    }, null, 8, ["row", "columns", "tableId", "can-edit", "template"]))), 128)) : (l(), c("div", A0, "No results found"))
  ]);
}
const y0 = /* @__PURE__ */ D(m0, [["render", g0]]), K0 = { class: "mb-4" }, v0 = { class: "ml-1" }, b0 = { class: "table table-sm mb-2" }, C0 = { class: "key border-right" }, w0 = ["onClick"], F0 = {
  key: 0,
  class: "text-black-50"
}, R0 = { key: 0 }, k0 = { key: 0 }, U0 = { key: 1 }, E0 = { key: 0 }, S0 = { key: 1 }, T0 = /* @__PURE__ */ Re({
  __name: "RefTable",
  props: {
    reference: {},
    tableId: {},
    schema: {},
    showDataOwner: { type: Boolean },
    startsCollapsed: { type: Boolean }
  },
  emits: ["refCellClicked"],
  setup(e, { emit: n }) {
    const t = e, { reference: o, startsCollapsed: i } = _n(t), r = n;
    let s = Te(() => f(o.value)), a = Te(() => Object.keys(s.value).length > 5);
    const u = Ae({});
    t.tableId && t.schema && nt.newClient(t.schema).convertRowToPrimaryKey(o.value, t.tableId).then((A) => {
      u.value = A;
    });
    let d = Ae(i.value && a.value);
    function f(g) {
      const A = { ...g };
      return delete A.mg_insertedBy, delete A.mg_insertedOn, delete A.mg_updatedBy, delete A.mg_updatedOn, delete A.mg_draft, delete A.metadata, A;
    }
    function y(g) {
      const A = o.value.metadata;
      if (C(A) && A.columns)
        return A.columns.find((w) => w.id === g) || {};
      throw "Error: Metadata for RefTable not found";
    }
    function C(g) {
      return g.id !== void 0;
    }
    function U(g) {
      var M;
      const A = o.value, w = (M = A.metadata.columns) == null ? void 0 : M.find((L) => L.id === g);
      w && go(w.columnType) && r("refCellClicked", {
        refColumn: w,
        refTableRow: A
      });
    }
    return (g, A) => (l(), c("div", K0, [
      p("h5", v0, [
        u.value ? (l(), F(or, {
          key: 0,
          data: u.value,
          metadata: ie(o).metadata,
          class: "mr-1"
        }, null, 8, ["data", "metadata"])) : v("", !0),
        ie(a) ? (l(), c("button", {
          key: 1,
          class: "btn p-0 m-0 btn-outline-primary border-0 ml-auto float-right",
          onClick: A[0] || (A[0] = (w) => ho(d) ? d.value = !ie(d) : d = !ie(d))
        }, [
          p("i", {
            class: G(`fas fa-fw fa-angle-${ie(d) ? "up" : "down"}`)
          }, null, 2)
        ])) : v("", !0)
      ]),
      p("div", null, [
        p("div", {
          class: G({ "collapsed-table": ie(d) })
        }, [
          p("table", b0, [
            (l(!0), c(oe, null, ae(ie(s), (w, M) => (l(), c("tr", null, [
              p("td", C0, E(M), 1),
              p("td", {
                onClick: (L) => U(M),
                class: G({
                  refType: ie(go)(y(M).columnType)
                })
              }, [
                T(nl, {
                  data: w,
                  metadata: y(M)
                }, null, 8, ["data", "metadata"])
              ], 10, w0)
            ]))), 256))
          ])
        ], 2),
        ie(d) ? (l(), c("div", {
          key: 0,
          class: "collapsed-tag border-top rounded-bottom mb-3",
          onClick: A[1] || (A[1] = (w) => ho(d) ? d.value = !1 : d = !1)
        }, [...A[2] || (A[2] = [
          p("small", { class: "px-3 link-color" }, " Show all records... ", -1)
        ])])) : v("", !0)
      ]),
      e.showDataOwner ? (l(), c("small", F0, [
        ie(o).mg_insertedBy ? (l(), c("div", R0, [
          _(" Inserted by '" + E(ie(o).mg_insertedBy) + "' ", 1),
          ie(o).mg_insertedOn ? (l(), c("span", k0, " On " + E(new Date(ie(o).mg_insertedOn).toLocaleString()), 1)) : v("", !0)
        ])) : v("", !0),
        ie(o).mg_updatedBy ? (l(), c("div", U0, [
          _(" Updated by '" + E(ie(o).mg_updatedBy) + "' ", 1),
          ie(o).mg_updatedOn ? (l(), c("span", E0, " On " + E(new Date(ie(o).mg_updatedOn).toLocaleString()), 1)) : v("", !0)
        ])) : v("", !0)
      ])) : v("", !0),
      ie(o).mg_draft ? (l(), c("div", S0, [...A[3] || (A[3] = [
        p("span", { class: "badge badge-secondary" }, "Draft", -1)
      ])])) : v("", !0)
    ]));
  }
}), I0 = /* @__PURE__ */ D(T0, [["__scopeId", "data-v-029d60a6"]]), D0 = {
  class: "modal-dialog modal-dialog-scrollable",
  role: "document"
}, O0 = { class: "modal-content" }, _0 = { class: "modal-header" }, M0 = { class: "modal-title" }, P0 = { class: "modal-body bg-light" }, B0 = { class: "modal-footer" }, L0 = /* @__PURE__ */ Re({
  __name: "SideModal",
  props: {
    label: {},
    isCloseButtonShown: { type: Boolean, default: !0 },
    isVisible: { type: Boolean, default: !0 }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = e, { isVisible: o } = _n(t);
    let i = Ae(!1);
    s(), mo(o, () => {
      s();
    });
    const r = n;
    jl(() => {
      document != null && document.addEventListener && document.addEventListener("keydown", a);
    }), Hl(() => {
      document != null && document.removeEventListener && document.removeEventListener("keydown", a);
    });
    function s() {
      setTimeout(() => {
        i.value = o.value;
      });
    }
    function a(d) {
      d.key === "Escape" && u();
    }
    function u() {
      i.value = !1, setTimeout(() => {
        r("onClose");
      }, 200);
    }
    return (d, f) => (l(), c("div", {
      class: G(["modal fade", { show: ie(i) }])
    }, [
      p("div", D0, [
        p("div", O0, [
          p("div", _0, [
            p("h5", M0, E(e.label), 1),
            e.isCloseButtonShown ? (l(), c("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: Ke(u, ["prevent"])
            }, [...f[0] || (f[0] = [
              p("span", { "aria-hidden": "true" }, "×", -1)
            ])])) : v("", !0)
          ]),
          p("div", P0, [
            j(d.$slots, "default", {}, void 0, !0)
          ]),
          p("div", B0, [
            j(d.$slots, "footer", { close: u }, void 0, !0)
          ])
        ])
      ])
    ], 2));
  }
}), N0 = /* @__PURE__ */ D(L0, [["__scopeId", "data-v-0cf264cb"]]), q0 = { key: 0 }, x0 = { key: 1 }, V0 = { key: 1 }, j0 = /* @__PURE__ */ Re({
  __name: "RefSideModal",
  props: {
    column: {},
    rows: { default: () => [] },
    schema: {},
    showDataOwner: { type: Boolean, default: !1 }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = e, { column: o, rows: i } = _n(t), r = n;
    let s = Ae(!0), a = Ae([]), u = Ae("");
    d(i.value, o.value.refTableId), mo([o, i], () => {
      d(i.value, o.value.refTableId);
    });
    async function d(U, g, A) {
      const w = A || o.value.refSchemaId || t.schema;
      w && g && (u.value = "", s.value = !0, a.value = await f(w, U, g), s.value = !1);
    }
    async function f(U, g, A) {
      let w = [];
      const M = nt.newClient(U), L = await M.fetchTableMetaData(A);
      for (const B of g) {
        const x = await Do(B, A, U);
        let q = await M.fetchRowData(A, x, 2).catch(C);
        q.metadata = L, w.push(q);
      }
      return w;
    }
    async function y({
      refColumn: U,
      refTableRow: g
    }) {
      const A = U.refTableId, w = U.refSchemaId || o.value.refSchemaId || t.schema;
      if (A && w) {
        const M = [g[U.id]].flat();
        d(M, A, w);
      } else
        u.value = "Failed to load reference data";
    }
    function C(U) {
      u.value = `Failed to load reference data, because: ${U.message}`;
    }
    return (U, g) => (l(), F(N0, {
      label: ie(o).label,
      isVisible: !0,
      onOnClose: g[0] || (g[0] = (A) => r("onClose"))
    }, {
      footer: b((A) => [
        T(He, {
          onClick: (w) => A.close()
        }, {
          default: b(() => [...g[1] || (g[1] = [
            _("Close", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: b(() => [
        ie(s) ? (l(), c("div", q0, [
          T(yt)
        ])) : (l(), c("div", x0, [
          ie(u) ? (l(), F(it, { key: 0 }, {
            default: b(() => [
              _(E(ie(u)), 1)
            ]),
            _: 1
          })) : v("", !0),
          ie(a).length ? v("", !0) : (l(), c("div", V0, " The selected reference was not found in the database ")),
          (l(!0), c(oe, null, ae(ie(a), (A) => (l(), c("div", null, [
            T(I0, {
              reference: A,
              showDataOwner: e.showDataOwner,
              startsCollapsed: ie(a).length > 1,
              tableId: ie(o).refTableId,
              schemaId: ie(o).refSchemaId || t.schema,
              onRefCellClicked: y
            }, null, 8, ["reference", "showDataOwner", "startsCollapsed", "tableId", "schemaId"])
          ]))), 256))
        ]))
      ]),
      _: 1
    }, 8, ["label"]));
  }
}), H0 = {
  components: {
    IconAction: ct,
    ButtonAlt: ot,
    LayoutModal: Kt
  },
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expand: !1
    };
  },
  methods: {
    flattenObject: on,
    deselect(e) {
      let n = this.selection;
      n.splice(e, 1), this.$emit("update:selection", n);
    },
    clear() {
      let e = this.selection;
      e.splice(0, e.length), this.$emit("update:selection", e);
    },
    toggle() {
      this.expand = !this.expand;
    }
  },
  emits: ["update:selection"]
}, G0 = {
  key: 0,
  class: "badge badge-pill badge-danger",
  style: { top: "-7px", left: "-7px" }
}, Q0 = { key: 0 };
function $0(e, n, t, o, i, r) {
  const s = K("ButtonAlt"), a = K("IconAction"), u = K("LayoutModal");
  return l(), c("div", null, [
    T(s, { onClick: r.toggle }, {
      default: b(() => [
        n[1] || (n[1] = _(" Selection ", -1)),
        n[2] || (n[2] = p("i", { class: "fa fa-lg fa-check-square-o" }, null, -1)),
        t.selection && t.selection.filter((d) => d != null).length > 0 ? (l(), c("span", G0, E(Array.isArray(t.selection) ? t.selection.filter((d) => d != null).length : 0), 1)) : v("", !0)
      ]),
      _: 1
    }, 8, ["onClick"]),
    i.expand ? (l(), F(u, {
      key: 0,
      onClose: n[0] || (n[0] = (d) => i.expand = !1),
      title: "Show selection"
    }, {
      body: b(() => [
        !Array.isArray(t.selection) || t.selection.filter((d) => d != null).length == 0 ? (l(), c("span", Q0, " No items selected ")) : (l(!0), c(oe, { key: 1 }, ae(t.selection.filter((d) => d != null), (d, f) => (l(), c("span", {
          class: "btn-outline-primary btn-sm mr-2",
          key: JSON.stringify(d)
        }, [
          _(E(r.flattenObject(d)) + " ", 1),
          T(a, {
            icon: "times",
            onClick: (y) => r.deselect(f)
          }, null, 8, ["onClick"])
        ]))), 128))
      ]),
      footer: b(() => [
        Array.isArray(t.selection) && t.selection.length > 0 ? (l(), F(s, {
          key: 0,
          onClick: r.clear
        }, {
          default: b(() => [...n[3] || (n[3] = [
            _(" clear selection ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : v("", !0)
      ]),
      _: 1
    })) : v("", !0)
  ]);
}
const J0 = /* @__PURE__ */ D(H0, [["render", $0]]), z0 = {
  components: { ButtonAlt: ot, ButtonDropdown: fr, IconAction: ct },
  props: {
    label: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    },
    columns: Array,
    exclude: {
      type: Array,
      default: () => []
    },
    checkAttribute: String,
    defaultValue: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    value(e) {
      return e[this.checkAttribute] == null ? this.defaultValue : e[this.checkAttribute];
    },
    change(e, n) {
      let t = JSON.parse(JSON.stringify(this.columns));
      t[e][this.checkAttribute] = n, this.$emit("update:columns", t);
    },
    hideAll(e) {
      let n = JSON.parse(JSON.stringify(this.columns));
      for (var t in n)
        (e && !n[t].id.startsWith("mg_") || !e && n[t].id.startsWith("mg_")) && (n[t][this.checkAttribute] = !1);
      this.$emit("update:columns", n);
    },
    showAll(e) {
      let n = JSON.parse(JSON.stringify(this.columns));
      for (var t in n)
        (e && !n[t].id.startsWith("mg_") || !e && n[t].id.startsWith("mg_")) && (n[t][this.checkAttribute] = !0);
      this.$emit("update:columns", n);
    }
  },
  emits: ["update:columns"]
}, Y0 = {
  class: "px-4 py-3",
  style: { "min-width": "15rem" }
}, W0 = { key: 0 }, X0 = {
  key: 0,
  class: "ml-0"
}, Z0 = {
  key: 1,
  class: "form-check"
}, eF = ["checked", "onInput", "id"], tF = ["for"];
function nF(e, n, t, o, i, r) {
  const s = K("IconAction"), a = K("ButtonAlt"), u = K("ButtonDropdown");
  return l(), F(u, {
    icon: t.icon,
    label: t.label
  }, {
    default: b((d) => [
      p("form", Y0, [
        T(s, {
          icon: "times",
          onClick: d.close,
          class: "float-right"
        }, null, 8, ["onClick"]),
        p("h6", null, E(t.label), 1),
        p("b", null, [
          n[6] || (n[6] = _(" data ( ", -1)),
          T(a, {
            class: "pl-0",
            onClick: n[0] || (n[0] = (f) => r.showAll(!0))
          }, {
            default: b(() => [...n[4] || (n[4] = [
              _("all", -1)
            ])]),
            _: 1
          }),
          T(a, {
            class: "p-0",
            onClick: n[1] || (n[1] = (f) => r.hideAll(!0))
          }, {
            default: b(() => [...n[5] || (n[5] = [
              _("none", -1)
            ])]),
            _: 1
          }),
          n[7] || (n[7] = _(" ) ", -1))
        ]),
        (l(!0), c(oe, null, ae(t.columns, (f, y) => (l(), c("div", { key: y }, [
          t.exclude.length == 0 || !t.exclude.includes(f.columnType) ? (l(), c("span", W0, [
            f.id == "mg_draft" ? (l(), c("b", X0, [
              n[10] || (n[10] = _(" metadata ( ", -1)),
              T(a, {
                class: "pl-0",
                onClick: n[2] || (n[2] = (C) => r.showAll(!1))
              }, {
                default: b(() => [...n[8] || (n[8] = [
                  _("all", -1)
                ])]),
                _: 1
              }),
              T(a, {
                class: "p-0",
                onClick: n[3] || (n[3] = (C) => r.hideAll(!1))
              }, {
                default: b(() => [...n[9] || (n[9] = [
                  _("none", -1)
                ])]),
                _: 1
              }),
              n[11] || (n[11] = _(" ) ", -1))
            ])) : v("", !0),
            f.columnType != "HEADING" ? (l(), c("div", Z0, [
              p("input", {
                class: "form-check-input",
                type: "checkbox",
                checked: f[t.checkAttribute] == null ? t.defaultValue : f[t.checkAttribute],
                onInput: Ke((C) => r.change(y, !f[t.checkAttribute]), ["prevent"]),
                id: f.id
              }, null, 40, eF),
              p("label", {
                class: "form-check-label",
                for: f.id
              }, E(f.label), 9, tF)
            ])) : v("", !0)
          ])) : v("", !0)
        ]))), 128))
      ])
    ]),
    _: 1
  }, 8, ["icon", "label"]);
}
const oF = /* @__PURE__ */ D(z0, [["render", nF]]), iF = {
  name: "TableSettings",
  components: {
    Spinner: yt,
    MessageError: it,
    MessageSuccess: pn,
    IconAction: ct,
    InputText: Vn,
    ButtonAction: He,
    LayoutModal: Kt,
    ButtonAlt: ot
  },
  props: {
    schemaId: {
      type: String,
      required: !1
    },
    tableMetadata: { type: Object, required: !0 }
  },
  data() {
    return {
      show: !1,
      graphqlError: null,
      success: null,
      loading: !1
    };
  },
  computed: {
    cardTemplate() {
      var e;
      return (e = this.tableMetadata.settings) == null ? void 0 : e.filter((n) => n.key === "cardTemplate").map((n) => n.value)[0];
    },
    recordTemplate() {
      var e;
      return (e = this.tableMetadata.settings) == null ? void 0 : e.filter((n) => n.key === "recordTemplate").map((n) => n.value)[0];
    }
  },
  methods: {
    emitCardTemplate(e) {
      this.tableMetadata.settings || (this.tableMetadata.settings = []), this.tableMetadata.settings = this.tableMetadata.settings.filter(
        (n) => n.key !== "cardTemplate"
      ), this.tableMetadata.settings.push({ key: "cardTemplate", value: e });
    },
    emitRecordTemplate(e) {
      this.tableMetadata.settings || (this.tableMetadata.settings = []), this.tableMetadata.settings = this.tableMetadata.settings.filter(
        (n) => n.key !== "recordTemplate"
      ), this.tableMetadata.settings.push({ key: "recordTemplate", value: e });
    },
    async saveSettings() {
      this.loading = !0, this.graphqlError = null, this.success = null;
      const e = this.tableMetadata.settings.map((t) => ({
        tableId: this.tableMetadata.id,
        key: t.key,
        value: t.value
      })), n = await Be(
        this.schemaId ? "/" + this.schemaId + "/graphql" : "graphql",
        "mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}",
        { settings: e }
      ).catch((t) => {
        this.graphqlError = t.errors[0].message;
      });
      this.success = n.change.message, this.loading = !1, this.$emit("update:settings");
    }
  },
  created() {
    this.tableMetadata && !this.tableMetadata.settings && (this.tableMetadata.settings = []);
  },
  emits: ["update:settings"]
}, rF = { key: 3 };
function sF(e, n, t, o, i, r) {
  const s = K("IconAction"), a = K("MessageSuccess"), u = K("MessageError"), d = K("Spinner"), f = K("InputText"), y = K("ButtonAlt"), C = K("ButtonAction"), U = K("LayoutModal");
  return i.show ? (l(), F(U, {
    key: 1,
    title: "Table Settings",
    onClose: n[2] || (n[2] = (g) => i.show = !1),
    show: i.show
  }, {
    body: b(() => [
      i.success ? (l(), F(a, { key: 0 }, {
        default: b(() => [
          _(E(i.success), 1)
        ]),
        _: 1
      })) : v("", !0),
      i.graphqlError ? (l(), F(u, { key: 1 }, {
        default: b(() => [
          _(E(i.graphqlError), 1)
        ]),
        _: 1
      })) : v("", !0),
      i.loading ? (l(), F(d, { key: 2 })) : (l(), c("form", rF, [
        n[5] || (n[5] = p("p", null, [
          _(" The data is in variable 'row'. For example, "),
          p("tt", null, "{{ row }}"),
          _(" will show all values available. "),
          p("tt", null, "{{ row.name }}"),
          _(" will get the 'name' column ")
        ], -1)),
        T(f, {
          id: "table-settings-card-template",
          name: "cardTemplate",
          label: "cardTemplate",
          modelValue: r.cardTemplate,
          "onUpdate:modelValue": r.emitCardTemplate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        T(f, {
          id: "table-settings-record-template",
          name: "recordTemplate",
          label: "recordTemplate",
          modelValue: r.recordTemplate,
          "onUpdate:modelValue": r.emitRecordTemplate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        T(y, {
          onClick: n[1] || (n[1] = (g) => i.show = !1)
        }, {
          default: b(() => [...n[3] || (n[3] = [
            _("Close", -1)
          ])]),
          _: 1
        }),
        T(C, { onClick: r.saveSettings }, {
          default: b(() => [...n[4] || (n[4] = [
            _("Save settings", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]))
    ]),
    _: 1
  }, 8, ["show"])) : (l(), F(s, {
    key: 0,
    icon: "cog",
    onClick: n[0] || (n[0] = (g) => i.show = !0)
  }));
}
const aF = /* @__PURE__ */ D(iF, [["render", sF]]), lF = Re({
  name: "SubTask",
  props: {
    task: {
      type: Object,
      required: !0
    }
  },
  computed: {
    color() {
      switch (this.task.status) {
        case "COMPLETED":
          return "text-success";
        case "ERROR":
          return "text-danger";
        case "WARNING":
          return "text-warning";
        case "SKIPPED":
          return "text-muted";
        default:
          return "text-primary";
      }
    },
    icon() {
      switch (this.task.status) {
        case "COMPLETED":
          return "fa-check";
        case "ERROR":
          return "fa-times";
        case "WARNING":
          return "fa-exclamation-circle";
        case "SKIPPED":
          return "fa-check";
        case "RUNNING":
          return "fa-spinner fa-spin";
        default:
          return "fa-question";
      }
    }
  }
}), uF = { class: "fa-ul" };
function dF(e, n, t, o, i, r) {
  const s = K("SubTask", !0);
  return l(), c("ul", uF, [
    e.task ? (l(), c("li", {
      key: 0,
      class: G(e.color)
    }, [
      p("i", {
        class: G(["fa-li fa", e.icon])
      }, null, 2),
      _(" " + E(e.task.description) + " ", 1),
      (l(!0), c(oe, null, ae(e.task.subTasks, (a, u) => (l(), F(s, {
        task: a,
        key: u
      }, null, 8, ["task"]))), 128))
    ], 2)) : v("", !0)
  ]);
}
const cF = /* @__PURE__ */ D(lF, [["render", dF]]), fF = Re({
  name: "Task",
  components: {
    SubTask: cF,
    Spinner: yt
  },
  props: {
    taskId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      task: null,
      loading: !0,
      error: !1
    };
  },
  methods: {
    async startMonitorTask() {
      for (; !this.error && !this.task || this.task && !["COMPLETED", "ERROR"].includes(this.task.status); ) {
        const e = `{
          _tasks(id:"${this.taskId}")
          {
            id, description, status, subTasks
            {
              id, description, status, subTasks
              {
                id, description, status, subTasks
                {
                  id, description, status, subTasks
                    {
                      id, description, status
                    }
                }
              }
            }
          }
        }`;
        Be("graphql", e).then((n) => {
          this.task = n._tasks[0], this.$emit("taskUpdated", this.task), this.loading = !1;
        }).catch((n) => {
          console.log(JSON.stringify(n)), this.error = n, this.loading = !1;
        }), await pF(500);
      }
    }
  },
  created() {
    this.startMonitorTask();
  }
});
function pF(e) {
  return new Promise((n) => setTimeout(n, e));
}
const hF = { key: 2 };
function mF(e, n, t, o, i, r) {
  const s = K("Spinner"), a = K("SubTask");
  return l(), c("div", null, [
    e.loading ? (l(), F(s, { key: 0 })) : e.task ? (l(), F(a, {
      key: 1,
      task: e.task
    }, null, 8, ["task"])) : (l(), c("span", hF, "Task with id = '" + E(e.taskId) + "' not found", 1))
  ]);
}
const yl = /* @__PURE__ */ D(fF, [["render", mF]]), Bt = {
  TABLE: "table",
  CARDS: "cards",
  RECORD: "record",
  AGGREGATE: "aggregate"
}, AF = {
  table: { id: Bt.TABLE, label: "Table", icon: "th" },
  cards: { id: Bt.CARDS, label: "Card", icon: "list-alt" },
  record: {
    id: Bt.RECORD,
    label: "Record",
    icon: "th-list",
    limitOverride: 1
  },
  aggregate: {
    id: Bt.AGGREGATE,
    label: "Aggregate",
    icon: "object-group"
  }
}, gF = {
  name: "TableExplorer",
  components: {
    LayoutModal: Kt,
    Task: yl,
    ShowHide: oF,
    Pagination: ol,
    ButtonAlt: ot,
    ButtonDropdown: fr,
    IconAction: ct,
    IconDanger: nr,
    InputSearch: ar,
    InputSelect: En,
    MessageError: it,
    SelectionBox: J0,
    Spinner: yt,
    TableMolgenis: sr,
    FilterSidebar: qK,
    FilterWells: $K,
    RecordCards: y0,
    RowButton: jt,
    TableSettings: aF,
    EditModal: pr,
    ConfirmModal: lr,
    AggregateTable: Xw,
    RefSideModal: j0
  },
  data() {
    return {
      cardTemplate: "",
      client: null,
      columns: [],
      count: 0,
      dataRows: [],
      editMode: "add",
      // add, edit, clone
      editRowPrimaryKey: void 0,
      graphqlError: "",
      taskId: String,
      taskDone: !1,
      success: !1,
      isDeleteAllModalShown: !1,
      isTaskModalShown: !1,
      isDeleteModalShown: !1,
      isEditModalShown: !1,
      limit: this.showLimit,
      loading: !1,
      order: this.showOrder,
      orderByColumn: this.showOrderBy,
      page: this.showPage,
      recordTemplate: "",
      searchTerms: "",
      selectedItems: [],
      tableMetadata: null,
      view: this.canView ? this.showView : Bt.AGGREGATE,
      refSideModalProps: void 0
    };
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      default: () => ""
    },
    showSelect: {
      type: Boolean,
      default: () => !1
    },
    showHeader: {
      type: Boolean,
      default: () => !0
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    },
    showView: {
      type: String,
      default: Bt.TABLE
    },
    showPage: {
      type: Number,
      default: 1
    },
    showLimit: {
      type: Number,
      default: 10
    },
    urlConditions: {
      type: Object,
      default: () => ({})
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    showOrderBy: {
      type: String,
      required: !1
    },
    showOrder: {
      type: String,
      default: () => "ASC"
    },
    canView: {
      type: Boolean,
      default: () => !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    canManage: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    View() {
      return Bt;
    },
    ViewButtons() {
      return AF;
    },
    filterCount() {
      var e;
      return ((e = this.columns) == null ? void 0 : e.filter((n) => n.showFilter).length) || 0;
    },
    graphqlFilter() {
      let e = this.filter;
      const n = (t) => {
        this.graphqlError = t;
      };
      return Hd(e, this.columns, n);
    },
    rowsWithComputed() {
      return this.tableMetadata ? ya(this.dataRows, this.tableMetadata) : [];
    }
  },
  methods: {
    convertRowToPrimaryKey: Yt,
    setSearchTerms(e) {
      this.searchTerms = e, this.$emit("searchTerms", e), this.reload();
    },
    taskUpdated(e) {
      ["COMPLETED", "ERROR"].includes(e.status) && (this.success = !0, this.taskDone = !0, this.reload());
    },
    async handleRowAction(e, n) {
      this.editMode = e, this.editRowPrimaryKey = await n, this.isEditModalShown = !0;
    },
    handleModalClose() {
      this.isEditModalShown = !1, this.reload();
    },
    async handleDeleteRowRequest(e) {
      this.editRowPrimaryKey = await e, this.isDeleteModalShown = !0;
    },
    async handleExecuteDelete() {
      var n;
      this.isDeleteModalShown = !1, await ((n = this.client) == null ? void 0 : n.deleteRow(this.editRowPrimaryKey, this.tableId).catch(this.handleError)) && this.reload();
    },
    async handelExecuteDeleteAll() {
      var e;
      await this.client.deleteAllTableData((e = this.tableMetadata) == null ? void 0 : e.id).then((n) => {
        n.data.data.truncate.taskId ? (this.taskId = n.data.data.truncate.taskId, this.isTaskModalShown = !0, this.isDeleteAllModalShown = !1) : (this.success = n.data.data.truncate.message, this.loading = !1);
      }).catch((n) => {
        this.isDeleteAllModalShown = !1, this.handleError(n);
      });
    },
    handleCellClick(e) {
      const { column: n, cellValue: t } = e, o = [t].flat();
      go(n == null ? void 0 : n.columnType) && (this.refSideModalProps = {
        column: n,
        rows: o
      });
    },
    setView(e) {
      this.view = e.id, e.limitOverride ? this.limit = e.limitOverride : this.limit = this.showLimit, this.page = 1, this.$emit("updateShowView", e.id, this.limit), this.reload();
    },
    onColumnClick(e) {
      const n = this.orderByColumn;
      let t = this.order;
      n !== e.id ? t = "ASC" : t === "ASC" ? t = "DESC" : t = "ASC", this.order = t, this.orderByColumn = e.id, this.$emit("updateShowOrder", {
        direction: t,
        column: e.id
      }), this.reload();
    },
    emitColumns(e) {
      this.columns = e, this.$emit("updateShowColumns", Rs(this.columns, "showColumn"));
    },
    emitFilters(e) {
      this.columns = e, this.$emit("updateShowFilters", Rs(e, "showFilter"));
    },
    emitConditions() {
      this.page = 1, this.$emit("updateConditions", this.columns), this.reload();
    },
    setPage(e) {
      this.page = e, this.$emit("updateShowPage", e), this.reload();
    },
    setLimit(e) {
      this.limit = parseInt(e), (!Number.isInteger(this.limit) || this.limit < 1) && (this.limit = 20), this.page = 1, this.$emit("updateShowLimit", e), this.reload();
    },
    handleError(e) {
      var n, t;
      Array.isArray((t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : t.errors) ? this.graphqlError = e.response.data.errors[0].message : this.graphqlError = e, this.loading = !1;
    },
    setTableMetadata(e) {
      var n;
      this.columns = e.columns.map((t) => {
        const o = this.showColumns.length ? this.showColumns.includes(t.id) : !t.id.startsWith("mg_"), i = yF(
          t.columnType,
          this.urlConditions[t.id]
        );
        return {
          ...t,
          showColumn: o,
          showFilter: this.showFilters.includes(t.id),
          conditions: i
        };
      }), (n = e.settings) == null || n.forEach((t) => {
        t.key === "cardTemplate" ? this.cardTemplate = t.value : t.key === "recordTemplate" && (this.recordTemplate = t.value);
      }), this.tableMetadata = e;
    },
    async reloadMetadata() {
      this.client = nt.newClient(this.schemaId);
      const e = await this.client.fetchTableMetaData(this.tableId).catch(this.handleError);
      this.setTableMetadata(e), this.canView && this.reload();
    },
    async reload() {
      this.loading = !0, this.graphqlError = "";
      const e = this.limit * (this.page - 1), n = this.orderByColumn ? { [this.orderByColumn]: this.order } : {}, t = await this.client.fetchTableData(this.tableId, {
        limit: this.limit,
        offset: e,
        filter: this.graphqlFilter,
        searchTerms: this.searchTerms,
        orderby: n
      }).catch(this.handleError);
      this.dataRows = t[this.tableId], this.count = t[this.tableId + "_agg"].count, this.loading = !1;
    }
  },
  mounted: async function() {
    await this.reloadMetadata();
  },
  emits: [
    "updateShowFilters",
    "rowClick",
    "updateShowLimit",
    "updateShowPage",
    "updateConditions",
    "updateShowColumns",
    "updateShowOrder",
    "updateShowView",
    "searchTerms"
  ]
};
function Rs(e, n) {
  return e.filter(
    (t) => t[n] && t.columnType !== "HEADING" && t.columnType !== "SECTION"
  ).map((t) => t.id);
}
function yF(e, n) {
  if (n)
    switch (e) {
      case "REF":
      case "REF_ARRAY":
      case "REFBACK":
      case "ONTOLOGY":
      case "ONTOLOGY_ARRAY":
      case "RADIO":
      case "SELECT":
      case "MULTISELECT":
      case "CHECKBOX":
        return JSON.parse(n);
      case "DATE":
      case "DATETIME":
      case "INT":
      case "LONG":
      case "DECIMAL":
        return n.split(",").map((t) => t.split(".."));
      default:
        return n.split(",");
    }
  else
    return [];
}
const KF = { key: 0 }, vF = { key: 1 }, bF = { key: 2 }, CF = { class: "btn-toolbar mb-3" }, wF = { class: "btn-group" }, FF = {
  class: "px-4 py-3",
  style: { "min-width": "15rem" }
}, RF = { key: 0 }, kF = { key: 0 }, UF = { key: 2 }, EF = ["onClick"], SF = {
  key: 2,
  class: "btn-group m-0"
}, TF = {
  key: 3,
  class: "btn-group"
}, IF = { class: "d-flex" }, DF = {
  key: 0,
  class: "col-3 pl-0"
}, OF = { key: 0 }, _F = { key: 1 };
function MF(e, n, t, o, i, r) {
  const s = K("MessageError"), a = K("ShowHide"), u = K("IconAction"), d = K("ButtonAlt"), f = K("ButtonDropdown"), y = K("InputSearch"), C = K("Pagination"), U = K("InputSelect"), g = K("SelectionBox"), A = K("TableSettings"), w = K("IconDanger"), M = K("FilterSidebar"), L = K("FilterWells"), B = K("Spinner"), N = K("AggregateTable"), x = K("RecordCards"), q = K("RowButton"), Y = K("TableMolgenis"), $ = K("EditModal"), Q = K("ConfirmModal"), ee = K("Task"), te = K("LayoutModal"), le = K("RefSideModal");
  return i.tableMetadata ? (l(), c("div", KF, [
    i.graphqlError ? (l(), F(s, { key: 0 }, {
      default: b(() => [
        _(E(i.graphqlError), 1)
      ]),
      _: 1
    })) : v("", !0),
    t.showHeader && i.tableMetadata ? (l(), c("h1", vF, E(i.tableMetadata.label), 1)) : v("", !0),
    t.showHeader && i.tableMetadata ? (l(), c("p", bF, E(i.tableMetadata.label), 1)) : v("", !0),
    p("div", CF, [
      p("div", wF, [
        T(a, {
          columns: i.columns,
          "onUpdate:columns": r.emitFilters,
          checkAttribute: "showFilter",
          exclude: ["HEADING", "FILE", "SECTION"],
          label: "filters",
          icon: "filter"
        }, null, 8, ["columns", "onUpdate:columns"]),
        i.view !== r.View.AGGREGATE ? (l(), F(a, {
          key: 0,
          columns: i.columns,
          "onUpdate:columns": r.emitColumns,
          checkAttribute: "showColumn",
          exclude: ["HEADING", "SECTION"],
          label: "columns",
          icon: "columns",
          id: "showColumn",
          defaultValue: !0
        }, null, 8, ["columns", "onUpdate:columns"])) : v("", !0),
        t.canView ? (l(), F(f, {
          key: 1,
          label: "download",
          icon: "download"
        }, {
          default: b((V) => [
            p("form", FF, [
              T(u, {
                icon: "times",
                onClick: V.close,
                class: "float-right"
              }, null, 8, ["onClick"]),
              n[33] || (n[33] = p("h6", null, "download", -1)),
              p("div", null, [
                p("div", null, [
                  n[20] || (n[20] = p("span", { class: "fixed-width" }, "zip", -1)),
                  T(d, {
                    href: "/" + t.schemaId + "/api/zip/" + t.tableId
                  }, {
                    default: b(() => [...n[19] || (n[19] = [
                      _(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ]),
                p("div", null, [
                  n[24] || (n[24] = p("span", { class: "fixed-width" }, "csv", -1)),
                  T(d, {
                    href: "/" + t.schemaId + "/api/csv/" + t.tableId
                  }, {
                    default: b(() => [...n[21] || (n[21] = [
                      _(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"]),
                  Object.keys(r.graphqlFilter).length > 0 ? (l(), c("span", RF, [
                    n[23] || (n[23] = _(" | ", -1)),
                    T(d, {
                      href: "/" + t.schemaId + "/api/csv/" + t.tableId + "?filter=" + JSON.stringify(r.graphqlFilter)
                    }, {
                      default: b(() => [...n[22] || (n[22] = [
                        _(" filtered rows ", -1)
                      ])]),
                      _: 1
                    }, 8, ["href"])
                  ])) : v("", !0)
                ]),
                p("div", null, [
                  n[28] || (n[28] = p("span", { class: "fixed-width" }, "excel", -1)),
                  T(d, {
                    href: "/" + t.schemaId + "/api/excel/" + t.tableId
                  }, {
                    default: b(() => [...n[25] || (n[25] = [
                      _("all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"]),
                  Object.keys(r.graphqlFilter).length > 0 ? (l(), c("span", kF, [
                    n[27] || (n[27] = _(" | ", -1)),
                    T(d, {
                      href: "/" + t.schemaId + "/api/excel/" + t.tableId + "?filter=" + JSON.stringify(r.graphqlFilter)
                    }, {
                      default: b(() => [...n[26] || (n[26] = [
                        _(" filtered rows ", -1)
                      ])]),
                      _: 1
                    }, 8, ["href"])
                  ])) : v("", !0)
                ]),
                p("div", null, [
                  n[30] || (n[30] = p("span", { class: "fixed-width" }, "jsonld", -1)),
                  T(d, {
                    href: "/" + t.schemaId + "/api/jsonld/" + t.tableId
                  }, {
                    default: b(() => [...n[29] || (n[29] = [
                      _(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ]),
                p("div", null, [
                  n[32] || (n[32] = p("span", { class: "fixed-width" }, "ttl", -1)),
                  T(d, {
                    href: "/" + t.schemaId + "/api/ttl/" + t.tableId
                  }, {
                    default: b(() => [...n[31] || (n[31] = [
                      _(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ])
              ])
            ])
          ]),
          _: 1
        })) : v("", !0),
        t.canView ? (l(), c("span", UF, [
          T(f, {
            closeOnClick: !0,
            label: r.ViewButtons[i.view].label,
            icon: r.ViewButtons[i.view].icon
          }, {
            default: b(() => [
              (l(!0), c(oe, null, ae(r.ViewButtons, (V) => (l(), c("div", {
                class: "dropdown-item",
                onClick: (Se) => r.setView(V),
                role: "button"
              }, [
                p("i", {
                  class: G(["fas fa-fw", "fa-" + V.icon])
                }, null, 2),
                _(" " + E(V.label), 1)
              ], 8, EF))), 256))
            ]),
            _: 1
          }, 8, ["label", "icon"])
        ])) : v("", !0)
      ]),
      t.canView ? (l(), F(y, {
        key: 0,
        class: "mx-1 inline-form-group",
        id: "explorer-table-search" + Date.now(),
        modelValue: i.searchTerms,
        "onUpdate:modelValue": n[0] || (n[0] = (V) => r.setSearchTerms(V))
      }, null, 8, ["id", "modelValue"])) : v("", !0),
      i.view !== r.View.AGGREGATE ? (l(), F(C, {
        key: 1,
        modelValue: i.page,
        "onUpdate:modelValue": n[1] || (n[1] = (V) => r.setPage(V)),
        limit: i.limit,
        count: i.count
      }, null, 8, ["modelValue", "limit", "count"])) : v("", !0),
      i.view !== r.View.RECORD && i.view !== r.View.AGGREGATE ? (l(), c("div", SF, [
        n[34] || (n[34] = p("span", { class: "btn" }, "Rows per page:", -1)),
        T(U, {
          id: "explorer-table-page-limit-select",
          modelValue: i.limit,
          options: [10, 20, 50, 100],
          clear: !1,
          required: !0,
          "onUpdate:modelValue": n[2] || (n[2] = (V) => r.setLimit(V)),
          class: "mb-0"
        }, null, 8, ["modelValue"]),
        t.showSelect ? (l(), F(g, {
          key: 0,
          selection: i.selectedItems,
          "onUpdate:selection": n[3] || (n[3] = (V) => i.selectedItems = V)
        }, null, 8, ["selection"])) : v("", !0)
      ])) : v("", !0),
      t.canManage ? (l(), c("div", TF, [
        i.tableMetadata ? (l(), F(A, {
          key: 0,
          tableMetadata: i.tableMetadata,
          schemaId: t.schemaId,
          "onUpdate:settings": r.reloadMetadata
        }, null, 8, ["tableMetadata", "schemaId", "onUpdate:settings"])) : v("", !0),
        T(w, {
          icon: "bomb",
          onClick: n[4] || (n[4] = (V) => i.isDeleteAllModalShown = !0)
        }, {
          default: b(() => [...n[35] || (n[35] = [
            _(" Delete All ", -1)
          ])]),
          _: 1
        })
      ])) : v("", !0)
    ]),
    p("div", IF, [
      r.filterCount ? (l(), c("div", DF, [
        T(M, {
          filters: i.columns,
          onUpdateFilters: r.emitConditions,
          schemaId: t.schemaId
        }, null, 8, ["filters", "onUpdateFilters", "schemaId"])
      ])) : v("", !0),
      p("div", {
        class: G(["flex-grow-1 pr-0 pl-0", r.filterCount ? "col-9" : "col-12"])
      }, [
        T(L, {
          filters: i.columns,
          onUpdateFilters: r.emitConditions,
          class: "border-top pt-3 pb-3"
        }, null, 8, ["filters", "onUpdateFilters"]),
        i.loading ? (l(), c("div", OF, [
          T(B)
        ])) : v("", !0),
        i.loading ? v("", !0) : (l(), c("div", _F, [
          i.view === r.View.AGGREGATE ? (l(), F(N, {
            key: 0,
            canView: t.canView,
            allColumns: i.columns,
            tableId: t.tableId,
            schemaId: t.schemaId,
            minimumValue: 1,
            graphqlFilter: r.graphqlFilter
          }, null, 8, ["canView", "allColumns", "tableId", "schemaId", "graphqlFilter"])) : v("", !0),
          i.view === r.View.CARDS ? (l(), F(x, {
            key: 1,
            class: "card-columns",
            id: "cards",
            data: r.rowsWithComputed,
            columns: i.columns,
            tableId: t.tableId,
            canEdit: t.canEdit,
            template: i.cardTemplate,
            onClick: n[5] || (n[5] = (V) => e.$emit("rowClick", V)),
            onReload: r.reload,
            onEdit: n[6] || (n[6] = (V) => r.handleRowAction(
              "edit",
              r.convertRowToPrimaryKey(V, i.tableMetadata.id, t.schemaId)
            )),
            onDelete: n[7] || (n[7] = (V) => r.handleDeleteRowRequest(
              r.convertRowToPrimaryKey(V, i.tableMetadata.id, t.schemaId)
            ))
          }, null, 8, ["data", "columns", "tableId", "canEdit", "template", "onReload"])) : v("", !0),
          i.view === r.View.RECORD ? (l(), F(x, {
            key: 2,
            id: "records",
            data: r.rowsWithComputed,
            columns: i.columns,
            tableId: t.tableId,
            canEdit: t.canEdit,
            template: i.recordTemplate,
            onClick: n[8] || (n[8] = (V) => e.$emit("rowClick", V)),
            onReload: r.reload,
            onEdit: n[9] || (n[9] = (V) => r.handleRowAction(
              "edit",
              r.convertRowToPrimaryKey(V, i.tableMetadata.id, t.schemaId)
            )),
            onDelete: n[10] || (n[10] = (V) => r.handleDeleteRowRequest(
              r.convertRowToPrimaryKey(V, i.tableMetadata.id, t.schemaId)
            ))
          }, null, 8, ["data", "columns", "tableId", "canEdit", "template", "onReload"])) : v("", !0),
          i.view === r.View.TABLE ? (l(), F(Y, {
            key: 3,
            schemaId: t.schemaId,
            selection: i.selectedItems,
            "onUpdate:selection": n[12] || (n[12] = (V) => i.selectedItems = V),
            columns: i.columns,
            "onUpdate:columns": n[13] || (n[13] = (V) => i.columns = V),
            "table-metadata": i.tableMetadata,
            data: r.rowsWithComputed,
            showSelect: t.showSelect,
            onColumnClick: r.onColumnClick,
            onRowClick: n[14] || (n[14] = (V) => e.$emit("rowClick", V)),
            onCellClick: r.handleCellClick
          }, {
            header: b(() => [
              p("label", null, E(i.count) + " records found", 1)
            ]),
            rowcolheader: b(() => [
              t.canEdit ? (l(), F(q, {
                key: 0,
                type: "add",
                tableId: t.tableId,
                schemaId: t.schemaId,
                onAdd: n[11] || (n[11] = (V) => r.handleRowAction("add")),
                class: "d-inline p-0"
              }, null, 8, ["tableId", "schemaId"])) : v("", !0),
              j(e.$slots, "rowcolheader", {}, void 0, !0)
            ]),
            colheader: b((V) => [
              V.col && i.orderByColumn === V.col.id ? (l(), F(u, {
                key: 0,
                icon: i.order === "ASC" ? "sort-alpha-down" : "sort-alpha-up",
                class: "d-inline p-0"
              }, null, 8, ["icon"])) : v("", !0)
            ]),
            rowheader: b((V) => [
              t.canEdit ? (l(), F(q, {
                key: 0,
                type: "edit",
                onEdit: (Se) => r.handleRowAction(
                  "edit",
                  r.convertRowToPrimaryKey(
                    V.row,
                    i.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onEdit"])) : v("", !0),
              t.canEdit ? (l(), F(q, {
                key: 1,
                type: "clone",
                onClone: (Se) => r.handleRowAction(
                  "clone",
                  r.convertRowToPrimaryKey(
                    V.row,
                    i.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onClone"])) : v("", !0),
              t.canEdit ? (l(), F(q, {
                key: 2,
                type: "delete",
                onDelete: (Se) => r.handleDeleteRowRequest(
                  r.convertRowToPrimaryKey(
                    V.row,
                    i.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onDelete"])) : v("", !0),
              j(e.$slots, "rowheader", {
                row: V.row,
                metadata: i.tableMetadata,
                rowKey: r.convertRowToPrimaryKey(
                  V.row,
                  i.tableMetadata.id,
                  t.schemaId
                )
              }, void 0, !0)
            ]),
            _: 3
          }, 8, ["schemaId", "selection", "columns", "table-metadata", "data", "showSelect", "onColumnClick", "onCellClick"])) : v("", !0)
        ]))
      ], 2)
    ]),
    i.isEditModalShown ? (l(), F($, {
      key: 3,
      isModalShown: !0,
      id: t.tableId + "-edit-modal",
      tableId: t.tableId,
      tableLabel: i.tableMetadata.label,
      pkey: i.editRowPrimaryKey,
      clone: i.editMode === "clone",
      schemaId: t.schemaId,
      onClose: r.handleModalClose,
      "apply-default-values": i.editMode === "add"
    }, null, 8, ["id", "tableId", "tableLabel", "pkey", "clone", "schemaId", "onClose", "apply-default-values"])) : v("", !0),
    i.isDeleteModalShown ? (l(), F(Q, {
      key: 4,
      title: "Delete from " + i.tableMetadata.label,
      actionLabel: "Delete",
      actionType: "danger",
      tableId: t.tableId,
      tableLabel: i.tableMetadata.label,
      pkey: i.editRowPrimaryKey,
      onClose: n[15] || (n[15] = (V) => i.isDeleteModalShown = !1),
      onConfirmed: r.handleExecuteDelete
    }, null, 8, ["title", "tableId", "tableLabel", "pkey", "onConfirmed"])) : v("", !0),
    i.isDeleteAllModalShown ? (l(), F(Q, {
      key: 5,
      title: "Truncate " + i.tableMetadata.label,
      actionLabel: "Truncate",
      actionType: "danger",
      tableId: t.tableId,
      tableLabel: i.tableMetadata.label,
      onClose: n[16] || (n[16] = (V) => i.isDeleteAllModalShown = !1),
      onConfirmed: r.handelExecuteDeleteAll
    }, {
      default: b(() => [
        p("p", null, [
          n[36] || (n[36] = _(" Truncate ", -1)),
          p("strong", null, E(i.tableMetadata.label), 1)
        ]),
        p("p", null, " Are you sure that you want to delete ALL rows in table '" + E(i.tableMetadata.label) + "'? ", 1)
      ]),
      _: 1
    }, 8, ["title", "tableId", "tableLabel", "onConfirmed"])) : v("", !0),
    i.isTaskModalShown ? (l(), F(te, {
      key: 6,
      title: "Truncating table",
      onClose: n[17] || (n[17] = (V) => i.isTaskModalShown = !1)
    }, {
      body: b(() => [
        T(ee, {
          taskId: i.taskId,
          onTaskUpdated: r.taskUpdated
        }, null, 8, ["taskId", "onTaskUpdated"])
      ]),
      _: 1
    })) : v("", !0),
    i.refSideModalProps ? (l(), F(le, {
      key: 7,
      column: i.refSideModalProps.column,
      rows: i.refSideModalProps.rows,
      schema: t.schemaId,
      onOnClose: n[18] || (n[18] = (V) => i.refSideModalProps = void 0),
      showDataOwner: t.canManage
    }, null, 8, ["column", "rows", "schema", "showDataOwner"])) : v("", !0)
  ])) : v("", !0);
}
const PF = /* @__PURE__ */ D(gF, [["render", MF], ["__scopeId", "data-v-e8f6aafd"]]), BF = {
  name: "RoutedTableExplorer",
  components: {
    TableExplorer: PF
  },
  data() {
    return {
      allColumns: []
    };
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    },
    canView: {
      type: Boolean,
      default: () => !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    canManage: {
      type: Boolean,
      default: () => !1
    },
    showOrderBy: {
      type: String,
      default: ""
    },
    showOrder: {
      type: String,
      default: "ASC"
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getOrderBy() {
      return this.$route.query._orderBy ? this.$route.query._orderBy : this.showOrderBy;
    },
    getOrder() {
      return this.$route.query._order ? this.$route.query._order : this.showOrder;
    },
    getColumns() {
      return this.$route.query._col ? Array.isArray(this.$route.query._col) ? this.$route.query._col : this.$route.query._col.split(",") : xe(this.showColumns);
    },
    getFilters() {
      return this.$route.query._filter ? Array.isArray(this.$route.query._filter) ? this.$route.query._filter : this.$route.query._filter.split(",") : xe(this.showFilters);
    },
    getPage() {
      return this.$route.query._page ? parseInt(this.$route.query._page) : 1;
    },
    getLimit() {
      return this.$route.query._limit ? parseInt(this.$route.query._limit) : 20;
    },
    getView() {
      return this.$route.query._view ? this.$route.query._view : "table";
    },
    getConditions() {
      let e = {};
      return Object.keys(this.$route.query).forEach((n) => {
        n.startsWith("_") || (e[n] = this.$route.query[n]);
      }), e;
    },
    updatePage(e) {
      const n = Object.assign({}, this.$route.query);
      n._page = e, this.updateRoute(n);
    },
    updateOrder(e) {
      const n = Object.assign({}, this.$route.query);
      n._order = e.direction, n._orderBy = e.column, this.updateRoute(n);
    },
    updateView(e, n) {
      const t = Object.assign({}, this.$route.query);
      t._view = e, t._limit = n, delete t._page, this.updateRoute(t);
    },
    updateLimit(e) {
      const n = Object.assign({}, this.$route.query);
      n._limit = e, delete n._page, this.updateRoute(n);
    },
    updateColumns(e) {
      const n = Object.assign({}, this.$route.query);
      e.length ? n._col = e.join(",") : delete n._col, this.updateRoute(n);
    },
    updateAllColumns(e) {
      this.allColumns = e;
    },
    updateFilters(e) {
      const n = Object.assign({}, this.$route.query);
      e.length > 0 ? n._filter = e.join(",") : delete n._filter, this.updateRoute(n);
    },
    updateConditions(e) {
      let n = Object.assign({}, this.$route.query);
      delete n._page, e.forEach((t) => {
        const o = t.conditions;
        if (o != null && o.length)
          switch (t.columnType) {
            case "REF":
            case "REF_ARRAY":
            case "REFBACK":
            case "ONTOLOGY":
            case "ONTOLOGY_ARRAY":
              n[t.id] = JSON.stringify(o);
              break;
            case "DATE":
            case "DATETIME":
            case "INT":
            case "LONG":
            case "DECIMAL":
              const i = o.map((r) => r.join("..")).join(",");
              i !== ".." ? n[t.id] = i : delete n[t.id];
              break;
            default:
              n[t.id] = o.join(",");
          }
        else
          delete n[t.id];
      }), this.updateRoute(n);
    },
    updateRoute(e) {
      JSON.stringify(e) !== JSON.stringify(this.$route.query) && this.$router.push({ query: e });
    }
  },
  emits: ["rowClick"]
};
function LF(e, n, t, o, i, r) {
  const s = K("TableExplorer");
  return l(), c("div", null, [
    T(s, {
      tableId: t.tableId,
      schemaId: t.schemaId,
      canView: t.canView,
      canEdit: t.canEdit,
      canManage: t.canManage,
      onUpdateConditions: r.updateConditions,
      onUpdateShowColumns: r.updateColumns,
      onUpdateShowFilters: r.updateFilters,
      onUpdateShowPage: r.updatePage,
      onUpdateShowLimit: r.updateLimit,
      onUpdateShowOrder: r.updateOrder,
      onUpdateShowView: r.updateView,
      showView: r.getView(),
      showColumns: r.getColumns(),
      showFilters: r.getFilters(),
      urlConditions: r.getConditions(),
      showPage: r.getPage(),
      showLimit: r.getLimit(),
      showOrderBy: r.getOrderBy(),
      showOrder: r.getOrder(),
      onRowClick: n[0] || (n[0] = (a) => e.$emit("rowClick", a))
    }, {
      rowcolheader: b(() => [
        j(e.$slots, "rowcolheader")
      ]),
      rowheader: b((a) => [
        j(e.$slots, "rowheader", {
          row: a.row,
          metadata: a.metadata,
          rowKey: a.rowKey
        })
      ]),
      _: 3
    }, 8, ["tableId", "schemaId", "canView", "canEdit", "canManage", "onUpdateConditions", "onUpdateShowColumns", "onUpdateShowFilters", "onUpdateShowPage", "onUpdateShowLimit", "onUpdateShowOrder", "onUpdateShowView", "showView", "showColumns", "showFilters", "urlConditions", "showPage", "showLimit", "showOrderBy", "showOrder"])
  ]);
}
const G1 = /* @__PURE__ */ D(BF, [["render", LF]]), NF = {
  name: "RowButtonClone",
  components: { RowButton: jt, EditModal: pr },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    pkey: {
      type: Object,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isModalShown: !1
    };
  },
  methods: {
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function qF(e, n, t, o, i, r) {
  const s = K("RowButton"), a = K("EditModal");
  return l(), c("div", null, [
    T(s, {
      type: "clone",
      onClone: n[0] || (n[0] = (u) => i.isModalShown = !0)
    }),
    i.isModalShown ? (l(), F(a, {
      key: 0,
      id: t.id + "edit-modal",
      tableId: t.tableId,
      pkey: t.pkey,
      clone: !0,
      isModalShown: i.isModalShown,
      schemaId: t.schemaId,
      onClose: r.handleClose
    }, null, 8, ["id", "tableId", "pkey", "isModalShown", "schemaId", "onClose"])) : v("", !0)
  ]);
}
const Q1 = /* @__PURE__ */ D(NF, [["render", qF]]), xF = {
  props: {
    /** the column names */
    columns: Array,
    /** list of rows matching column names */
    rows: Array,
    /** set to create select boxes that will yield this columns value when selected. */
    selectColumn: String,
    /** default value */
    defaultValue: Array
  },
  data: function() {
    return {
      selectedItems: []
    };
  },
  created() {
    Array.isArray(this.defaultValue) ? this.selectedItems = this.defaultValue : this.defaultValue !== null ? this.selectedItems.push(this.defaultValue) : this.selectedItems = [];
  },
  computed: {
    tableHover() {
      return this.selectColumn;
    },
    hasColheader() {
      return this.selectColumn || !!this.$slots.colheader || !!this.$slots.rowheader;
    }
  },
  methods: {
    flattenObject(e) {
      let n = "";
      return e && e.length > 0 && typeof e == "object" ? (Object.keys(e).forEach((t) => {
        e[t] === null || (typeof e[t] == "object" ? n += this.flattenObject(e[t]) : n += " " + e[t]);
      }), n.replace(/^\./, "")) : e;
    },
    isSelected(e) {
      return this.selectedItems !== null && this.selectedItems.includes(e[this.selectColumn]);
    },
    toggleSelect(e) {
      this.isSelected(e) ? (this.selectedItems = this.selectedItems.filter(
        (n) => n !== e[this.selectColumn]
      ), this.$emit("deselect", e[this.selectColumn])) : (this.selectedItems.push(e[this.selectColumn]), this.$emit("select", e[this.selectColumn])), this.$emit("update:modelValue", this.selectedItems);
    },
    onRowClick(e) {
      this.$emit("rowClick", e);
    }
  }
}, VF = { class: "table-responsive" }, jF = {
  key: 0,
  scope: "col",
  style: { width: "1px" }
}, HF = { key: 0 }, GF = { style: { display: "flex" } }, QF = ["checked", "onClick"], $F = ["onClick"], JF = {
  key: 0,
  class: "list-unstyled"
}, zF = { key: 1 };
function YF(e, n, t, o, i, r) {
  return l(), c("div", VF, [
    p("table", {
      class: G(["table table-bordered", { "table-hover": r.tableHover }])
    }, [
      p("thead", null, [
        p("tr", null, [
          r.hasColheader ? (l(), c("th", jF, [
            j(e.$slots, "colheader", {}, void 0, !0)
          ])) : v("", !0),
          (l(!0), c(oe, null, ae(t.columns, (s) => (l(), c("th", {
            key: s,
            scope: "col"
          }, E(s), 1))), 128))
        ])
      ]),
      p("tbody", null, [
        (l(!0), c(oe, null, ae(t.rows, (s) => (l(), c("tr", {
          key: JSON.stringify(s)
        }, [
          r.hasColheader ? (l(), c("td", HF, [
            p("div", GF, [
              t.selectColumn ? (l(), c("input", {
                key: 0,
                class: "form-check form-check-inline mr-1",
                type: "checkbox",
                checked: r.isSelected(s),
                onClick: Ke((a) => r.toggleSelect(s), ["stop"])
              }, null, 8, QF)) : v("", !0),
              j(e.$slots, "rowheader", { row: s }, void 0, !0)
            ])
          ])) : v("", !0),
          (l(!0), c(oe, null, ae(t.columns, (a) => (l(), c("td", {
            key: a,
            onClick: (u) => r.onRowClick(s),
            style: { cursor: "pointer" }
          }, [
            Array.isArray(s[a]) ? (l(), c("ul", JF, [
              (l(!0), c(oe, null, ae(s[a], (u, d) => (l(), c("li", { key: d }, E(u), 1))), 128))
            ])) : s[a] !== void 0 ? (l(), c("span", zF, E(r.flattenObject(s[a])), 1)) : v("", !0)
          ], 8, $F))), 128))
        ]))), 128))
      ])
    ], 2)
  ]);
}
const $1 = /* @__PURE__ */ D(xF, [["render", YF], ["__scopeId", "data-v-3297a3f0"]]), WF = Re({
  name: "TaskList",
  components: {
    MessageError: it
  },
  data() {
    return {
      loading: !1,
      tasks: [],
      error: null
    };
  },
  methods: {
    retrieveTasks() {
      this.loading = !0, this.error = null, Be("graphql", "{_tasks{id,description,status}}").then((e) => {
        this.tasks = e._tasks, this.loading = !1;
      }).catch((e) => {
        Array.isArray(e.response.errors) ? this.error = e.response.errors[0].message : this.error = e, this.loading = !1;
      });
    }
  },
  mounted() {
    this.retrieveTasks();
  }
}), XF = { class: "table table-bordered" }, ZF = ["onClick"];
function e1(e, n, t, o, i, r) {
  const s = K("MessageError");
  return l(), c("div", null, [
    e.error ? (l(), F(s, { key: 0 }, {
      default: b(() => [
        _(E(e.error), 1)
      ]),
      _: 1
    })) : v("", !0),
    p("table", XF, [
      n[0] || (n[0] = p("thead", null, [
        p("th", { scope: "col" }, "Task Description"),
        p("th", null, "Task Status")
      ], -1)),
      p("tbody", null, [
        (l(!0), c(oe, null, ae(e.tasks, (a) => (l(), c("tr", {
          key: a.id
        }, [
          p("td", null, [
            p("button", {
              onClick: Ke((u) => e.$emit("select", a.id), ["prevent", "stop"]),
              type: "button",
              class: "btn btn-link"
            }, E(a.description), 9, ZF)
          ]),
          p("td", null, E(a.status), 1)
        ]))), 128))
      ])
    ])
  ]);
}
const t1 = /* @__PURE__ */ D(WF, [["render", e1]]), n1 = Re({
  name: "TaskManager",
  components: { Task: yl, TaskList: t1, IconAction: ct },
  data() {
    return {
      selectedTaskId: null
    };
  },
  methods: {
    selectTask(e) {
      this.selectedTaskId = e;
    },
    clearSelection() {
      this.selectedTaskId = null;
    }
  }
}), o1 = { key: 0 }, i1 = { key: 1 };
function r1(e, n, t, o, i, r) {
  const s = K("IconAction"), a = K("Task"), u = K("TaskList");
  return l(), c("div", null, [
    e.selectedTaskId ? (l(), c("span", o1, [
      p("span", {
        onClick: n[0] || (n[0] = (...d) => e.clearSelection && e.clearSelection(...d))
      }, [
        T(s, { icon: "angle-left" }),
        n[1] || (n[1] = _(" Back to task list ", -1))
      ]),
      n[2] || (n[2] = p("h1", null, "Task details", -1)),
      T(a, { taskId: e.selectedTaskId }, null, 8, ["taskId"])
    ])) : (l(), c("div", i1, [
      n[3] || (n[3] = p("h1", null, "Task list", -1)),
      T(u, { onSelect: e.selectTask }, null, 8, ["onSelect"])
    ]))
  ]);
}
const J1 = /* @__PURE__ */ D(n1, [["render", r1]]);
export {
  Xw as AggregateTable,
  st as ArrayInput,
  yC as Breadcrumb,
  He as ButtonAction,
  ot as ButtonAlt,
  Dy as ButtonDanger,
  fr as ButtonDropdown,
  Po as ButtonOutline,
  Uh as ButtonSubmit,
  nt as Client,
  lr as ConfirmModal,
  k1 as ContactDisplay,
  ZC as CookieWall,
  nl as DataDisplayCell,
  pr as EditModal,
  ir as EmailDisplay,
  tl as FileDisplay,
  FA as FilterContainer,
  PK as FilterInput,
  qK as FilterSidebar,
  Xa as FilterWell,
  $K as FilterWells,
  ke as FormGroup,
  Zv as FormInput,
  Th as FormMolgenis,
  YC as GTag,
  Dm as GridBlock,
  O1 as HtmlDropdown,
  rr as HyperlinkDisplay,
  ct as IconAction,
  _1 as IconBar,
  nr as IconDanger,
  U1 as ImageCard,
  E1 as ImageDisplay,
  M1 as Info,
  P1 as InfoPopover,
  Kv as InlineInput,
  No as InputBoolean,
  Mh as InputCheckbox,
  Bo as InputDate,
  Lo as InputDateTime,
  ur as InputDecimal,
  ll as InputEmail,
  dl as InputFile,
  Ve as InputGroup,
  Ii as InputHeading,
  ul as InputHyperlink,
  dr as InputInt,
  Jv as InputJson,
  cr as InputLong,
  Co as InputOntology,
  dK as InputOntologySubtree,
  Ji as InputPassword,
  Wa as InputRadio,
  Ya as InputRangeDate,
  pg as InputRangeDateTime,
  jA as InputRangeDecimal,
  OA as InputRangeInt,
  TK as InputRangeLong,
  cl as InputRefBack,
  uo as InputRefList,
  fo as InputRefSelect,
  ar as InputSearch,
  En as InputSelect,
  B1 as InputSelectInplace,
  At as InputString,
  Vn as InputText,
  L1 as InputTextLocalized,
  S1 as KeyValueBlock,
  q1 as LayoutCard,
  jh as LayoutForm,
  Kt as LayoutModal,
  T1 as LinksList,
  Xg as ListDisplay,
  em as LocaleSwitch,
  it as MessageError,
  pn as MessageSuccess,
  Nv as MessageWarning,
  x1 as Molgenis,
  vh as MolgenisAccount,
  sw as MolgenisFooter,
  mw as MolgenisMenu,
  am as MolgenisSession,
  qh as MolgenisSignin,
  Qh as MolgenisSignup,
  or as ObjectDisplay,
  I1 as PageHeader,
  ol as Pagination,
  mm as PersonDetails,
  R1 as QueryEMX2,
  ja as ReadMore,
  G1 as RoutedTableExplorer,
  jt as RowButton,
  Za as RowButtonAdd,
  Q1 as RowButtonClone,
  qy as RowButtonDelete,
  Sy as RowButtonEdit,
  ib as RowEdit,
  ab as RowEditFooter,
  oF as ShowHide,
  V1 as ShowMore,
  j1 as SimpleModal,
  yt as Spinner,
  el as StringDisplay,
  cF as SubTask,
  D1 as TableDisplay,
  PF as TableExplorer,
  sr as TableMolgenis,
  $1 as TableSimple,
  xw as TableStickyHeaders,
  H1 as Tabs,
  yl as Task,
  t1 as TaskList,
  J1 as TaskManager,
  Pg as TextDisplay,
  gh as TokenManager,
  un as Tooltip,
  N1 as TooltipComponent,
  Mw as VueTemplate,
  yo as applyJsTemplate,
  Tt as constants,
  xe as deepClone,
  on as flattenObject,
  Td as getRowErrors,
  Cd as privacyConstants,
  Be as request
};
